(function () {
  'use strict';

  angular
    .module('app.routes', [])
    .config(config);

  /** @ngInject */
  function config ($stateProvider, $injector) {
    var APP_NAME = $injector.get('APP_NAME');
    $stateProvider.state('app.routes', {
      url: '/ruta?dates&lang&gclid&utm_source&utm_medium&utm_campaign&utm_temporary&code&spMailingID&spUserID&spJobID&spReportID&spReportId',
      views: {
        'content@app': {
          templateUrl: 'app/views/' + APP_NAME + '/pages/routes/routes.html',
          controller: 'RoutesController as vm'
        }
      },
      bodyClass: {app: APP_NAME + '_app', page: 'routes'}
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.routes')
        .controller('BusDialogController', BusDialogController);

    /** @ngInject */
    function BusDialogController($mdDialog) {

        var vm = this;

        // Methods
        vm.closeDialog = closeDialog;

        //////////

        function closeDialog() {
            $mdDialog.hide(false);
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.payment', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $injector)
    {
        var APP_NAME = $injector.get('APP_NAME');
        // State
        $stateProvider.state('app.payment', {
            url      : '/pago?lang',
            views    : {
                'content@app': {
                    templateUrl: 'app/views/'+ APP_NAME +'/pages/payment/payment.html',
                    controller : 'PaymentController as vm'
                }
            },
            bodyClass: {app: APP_NAME+'_app', page: 'payment'},
            data : {
                meta:{
                    'busolinea':{
                        page_title: 'META.PAYMENT.TITLE'
                    },
                    'futura':{
                        page_title: 'Pago | Futura'
                    },
                    'geb':{
                        page_title: 'Pago | Grupo Estrella Blanca'
                    },
                    'transportamex':{
                        page_title: 'META.PAYMENT.TITLE'
                    }

                }
            }
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.payment')
        .controller('TimeoutDialogController', TimeoutDialogController);

    /** @ngInject */
    function TimeoutDialogController($mdDialog) {

        var vm = this;

        // Methods
        vm.closeDialog = closeDialog;

        //////////

        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.payment')
        .controller('ExitDialogController', ExitDialogController);

    /** @ngInject */
    function ExitDialogController($mdDialog) {

        var vm = this;

        // Methods
        vm.closeDialog = closeDialog;
        vm.confirmDialog = confirmDialog;

        //////////

        function closeDialog() {
            $mdDialog.hide(false);
        }

        function confirmDialog() {
            $mdDialog.hide(true);
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('RegisterDialogController', RegisterDialogController);

    /** @ngInject */
    function RegisterDialogController($mdDialog, showLoginForm,auth)
    {
        var vm = this;

        vm.registroMail = false;
        vm.user={
          email:"",
          password:"",
          passwordConfirm:"",
          terms:false
        }

        // Methods
        vm.closeDialog = closeDialog;
        vm.toggleRegistroMail = toggleRegistroMail;
        vm.showLoginForm = showLoginForm;
        vm.signUp = signUp;
        // temporal
        vm.showProfile = showProfile;


        //////////

        function closeDialog(){
            $mdDialog.hide(false);
        }

        function toggleRegistroMail(){
            vm.registroMail = vm.registroMail == false ? true : false;
        }

        function showProfile(){
            $mdDialog.hide(true);
        }

        function signUp(){
            auth.on.signup(vm.user).then(function(resp){
              vm.closeDialog();
            },function(error){
              if(error.data.errors){
                vm.errors = error.data.errors[0];
                vm.user={
                  email:"",
                  password:"",
                  passwordConfirm:"",
                  terms:false
                }
              }
            })
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('RecoverDialogController', RecoverDialogController);

    /** @ngInject */
    function RecoverDialogController($mdDialog)
    {
        var vm = this;

        // Methods
        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide(false);
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('LoginDialogController', LoginDialogController);

    /** @ngInject */
    function LoginDialogController($mdDialog, showRegisterForm, showRecoverForm, auth, localStorageService)
    {
        var vm = this;

        // Methods
        vm.closeDialog = closeDialog;
        vm.showRegisterForm = showRegisterForm;
        vm.showRecoverForm = showRecoverForm;

        // Data
        vm.showProfile = showProfile;
        vm.login = login;
        vm.user = {
          email: null,
          password: null,
          cookie: false
        }

        //////////

        function closeDialog()
        {
            $mdDialog.hide(false);
        }

        function showProfile(){
            $mdDialog.hide(true);
        }

        function login(){
          vm.errorMessage = null;
          vm.user.deviceprint = vm.deviceprint;
          auth.on.login(vm.user)
            .then(function(resp){
              if (resp.data.errorMessage){
                vm.errorMessage = resp.data.errorMessage;
                vm.user.email = null;
                vm.user.password = null;
                vm.user.cookie = false;
                return
              }

              if (vm.user.cookie == true){
                localStorageService.set("userEmail", vm.user.email);
                localStorageService.set("isLogged", true);
              }
              localStorageService.set("token", resp.data.data.token);
              $mdDialog.hide(vm.user);
            },function(err){

            });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ClubDialogController', ClubDialogController);

    /** @ngInject */
    function ClubDialogController($mdDialog)
    {
        var vm = this;

        // Methods
        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide(false);
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.routes')
        .controller('ToastController', ToastController);

    /** @ngInject */
  function ToastController(city, $translate) {

      var vm = this;
      var city = city != undefined ? city : 'Ciudad de México';
      $translate('ROUTES.TOASTS.RECENT', {city: city})
	  .then(function (translatedValue) {
	       vm.toastMessage1 = translatedValue;
	  });
      $translate('ROUTES.TOASTS.PEOPLE', {number: Math.floor((Math.random() * 4) + 2)})
	  .then(function (translatedValue) {
	       vm.toastMessage2 = translatedValue;
	  });
    
        //vm.toastMessage1 = 'La reservación más reciente se realizó en '+city;
        //vm.toastMessage2 = 'Hay otras '+ Math.floor((Math.random() * 4) + 2) +' personas viendo esta ruta';

        // Methods
       

        //////////

    

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.error-503', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $injector)
    {
        var APP_NAME = $injector.get('APP_NAME');
        //State
        $stateProvider.state('app.errors_error-503', {
            url      : '/error/503?lang',
            views    : {
                'main@': {
                    templateUrl: 'app/views/'+ APP_NAME +'/layouts/default-navigation-nosearchbar.html',
                    controller: 'Error503Controller as vm'
                },
                'toolbar@app.errors_error-503' : {
                    templateUrl: 'app/views/'+ APP_NAME +'/elements/toolbar/toolbar.html',
                    controller : 'ToolbarController as vm'
                },
                'content@app.errors_error-503': {
                    templateUrl: 'app/views/'+ APP_NAME +'/pages/errors/503/error-503.html'
                }
            },
            bodyClass: {app: APP_NAME+'_app', page: 'error-503'},
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.error-503')
        .controller('Error503Controller', Error503Controller);

    /** @ngInject */
    function Error503Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $injector)
    {
        var APP_NAME = $injector.get('APP_NAME');
        //State
        $stateProvider.state('app.errors_error-500', {
            url      : '/errors/error-500?lang',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/views/'+ APP_NAME +'/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.errors_error-500': {
                    templateUrl: 'app/views/'+ APP_NAME +'/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: {app: APP_NAME+'_app', page: 'error-500'},
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $injector)
    {
        var APP_NAME = $injector.get('APP_NAME');
        //State
        $stateProvider.state('app.errors_error-404', {
            url      : '/error/404?lang',
            views    : {
                'main@': {
                    templateUrl: 'app/views/'+ APP_NAME +'/layouts/default-navigation-nosearchbar.html',
                    controller: 'Error404Controller as vm'
                },
                'toolbar@app.errors_error-404' : {
                    templateUrl: 'app/views/'+ APP_NAME +'/elements/toolbar/toolbar.html',
                    controller : 'ToolbarController as vm'
                },
                'content@app.errors_error-404': {
                    templateUrl: 'app/views/'+ APP_NAME +'/pages/errors/404/error-404.html'
                }
            },
            bodyClass: {app: APP_NAME+'_app', page: 'error-404'},
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
  'use strict';

  angular
    .module('app.core',
      [
        'ngAnimate',
        'ngAria',
        'ngCookies',
        'ngMessages',
        'ngResource',
        'ngSanitize',
        'ngMaterial',
        'pascalprecht.translate',
        'timer',
        'ui.router',
        'moment-picker',
        'tmh.dynamicLocale',
        'ui-rangeSlider',
        'ngMeta',
        'LocalStorageModule',
        'angularMoment'
      ]);
})();

  (function () {
     'use strict';

     /**
      * Video Slider Component
      */

     angular

       .module('app.core')

       .directive('videoSlider', function ($mdDialog) {


                    return {

                      restrict: 'E',

                      templateUrl: 'app/core/directives/video-slider/video-slider.html',
                      link: function (scope, elem, attrs) {

                        $("#carousel").Cloud9Carousel( {
                                                         buttonLeft: $(".buttons > .left"),
                                                         buttonRight: $(".buttons > .right"),
                                                         yRadius: -15,
                                                         xRadius: 200,
                                                         yOrigin: 40,
                                                         farScale: 0.75,

                                                       } );

                		      scope.showVideo = function(idx,queueId){

                      			$mdDialog.show({
                              template: '<script src="https://www.youtube.com/player_api"></script><div id="playerFutura"</div>',
                      			  parent: elem,
                      			  clickOutsideToClose:true,
                      			  fullscreen: scope.customFullscreen, // Only for -xs, -sm breakpoints.
                              controller:function(){
                                // create youtube player
                                var player;

                                setTimeout(function(){
                                  player = new YT.Player('playerFutura', {
                                    videoId: idx,
                                    height: "100%",
                                    width: "100%",
                                    playerVars: {rel: 0},
                                    events: {
                                      'onReady': onPlayerReady,
                                      'onStateChange': onPlayerStateChange
                                    }
                                  });

                                },300)

                                // autoplay video
                                function onPlayerReady(event) {
                                    event.target.playVideo();
                                }

                                // when video ends
                                function onPlayerStateChange(event) {
                                    if(event.data === 0) {
                                        $mdDialog.hide();
                                        var next ;
                                        (queueId==0)?next=3:next = parseInt(queueId)-parseInt(1);
                                        if(queueId==0){
                                          next=3;
                                        }
                                        $("#carousel").data("carousel").goTo(next)
                                    }
                                }
                              }  // Controller end
                            });  // $mdDialog end
                        };  // Show video end

                      } // link function
                    };

                  });

   })();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('validPassengerName', function () {

      return {
        require: 'ngModel',
        link: function(scope, element, attr, ngModelCtrl) {
          function fromUser(text) {
            var transformedInput = text.replace(/[^a-zA-Z\u00C0-\u024F ]/g, '');
            if (transformedInput !== text) {
              ngModelCtrl.$setViewValue(transformedInput);
              ngModelCtrl.$render();
            }
            return transformedInput;
          }
          ngModelCtrl.$parsers.push(fromUser);
        }
      };

    });
})();
(function () {
  'use strict';

  /**
   * Time Selector Component
   *
   * @param {Object[]} ngModel - Component properties.
   * @param {string} ngModel[].label - Label to be displayed above the option.
   * @param {string} ngModel[].display - Option's content, this goes inside the box.
   * @param {string=} ngModel[].footer - Option's footer text shown on muted text.
   * @param {boolean} ngModel[].value - Indicates checkbox' checked state.
   */

  angular
    .module('app.core')
    .directive('timeSelector', function () {
      return {
        restrict: 'E',
        templateUrl: 'app/core/directives/time-selector/templates/time-selector.html',
        scope: {
          ngModel: '='
        },
        link: function ($scope) {

          $scope.$watch('ngModel', function () {

            var flags = 0;

            for (var i = 0; i < $scope.ngModel.length - 1; i += 1) {
              if ($scope.ngModel[i]['value']) {
                flags++;
              }
            }

            $scope.ngModel[$scope.ngModel.length - 1]['value'] = flags === 0;

          }, true);

          $scope.toggleOptionValue = function (option, isLastElement) {
            if( option.active ){
              if (isLastElement) {
                restartState();
              } else {
                option.value = !option.value;
              }
            }
          };

          function restartState() {
            var clone = $scope.ngModel.slice(0);

            clone.forEach(function (option) {
              option.value = false;
            });

            $scope.ngModel = clone;
          }

        }
      };
    });
})();

(function () {
  'use strict';

  /**
   * Seat Selection Component
   */

  angular
    .module('app.core')
    .directive('seat', function ($injector, msUtils, $window, $timeout) {

      var APP_NAME = $injector.get('APP_NAME');
      return {
        restrict: 'E',
        templateUrl: 'app/views/' + APP_NAME + '/pages/seats/seat-selection/seat.html',
        scope: {
          number: '=',
          state: '=',
          isLoading: '=',
          isSelected: '='
        },
        link: function ($scope, element) {

          $scope.displayNumber = function () {
            return $scope.state !== 'space' && $scope.state !== 'occupied' && $scope.state !== 'wc' && $scope.state !== 'stair';
          };

          $scope.renderSvg = function () {
            if ($scope.state === 'wc' && ($scope.$parent.$parent.$index === 1 || $scope.$parent.$parent.$index === 4) && ($scope.$parent.$last === true)) {
              $timeout(function () {
                if ($window.innerWidth <= 959) {
                  $(element).parent().find('.svgWc').remove()
                  if ($('.seats-selection-wrapper').size() === 0) {
                    if ($('body').hasClass('busolinea_app')) {
                      $(element).parent().append("<div class='svgWc' style='width:139px;height:61px;position:absolute;left:-50px!important;top:" + $(element).position().top + "px;'></div>")
                    } else {
                      $(element).parent().append("<div class='svgWc' style='width:139px;height:61px;position:absolute;left:0px;top:" + $(element).position().top + "px;'></div>")
                    }
                  } else {
                    $(element).parent().append("<div class='svgWc' style='width:139px;height:61px;position:absolute;left:-45px;top:" + $(element).position().top + "px;'></div>")
                  }
                } else {
                  $(element).parent().find('.svgWc').remove()
                  $(element).parent().append("<div class='svgWc' style='width:50px;height:108px;position:absolute;left:" + $(element).position().left + "px;'></div>")
                }
              }, 0)
            }

            if ($scope.state === 'stair' && ($scope.$parent.$parent.$index === 1 || $scope.$parent.$parent.$index === 4)) {
              $timeout(function () {
                if ($window.innerWidth <= 959 && ($scope.$parent.$even === true)) {
                  $(element).parent().find('.svgStair').remove()
                  $(element).parent().append("<div class='svgStair' style='width:110px;height:108px;position:absolute;left:-50px;top:" + $(element).position().top + "px;'></div>")
                } else {
                  if ($scope.$parent.$even == true) {
                    $(element).parent().find('.svgStair').remove()
                    $(element).parent().append("<div class='svgStair' style='width:100px;height:108px;position:absolute;left:" + $(element).position().left + "px;'></div>")
                  }
                }
              }, 0)
            }
          }

          $scope.renderSvg()

          angular.element($window).bind('resize', function () {
             $scope.renderSvg();
            $scope.$digest();
           });

        }
      };

    });
})();

(function () {
  'use strict';

  /**
   * Time Selector Component
   *
   * @param {Object[]} ngModel - Component properties.
   * @param {string} ngModel[].label - Label to be displayed above the option.
   * @param {string} ngModel[].display - Option's content, this goes inside the box.
   * @param {string=} ngModel[].footer - Option's footer text shown on muted text.
   * @param {boolean} ngModel[].value - Indicates checkbox' checked state.
   */

  angular
    .module('app.core')
    .directive('seatTypeSelector', function ($injector) {

      var APP_NAME = $injector.get('APP_NAME');
      return {
        restrict: 'E',
        templateUrl: 'app/views/'+ APP_NAME +'/pages/seats/seat-selection/seat-type-selector.html',
        scope: {
          ticketType: '=',
          prices: '=',
          onUpdateSeat: '&'
        },
        link: function ($scope) {
          $scope.pricesByType = {};
	    $scope.availableByType = {};

            $scope.prices.forEach(function (price) {

              $scope.pricesByType[price.type] = price.total;
	      $scope.availableByType[price.type] = price.slots > 0;
          });
        }
      };

    });
})();

(function () {
  'use strict';

  /**
   * Seat Selection Component
   */

  angular
    .module('app.core')
     .directive('seatSelection', function ($injector, GTM) {

      var APP_NAME = $injector.get('APP_NAME');
      return {
        restrict: 'E',
        templateUrl: 'app/views/'+ APP_NAME +'/pages/seats/seat-selection/seat-selection.html',
        scope: {
          isSelectionComplete: '=',
          route: '=',
          seats: '=',
          selectedSeats: '=',
          onSeatClick: '&',
          onSeatRemove: '&',
          onSeatUpdate: '&',
          onClickContinue: '&',  
          showTimer: '=',
          remainTime: '='
        },
        link: function ($scope) {

          $scope.typeDescription = {
            occupied: 'Ocupado',
            selected: 'Seleccionado',
            regular: 'Disponible',
            woman: 'Exclusivo Mujer',
            first_class: 'Primera select'
          };

          $scope.vista = 'lowLevel';
          

          $scope.changeFirstFloor = function(){
            $scope.vista = 'firstFloor'
          }

          $scope.changeDownFloor = function(){
            $scope.vista = 'lowLevel'
          }


          $scope.selected = 'selected';

          $scope.totalPrice = 0;

          $scope.types = [];

          $scope.$watch('selectedSeats', function () {
            var totalPrice = 0;
            var isSelectionComplete = false;

            $scope.selectedSeats.forEach(function (seat) {
              if (!seat.prices) {
                return;
              }

              var price = findPrice(seat);

              if (typeof price === 'number') {
                totalPrice += price;
              }

              isSelectionComplete = true;

              if (!seat.isComplete) {
                isSelectionComplete = false;
              }
            });

            $scope.totalPrice = totalPrice;
            $scope.isSelectionComplete = isSelectionComplete;

            function findPrice(seat) {
              var selectedPrice = null;
              angular.forEach(seat.prices, function(price, key) {
                if( price.type === seat.ticket_type ){
                  selectedPrice = seat.prices[key];
                }
              });

              return selectedPrice.total;
            }
          }, true);

          $scope.$watch('seats', function () {
            var types = {};

            $scope.seats.forEach(function (row) {
              row.forEach(function (seat) {
                _.map(seat,function(s){
                  if(s.type=='wc' || s.type=='stair')
                    return;
                  s.seat_type = s.type;
                  Object.defineProperty(types, s.seat_type, {value : true,
                   writable : true,
                   enumerable : true,
                   configurable : true});
                })

              });
            });

            $scope.types = [];

            for (var prop in types) {
              $scope.types.push(prop);
            }
          });

          $scope.seatClick = function (seat) {
            if (seat.isSelected === true) {
              GTM.sendEvent('seats', "deseleccionar", seat.number);	      
            } else {
              GTM.sendEvent('seats', "seleccionar", seat.number);
            }            
            if (seat.seat_type != 'space' && seat.seat_type != 'occupied') {
              $scope.onSeatClick({seat: seat});
            }
          };

          $scope.continue = function () {
            $scope.onClickContinue();
          };

        }

      };

    });

})();

(function () {
  'use strict';

  /**
   * Seat Selection Component
   */

  angular
    .module('app.core')
     .directive('seatForm', function ($injector) {

      var APP_NAME = $injector.get('APP_NAME');
      return {
        restrict: 'E',
        templateUrl: 'app/views/'+ APP_NAME +'/pages/seats/seat-selection/seat-form.html',
        scope: {
          seat: '=',
          type: '=',
          onSeatUpdate: '&',
          onSeatRemove: '&'
        },
        link: function ($scope) {

          $scope.seat.name = '';

          $scope.update = function (seat, type) {
            seat.event = type;

            $scope.onSeatUpdate({seat: seat});
          };

        }
      };

    });
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('scrollTo', scrollToDirective);

  /** @ngInject */
    function scrollToDirective($window, msUtils) {
    return {
      restrict: 'A',

      link: function ($scope, element, attrs) {
          element.on('click', function () {
	    if (msUtils.isMobile() == null && attrs.scrollTo == "#origin") return;
            if (!attrs.scrollTo) return;

          var elem = $window.document.querySelector(attrs.scrollTo);

          if (!elem) return;

          $window.document.querySelector(attrs.scrollTo).scrollIntoView();
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('routesList', function ($injector, $mdSidenav) {

      var APP_NAME = $injector.get('APP_NAME');
      return {
        restrict: 'E',
        templateUrl: 'app/views/'+ APP_NAME +'/pages/routes/route-selection/routes-list.html',
        scope: {
          labelTranslate: '@',
          routes: '=',
          cabinTypes: '=',
          filterTime: '=',
          localpaso: '=',
          busCompanies: '=',
          timeMin: '=',
          timeMax: '=',
          orinfoServer: '=',
          onRouteSelection: '&'
        },
        controller: function ($scope, $rootScope) {

          //Sets the values on the sorter select
          $scope.sortItems = [
            { id: 'departure_time', name: 'Hora' },
            { id: 'price', name: 'Precio' },
            { id: 'duration', name: 'Duración' }
          ];
          $scope.sortItem = { id: 'departure_time', name: 'Hora' };

          // Toggles mobile sidebar
          $scope.toggleSidebar = function(sidenavId){
            $mdSidenav(sidenavId).toggle();
          }

          this.onRouteSelection = function (item, central_buy) {
            $scope.onRouteSelection({item: item, central_buy: central_buy});
          };

        }

      };

    });

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('route', function ($injector, $document, $mdDialog, _ba) {

      var APP_NAME = $injector.get('APP_NAME');
      return {
        restrict: 'E',
        require: '^routesList',
        templateUrl: 'app/views/'+ APP_NAME +'/pages/routes/route-selection/route.html',
        scope: {
          route: '='
        },
        link: function ($scope, elem, attr, routesListControl) {
          $scope.selectRoute = function(item, central_buy) {
            routesListControl.onRouteSelection(item, central_buy);
          }

          // Dialog for Local/Paso link
          $scope.showBusDialog = function() {
              $mdDialog.show({
                  parent      : angular.element(document.body),
                  controller  : 'BusDialogController',
                  controllerAs: 'vm',
                  templateUrl : 'app/views/'+ APP_NAME +'/pages/routes/dialogs/bus/bus-dialog.html',
                  clickOutsideToClose: true
              });
              _ba.send('local/paso link clicked');
          }

          // Shows/hides the services icons offered in a route
          $scope.toggleServices = function($event){
              angular.element($event.currentTarget).closest('.result_wrapper').find('.services').show();
          }     
          // console.log('this is route',$scope.route)
          $scope.leftSeats = 0;
          if ($scope.route.discounts) {
            $scope.route.discounts.map(function(discount) {
              if (discount.discount_price === $scope.route.price) {
                $scope.leftSeats = discount.available_seats;
              }
              return discount
            })
          }
          if ($scope.route.discount === 100) {
            $scope.route.has_discount = false
          }
          $scope.showDiscountMessage = false;
          $scope.discountMessagePosition = ""
          $scope.discountMessage = ""
          $scope.discountMessages = {
            office: "Precio taquilla",
            onLine: "¡Cuidate! Compra sin salir de casa y obten un " + $scope.route.discount + "% de descuento",
            dynamic: "Con esta tarifa podras ahorrar mas al comprar anticipadamente",
            dynamicEnd: "¡Lo sentimos! Esta tarifa ya no esta disponible, busca tus boletos anticipadamente."
          }
          $scope.toggleMessage = function(state,position,messageType) {
            $scope.showDiscountMessage = state;
            $scope.discountMessagePosition = position;
            $scope.discountMessage = $scope.discountMessages[messageType];
          }

        }

      };

    });

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document, $rootScope)
    {
        return {
            restrict   : 'E',
            scope      : {
                clearOnCollapse: '=?',
                debounce: '=?',
            },
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement, iAttrs)
                {
                    var expanderEl,
                        collapserEl,
                        clearOnCollapse;

                    // Initialize
                    init();

                    function init()
                    {
                        // Figure out the clearOnCollapse status
                        if ( angular.isDefined(scope.clearOnCollapse) )
                        {
                            clearOnCollapse = scope.clearOnCollapse;
                        }
                        else
                        {
                            clearOnCollapse = angular.isDefined(iAttrs.clearOnCollapse);
                        }
                        
                        // Figure out the scope.debounce value
                        scope.debounce = scope.debounce || 0;

                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');

                        if ( clearOnCollapse )
                        {
                            scope.$evalAsync(function ()
                            {
                                iElement.find('#ms-search-bar-input').val('');
                                $rootScope.global.search = '';
                            });
                        }
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, busolineaConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( busolineaConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( busolineaConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                deleteItem         : deleteItem,
                sort               : sortByWeight,
                clearNavigation    : clearNavigation,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function () {
  'use strict'

  angular
    .module('app.core')
    .directive('mobileBanner', function ($rootScope, $injector, msUtils, $timeout, $cookies, _ba) {

      var APP_NAME = $injector.get('APP_NAME')

      return {
        restrict: 'E',
        templateUrl: 'app/core/directives/mobile-banner/templates/mobile-banner.html',
        replace: true,
        scope: {
          position: '@'
        },
        link: function ($scope) {
          if (msUtils.isMobile() != null) {
            /*
            // Initializing top and bottom ad banner values
            // @contentLoaded
            // @os
            // @isMobile
            // @app_url
            // @ad_src_top
            // @ad_src_bottom
            */

            var contentLoaded = 0
            $scope.os = msUtils.mobileOs()
            $scope.isMobile = msUtils.isMobile()

            switch (APP_NAME) {
              case 'busolinea':
                $scope.ad_src = 'assets/busolinea/images/other/busolinea-version1.jpg'
                if ($scope.os === 'ios') {
                  $scope.app_url = 'https://itunes.apple.com/us/app/busolinea-compare-bus-tickets/id957028884'
                } else {
                  $scope.app_url = 'https://play.google.com/store/apps/details?id=com.busolinea.app'
                }
                break
              case 'futura':
                $scope.ad_src = 'assets/futura/images/other/futura-version1.jpg'
                if ($scope.os === 'ios') {
                  $scope.app_url = 'https://itunes.apple.com/us/app/id1253518459?mt=8'
                } else {
                  $scope.app_url = false
                }
                break
            }

            // Places the ad
            $rootScope.$on('$viewContentLoaded', function (event, viewName, viewContent) {
              if ($rootScope.adActive) {
                $timeout(function () {
                  if (viewName === 'main@' && contentLoaded === 0) {
                    contentLoaded++
                    $scope.placeBottomAd()
                  }
                }, 0)
              }
            })
          }

          /**
           * Close top and bottom Ad
           */
          $scope.closeAd = function (ad) {
            angular.element('body').removeClass('mobile-' + ad)
            angular.element('#mobile-' + ad + '-section').removeClass('visible')
            if (ad === 'top') {
              angular.element('#main').css('padding-top', '0px')
              if (APP_NAME === 'busolinea') {
                $timeout(function () {
                  msUtils.setMainSearchHeight(0, 0)
                }, 0)
              }
            }
            $rootScope.adActive = false
          }

          $scope.placeBottomAd = function () {
            if ($scope.app_url) {
              angular.element('body').addClass('mobile-bottom')
              angular.element('#mobile-bottom-section').addClass('visible')
            }
          }

          $scope.adClick = function () {
            _ba.send('Download app ad clicked')
          }
        }
      }
    })
})();
(function () {
   'use strict';

    /**
     * Image Slider Component
     *
     * @param {string} title - Label to be displayed above the option.
     * @param {string} setTime - time to change images.
     * @param {boolean} showControls - Option's content, this goes inside the box.
     * @param {Object} images - Collection of images to be displayed.
     */

  angular
    .module('app.core')
    .directive('imageFadera', function ($interval) {

      function link(scope){

        var imagesOnly = scope.images.map(function(obj) { 
          return obj.resourceUrl;
        });

        var bgSwitcherConfig = {
          images: imagesOnly,
          interval: 0,
          start: false,
          loop: true,
          shuffle: false,
          effect: 'fade',
          duration: 1000,
          easing: 'swing'
        };

        var $el = $(".ng-fader").bgswitcher(bgSwitcherConfig);

        /*****************************************************
         STOP! NO FURTHER CODE SHOULD HAVE TO BE EDITED
         ******************************************************/
         
        if( imagesOnly !== undefined ){
          //Pagination dots - gets number of images
          scope.numberOfImages = imagesOnly.length;
          scope.dots = function(num) {
            return new Array(num);
          };

          //Pagination - click on dots and change image
          scope.selectedImage = 0;
          scope.setSelected = function (idx) {
            scope.stopSlider();
            scope.selectedImage = idx;
            $el.bgswitcher("select", idx);
          };

          //Slideshow controls
          scope.sliderBack = function() {
            scope.stopSlider();
            scope.selectedImage === 0 ? scope.selectedImage = scope.numberOfImages - 1 : scope.selectedImage--;
            $el.bgswitcher("select", scope.selectedImage);
          };

          scope.sliderForward = function() {
            scope.stopSlider();
            scope.autoSlider();
          };

          scope.autoSlider = function (){
            scope.selectedImage < scope.numberOfImages - 1 ? scope.selectedImage++ : scope.selectedImage = 0;
            $el.bgswitcher("select", scope.selectedImage);
          };

          scope.stopSlider = function() {
            $interval.cancel(scope.intervalPromise);
            scope.activePause = true;
            scope.activeStart = false;
          };

          scope.toggleStartStop = function() {
            if(scope.activeStart) {
              scope.stopSlider();
            } else {
              scope.startSlider();
            }
          };

          scope.startSlider = function(){
            scope.intervalPromise = $interval(scope.autoSlider, scope.setTime);
            scope.activeStart = true;
            scope.activePause = false;
          };
          scope.startSlider();
        }
      }

      return {
        restrict: 'E',
        scope: {
          showControls: '@',
          title: '@',
          setTime: '@',
          images: '='
        },
        templateUrl: 'app/core/directives/image-fadera/image-fadera.html',
        link: link
      };

    });

}());

(function () {
  'use strict';

  angular
    .module('app.core')
     .directive('homeSearchBox', function ($injector, $filter, $q, $timeout, $state, _ba, msUtils, $translate, Stations, GTM) {

      var APP_NAME = $injector.get('APP_NAME');
      return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/views/'+ APP_NAME +'/pages/home/home-search-box/home-search-box.html',
        scope: { },
        controller: function ($scope, $rootScope) {

          $rootScope.originStations = [];
          $rootScope.destinationStations = [];
          $rootScope.route = {
            originCityId: null,
            originCityParam: null,
            originCity: null,
            destinationCityId: null,
            destinationCityParam: null,
            destinationCity: null,
            departureDate: null,
            arrivalDate: null,
            requisition_id: null,
            outbound_route: {},
            return_route: {},
            outbound_ticket: {},
            return_ticket: {},
            coupon: {}
          }

          $scope.stations = {};
          $scope.originStations = [];
          $scope.destinationStations = [];

          $scope.simulateQuery = false;
          $scope.isDisabledOrigin = true;
          $scope.isDisabledDestination = true;
          $scope.currentDate = new Date();
          $scope.todayDate = $filter('date')($scope.currentDate, "yyyy-MM-dd");
          $scope.departureMinDate = new Date(
            $scope.currentDate.getFullYear(),
            $scope.currentDate.getMonth(),
            $scope.currentDate.getDate()
          );
          $scope.arrivalMinDate = $scope.departureMinDate;

          $scope.departureDate = null;
          $scope.arrivalDate = null;
          $scope.departureisOpen = false;
          $scope.arrivalisOpen = false;

          //Methods
          $scope.querySearchOrigin = querySearchOrigin;
          $scope.querySearchDestination = querySearchDestination;
          $scope.originCityChange = originCityChange;
          $scope.destinationCityChange = destinationCityChange;
          $scope.departureDateChange = departureDateChange;
          $scope.arrivalDateChange = arrivalDateChange;
          $scope.loadResults = loadResults;
          $scope.getCurrentDate = getCurrentDate;
          $scope.handleCalendar = handleCalendar;

          // Gets origin stations
          Stations.origins()
            .then(function(response){
              $scope.stations = response.data.stations;

              // Gets origin stations
              if ( !angular.isUndefined($scope.stations) ){
                var allStations = [];
                angular.forEach($scope.stations, function(value, key) {
                  if( value.is_origin == true )
                    this.push(value);
                }, allStations);

                $scope.originStations = allStations;
                $rootScope.originStations = allStations;
                $scope.isDisabledOrigin = false;
              }else{
                $translate('NOTIFICATION.ERRORS.ORIGINS')
                .then(function (error) {
                  msUtils.showNotification(error,'md-yellow-300-bg');
                  _ba.send('error', { "error": error });
                });
              }
            })
            .catch(onError);

          // Opens calendar date input
          function handleCalendar(open, route, ev){
            switch(route){
              case 'departure':
                $scope.departureisOpen = open;
                break;
              case 'arrival':
                if( open == false ){
                  $scope.arrivalDate = null;
                  $rootScope.route.arrivalDate = null;
                }else{
                  $scope.arrivalisOpen = open;
                }
                break;
            }
          }

          // Searches for stations
          function querySearchOrigin (query) {
            var results = query ? $scope.originStations.filter( createFilterFor(query) ) : $scope.originStations,
                deferred;
            deferred = $q.defer();
            deferred.resolve(results);
            return deferred.promise;
          }

          // Makes a query of stations and return the results
          function querySearchDestination (query) {
            var results = query ? $scope.destinationStations.filter( createFilterFor(query) ) : $scope.destinationStations,
                deferred;
            deferred = $q.defer();
            deferred.resolve(results);
            return deferred.promise;
          }

          // Handles an origin city change
          function originCityChange(item) {
            if ( typeof item !== 'undefined'){
              if ( item.name.length ){
                $rootScope.route.originCity = item.name;
                $rootScope.route.originCityId = item.id;
                $rootScope.route.originCityParam = item.param;
                clearDestinationField();
    		GTM.sendEvent('home', 'origen', item.name);
                _ba.send('origin selected',{ "origin":item.name });

                Stations.destinations(item.id)
                  .then(function(response){
                    $scope.destinationStations = response.data.stations;
                    $scope.isDisabledDestination = false;
                    $rootScope.destinationStations = $scope.destinationStations;
                    $timeout(function () { document.querySelector('#destination_city').focus();}, 100, false);
                  })
                  .catch(onError);
              }
            }else{
              clearDestinationField();
            }
          }

          // Handles a destination city change
          function destinationCityChange(item2) {
            if ( typeof item2 !== 'undefined'){
              if ( item2.name.length ){
                $rootScope.route.destinationCity = item2.name;
                $rootScope.route.destinationCityId = item2.id;
                $rootScope.route.destinationCityParam = item2.param;

    		GTM.sendEvent('home', 'destino', item2.name);
                _ba.send('destination selected',{ "destination":item2.name });

                var deferred = $q.defer();
                $timeout(function () { deferred.resolve( angular.element('#route_departure_date button').click() ); }, 0, false);
                return deferred.promise;
              }
            }
          }

          // Clears the destination input
          function clearDestinationField(){
            $timeout(function () {
              angular.element('#destination_city').val('');
              $scope.isDisabledDestination = false;
              $scope.searchText2 = '';
            }, 0, false);
          }

          // Creates filter function for a query string
          function createFilterFor(query) {
            var lowercaseQuery = msUtils.normalize(angular.lowercase(query));
            return function filterFn(station) {
              var stationLowerCase = msUtils.normalize(angular.lowercase(station.value));
              return (stationLowerCase.indexOf(lowercaseQuery) != -1);
            };
          }

          // Updates the departure date
          function departureDateChange(){
            $scope.arrivalDate = null;
            $rootScope.route.arrivalDate = null;
            $scope.arrivalMinDate = $scope.departureDate;
            $rootScope.route.departureDate = $scope.departureDate;

	    GTM.sendEvent('home', 'fechas-ida', $scope.departureDate);
            _ba.send('departure date selected',{ "departure_date":$scope.departureDate });
          }

          // Updates the arrival date
          function arrivalDateChange(){
            $rootScope.route.arrivalDate = $scope.arrivalDate;

	    GTM.sendEvent('home', 'fechas-vuelta', $scope.arrivalDate);
            _ba.send('arrival date selected',{ "arrival_date":$scope.arrivalDate });
          }

          // Gets the current date
          function getCurrentDate(){
            if( $scope.departureDate == null || $scope.departureDate == undefined ){
              $scope.departureDate = new Date(
                $scope.currentDate.getFullYear(),
                $scope.currentDate.getMonth(),
                $scope.currentDate.getDate()
              );
              $rootScope.route.departureDate = $scope.departureDate;
            }
          }

          // Goes to results page with the search data loaded
          function loadResults(){
            $rootScope.returnTravel = false;
            $rootScope.returnTicket = false;
            $rootScope.storedRoutes = false;
            if( $scope.departureDate == null || $scope.departureDate == undefined ){
              getCurrentDate();
              _ba.send('default date selected');
            }

            if( $rootScope.route.originCity != null && $rootScope.route.destinationCity != null ){
              var dates = $filter('date')($rootScope.route.departureDate, "yyyy-MM-dd");
              if($rootScope.route.arrivalDate){
                dates += ","+$filter('date')($rootScope.route.arrivalDate, "yyyy-MM-dd");
              }
              _ba.send('search for routes');
	      GTM.sendEvent('home', 'buscar');
              $state.go('app.routes', {
                origin: $rootScope.route.originCityParam,
                destination: $rootScope.route.destinationCityParam,
                dates: dates,
                lang: $rootScope.selectedLanguage
              }, { reload: true });
            }
          }

          /*
          *   ERROR HANDLING
          */

          // Handles the error callback
          function onError(error) {
            if(error !== undefined && error.status !== 500){
              if (error.status != 503){ // en mantenimiento
                if( error.data != null ){
                  var param = error.data.errors[0].param_name != null ? error.data.errors[0].param_name : '';
                  var title = error.data.errors[0].message != undefined ? error.data.errors[0].message : error.data.errors[0].title;
                  var message = param != '' ? param+', '+title : title;
                  msUtils.showNotification(message,'md-yellow-300-bg');
                  _ba.send('error', { "error": message });
                }else{
                  $translate('NOTIFICATION.ERRORS.TIMEOUT').then(function (error) {
                    msUtils.showNotification(error,'md-yellow-300-bg');
                    _ba.send('error', { "error": error });
                  });
                }
              }
            }else{
              $translate('NOTIFICATION.ERROR500.NOTIFICATION').then(function (error) {
                  msUtils.showNotification(error,'md-yellow-300-bg');
                  _ba.send('error', { "error": error });
                });
            }
            angular.element('#subscribe_btn').removeAttr('disabled','disabled');
          }

        }// end controller

      };

    });

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('filterSidebar', function ($injector) {
      
      var APP_NAME = $injector.get('APP_NAME');
      return {
        restrict: 'E',
        templateUrl: 'app/views/'+ APP_NAME +'/pages/routes/filter-sidebar/filter-sidebar.html',
        replace: true,
        scope: {
          routes: '=',
          filterTimeOutbound: '=',
          filterTimeReturn: '=',
          timeMin: '=',
          timeMax: '=',
          cabinTypesRoute: '=',
          localpasoRoute: '=',
          busCompaniesOutboundRoute: '=',
          busCompaniesReturnRoute: '='
        },
        link: function ($scope) {

        }
      };

    });
})();

(function () {
  'use strict';

  /**
   * Time Selector Component
   *
   * @param {Object} selection - Option selected, should be included on collection.
   * @param {Object[]} collection - Options collection.
   * @param {string} collection[].id - Option's identifier.
   * @param {string} collection[].name - Name to be displayed for this option.
   */

  angular

    .module('app.core')

    .directive('filterInline', function () {

      return {

        restrict: 'E',

        templateUrl: 'app/core/directives/filter-inline/templates/filter-inline.html',

        scope: {

          collection: '=',

          selection: '='

        },

        link: function ($scope) {

          $scope.filterClick = function (option) {
            $scope.selection = option;
          };

        }

      };

    });

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('analyticsOn', function (GTM) {

      return {
        restrict: 'A',
        link: function ($scope, $element, $attrs) {
          var eventType = $attrs.analyticsOn || 'click';
          var trackingData = {};
          
          angular.forEach($attrs.$attr, function(attr, name) {
            if (isProperty(name)) {
              trackingData[propertyName(name)] = $attrs[name];
              $attrs.$observe(name, function(value){
                trackingData[propertyName(name)] = value;
              });
            }
          });

          angular.element($element[0]).bind(eventType, function ($event) {
            var eventName = $attrs.analyticsEvent || inferEventName($element[0]);
            trackingData.eventType = $event.type;

            // Allow components to pass through an expression that gets merged on to the event properties
            // eg. analytics-properites='myComponentScope.someConfigExpression.$analyticsProperties'
            if($attrs.analyticsProperties){
              angular.extend(trackingData, $scope.$eval($attrs.analyticsProperties));
            }
            GTM.eventTrack(eventName, trackingData);
          });

          function isCommand(element) {
            return ['a:','button:','button:button','button:submit','input:button','input:submit'].indexOf(
              element.tagName.toLowerCase()+':'+(element.type||'')) >= 0;
          }

          function inferEventType(element) {
            if (isCommand(element)) return 'click';
            return 'click';
          }

          function inferEventName(element) {
            if (isCommand(element)) return element.innerText || element.value;
            return element.id || element.name || element.tagName;
          }

          function isProperty(name) {
            return name.substr(0, 9) === 'analytics' && ['On', 'Event', 'If', 'Properties', 'EventType'].indexOf(name.substr(9)) === -1;
          }

          function propertyName(name) {
            var s = name.slice(9); // slice off the 'analytics' prefix
            if (typeof s !== 'undefined' && s!==null && s.length > 0) {
              return s.substring(0, 1).toLowerCase() + s.substring(1);
            }
            else {
              return s;
            }
          }

        }
      }

    });
})();
(function ()
{
    'use strict';

    angular
        .module('app.terms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $injector)
    {
        var APP_NAME = $injector.get('APP_NAME');
        // State
        $stateProvider.state('app.terms', {
            url      : '/terminos-y-condiciones?lang',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/views/'+ APP_NAME +'/layouts/default-navigation-nosearchbar.html',
                    controller : 'MainController as vm'
                },
                'toolbar@app.terms'   : {
                    templateUrl: 'app/views/'+ APP_NAME +'/elements/toolbar/toolbar.html',
                    controller : 'ToolbarController as vm'
                },
                'content@app.terms': {
                    templateUrl: 'app/views/'+ APP_NAME +'/pages/terms/terms.html',
                    controller : 'TermsController as vm'
                },
                'notifications@app.terms': {
                    templateUrl: 'app/views/'+ APP_NAME +'/elements/notifications/notification.html',
                    controller : 'NotificationController as vm'
                },
                'sidebar_left@app.terms': {
                    templateUrl: 'app/views/'+ APP_NAME +'/elements/sidebar_left/sidebar_left.html',
                    controller : 'SideBarLeftController as vm'
                }
            },
            bodyClass: {app: APP_NAME+'_app', page: 'terms'},
        });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.terms')
        .controller('TermsController', TermsController);

    /** @ngInject */
    function TermsController($rootScope, msUtils)
    {
        var vm = this;


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.seats', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $injector)
    {
        var APP_NAME = $injector.get('APP_NAME');
        // State
        $stateProvider.state('app.seats', {
            url      : '/asientos?lang',
            views    : {
                'content@app': {
                    templateUrl: 'app/views/'+ APP_NAME +'/pages/seats/seats.html',
                    controller : 'SeatsController as vm'
                }
            },
            bodyClass: {app: APP_NAME+'_app', page: 'seats'},
            data : {
                meta:{
                    'busolinea':{
                        page_title: 'META.SEATS.TITLE'
                    },
                    'futura':{
                        page_title: 'Asientos Ida | Futura'
                    },
                    'geb':{
                        page_title: 'Asientos Ida | Grupo Estrella Blanca'
                    },
                    'transportamex':{
                        page_title: 'META.SEATS.TITLE'
                    }
                }
            }
        });

    }

})();
(function () {
  'use strict';

  angular
    .module('app.seats')
    .controller('SeatsController', SeatsController);

    /** @ngInject */
    function SeatsController($scope, $rootScope, $filter, $document, $compile, $q, $timeout, $state, $translate, msUtils, api, GTM, $injector, _ba, $window) {

    var vm = this;
    var APP_NAME = $injector.get('APP_NAME');
    var APP_TITLE = $injector.get('APP_TITLE');

    $rootScope.returnTicket = false;
    $rootScope.route.coupon.coupon = {'code': ''};

    vm.prereservationLocked = false;

    vm.seatsIda = [];
    vm.seatsRegreso = [];
    vm.seatsLoading = [];

    vm.outboundRouteIsComplete = false;
    vm.returnRouteIsComplete = false;

    vm.selectedSeatsOutboundRoute = [];
    vm.selectedSeatsReturnRoute = [];

    //Timer
    vm.timeoutSelection = null
    vm.showTimer = false;
    vm.remainReservationTime = 0;

    //Captcha
    vm.showCaptcha = false;
    vm.captchaToken = null;
    vm.isFirstSeat = true; 
    vm.dataToContinue= null;

    // Methods
    vm.seatSelection = seatSelection;
    vm.removeSelection = removeSelection;
    vm.seatUpdate = seatUpdate;
    vm.continueToCheckout = continueToCheckout;
    vm.focusSearch = focusSearch;
    vm.confirmCaptcha = confirmCaptcha;    
    //////////

    init();

    function init(){

      // Gets the seats layout for the selected route
      api.seats.profile.create({requisition_id: $rootScope.route.requisition_id, outbound_route_id: $rootScope.route.outbound_route.id, step:'seats_selection',session_id: $rootScope.route.session_id},
        function(response){
          //console.log('make profile')
        },
        function(error){
          console.log('error profile',error)
        }
      )
        
      loadSeats()
      $scope.$on('clearAllSeatsEvent', function(){
        clearAllSeats(false)
      });
      $scope.$watch(function () {
        return $rootScope.paymentExitDialog;
      }, function (exit) {
        if (exit) {
          clearAllSeats(true)
        }
      });   
    }

    function loadSeats() {
      api.seats.seats.get({requisition_id: $rootScope.route.requisition_id, outbound_route_id: $rootScope.route.outbound_route.id, return_route_id: $rootScope.route.return_route.id},
        function(response){
          _ba.send('seats listed');

          vm.seatsOutbound = response.data.outbound_route;
          vm.seatsReturn = response.data.return_route;

          $rootScope.route.outbound_route.seatslimit = response.data.outbound_route.available.ad;
          if( $rootScope.returnTravel ){
            $rootScope.route.return_route.seatslimit = response.data.outbound_route.available.ad;
          }
          vm.seatsIda = vm.seatsOutbound.seats;
          vm.seatsRegreso = vm.seatsReturn.seats;
          if( vm.seatsIda.length == 0 )
            removeLoading();
        },
        function(error){
          onError(error);
        }
      );
    }

    /*
    *  FOR ELEMENTS IN SEATS PAGE
    */

    // Sends a broadcast to be listened by the searchbar controller and set the focus over departure field
    function focusSearch(){
        $rootScope.$broadcast('searchbarController::editSearch');
        _ba.send('edit search button clicked');
    }

    // Removes the loading animation if error
    function removeLoading(){
        if( angular.element('#loader').is(':visible') ){
            angular.element('.view-content #loader').after('<div id="after-loading-msg"><p translate="NOTIFICATION.ERRORS.ROUTES"></p><md-button class="md-button btn btn-default" type="button" ng-click="vm.focusSearch()" translate="NOTIFICATION.DIALOG.BUTTON.EDIT_SEARCH"></md-button></div>');
            var element = angular.element('#after-loading-msg');
            $compile(element.contents())($scope);
        }
        angular.element('#loader').hide();
    }


    /*
    *  FOR SEATS SELECTION
    */

    // Removes a seat
    function removeSelection(obj, selectedSeats) {
      if( vm.prereservationLocked == false ){
        var seat = obj.seat;

        if (seat.isLoading) {
          return;
        }
        

        seat.isLoading = true;

        angular.element('.buttons .md-button').attr('disabled','disabled');

  	    seatReservation(seat.number, 'delete', seat.id)
          .then(function (response) {
            seat.isLoading = false;
            seat.isSelected = false;
            var indexOfSeat = selectedSeats.indexOf(seat);
            selectedSeats.splice(indexOfSeat, 1);
            vm.returnRouteIsComplete = selectedSeats.length < vm.selectedSeatsOutboundRoute.length ? false : true;

            if ( selectedSeats.length == 0 || vm.returnRouteIsComplete == false ){
              angular.element('.buttons .md-button').attr('disabled','disabled');
            }else{
              angular.element('.buttons .md-button').removeAttr('disabled');
              $timeout( function(){
                angular.forEach(selectedSeats, function(value, key) {
                  if (value.name.trim().split(' ').length < 2) {
                    angular.element('.buttons .md-button').attr('disabled','disabled');
                  }
                });
              }, 0);
            }
          })
          .catch(function(error){
            seat.isLoading = false;
            seat.isSelected = false;
            onError(error);
          });

  	    GTM.sendRemoveCart(seat.id);
        _ba.send('seat removed',{ "seat_id":seat.id, "seat_num":seat.number });

      }
    };

    function clearAllSeats (redirect) {            
      vm.selectedSeatsOutboundRoute.forEach(function(seat){
        removeSelection({seat:seat},vm.selectedSeatsOutboundRoute);
      });
      vm.selectedSeatsReturnRoute.forEach(function(seat){
        removeSelection({seat:seat},vm.selectedSeatsReturnRoute);
      });
      vm.showTimer=false   ;
      vm.outboundRouteIsComplete=false;
      vm.returnRouteIsComplete=false;
      $rootScope.returnTicket = false;
      var dates = $filter('date')($rootScope.route.departureDate, 'yyyy-MM-dd');
      if ($rootScope.route.arrivalDate) {
        dates += ',' + $filter('date')($rootScope.route.arrivalDate, 'yyyy-MM-dd');
      }
      if (redirect) {
        $state.go('app.routes', {
          origin: $rootScope.route.originCityParam,
          destination: $rootScope.route.destinationCityParam,
          dates: dates,
          lang: $rootScope.selectedLanguage === 'en' ? 'en' : ''
        }, {reload: true}); 
      }      
    }

    function confirmCaptcha(params) {
      vm.captchaToken = params;
      vm.isFirstSeat = false;
      vm.showCaptcha = false;
      seatSelection(vm.dataToContinue.obj,vm.dataToContinue.selectedSeats,vm.dataToContinue.route_id)
    }

    // Selects a seat sending data to the API
    function seatSelection(obj, selectedSeats, route_id) {
      /*if (vm.isFirstSeat) {
        vm.showCaptcha = true;
        vm.dataToContinue= {
          obj: obj,
          selectedSeats: selectedSeats,
          route_id: route_id
        }
        return;
      }*/
      if( vm.prereservationLocked == false ){
          var seat = obj.seat;
          var totalSeats = $rootScope.returnTicket == false ? 5 : vm.selectedSeatsOutboundRoute.length;
          if (seat.isLoading) {
            return;
          }

          _ba.send('seat clicked', {"seat_id":seat.id, "seat_num":seat.number});

          if (seat.isSelected) {                        
            removeSelection(obj, selectedSeats);
          } else {
            //console.log("select:"+' '+vm.returnRouteIsComplete);
                        
            if( selectedSeats.length < totalSeats ){
              angular.element('.buttons .md-button').attr('disabled','disabled');
              seat.isLoading = true;
              seat.isSelected = true;

              seatReservation(seat.number, 'create', null, route_id)
                .then(function (response) {
                  if (!response.data.seat_reservation.prices) {
                    return onError();
                  }

                  seat.isLoading = false;
                  seat.id = response.data.seat_reservation.id;
                  seat.prices = response.data.seat_reservation.prices;
                  seat.ticket_type = 'ad'; // default
                  seat.route_id = route_id;

                  GTM.sendAddToCart($rootScope.route, seat);
                  _ba.send('seat prereserved', {"seat_id":seat.id, "seat_num":seat.number});
                  if (selectedSeats.length === 0) {
                    //console.log('aqui se agrega el timer')
                    vm.showTimer = true;              
                    $scope.$on('timer-stopped', function (event, data) {
                      clearAllSeats()                      
                    });  
                    $scope.$on('timer-tick', function (event, data) {
                      vm.remainReservationTime = Math.floor(data.millis / 1000)
                    });          
                  }
                  selectedSeats.push(seat);

                  if ($rootScope.returnTravel == true && $rootScope.returnTicket == true){

                    _.map(selectedSeats, function(so, idx){
                      vm.returnRouteIsComplete = selectedSeats.length < vm.selectedSeatsOutboundRoute.length ? false : true;
                      //console.log("map:"+' '+vm.returnRouteIsComplete);
                      if (selectedSeats.length <= vm.selectedSeatsOutboundRoute.length){
                        $timeout( function(){
                          so.name = vm.selectedSeatsOutboundRoute[idx].name;
                          so.ticket_type = vm.selectedSeatsOutboundRoute[idx].ticket_type;
                          so.isComplete = true;
                          var lastSeat = _.last(selectedSeats);
                          if (selectedSeats.length == vm.selectedSeatsOutboundRoute.length){
                            angular.element('.buttons .md-button').removeAttr('disabled');
                          }
                        }, 0);
                      }
                    });

                  }

                })
                .catch(function(error){
                  seat.isLoading = false;
                  seat.isSelected = false;
                  if( error.status == 422 ){
                    seat.seat_type = "occupied"
                    //loadSeats()
                  }
                  onError(error);
                });
            }else{
              seat.isLoading = false;
              seat.isSelected = false;
              _ba.send('seats limit reached');
            }
          }

      }
    }

    // Updates seat information sending data to the API
    function seatUpdate(obj, selectedSeats) {
      angular.element('.buttons .md-button').removeAttr('disabled');

      if( vm.prereservationLocked == false ){
        var seat = obj.seat;
        seat.isComplete = false;

        if( seat.name.trim().split(' ').length > 1){
          seat.isComplete = true;
        }
	  var availableByType = {};
	  seat.prices.forEach(function (price) {
	      availableByType[price.type] = price.slots;
	  });

        _.map(selectedSeats, function(so, idx){
            $timeout( function(){
		var numTicketType = 0;
		selectedSeats.forEach(function (st){
		    if (st.ticket_type == seat.ticket_type) numTicketType += 1;
		});
		if (numTicketType > availableByType[seat.ticket_type]){
		    onError({status: 422, data: {errors: [{param_name: "ticket_type", message: seat.ticket_type }]}});
		    seat.ticket_type = "ad";
		}

            if (so.name.trim().split(' ').length < 2) {
              so.isComplete = false;
              angular.element('.buttons .md-button').attr('disabled','disabled');

              if ($rootScope.returnTravel == true && $rootScope.returnTicket == true){
                vm.returnRouteIsComplete = false;
                //console.log("update:"+' '+vm.returnRouteIsComplete);
              }
            }else{
              if ($rootScope.returnTravel == true && $rootScope.returnTicket == true){
                vm.returnRouteIsComplete = selectedSeats.length < vm.selectedSeatsOutboundRoute.length ? false : true;
                if (vm.returnRouteIsComplete == false )
                  angular.element('.buttons .md-button').attr('disabled','disabled');
                //console.log("update:"+' '+vm.returnRouteIsComplete);
              }
            }
          }, 0);

        });


      }
    };


    /*
    *  FOR SEAT PRERESRVATION AND RESERVATION
    */

    // Makes a seats prereservation and continues to the payment page
    function continueToCheckout() {
      if( vm.prereservationLocked == false ){
        angular.element('.buttons').addClass('loading');
        if( vm.outboundRouteIsComplete ){
      	  if( $rootScope.returnTravel ){
            if( $rootScope.returnTicket ){

              if( vm.returnRouteIsComplete ){
                _ba.send('return checkout button clicked');
                // preReservation request
                var selectedSeats = [];
                _.map(vm.selectedSeatsOutboundRoute, function(obj, key) {
                  selectedSeats.push(obj);
                });
                _.map(vm.selectedSeatsReturnRoute, function(obj, key) {
                  selectedSeats.push(obj);
                });

                preReservation(selectedSeats)
                  .then(prereservationCallback)
                  .catch(onError);
              }else{
                msUtils.showNotification('Ruta de regreso no está completa: '+vm.returnRouteIsComplete,'md-yellow-300-bg');
                angular.element('.buttons').removeClass('loading');
              }

            }else{
              //Changes page title
              $rootScope.ngMeta[APP_NAME].page_title = 'Asientos Regreso | '+APP_TITLE;
              _ba.send('outbound checkout button clicked');
              $rootScope.returnTicket = true;
              angular.element('.buttons').removeClass('loading');
            }
          }else{
            _ba.send('outbound checkout button clicked');
            // preReservation request
            preReservation(vm.selectedSeatsOutboundRoute)
              .then(prereservationCallback)
              .catch(onError);
          }
        }else{
          $translate('NOTIFICATION.ERRORS.BLANK_INPUTS').then(function (error) {
            msUtils.showNotification(error,'md-yellow-300-bg');
            _ba.send('error', { "error": error });
          });
          angular.element('.buttons').removeClass('loading');
        }
      }
    };

    // Seats prereservation callback function on prereservation successful response
    function prereservationCallback(response){
      if( response ){
        $rootScope.route.prereservation = response.data.prereservation;
        $rootScope.route.total_amount = response.data.prereservation.total;
        $rootScope.reservationActive = true;
        $rootScope.remainReservationTime = vm.remainReservationTime
        GTM.sendCheckout(response.data.prereservation.outbound_route.seat_reservations
		       .concat(response.data.prereservation.return_route.seat_reservations),
           $rootScope.route.total_amount); 
        $window.onbeforeunload= function() {        
            
        };      
        $state.go('app.payment', {
          lang: $rootScope.selectedLanguage == 'en' ? 'en' : ''
        }, { reload: false });
      }
    }

    // Makes seats prereservation API request
    function preReservation(selectedSeats){
      var defered = $q.defer();
      var promise = defered.promise;
      vm.prereservationLocked = true;
      // API request for seat reservation

      api.seats.prereservation.make({
        requisition_id: $rootScope.route.requisition_id,
        seat_reservations: selectedSeats
      },
         function (response){
             defered.resolve(response);
             vm.prereservationLocked = false;
         },
         function (error){
             defered.reject(error);
             vm.prereservationLocked = false;
         }
      );
      return promise;
    }

    // Makes seats reservation API request
    function seatReservation(num, action, seat_id, route_id) {
      var defered = $q.defer();
      var promise = defered.promise;

      switch(action){
        case 'create':
          // API request for seat reservation
          api.seats.seat_reservation.create({
              requisition_id: $rootScope.route.requisition_id,
              route_id: route_id,
              number: num
            },
            function (response) {
              defered.resolve(response);
            },
            function (error) {
              defered.reject(error);
            }
          );
          break;
      case 'delete':
        // API request for cancel seat reservation
        api.seats.seat_reservation.delete({id: seat_id, requisition_id: $rootScope.route.requisition_id},
          function (response) {
            defered.resolve(response);
          },
          function (error) {
            defered.reject(error);
          }
        );
        break;
      }
      return promise;
    }


    /*
    *   ERROR HANDLING
    */

    // Handles the error callback
    function onError(error) {
      if(error !== undefined && error.status !== 500){
        if( error.data !== null ){
          var param = error.data.errors[0].param_name != null ? error.data.errors[0].param_name : '';
          var title = error.data.errors[0].message != undefined ? error.data.errors[0].message : error.data.errors[0].title;
          var message = param != '' ? param+', '+title : title;

	        if (param === "ticket_type"){
		        $translate('NOTIFICATION.ERRORS.OUT_OF_STOCK.' + title).then(function (error) {
		          msUtils.showNotification(error,'md-yellow-300-bg');
		          _ba.send('error', { "error": error });
		        });
	        } else if(param === 'ChildrenTravellingAlone') {
            msUtils.showNotification('Los niños deben viajar en compañía de un adulto.','md-yellow-300-bg');
            _ba.send('error', { "error": error });
          } else {
		        msUtils.showNotification(message,'md-yellow-300-bg');
            _ba.send('error', { "error": message });
            if (message === 'Tu sesión ha expirado. Por favor realiza tu búsqueda nuevamente.') {
              setTimeout(clearAllSeats(),5000)              
            }
	        } 
        }else{
          $translate('NOTIFICATION.ERRORS.TIMEOUT').then(function (error) {
            msUtils.showNotification(error,'md-yellow-300-bg');
            _ba.send('error', { "error": error });
          });
        }
      }else{
        $translate('NOTIFICATION.ERROR500.NOTIFICATION').then(function (error) {
            msUtils.showNotification(error,'md-yellow-300-bg');
            _ba.send('error', { "error": error });
          });
      }
      angular.element('.buttons').removeClass('loading');
      if( vm.seatsIda.length == 0 )
        removeLoading();
      }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.routes')
        .controller('RoutesController', RoutesController);

    /** @ngInject */
    function RoutesController($scope, $rootScope, $stateParams, msUtils, $mdSidenav, $mdDialog, $mdToast, $translate, $location, $q, $filter, $state, api, GTM, $injector, CONST, $compile, $timeout, $cookies, _ba, moment, Stations)
    {
        var vm = this;

        //Data
        var APP_NAME = $injector.get('APP_NAME');
        var APP_TITLE = $injector.get('APP_TITLE');

        $rootScope.returnTravel = false;
        $rootScope.returnTicket = false;

        if( typeof $rootScope.route != 'undefined' ) {
            $rootScope.route.return_route = {id:null};
            $rootScope.route.return_ticket = null;

            //  Save coupon code to use it later or initialize it
            if ($stateParams.code){
                $rootScope.route.coupon = {
                    code: $stateParams.code
                };
            }else{
                $rootScope.route.coupon = {};
            }
        }

        var storedRoutes = $rootScope.storedRoutes;
        var originId = $rootScope.route.originCityId;
        var destinationId = $rootScope.route.destinationCityId;
        var departureDate = null;
        var arrivalDate = null;
        var dates = null;
	    var addToTimeSelector;


        vm.routes = '';
        vm.timeMin = 0;
        vm.timeMax = 24;
        vm.cabinTypes = [];
        vm.cabinTypesRoute = [];
        vm.localpasoRoute = [];
        vm.busCompanies = [];
        vm.busCompaniesOutboundRoute = [];
        vm.busCompaniesReturnRoute = [];

        vm.orinfo = '-1';
        vm.filterTimeOutbound = [
        {
            label: 'Madrugada',
            display: 0,
            value: false,
            range: {
                min: 0,
                max: 7
            },
            footer: '00:00',
            show: true,
            active: true
        },
        {
            label: 'Mañana',
            display: 0,
            value: false,
            range: {
                min: 7,
                max: 12
            },
            footer: '07:00',
            show: true,
            active: true
        },
        {
            label: 'Tarde',
            display: 0,
            value: false,
            range: {
                min: 12,
                max: 19
            },
            footer: '12:00',
            show: true,
            active: true
        },
        {
            label: 'Noche',
            display: 0,
            value: false,
            range: {
                min: 19,
                max: 24
            },
            footer: '19:00',
            show: true,
            active: true
        },
        {
            label: 'Todas',
            display: 0,
            value: true,
            range: {
                min: 0,
                max: 24
            },
            footer: '00:00',
            show: true,
            active: true
        }
        ];

        vm.filterTimeReturn = [
        {
            label: 'Madrugada',
            display: 0,
            value: false,
            range: {
                min: 0,
                max: 7
            },
            footer: '00:00',
            show: true,
            active: true
        },
        {
            label: 'Mañana',
            display: 0,
            value: false,
            range: {
                min: 7,
                max: 12
            },
            footer: '07:00',
            show: true,
            active: true
        },
        {
            label: 'Tarde',
            display: 0,
            value: false,
            range: {
                min: 12,
                max: 19
            },
            footer: '12:00',
            show: true,
            active: true
        },
        {
            label: 'Noche',
            display: 0,
            value: false,
            range: {
                min: 19,
                max: 24
            },
            footer: '19:00',
            show: true,
            active: true
        },
        {
            label: 'Todas',
            display: 0,
            value: true,
            range: {
                min: 0,
                max: 24
            },
            footer: '00:00',
            show: true,
            active: true
        }
        ];

        // Methods
        vm.toggleSidebar = toggleSidebar;
        vm.selectRoute = selectRoute;
        vm.focusSearch = focusSearch;
        vm.EbSearch = EbSearch;

        //////////

        init();


        function init(){
            //Cleans the requisition_id if exists
            if( $rootScope.route.prereservation == undefined ){
                if( $rootScope.route.requisition_id != null ){
                    clearRequisitionId();
                }
            }else{
                delete $rootScope.route.prereservation;
                delete $rootScope.storedRoutes;
                storedRoutes = null;
            }

            // Getting dates
            // Get departure date from rootScope or url
            if( $rootScope.route.departureDate ){
                departureDate = moment($rootScope.route.departureDate).endOf('day').toDate();
                if( moment(departureDate).isBefore(moment().endOf('day').toDate()) ){
                    $state.go('app.home');
                }
            }else{
                if($stateParams.dates){
                    var dates = $stateParams.dates.split(',');
                    departureDate = moment(dates[0]).endOf('day').toDate();
                    if( moment(departureDate).isBefore(moment().endOf('day').toDate()) ){
                        $state.go('app.home');
                    }
                    $rootScope.route.departureDate = departureDate;
                }else{
                    departureDate = moment().endOf('day').toDate();
                    $rootScope.route.departureDate = departureDate;
                    arrivalDate = null;
                }
            }

            // Get arrival date from rootScope or url
            if( $rootScope.route.arrivalDate ){
                arrivalDate = moment($rootScope.route.arrivalDate).endOf('day').toDate();
                $rootScope.returnTravel = true;
            }else{
                if (dates){
                    if( dates[1] ){
                        arrivalDate = moment(dates[1]).endOf('day').toDate();
                        $rootScope.route.arrivalDate = arrivalDate;
                        $rootScope.returnTravel = true;
                    }else{
                        arrivalDate = null;
                    }
                }else{
                    arrivalDate = null;
                }
            }


            if( originId == null || destinationId == null ){
                if ($stateParams.origin && $stateParams.destination) {
                    getRouteIds($stateParams.origin, $stateParams.destination);   
                } else {
                    if ($rootScope.route.originName && $rootScope.route.destinationName) {
                        //console.log('searching routes',$rootScope.route.originName, $rootScope.route.destinationName)
                        getRouteIds($rootScope.route.originName, $rootScope.route.destinationName);   
                    }
                }
            }else{
                //Changes page title
            $translate('META.ROUTES.TITLE', {origin: $rootScope.route.originCity, destination: $rootScope.route.destinationCity, app_title: APP_TITLE})
            .then(function (translatedValue) {
                $rootScope.ngMeta[APP_NAME].page_title = translatedValue;
              });
                getRoutes(originId, destinationId, departureDate, arrivalDate, storedRoutes)
                    .then(routesCallback)
                    .catch(onError);
            }

            // Code to execute when Main view is already loaded
            $scope.$on('$viewContentLoaded', function(event, viewName, viewContent) {
                $timeout(function() {
                    if(viewName == 'content@app'){

                        if( $rootScope.analytics.ga_id == null ){
                            if( $cookies.get('_ga') ){
                              var ga_id_strings = $cookies.get('_ga').split('.');
                              if( ga_id_strings[2] && ga_id_strings[3]){
                                var ga_id =  ga_id_strings[2].concat('.'+ ga_id_strings[3]);
                                $rootScope.analytics.ga_id = ga_id;
                              }
                            }
                            $rootScope.analytics.campaign = $stateParams.utm_temporary ? $stateParams.utm_temporary : $stateParams.utm_campaign ? $stateParams.utm_campaign : null;
                        }

                    }
                },0);
            });

        }



        /*
        *   FOR ELEMENTS IN ROUTES PAGE
        */

        // Sends a broadcast to be listened by the searchbar controller and set the focus over departure field
        function focusSearch(cast){
            $rootScope.$broadcast('searchbarController::'+cast);
            _ba.send('edit search button clicked');
        }

        // go to estrella blanca web site to search for routes
        function EbSearch(){
            _ba.send('Estrella blanca search button clicked');
            var url = CONST.DEPLOYMENT_ENVIRONMENT === 'production' ? 'https://estrellablanca.com.mx/' : 'https://geb.testhebus.info/'

            // var path = url+$stateParams.origin+'/'+$stateParams.destination+'?dates='+$stateParams.dates;
            window.location = url; // path;
        }

        // Removes the loading animation if error
        function removeLoading(){
            if( angular.element('#loader').is(':visible') ){
                if (APP_NAME !== 'busolinea' && APP_NAME !== 'geb') {
                    angular.element('.view-content #loader').after('<div id="after-loading-msg"><p translate="NOTIFICATION.ERRORS.ROUTES_EB"></p><md-button class="md-primary btn-default" type="button" ng-click="vm.EbSearch()" aria-label="search" translate="NOTIFICATION.DIALOG.BUTTON.EB_SEARCH"></md-button></div>');
                }else{
                    angular.element('.view-content #loader').after('<div id="after-loading-msg"><p translate="NOTIFICATION.ERRORS.ROUTES"></p><md-button class="md-primary btn-default" type="button" ng-click="vm.focusSearch(\'editSearch\')" aria-label="search" translate="NOTIFICATION.DIALOG.BUTTON.EDIT_SEARCH"></md-button></div>');
                }
                var element = angular.element('#after-loading-msg');
                $compile(element.contents())($scope);
            }
            angular.element('#loader').hide();
        }

        // Removes the loading animation and shows a custom error
        function noDestinationError(){
            if( angular.element('#loader').is(':visible') ){
                angular.element('.view-content #loader').after('<div id="after-loading-msg"><p translate="NOTIFICATION.ERRORS.DESTINATIONS"></p><md-button class="md-primary btn-default" type="button" ng-click="vm.focusSearch(\'editDestinationSearch\')" aria-label="search" translate="NOTIFICATION.DIALOG.BUTTON.EDIT_SEARCH"></md-button></div>');
                var element = angular.element('#after-loading-msg');
                $compile(element.contents())($scope);
            }
            angular.element('#loader').hide();
        }

        // Time selector filter fix
        function addToTimeSelector(filter, time, orinfo) {
    	    var mtime = time;
    	    $.each(filter, function(index, value){
        		if (mtime <= value.range.max * 100 && mtime > value.range.min * 100 && (orinfo == vm.orinfo || orinfo == null) ){
                    filter[index].display = value.display + 1;
        		}
    	    });
        }


        // Toggles mobile sidebar
        function toggleSidebar(sidenavId){
            $mdSidenav(sidenavId).toggle();
        }

        // Handles toasts
        function handleToasts(){
            getLastReservation()
                .then(function(response){
                    showToasts(response);
                }, function(error) {
                    // error handler
                    showToasts(undefined);
                })
                .catch(function(error){
                    showToasts(undefined);
                    //console.log(error);
                });
        }

        // Shows the toast windows on top right
        function showToasts(data){
            var city = data != undefined ? data.data.city : undefined;
            setTimeout(function(){
                $mdToast.show({
                    templateUrl : 'app/views/'+ APP_NAME +'/pages/routes/toasts/recent-toast.html',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#main',
                    locals: { city: city },
                    controller : 'ToastController',
                    controllerAs : 'vm'
                });
            }, 1000);
            setTimeout(function(){
                $mdToast.show({
                    templateUrl : 'app/views/'+ APP_NAME +'/pages/routes/toasts/route-toast.html',
                    hideDelay: 6000,
                    position : 'top right',
                    parent   : '#main',
                    locals: { city: undefined },
                    controller : 'ToastController',
                    controllerAs : 'vm'
                });
            }, 2000);
        }

        // Gets the last reservation for the toast window
        function getLastReservation(){
            var defered = $q.defer();
            var promise = defered.promise;
            api.routes.last.get({},
                //Success
                function(response){
                    //console.log(response);
                    defered.resolve(response);
                },
                //Error
                function(error){
                    //console.log(error);
                    defered.reject(error);
                }
            );
            return promise;
        }



        /*
        *   FOR ROUTES LIST
        */

        // Gets the routes from the API
        function getRoutes(originId, destinationId, departureDate, arrivalDate, storedRoutes){
            var defered = $q.defer();
            var promise = defered.promise;
            if( storedRoutes ){
                defered.resolve(storedRoutes);
            }else{
                var departureDateFormated = departureDate !== null ? moment(departureDate).format('YYYY-MM-DD') : null;
                var arrivalDateFormated = arrivalDate !== null ? moment(arrivalDate).format('YYYY-MM-DD') : null;
                api.routes.routes.get({
                  origin_id: originId,
                  destination_id: destinationId,
                  date: departureDateFormated,
                  return_date: arrivalDateFormated,
                  domain: APP_NAME
                },
                  //Success
                  function(response){
                    //console.log(response);
                    defered.resolve(response);
                  },
                  //Error
                  function(error){
                    //console.log(error);
                    defered.reject(error);
                  }
                );
            }
            return promise;
        }

        // Gets the routes from the API using the param name
        function getRouteIds(origin, destination){
            // Gets origin station
            Stations.station(origin)
                .then(function(response){
                    if( response.data.station.id ){
                        $rootScope.route.originCityId = response.data.station.id;
                        $rootScope.route.originCity = response.data.station.name;
                        $rootScope.route.originCityParam = response.data.station.param;
                        $rootScope.$broadcast('searchbarController::editDestinationSearch');
                        $rootScope.route.originCityGroup = {
                            'display': $rootScope.route.originCity,
                            'id': $rootScope.route.originCityId,
                            'param': $rootScope.route.originCityParam
                        }
                        var originId = response.data.station.id;
                        // Get destination station
                        Stations.station(destination)
                            .then(function(response){
                                if( response.data.station.id ){
                                    $rootScope.route.destinationCityId = response.data.station.id;
                                    $rootScope.route.destinationCity = response.data.station.name;
                                    $rootScope.route.destinationCityParam = response.data.station.param;
                                    $rootScope.route.destinationCityGroup = {
                                        'display': $rootScope.route.destinationCity,
                                        'id': $rootScope.route.destinationCityId,
                                        'param': $rootScope.route.destinationCityParam
                                    }
                                    var destinationId = response.data.station.id;
                                    // Changes page title
                				    $translate('META.ROUTES.TITLE', {
                              origin: $rootScope.route.originCity,
                              destination: $rootScope.route.destinationCity,
                              app_name: APP_NAME
                            })
                  					.then(function (translatedValue) {
                  					    $rootScope.ngMeta[APP_NAME].page_title = translatedValue;
                  					});
                                    // Get routes
                                    getRoutes(originId, destinationId, departureDate, arrivalDate, storedRoutes)
                                        .then(routesCallback)
                                        .catch(onError);
                                }else{
                                    noDestinationError();
                                }
                            })
                            .catch(noDestinationError);
                    }else{
                        $translate('NOTIFICATION.ERRORS.STATION_ORIGIN').then(function (error) {
                            msUtils.showNotification(error,'md-yellow-300-bg');
                            _ba.send('error', { "error": error });
                        });
                    }
                })
                .catch(onError);
        }

        // Generate uuidv4
        function uuidv4() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, function(c) {
             return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);  
            });
        }
        // Callback function used in getRoutes()
    	function routesCallback (response) {
            vm.routes = response.data;
            if (vm.routes === undefined) {
                onError({status: 422, data: null});
                return;
            } else {
                if (vm.routes.outbound_routes !== undefined) {
                    if (vm.routes.outbound_routes.length === 0) {
                        vm.routes.outbound_routes = undefined;
                        onError({status: 422, data: null});
                        return;
                    }
                } else {
                    onError({status: 422, data: null});
                    return;
                }
            }

            if (!storedRoutes) {
                $rootScope.storedRoutes = response;
                $rootScope.route.requisition_id = vm.routes.requisition_id;
                var departureDate = new Date($rootScope.route.departureDate).toISOString()
                var arrivalDate = $rootScope.route.arrivalDate ? new Date($rootScope.route.arrivalDate).toISOString() : null
                $rootScope.route.session_id = btoa($rootScope.route.originCityId + ',' + $rootScope.route.destinationCityId + ',' + departureDate + ',' + arrivalDate + ',' + uuidv4());
                api.seats.profile.create({requisition_id: $rootScope.route.requisition_id, outbound_route_id: '', step:'list_routes',session_id: $rootScope.route.session_id},
                    function(response){
                    //console.log('make profile')
                    },
                    function(error){
                    console.log('error profile',error)
                    }
                )       
            }
    	    GTM.sendSearchResults($rootScope.route);
            _ba.send('routes results listed');

            getFilters(vm.routes.outbound_routes, 'outbound');
            if (APP_NAME === 'busolinea') {
                handleToasts();
            }
      	    window.prerenderReady = true;
    	}

        // Handles the selection of a wanted route
        function selectRoute($event, central_buy){
            if( central_buy ){
                $translate('NOTIFICATION.ERRORS.CENTRAL_BUY').then(function (error) {
                    msUtils.showNotification(error,'md-yellow-300-bg');
                    _ba.send('error', { "error": error });
                });
            }else{
                if( $rootScope.returnTravel ){
                    if( $rootScope.returnTicket == false ){
                        // Selecting outbound route if the route is with return
                        $rootScope.returnTicket = true;
                        var outbound_route_id = angular.element($event.currentTarget).attr('data-id');
                        var ida = vm.routes.outbound_routes.filter(function (route) {
                            return (route.id == outbound_route_id);
                        })[0];
                        vm.orinfo = ida.orinfo;
                        $rootScope.route.outbound_route = ida;

                        getFilters(vm.routes.return_routes, 'return');

                        GTM.sendDetail($rootScope.route, ida);
                        _ba.send('outbound route selected', {
                          route_id: ida.id,
                          departure_time: ida.departure_time,
                          cabin_type_ws: ida.cabin_type_ws,
                          company: ida.company.name
                        });

                    }else{
                        // Selecting return route
                        var return_route_id = angular.element($event.currentTarget).attr('data-id');
                        var regreso = vm.routes.return_routes.filter(function (route) {
                            return (route.id == return_route_id);
                        })[0];
                        $rootScope.route.return_route = regreso;

                        GTM.sendDetail($rootScope.route, regreso);
                        _ba.send('return route selected', {
                          route_id: regreso.id,
                          departure_time: regreso.departure_time,
                          cabin_type_ws: regreso.cabin_type_ws,
                          company: regreso.company.name
                        });

                        $state.go('app.seats', {
                            lang: $rootScope.selectedLanguage == 'en' ? 'en' : ''
                        }, { reload: false });
                    }
                }else{
                    // Selecting the route if there is no return
                    var outbound_route_id = angular.element($event.currentTarget).attr('data-id');
                    var ida = vm.routes.outbound_routes.filter(function (route) {
                        return (route.id == outbound_route_id);
                    })[0];
                    $rootScope.route.outbound_route = ida;

                    GTM.sendDetail($rootScope.route, ida);
                    _ba.send('outbound route selected', {
                      route_id: ida.id,
                      departure_time: ida.departure_time,
                      cabin_type_ws: ida.cabin_type_ws,
                      company: ida.company.name
                    });


                    $state.go('app.seats', {
                        lang: $rootScope.selectedLanguage == 'en' ? 'en' : ''
                    }, { reload: false });

                }

            }
        }

        // Clears the route's requisition id
        function clearRequisitionId(){
            var defered = $q.defer();
            var promise = defered.promise;
            api.routes.requisition.clear({ requisition_id: $rootScope.route.requisition_id },
                function(response){
                    defered.resolve(response);
                },
                function(error){
                    defered.reject(error);
                }
            );
            return promise;
        }



        /*
        *   FOR FILTERS
        */

        // Creates the filters for the routes
        function getFilters (routes, direction) {
          vm.busCompanies = [];
          vm.cabinTypes = [];
          vm.cabinTypesRoute = [];
          vm.localpasoRoute = [];

          if (routes !== undefined && routes.length > 0) {
            if (direction === 'outbound') {
              //Outbound routes
              angular.forEach(routes, function (item) {
                item.discount = Math.trunc((item.original_price - item.price) / item.original_price * 100);
                addToTimeSelector(vm.filterTimeOutbound, parseInt(item.departure_time.replace(':', '')), null);
                if (item.company.name !== '') {
                  if (vm.busCompanies.indexOf(item.company.name.toLowerCase()) < 0) {
                    vm.busCompanies.push(item.company.name.toLowerCase());
                    var company_name = item.company.name.toLowerCase();
                    vm.busCompaniesOutboundRoute.push({
                      id: item.company.name.toLowerCase(),
                      name: company_name.toLowerCase(),
                      check: true
                    });
                  }
                }
                if (item.cabin_type_ws !== '') {
                  if (vm.cabinTypes.indexOf(item.cabin_type_ws) < 0) {
                    vm.cabinTypes.push(item.cabin_type_ws);
                    vm.cabinTypesRoute.push({
                      id: msUtils.normalize($filter('nospace')(item.cabin_type_ws.toLowerCase())),
                      type: msUtils.normalize($filter('nospace')(item.cabin_type_ws.toLowerCase())),
                      name: item.cabin_type_ws,
                      check: true
                    });
                  }
                }
              });
            } else {
              //Return routes
              angular.forEach(routes, function (item) {
                if (item.orinfo === vm.orinfo) {
                  item.discount = Math.trunc((item.original_price - item.price) / item.original_price * 100);
                  addToTimeSelector(vm.filterTimeReturn, parseInt(item.departure_time.replace(':', '')), item.orinfo);
                  if (item.company.name !== '') {
                    if (vm.busCompanies.indexOf(item.company.name.toLowerCase()) < 0) {
                      vm.busCompanies.push(item.company.name.toLowerCase());
                      var company_name = item.company.name.toLowerCase();
                      vm.busCompaniesReturnRoute.push({
                        id: item.company.name.toLowerCase(),
                        name: company_name.toLowerCase(),
                        check: true
                      });
                    }
                  }
                  if (item.cabin_type_ws !== '') {
                    if (vm.cabinTypes.indexOf(item.cabin_type_ws) < 0) {
                      vm.cabinTypes.push(item.cabin_type_ws);
                      vm.cabinTypesRoute.push({
                        id: msUtils.normalize($filter('nospace')(item.cabin_type_ws.toLowerCase())),
                        type: msUtils.normalize($filter('nospace')(item.cabin_type_ws.toLowerCase())),
                        name: item.cabin_type_ws,
                        check: true
                      });
                    }
                  }
                }
              });
            }
            vm.localpasoRoute.push({ id: 0, name: 'Local', local: true, check: true });
            vm.localpasoRoute.push({ id: 1, name: 'Paso', local: false, check: true });
          }
        }

        /*
        *   ERROR HANDLING
        */

        // Handles the error callback
        function onError (error) {
            if (error === undefined) {
                $translate('NOTIFICATION.ERROR500.NOTIFICATION').then(function (error) {
                    msUtils.showNotification(error, 'md-yellow-300-bg')
                    _ba.send('error', {error: error})
                })
            } else {
                if (vm.routes) {
                    if (error.status !== 503) { // en mantenimiento
                        if (error.data) {
                            var firstError = error.data.errors[0]
                            if (firstError.title !== 'no_routes_with_query') {
                                var param = firstError.param_name ? firstError.param_name : ''
                                var title = firstError.message ? firstError.message : firstError.title
                                var message = param !== '' ? param + ', ' + title : title
                                msUtils.showNotification(message, 'md-yellow-300-bg')
                                _ba.send('error', {error: message})
                            }
                        } else {
                            if (error.status !== 422) {
                                $translate('NOTIFICATION.ERRORS.TIMEOUT').then(function (error) {
                                    msUtils.showNotification(error, 'md-yellow-300-bg')
                                    _ba.send('error', {error: error})
                                })
                            }
                        }
                    }
                }
            }
            removeLoading()
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.notification', [])
        .config(config);

    /** @ngInject */
    function config()
    {
       
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.notification')
        .controller('NotificationController', NotificationController);

    /** @ngInject */
    function NotificationController($rootScope, msUtils)
    {
        var vm = this;

    	//msUtils.showNotification('Lorem ipsum dolor sit amet consectetur adipiscing','md-yellow-300-bg');

    	// Methods
        vm.closeNotification = closeNotification;

        function closeNotification(){
        	angular.element('#notifications').removeClass('visible').find('.message').html('');
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $injector)
    {
        var APP_NAME = $injector.get('APP_NAME');
        // State
        $stateProvider.state('app.profile', {
            url      : '/perfil?lang',
            views    : {
                'content@app': {
                    templateUrl: 'app/views/'+ APP_NAME +'/pages/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            bodyClass: {app: APP_NAME+'_app', page: 'profile'},
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController($rootScope, msUtils)
    {
        var vm = this;

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.privacy', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $injector)
    {
        var APP_NAME = $injector.get('APP_NAME');
        // State
        $stateProvider.state('app.privacy', {
            url      : '/privacidad?lang',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/views/'+ APP_NAME +'/layouts/default-navigation-nosearchbar.html',
                    controller : 'MainController as vm'
                },
                'toolbar@app.privacy'   : {
                    templateUrl: 'app/views/'+ APP_NAME +'/elements/toolbar/toolbar.html',
                    controller : 'ToolbarController as vm'
                },
                'content@app.privacy': {
                    templateUrl: 'app/views/'+ APP_NAME +'/pages/privacy/privacy.html',
                    controller : 'PrivacyController as vm'
                },
                'notifications@app.privacy': {
                    templateUrl: 'app/views/'+ APP_NAME +'/elements/notifications/notification.html',
                    controller : 'NotificationController as vm'
                },
                'sidebar_left@app.privacy': {
                    templateUrl: 'app/views/'+ APP_NAME +'/elements/sidebar_left/sidebar_left.html',
                    controller : 'SideBarLeftController as vm'
                }
            },
            bodyClass: {app: APP_NAME+'_app', page: 'privacy'},
        });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.privacy')
        .controller('PrivacyController', PrivacyController);

    /** @ngInject */
    function PrivacyController($rootScope, msUtils)
    {
        var vm = this;


    }
})();
(function () {
  'use strict';

  angular
  .module('app.payment')
  .controller('PaymentController', PaymentController);

  /** @ngInject */
  function PaymentController ($rootScope, $scope, $state, $filter, $q, api, $translate, $mdDialog, msUtils, GTM, $injector, CONST, $cookies, _ba, $window) {
    var vm = this;
    var APP_NAME = $injector.get('APP_NAME');
    var errorCardToken, successCardToken, createCardToken, tokenParams;
    var deviceprint = null;
    var deviceprint_pg = null;
    var source = msUtils.detectBrowser();
    var forceTimerToStop = false

    $rootScope.returnTicket = false;
    vm.reservationLocked = false;
    vm.country = 'MX';
    vm.city = 'AS';
    vm.coupon = '';
    vm.couponTimer = 0;
    vm.couponApplied = false;
    vm.subtotal = $rootScope.route.prereservation.subtotal != undefined ? $rootScope.route.prereservation.subtotal : '';
    vm.iva = $rootScope.route.prereservation.iva != undefined ? $rootScope.route.prereservation.iva : '';
    vm.flag_msi = false
    vm.msi = null
    vm.remainReservationTime = $rootScope.remainReservationTime
    vm.timeLeft = null
    vm.isNotBuy = false
    // ////////////////////// FUTURA /////////////////////////
    var itinerarySelectorFlag = $rootScope.returnTravel ? true : false;
    vm.itinerarySelector = [
      {
        display: $rootScope.selectedLanguage === 'en' ? 'GOING' : 'IDA',
        value: true,
        show: true,
        active: itinerarySelectorFlag
      },
      {
        display: $rootScope.selectedLanguage === 'en' ? 'RETURN' : 'REGRESO',
        value: false,
        show: itinerarySelectorFlag,
        active: itinerarySelectorFlag
      }
    ];
    vm.months = new Array(12);
    vm.years = [2016, 2017];
    // ////////////////////// FUTURA /////////////////////////

    vm.paymentMethod = 'card';
    vm.total_amount = $rootScope.route.total_amount;
    vm.real_price = $rootScope.route.total_amount;
    //ar total_copp = 0
    //var total_copp_iva = 0
    
    // var seats_outgoing = []
    // var s_seats = "|"
    // for (var index = 0; index <  $rootScope.route.prereservation.outbound_route.seat_reservations.length; index++) {
    //   const element =  $rootScope.route.prereservation.outbound_route.seat_reservations[index];
      
    //   var seat = JSON.parse(JSON.stringify(element))  
    //   seat.total = element.total - ( element.total * 0.10 )
    //   seat.iva = ( element.subtotal - ( element.subtotal * 0.1 ) ) * 0.16            
    //   //total_copp = total_copp + seat.total
    //   //total_copp_iva = total_copp_iva + seat.iva 
    //   seats_outgoing.push(seat)
    //   s_seats += seat.number + "$" + seat.ticket_type.toUpperCase() + "$" + seat.total + ","
    // }   
    // var seats_return = []
    // if ($rootScope.route.prereservation.return_route.seat_reservations) {
    //   s_seats += "|"
    //   for (var index = 0; index <  $rootScope.route.prereservation.return_route.seat_reservations.length; index++) {
    //     const element =  $rootScope.route.prereservation.return_route.seat_reservations[index];
    //     var seat = JSON.parse(JSON.stringify(element))  
    //     seat.total = element.total - ( element.total * 0.10 )
    //     seat.iva = ( element.subtotal - ( element.subtotal * 0.1 ) ) * 0.16                      
    //     //total_copp = total_copp + seat.total
    //     //total_copp_iva = total_copp_iva + seat.iva
    //     seats_return.push(seat)
    //     s_seats += seat.number + "$" + seat.ticket_type.toUpperCase() + "$" + seat.total + ","
    //   }   
    // }
    // vm.string_seats = s_seats
    //vm.coppel_seats_outgoing = seats_outgoing;
    //vm.coppel_seats_return = seats_return;
    //vm.total_amount_coppel =  total_copp;
    //vm.total_amount_coppel_iva =  total_copp_iva;
    vm.coppel_round = Math.ceil(vm.total_amount) - vm.total_amount;
    //$rootScope.coppelDiscount = vm.total_amount - vm.total_amount_coppel
  
    // Methods
    vm.validatePaymentData = validatePaymentData;
    vm.toggleTicket = toggleTicket;
    vm.validateCoupon = validateCoupon;
    vm.removeCoupon = removeCoupon;
    vm.setState = setState;
    vm.selectPayment = selectPayment;
    vm.showTimer = true

    vm.clearSeats = clearSeats;

    // //////////

    init();

    function init () {      
      $scope.$on('timer-stopped', function (event, data) {
        if (!forceTimerToStop) {
          showTimeoutDialog();
          _ba.send('time out dialog open');
        }
      });

      $scope.$on('timer-tick', function (event, data) {
        vm.remainReservationTime = Math.floor(data.millis / 1000)
      }); 

      $scope.$watch(function () {
        return $rootScope.paymentExitDialog;
      }, function (exit) {
        if (exit) {
          showExitDialog();
          _ba.send('exit purchase dialog showed');
        }
      });

      angular.element('input[type="text"]').on('focus', function () {
        $(this).removeClass('error');
      });

      createFingerprint(CONST.PAYMENT_GATEWAY)
        .then(function (fingerprints) {
          deviceprint = fingerprints.deviceprint || '';
          deviceprint_pg = fingerprints.deviceprint_pg || '';
        })
        .catch(onError);

        // Applies coupon if exists
        if ($rootScope.route.coupon.code) {
          vm.coupon = $rootScope.route.coupon.code;
          validateCoupon();
        }
        api.seats.profile.create({requisition_id: $rootScope.route.requisition_id, outbound_route_id: $rootScope.route.outbound_route.id, step:'payment',session_id: $rootScope.route.session_id},
          function(response){
            //console.log('make profile')
          },
          function(error){
            console.log('error profile',error)
          }
        )
      }

    /** clear seats when exit */

    function clearSeats() {
      for (var index = 0; index < $rootScope.route.prereservation.outbound_route.seat_reservations.length; index++) {
        const element = $rootScope.route.prereservation.outbound_route.seat_reservations[index];
        removeSeatReservation(element.id)
      }
      if ($rootScope.route.prereservation.return_route.seat_reservations) {
        for (var index = 0; index < $rootScope.route.prereservation.return_route.seat_reservations.length; index++) {
          const element = $rootScope.route.prereservation.return_route.seat_reservations[index];
          removeSeatReservation(element.id)
        }
      } 
    }

    function removeSeatReservation(seat_id){
      api.seats.seat_reservation.delete({id: seat_id, requisition_id: $rootScope.route.requisition_id},
        function (response) {
          console.error('removed seat', response)
        },
        function (error) {
          console.error('error while deleting seats', error)
        }
      );
    }

    /*
    *   FOR DIALOGS IN PAYMENTS PAGE
    */

    // Shows the exit warning dialog
    function showExitDialog () {
      $mdDialog.show({
        parent: angular.element(document.body),
        controller: 'ExitDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/views/' + APP_NAME + '/pages/payment/dialogs/exit/exit-dialog.html'
      }).then(function (response) {
        if (response !== false) {
          clearSeats()
          _ba.send('exit purchase dialog accepted');
          $rootScope.reservationActive = false;
          $rootScope.paymentExitDialog = false;
          var dates = $filter('date')($rootScope.route.departureDate, 'yyyy-MM-dd');
          if ($rootScope.route.arrivalDate) {
            dates += ',' + $filter('date')($rootScope.route.arrivalDate, 'yyyy-MM-dd');
          }
          if ($rootScope.uistate === 'app.routes') {
            $state.go('app.routes', {
              origin: $rootScope.route.originCityParam,
              destination: $rootScope.route.destinationCityParam,
              dates: dates,
              lang: $rootScope.selectedLanguage === 'en' ? 'en' : ''
            }, {reload: true});
          } else {
            $state.go($rootScope.uistate, {
              lang: $rootScope.selectedLanguage === 'en' ? 'en' : ''
            }, { reload: true });
          }
        } else {
          $rootScope.paymentExitDialog = false;
          _ba.send('exit purchase dialog canceled');
        }
      });
    }

    // Shows the timeout warning dialog
    function showTimeoutDialog () {
      var pathDialog = vm.isNotBuy ? '/pages/payment/dialogs/notbuy/notbuy.html' : '/pages/payment/dialogs/timeout/timeout-dialog.html'
      if (!forceTimerToStop) {
        $mdDialog.show({
          parent: angular.element(document.body),
          controller: 'TimeoutDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/views/' + APP_NAME + pathDialog
        }).then(function () {          
          clearSeats()
          _ba.send('time out dialog closed');
          $rootScope.reservationActive = false;
          var dates = $filter('date')($rootScope.route.departureDate, 'yyyy-MM-dd');
          if ($rootScope.route.arrivalDate) {
            dates += ',' + $filter('date')($rootScope.route.arrivalDate, 'yyyy-MM-dd');
          }

          vm.isNotBuy = false
          vm.timeLeft = null
          $state.go('app.routes', {
            origin: $rootScope.route.originCityParam,
            destination: $rootScope.route.destinationCityParam,
            dates: dates,
            lang: $rootScope.selectedLanguage === 'en' ? 'en' : ''
          }, {reload: true});
        }); 
      }  
    }

    /*
    *   FOR ELEMENTS IN PAYMENTS PAGE
    */

    // Set up the city and country default value
    function setState () {
      if (vm.country !== 'MX') {
        vm.city = 'NA';
      } else {
        vm.city = 'AS';
      }
    }

    // Toggles and shows the route's itinerary
    function toggleTicket () {
      $rootScope.returnTicket = !$rootScope.returnTicket;
    }

    function createFingerprint (gateway) {
      var defered = $q.defer()
      var promise = defered.promise

      new Fingerprint2().get(function (fingerprint, components) {
        if (fingerprint) {
          var fingerprint_openpay = gateway === 'openpay' ? OpenPay.deviceData.setup('formId', 'deviceIdHiddenFieldName') : fingerprint;
          var fingerprints = {
            deviceprint: fingerprint,
            deviceprint_pg: fingerprint_openpay
          }
          defered.resolve(fingerprints)
        } else {
          defered.reject(false)
        }
      })

      return promise
    }

    /*
    *   FOR COUPON
    */

    // Validates the coupon code
    function validateCoupon () {
      clearTimeout(vm.couponTimer);
      if (vm.coupon.length) {
        if (vm.coupon.length === 14) {
          sendCoupon();
        } else {
          vm.couponTimer = setTimeout(function () {
            sendCoupon();
          }, 1000);
        }
      }
      return false;
    }

    // Makes the API request to validate the coupon
    function sendCoupon () {
      if (vm.reservationLocked === false) {
        GTM.sendEvent('payment', 'promocode', vm.coupon);
        _ba.send('coupon entered');
        getCoupon(vm.coupon)
          .then(function (response) {
            if (response.data) {
              $rootScope.route.coupon = response.data;
              vm.couponApplied = true;
              _ba.send('coupon applied');
            }
          })
          .catch(onError);
      }
    }

    // Gets the coupon information from the API
    function getCoupon (code, amount) {
      var defered = $q.defer();
      var promise = defered.promise;

      // API request for seat reservation
      api.coupons.validate.get({ code: code, requisition_id: $rootScope.route.requisition_id },
        // Success
        function (response) {
          defered.resolve(response);
        },
        // Error
        function (error) {
          defered.reject(error);
        }
      );
      return promise;
    }

    // Removes the coupon code information
    function removeCoupon () {
      vm.coupon = '';
      vm.couponApplied = false;
      $rootScope.route.coupon = {
        coupon: {'code': ''}
      }
      _ba.send('coupon removed');
      return false;
    }

    /*
    *   HANDLES THE PAYMENT FORM
    */

    function validateCustomerInfo () {
      var flag = 0;
      angular.element('.customer-info input').each(function (index, element) {
        if (angular.element(this).val().length < 1) {
          angular.element(this).addClass('error');
          flag = 1;
        } else {
          if (angular.element(this).is('.error')) {
            angular.element(this).removeClass('error');
          }
        }
      });
      if (flag === 1) {
        $translate('NOTIFICATION.VALIDATION.PAYMENT_USER_DATA').then(function (message) {
          msUtils.showNotification(message, 'md-yellow-300-bg');
          _ba.send('error', {error: message});
        });
        return false;
      }
      return true;
    }

    function validatePaymentInfo () {
      if (vm.paymentMethod === 'card') {
        var flag = 0;
        // validamos datos de tarjeta
        angular.element('.new_card input').each(function (index, element) {
          if (angular.element(this).val().length < 1) {
            angular.element(this).addClass('error');
            flag = 1;
          } else {
            if (angular.element(this).is('.error')) {
              angular.element(this).removeClass('error');
            }
          }
        });
        if (flag === 1) {
          $translate('NOTIFICATION.VALIDATION.PAYMENT_CARD_DATA').then(function (message) {
            msUtils.showNotification(message, 'md-yellow-300-bg');
            _ba.send('error', {error: message});
          });
          angular.element('.buttons').removeClass('loading');
          return false;
        } else {
          // validamos tipo de tarjeta
          if (angular.element('[name=card_type]:checked').length < 1) {
            $translate('NOTIFICATION.VALIDATION.PAYMENT_CARD_TYPE').then(function (message) {
              msUtils.showNotification(message, 'md-yellow-300-bg');
              _ba.send('error', {error: message});
            });
            angular.element('.buttons').removeClass('loading');
          } else {
            // Token card object
            tokenParams = {
              card: {
                number: angular.element('input[name="card_num"]').val().trim(),
                name: angular.element('input[name="fname"]').val().trim() + ' ' + angular.element('input[name="lname"]').val().trim(),
                exp_year: '20' + angular.element('input[name="card_exp_year"]').val().trim(),
                exp_month: angular.element('input[name="card_exp_month"]').val().trim(),
                cvc: angular.element('input[name="card_cvv"]').val().trim(),
                address: {
                  street1: angular.element('input[name="address"]').val().trim(),
                  street2: '',
                  city: angular.element('input[name="cust_city"]').val().trim(),
                  state: angular.element('select[name="cust_stpr_cd"] option:selected').val().trim(),
                  zip: angular.element('input[name="cust_postal_cd"] ').val().trim(),
                  country: angular.element('select[name="cust_cntry_cd"] option:selected').val().trim()
                }
              }
            };
            createCardToken(tokenParams);
          }
        }
      } else {
        finishBuy(null);
      }
    }

    function validateTerms () {
      if (angular.element('[name=terms_check2]:checked').length < 1) {
        $translate('NOTIFICATION.VALIDATION.PAYMENT_TERMS').then(function (message) {
          msUtils.showNotification(message, 'md-yellow-300-bg');
          _ba.send('error', {error: message});
        });
        angular.element('.buttons').removeClass('loading');
        return false;
      }
      return true;
    }

    // Validates payment form
    function validatePaymentData () {
      angular.element('.buttons').addClass('loading');
      var isCustomerInfoValid = validateCustomerInfo();
      var areTermsChecked = validateTerms();
      if (isCustomerInfoValid) {
        if (areTermsChecked) {
          validatePaymentInfo();
        }
      }
    }

    // Makes the API request to make a reservation
    function reservation (params) {      
      var defered = $q.defer();
      var promise = defered.promise;
      vm.reservationLocked = true;
      // API request for seat reservation
      api.seats.reservation.make(params,
        function (response) {
          defered.resolve(response);
          vm.reservationLocked = false;
        },
        function (error) {
          defered.reject(error);
          vm.reservationLocked = false;
        }
      );
      return promise;
    }

    // CONEKTA process
    createCardToken = function (params) {
      if (CONST.PAYMENT_GATEWAY === 'openpay') {
        var paymentData = {
          card_number: params.card.number,
          holder_name: params.card.name,
          expiration_year: params.card.exp_year.slice(-2),
          expiration_month: params.card.exp_month,
          cvv2: params.card.cvc,
          address: {
            city: params.card.address.city,
            line3: '',
            postal_code: params.card.address.zip,
            line1: params.card.address.street1,
            line2: '',
            state: params.card.address.state,
            country_code: params.card.address.country,
          }
        }
        OpenPay.token.create(paymentData, successCardToken, errorCardToken);
      } else {
        Conekta.Token.create(tokenParams, successCardToken, errorCardToken);
      }
    };
    // Después de tener una respuesta exitosa, envía la información al servidor
    successCardToken = function (token) {
      _ba.send('card token created');
      finishBuy(token.id || token.data.id);
    };

    // Después de recibir un error
    errorCardToken = function (response) {
      angular.element('.buttons').removeClass('loading');
      $translate('NOTIFICATION.ERRORS.INVALID_CARD').then(function (error) {
        msUtils.showNotification(error, 'md-yellow-300-bg');
        _ba.send('error', {error: error});
      });
    };

    // Function to finish the buy and call the final reservation request
    function finishBuy (tokenId) {
      if (vm.reservationLocked === false) {
        var isCard = vm.paymentMethod === 'card';
        vm.total_amount = vm.real_price;
        var params = {
          requisition_id: $rootScope.route.requisition_id,
          payment_method: vm.paymentMethod,
          fname: angular.element('input[name="fname"]').val().trim(),
          lname: angular.element('input[name="lname"]').val().trim(),
          country_cd: angular.element('select[name="cust_cntry_cd"] option:selected').val(),
          stpr_cd: angular.element('select[name="cust_stpr_cd"] option:selected').val(),
          city: angular.element('input[name="cust_city"]').val().trim(),
          address: angular.element('input[name="address"]').val().trim(),
          zip_code: angular.element('input[name="cust_postal_cd"] ').val().trim(),
          phone: angular.element('input[name="phone"] ').val().trim(),
          email: angular.element('input[name="email"] ').val().trim(),
          deviceprint: deviceprint,
          deviceprint_pg: deviceprint_pg,
          credit_card_token: tokenId,
          card_expiration: isCard ? angular.element('input[name="card_exp_month"]').val().trim() + '/' + angular.element('input[name="card_exp_year"]').val().trim() : '',
          coupon_code: $rootScope.route.coupon.coupon.code,
          source: 'web',
          source_version: source.version,
          device: source.os,
          terms_check: angular.element('input[name="terms_check2"]').is(':checked'),
          domain: APP_NAME,
          campaign: $rootScope.analytics.campaign,
          ga_id: $rootScope.analytics.ga_id,
          ba_id: $cookies.get('_baid'),
          monthly_installments: vm.flag_msi ? vm.msi : null         
        }
        

        if (vm.paymentMethod === 'coppelpay') {
          // vm.total_amount = vm.total_amount_coppel;
          msUtils.myIp()
            .then(function (ipResponse) {
              var cpl_params = {
                cpl_ip: ipResponse.ip
              }
              var cplpy = isCoppelReady();
              if (cplpy !== null) {
                cpl_params.cpl_iovation = cplpy.cpl_iovation;
                cpl_params.cpl_token = cplpy.cpl_token;
                cpl_params.cpl_solicitud = vm.cpl_solicitud;
                cpl_params.amount =  Math.round(vm.total_amount + vm.coppel_round);
                params.coppelpay = cpl_params;
                // params.outgoing_seats = vm.coppel_seats_outgoing;
                // params.return_seats = vm.coppel_seats_return;                                
                // params.string_seats = vm.string_seats
                // params.total_sale = Math.round(vm.total_amount_coppel + vm.coppel_round);
                reservationRequest(params);
              } else {
                $translate('NOTIFICATION.ERRORS.COPPELPAY_SESSION').then(function (error) {
                  msUtils.showNotification(error, 'md-yellow-300-bg');
                  _ba.send('error', {error: error});
                });
                angular.element('.buttons').removeClass('loading');
              }
            });
        } else {
          reservationRequest(params);
        }
      }
    }

    function remove3min() {
      vm.isNotBuy = false
      vm.remainReservationTime = vm.timeLeft
      $scope.$broadcast('timer-set-countdown', vm.timeLeft);
    }

    // Reservation request
    function reservationRequest (params) {
      vm.timeLeft = vm.remainReservationTime
      vm.remainReservationTime = 180
      $scope.$broadcast('timer-set-countdown', 180);
      vm.isNotBuy = true
      _ba.send('finish purchase button clicked');
      reservation(params)
        .then(function (response) {
          if (response) {            
            $rootScope.route.reservation = response.data;
            $window.onbeforeunload= function() {        
              
            };
            $state.go('app.confirmation', {
              lang: $rootScope.selectedLanguage === 'en' ? 'en' : ''
            }, { reload: false });
          } else {
            remove3min()
            angular.element('.buttons').removeClass('loading');
          }
        })
        .catch(onError);
    }

    /*
    *   ERROR HANDLING
    */

    // Handles the error callback
    function onError (error) {
      remove3min()
      if (error.status !== 500) {
        if (error.data !== null) {
          var param = error.data.errors[0].param_name !== null ? error.data.errors[0].param_name : '';
          var title = error.data.errors[0].message !== undefined ? error.data.errors[0].message : error.data.errors[0].title;
          var status = error.data.errors[0].status !== undefined ? error.data.errors[0].status : 422;
          if (status === 455) {
            console.log('error de miguelono')
            $mdDialog.show({
              parent: angular.element(document.body),
              controller: 'TimeoutDialogController',
              controllerAs: 'vm',
              templateUrl: 'app/views/' + APP_NAME + '/pages/payment/dialogs/noreservationconfirm/noreservationconfirm.html'
            }).then(function () {      
              $rootScope.reservationActive = false;
              var dates = $filter('date')($rootScope.route.departureDate, 'yyyy-MM-dd');
              if ($rootScope.route.arrivalDate) {
                dates += ',' + $filter('date')($rootScope.route.arrivalDate, 'yyyy-MM-dd');
              }        
              $state.go('app.routes', {
                origin: $rootScope.route.originCityParam,
                destination: $rootScope.route.destinationCityParam,
                dates: dates,
                lang: $rootScope.selectedLanguage === 'en' ? 'en' : ''
              }, {reload: true});
            }); 
            return;
          }
          var message = param !== '' ? param + ', ' + title : title;
          msUtils.showNotification(message, 'md-yellow-300-bg');
          _ba.send('error', {error: message});
        } else {
          $translate('NOTIFICATION.ERRORS.TIMEOUT').then(function (error) {
            msUtils.showNotification(error, 'md-yellow-300-bg');
            _ba.send('error', {error: error});
          });
        }
      } else {
        $translate('NOTIFICATION.ERROR500.NOTIFICATION').then(function (error) {
          msUtils.showNotification(error, 'md-yellow-300-bg');
          _ba.send('error', {error: error});
        });
      }
      angular.element('.buttons').removeClass('loading');
    }

    /*
    *   PAYMENT BY STEPS LOGIC
    */

    $scope.$watch(function () {
      return vm.paymentMethod;
    }, function (selectedPayment) {
      vm.selectPayment();
    });

    function selectPayment () {
      if (vm.paymentMethod === 'coppelpay') {
        $rootScope.route.coppel_round = vm.coppel_round;
        var cpl_description = 'Ticket ' + APP_NAME.toUpperCase() + ' ' + $rootScope.route.outbound_route.origin_name + ' - ' + $rootScope.route.outbound_route.destination_name + ' ' + $rootScope.route.outbound_route.departure_time_ampm;
        var params = {
          cpl_business: CONST.COPPELPAY_PUBLIC_KEY,
          cpl_transaction: $rootScope.route.requisition_id,
          cpl_signature: cplSignature(),
          cpl_amount: Math.round(vm.total_amount + vm.coppel_round),
          cpl_currency: 'MXN',
          cpl_description: cpl_description,
          cpl_url_redirect: ''
        }
        solicitudCompra(params)
          .then(function (response) {
            if (response.code === 'ERROR') {
              $translate('NOTIFICATION.ERRORS.COPPELPAY_BAD_REQUEST').then(function (error) {
                msUtils.showNotification(error, 'md-yellow-300-bg');
                _ba.send('error', {error: error});
              });
            } else {
              var objResponse = JSON.parse(response.data);
              vm.cpl_solicitud = objResponse.solicitud;
              initCoppelPay(vm.cpl_solicitud);
            }
          })
          .catch(onError);
      } else {
        $rootScope.route.coppel_round = null;
      }
    }

    function solicitudCompra (params) {
      var defered = $q.defer();
      var promise = defered.promise;

      api.coppelPay.solicitud.create(params,
        function (response) {
          defered.resolve(response);
        },
        function (error) {
          defered.reject(error);
        }
      );
      return promise;
    }

    function initCoppelPay (solicitudCompraResponse) {
      CPLPY.init(solicitudCompraResponse);      
      CPLPY.sandbox = CONST.COPPELPAY_TEST;
      CPLPY.open();      
    }

    function isCoppelReady () {    
      if (CPLPY.blackbox) {
        var cplpy = {
          cpl_iovation: CPLPY.blackbox,
          cpl_token: CPLPY.token
        }
        return cplpy;
      } else {
        return null;
      }
    }

    function cplSignature () {
      var signature = CONST.COPPELPAY_PRIVATE_KEY;
      signature += '#' + CONST.COPPELPAY_PUBLIC_KEY;
      signature += '#' + $rootScope.route.requisition_id;
      signature += '#' + Math.round(vm.total_amount + vm.coppel_round);
      return md5(signature);
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.mobile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $injector)
    {

        var APP_NAME = $injector.get('APP_NAME');
        // State
        $stateProvider.state('app.mobile', {
            url      : '/mobile?lang',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/views/'+ APP_NAME +'/layouts/default-navigation-nosearchbar.html',
                    controller : 'MainController as vm'
                },
                'toolbar@app.mobile'   : {
                    templateUrl: 'app/views/'+ APP_NAME +'/elements/toolbar/toolbar.html',
                    controller : 'ToolbarController as vm'
                },
                'content@app.mobile': {
                    templateUrl: 'app/views/'+ APP_NAME +'/pages/mobile/mobile.html',
                    controller : 'MobileController as vm'
                },
                'notifications@app.mobile': {
                    templateUrl: 'app/views/'+ APP_NAME +'/elements/notifications/notification.html',
                    controller : 'NotificationController as vm'
                },
                'sidebar_left@app.mobile': {
                    templateUrl: 'app/views/'+ APP_NAME +'/elements/sidebar_left/sidebar_left.html',
                    controller : 'SideBarLeftController as vm'
                }
            },
            bodyClass: {app: APP_NAME+'_app', page: 'mobilepage'},
        });
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.mobile')
        .controller('MobileController', MobileController);

    /** @ngInject */
    function MobileController($rootScope, msUtils)
    {
        var vm = this;


    }
})();
(function () {
  'use strict';

  angular
    .module('app.home', [])
    .config(config);

  /** @ngInject */
  function config ($stateProvider, msApiProvider, $injector) {
    var APP_NAME = $injector.get('APP_NAME');
    $stateProvider.state('app.home', {
      url: '/?lang&gclid&fbclid&msclkid&utm_source&utm_medium&utm_campaign&utm_temporary&spMailingID&spUserID&spJobID&spReportID&spReportId',
      views: {
        'main@': {
          templateUrl: 'app/views/' + APP_NAME + '/layouts/default-navigation-nosearchbar.html',
          controller: 'HomeController as vm'
        },
        'toolbar@app.home': {
          templateUrl: 'app/views/' + APP_NAME + '/elements/toolbar/toolbar.html',
          controller: 'ToolbarController as vm'
        },
        'content@app.home': {
          templateUrl: 'app/views/' + APP_NAME + '/pages/home/home.html'
        },
        'notifications@app.home': {
          templateUrl: 'app/views/' + APP_NAME + '/elements/notifications/notification.html',
          controller: 'NotificationController as vm'
        },
        'sidebar_left@app.home': {
          templateUrl: 'app/views/' + APP_NAME + '/elements/sidebar_left/sidebar_left.html',
          controller: 'SideBarLeftController as vm'
        }
      },
      bodyClass: {app: APP_NAME + '_app', page: 'home'}
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.home')
        .controller('HomeController', HomeController);

    /** @ngInject */
    function HomeController($scope, $rootScope, $log, $translate, $q, $filter, $timeout, $state, msUtils, api, $cookies, $injector, CONST, $stateParams, _ba, localStorageService, Galerux)
    {
        var vm = this;
        var APP_NAME = $injector.get('APP_NAME');

        if(localStorageService.get("isLogged")){
          var obj = {email:localStorageService.get("userEmail")}
          $rootScope.loggedIn=obj;
        }else{
            localStorageService.clearAll()
        }

        // Data
        $timeout(function () {
          $rootScope.storedRoutes = null;
          msUtils.setMainSearchHeight(0,0);
          setReadonlyDateInputs();
        }, 0, false);

        //Methods
        vm.doSubscribe = doSubscribe;
        vm.seeRoute = seeRoute;
        /////////
        
        init();

        function init() {

          // Gets the home slider images
          if( APP_NAME !== 'busolinea' ){
            Galerux.get_elements(CONST.SLIDESHOW_ID)
              .then(function(response){
                if ( response !== undefined )
                  vm.sliderCollection = response._embedded.items;
              }, function(error) {
                console.log(error);
              });
          }

          // Notifies to prerender the main view is already loaded
          $scope.$on('$viewContentLoaded', function(event, viewName, viewContent) {
            $timeout(function() {
              if(viewName == 'main@'){
                window.prerenderReady = true;

                if( $cookies.get('_ga') ){
                  var ga_id_strings = $cookies.get('_ga').split('.');
                  if( ga_id_strings[2] && ga_id_strings[3]){
                    var ga_id =  ga_id_strings[2].concat('.'+ ga_id_strings[3]);
                    $rootScope.analytics.ga_id = ga_id;
                  }
                }
                $rootScope.analytics.campaign = $stateParams.utm_temporary ? $stateParams.utm_temporary : $stateParams.utm_campaign ? $stateParams.utm_campaign : null;

              }
            },0);
          });

          // (BUSOLINEA) Sets the background image in busolinea
          /*if( APP_NAME == 'busolinea'  ){
              if( typeof(cxApi)  !== 'undefined' ){
                $rootScope.background = $cookies.get('background');
                if( $rootScope.background == undefined ){
                                var random_num = cxApi.chooseVariation();
                                if( random_num != undefined ){
                  switch(random_num){
                  case 0: $cookies.put('background', 'background_blue'); $rootScope.background = 'background_blue'; break;
                  case 1: $cookies.put('background', 'background_orange'); $rootScope.background = 'background_orange'; break;
                  }
                                }else{
                  $rootScope.background = '';
                                }
                }
              } else {
                console.log("A/B not working");
              }
          }*/

        }

        /*
        * for prometed routes
        */

       function seeRoute(outbundRouteName, arrivalRouteName ){
          console.log('para la ruta', outbundRouteName, arrivalRouteName);    
          $rootScope.route.originName=outbundRouteName;
          $rootScope.route.destinationName=arrivalRouteName;
          $state.go('app.routes', {
            //origin: $rootScope.route.originCityParam,
            //destination: $rootScope.route.destinationCityParam,            
          }, { reload: true });
        }
        /*
        *  FOR FOOTER ELEMENTS
        */

        // Subscribe to newsletter action and handling response
        function doSubscribe () {
          angular.element('#subscribe_btn').attr('disabled', 'disabled')
          if (angular.element('#newsletter').val().length > 0) {
            _ba.send('newsletter subscribe request')
            sendSubscription()
              .then(function (response) {
                  vm.newsLetterEmail = ''
                  $translate('NOTIFICATION.NEWSLETTER.SUCCESS').then(function (error) {
                    msUtils.showNotification(error, 'md-yellow-300-bg')
                  })
                  angular.element('#subscribe_btn').removeAttr('disabled', 'disabled')
                  _ba.send('newsletter subscribe success')
              })
              .catch(onError)
          } else {
            angular.element('#subscribe_btn').removeAttr('disabled', 'disabled')
          }
        }

        // Makes a subscribe api request
        function sendSubscription () {
            var defered = $q.defer()
            var promise = defered.promise
            // API request for subscribe
            api.newsletter.subscribe.create({
              name: APP_NAME,
              email: vm.newsLetterEmail
            },
               function (response) {
                   defered.resolve(response)
               },
               function (error) {
                   defered.reject(error)
               }
            )
            return promise
        }


        /*
        *  FOR SEARCH ELEMENT
        */

        // Sets a readonly attribute to every date search input on mobile to avoid showing the keyboard
        function setReadonlyDateInputs(){
          if (msUtils.isMobile()){
            angular.element('#search md-datepicker input').attr('readonly', 'readonly');
          }
        }


        /*
        *   ERROR HANDLING
        */

        // Handles the error callback
        function onError(error) {
          if(error !== undefined && error.status !== 500){
            if( error.data != null ){
              var param = error.data.errors[0].param_name != null ? error.data.errors[0].param_name : '';
              var title = error.data.errors[0].message != undefined ? error.data.errors[0].message : error.data.errors[0].title;
              var message = param != '' ? param+', '+title : title;
              msUtils.showNotification(message,'md-yellow-300-bg');
              _ba.send('error', { "error": message });
            }else{
              $translate('NOTIFICATION.ERRORS.TIMEOUT').then(function (error) {
                msUtils.showNotification(error,'md-yellow-300-bg');
                _ba.send('error', { "error": error });
              });
            }
          }else{
            $translate('NOTIFICATION.ERROR500.NOTIFICATION').then(function (error) {
                msUtils.showNotification(error,'md-yellow-300-bg');
                _ba.send('error', { "error": error });
              });
          }
          angular.element('#subscribe_btn').removeAttr('disabled','disabled');
        }

    }
})();

(function () {
  'use strict';

  angular
        .module('app.confirmation', [])
        .config(config);

    /** @ngInject */
  function config ($stateProvider, msApiProvider, $injector) {
    var APP_NAME = $injector.get('APP_NAME');
        // State
    $stateProvider.state('app.confirmation', {
      url: '/confirmacion?lang',
      views: {
        'main@': {
          templateUrl: 'app/views/' + APP_NAME + '/layouts/default-navigation-nosearchbar.html',
          controller: 'MainController as vm'
        },
        'toolbar@app.confirmation': {
          templateUrl: 'app/views/' + APP_NAME + '/elements/toolbar/toolbar.html',
          controller: 'ToolbarController as vm'
        },
        'content@app.confirmation': {
          templateUrl: 'app/views/' + APP_NAME + '/pages/confirmation/confirmation.html',
          controller: 'ConfirmationController as vm'
        },
        'notifications@app.confirmation': {
          templateUrl: 'app/views/' + APP_NAME + '/elements/notifications/notification.html',
          controller: 'NotificationController as vm'
        },
        'sidebar_left@app.confirmation': {
          templateUrl: 'app/views/' + APP_NAME + '/elements/sidebar_left/sidebar_left.html',
          controller: 'SideBarLeftController as vm'
        }
      },
      bodyClass: {app: APP_NAME + '_app', page: 'confirmation'},
      data: {
        meta: {
          'busolinea': {
            page_title: 'META.CONFIRMATION.TITLE'
          },
          'futura': {
            page_title: 'Confirmación | Futura'
          },
          'geb': {
            page_title: 'Confirmación | Grupo Estrella Blanca'
          },
          'transportamex': {
            page_title: 'META.CONFIRMATION.TITLE'
          }
        }
      }
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.confirmation')
        .controller('ConfirmationController', ConfirmationController);

    /** @ngInject */
    function ConfirmationController($rootScope, $q, $translate, api, msUtils, GTM, _ba, $mdDialog,$injector, CONST)
    {
        var vm = this;
        vm.aditionalEmail = '';
        var APP_NAME = $injector.get('APP_NAME');
        $rootScope.reservationActive = false;

        // Methods
        vm.getMail = getMail;

        //////////
        init();
        function init() {
          api.seats.profile.create({requisition_id: $rootScope.route.requisition_id, outbound_route_id: $rootScope.route.outbound_route.id, step:'confirmation',session_id: $rootScope.route.session_id},
            function(response){
              console.log('make profile')
            },
            function(error){
              console.log('error profile',error)
            }
          )
        }

        $mdDialog.show({
          parent: angular.element(document.body),
          controller: 'ExitDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/views/' + APP_NAME + '/pages/confirmation/dialogs/covid/covid-dialog.html'
        }).then(function (response) {
          console.log(response)
          var covid_params= btoa( $rootScope.route.reservation.outbound_route.reservation_number + ($rootScope.route.reservation.return_route ? ',' +$rootScope.route.reservation.return_route.reservation_number : '' ))
          window.open((CONST.DEPLOYMENT_ENVIRONMENT === 'production' ? 'https://encuesta-ifr.estrellablanca.com.mx/' : 'https://encuesta-ifr-staging.estrellablanca.com.mx/') +'?t='+ covid_params,"_blank")
        });
        if ($rootScope.route.reservation != undefined){
          GTM.sendPurchase($rootScope.route.reservation);
          _ba.send('reservation done');
        }

        /*
        *  FOR EMAIL ELEMENT
        */

        // Handles the event to send an additional email
        function getMail(){
          angular.element('.buttons').addClass('loading');
          if( angular.element('#email').val().length > 0 ){
            sendMail()
              .then(function(response){
                  _ba.send('additional email sent');
                  vm.aditionalEmail = '';
                  $translate('NOTIFICATION.CONFIRMATION.EMAIL').then(function (message) {
                      msUtils.showNotification(message,'md-yellow-300-bg');
                  });
                  angular.element('.buttons').removeClass('loading');
              })
              .catch(onError);
          }else{
            angular.element('.buttons').removeClass('loading');
          }
        }

        // Makes an API request to send an email
        function sendMail(){
            var defered = $q.defer();
            var promise = defered.promise;
            // API request for sendmail
            api.confirmation.sendmail.create({ reservation_code: $rootScope.route.reservation.reservation_token, email: vm.aditionalEmail },
               function (response){
                   defered.resolve(response);
               },
               function (error){
                   defered.reject(error);
               }
            );
            return promise;
        }


        /*
        *   ERROR HANDLING
        */

        // Handles the error callback
        function onError(error) {
            if(error !== undefined && error.status !== 500){
              if( error.data !== null ){
                var param = error.data.errors[0].param_name != null ? error.data.errors[0].param_name : '';
                var title = error.data.errors[0].message != undefined ? error.data.errors[0].message : error.data.errors[0].title;
                var message = param != '' ? param+', '+title : title;
                msUtils.showNotification(message,'md-yellow-300-bg');
                _ba.send('error', { "error": message });
              }else{
                $translate('NOTIFICATION.ERRORS.TIMEOUT').then(function (error) {
                  msUtils.showNotification(error,'md-yellow-300-bg');
                  _ba.send('error', { "error": error });
                });
              }
            }else{
              $translate('NOTIFICATION.ERROR500.NOTIFICATION').then(function (error) {
                  msUtils.showNotification(error,'md-yellow-300-bg');
                  _ba.send('error', { "error": error });
                });
            }
            angular.element('.buttons').removeClass('loading');
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.about', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $injector)
    {
        var APP_NAME = $injector.get('APP_NAME');
        //State
        $stateProvider.state('app.about', {
            url      : '/quienes-somos?lang',
            views    : {
                'main@' : {
                    templateUrl: 'app/views/'+ APP_NAME +'/layouts/default-navigation-nosearchbar.html',
                    controller : 'MainController as vm'
                },
                'toolbar@app.about' : {
                    templateUrl: 'app/views/'+ APP_NAME +'/elements/toolbar/toolbar.html',
                    controller : 'ToolbarController as vm'
                },
                'content@app.about': {
                    templateUrl: 'app/views/'+ APP_NAME +'/pages/about/about.html',
                    controller : 'AboutController as vm'
                },
                'notifications@app.about': {
                    templateUrl: 'app/views/'+ APP_NAME +'/elements/notifications/notification.html',
                    controller : 'NotificationController as vm'
                },
                'sidebar_left@app.about': {
                    templateUrl: 'app/views/'+ APP_NAME +'/elements/sidebar_left/sidebar_left.html',
                    controller : 'SideBarLeftController as vm'
                }
            },
            bodyClass: {app: APP_NAME+'_app', page: 'about'},
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.about')
        .controller('AboutController', AboutController);

    /** @ngInject */
    function AboutController($rootScope, msUtils)
    {
        var vm = this;


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($scope, $rootScope, $state, $http, $document, $mdSidenav, $translate, $mdDialog, tmhDynamicLocale, msUtils, $injector, $location, _ba, auth)
    {
        var vm = this;

        // Data
        var APP_NAME = $injector.get('APP_NAME');

        vm.loggedIn = $rootScope.loggedIn;
        vm.bodyEl = angular.element('body');

        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            }
        };

        // Methods
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.toggleSidebar = toggleSidebar;
        vm.showRegisterForm = showRegisterForm;
        vm.showLoginForm = showLoginForm;
        vm.showRecoverForm = showRecoverForm;
        vm.downloadApp = downloadApp;
        vm.clearTickets = clearTickets
        // Methods GEB
        vm.showJoinClubForm = showJoinClubForm;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Get the selected language directly from angular-translate module setting
            if( $location.search().lang ){
                vm.selectedLanguage  = vm.languages[$location.search().lang];
                if( $rootScope.selectedLanguage != $location.search().lang ){
                    changeLanguage(vm.selectedLanguage );
                }
            }else{
                if( $rootScope.selectedLanguage != undefined ){
                    vm.selectedLanguage = vm.languages[$rootScope.selectedLanguage];
                    changeLanguage(vm.selectedLanguage);
                }else{
                    vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
                    changeLanguage(vm.selectedLanguage);
                }
            }
        }

        $scope.$watch(function() {
            return $rootScope.joinclub;
        }, function(joinclub) {
            if( joinclub == true )
                showJoinClubForm();
        });

        /**
         * Logout Function
         */
        function logout()
        {
            auth.on.logout();
            $rootScope.loggedIn = false;
            vm.loggedIn = $rootScope.loggedIn;
        }

        /**
         * Toggle mobile menu
         */
        function toggleSidebar(sidenavId){
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Change Language
         */
        function changeLanguage(lang, click)
        {   
            if( angular.isUndefined(lang) ){
                lang = vm.languages[$translate.preferredLanguage()];
            }
            vm.selectedLanguage = lang;
            $translate.use(lang.code);
            $rootScope.selectedLanguage = lang.code;
            $http.defaults.headers.get = { 'Accept-Language' : lang.code };
            Conekta.locale = lang.code;
            tmhDynamicLocale.set(lang.code);

            $state.transitionTo($rootScope.state.current.name, {
                lang: $rootScope.selectedLanguage == 'en' ? 'en' : ''
            }, { location:true, reload: false, inherit: true, notify: false });

            if( click )
                _ba.send('language selected: '+lang.code);

        }

        /**
         * ScrollTo an element
         */
        function downloadApp(){
            if( $state.current.name == 'app.home' ) {
                msUtils.scrollToElement('mobiles', 500);
            }else{
                $state.go('app.mobile', {
                    lang: $rootScope.selectedLanguage == 'en' ? 'en' : ''
                }, {  reload: false });
            }
            _ba.send('download app button clicked');
        }

        /**
        * Show sign up form
        */
        function showRegisterForm(ev)
        {
            $mdDialog.show({
                controller         : 'RegisterDialogController',
                controllerAs       : 'vm',
                locals             : {showLoginForm : showLoginForm},
                templateUrl        : 'app/views/'+ APP_NAME +'/elements/toolbar/dialogs/register/register-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            }).then(function (response){
                $rootScope.loggedIn = response;
                vm.loggedIn = $rootScope.loggedIn;
            }, function (error){

            })
            .catch(function (error){

            });
        }

        /**
        * Show login form
        */
        function showLoginForm(ev)
        {
            $mdDialog.show({
                controller         : 'LoginDialogController',
                controllerAs       : 'vm',
                locals             : {
                    showRegisterForm : showRegisterForm,
                    showRecoverForm : showRecoverForm
                },
                templateUrl        : 'app/views/'+ APP_NAME +'/elements/toolbar/dialogs/login/login-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            }).then(function (response){
                $rootScope.loggedIn = response;
                vm.loggedIn = $rootScope.loggedIn;
            }, function (error){

            })
            .catch(function (error){

            });

        }

        /**
        * Show recover password form
        */
        function showRecoverForm(ev)
        {
            $mdDialog.show({
                controller         : 'RecoverDialogController',
                controllerAs       : 'vm',
                locals             : {},
                templateUrl        : 'app/views/'+ APP_NAME +'/elements/toolbar/dialogs/recover/recover-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            }).then(function (response){

            }, function (error){

            })
            .catch(function (error){

            });
        }

        /**
        * Show join club form
        */
        function showJoinClubForm()
        {
            $mdDialog.show({
                controller         : 'ClubDialogController',
                controllerAs       : 'vm',
                locals             : {},
                templateUrl        : 'app/views/'+ APP_NAME +'/elements/toolbar/dialogs/club/club-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true
            }).then(function (response){
               $rootScope.joinclub = false;
            }, function (error){
                $rootScope.joinclub = false;
            })
            .catch(function (error){
                $rootScope.joinclub = false;
            });
        }

        /* Hide dialogs*/
        function closeDialog(){
          $scope.closeDialog = function() {
            $mdDialog.hide();
          }
        }

        function clearTickets() {
            $scope.$emit('clearAllSeats', {});
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.sidebar_left', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.sidebar_left')
        .controller('SideBarLeftController', SideBarLeftController);

    /** @ngInject */
    function SideBarLeftController($scope, $rootScope, $mdSidenav)
    {
        var vm = this;
        
        // Data
        
        $rootScope.foldedLeft = false;
        $rootScope.foldedRight = false;

        // Methods
        vm.toggleSidebar = toggleSidebar;
        
        //////////

        /**
         * Toggle mobile menu
         */
        function toggleSidebar(sidenavId){
            $mdSidenav(sidenavId).toggle();
        }

        $scope.$watch(function() {
            return $rootScope.foldedLeft;
        }, function(foldedLeft) {
            if( foldedLeft ){
                angular.element('body').addClass('sidebar-left-mobile-menu-active');
            }else{
                angular.element('body').removeClass('sidebar-left-mobile-menu-active');
            }
        });

        $scope.$watch(function() {
            return $rootScope.foldedRight;
        }, function(foldedRight) {
            if( foldedRight ){
                angular.element('body').addClass('sidebar-right-mobile-menu-active');
            }else{
                angular.element('body').removeClass('sidebar-right-mobile-menu-active');
            }
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.searchbar', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.searchbar')
        .controller('SearchbarController', SearchbarController);

    /** @ngInject */
  function SearchbarController($scope, $rootScope, $state, $log, $translate, $filter, $q, $timeout, $location, msUtils, api, _ba, Stations, GTM)
    {
        var vm = this;

        if( typeof $rootScope.route == 'undefined' ) {
          $rootScope.route = {
            originCityId: null,
            originCityParam: null,
            originCity: null,
            destinationCityId: null,
            destinationCityParam: null,
            destinationCity: null,
            departureDate: null,
            arrivalDate: null,
            requisition_id: null,
            outbound_route: {},
            return_route: {id: null},
            outbound_ticket: {},
            return_ticket: {},
            coupon: {}
          }
        }

        vm.searchbarShowing = 'show';
        vm.simulateQuery = false;
        vm.isDisabledOrigin = false;
        vm.isDisabledDestination = false;
        vm.currentDate = new Date();
        vm.departureMinDate = new Date(
          vm.currentDate.getFullYear(),
          vm.currentDate.getMonth(),
          vm.currentDate.getDate()
        );
        vm.arrivalMinDate = $rootScope.route.departureDate;

        vm.departureisOpen = false;
        vm.arrivalisOpen = false;

        //Methods
        vm.querySearchOrigin = querySearchOrigin;
        vm.querySearchDestination = querySearchDestination;
        vm.originCityChange = originCityChange;
        vm.destinationCityChange = destinationCityChange;
        vm.departureDateChange = departureDateChange;
        vm.arrivalDateChange = arrivalDateChange;
        vm.getCurrentDate = getCurrentDate;
        vm.reloadPage = reloadPage;
        vm.handleCalendar = handleCalendar;
        vm.toggleSearchbar = toggleSearchbar;

        /////////

        init();

        function init() {

          // Global search data
          if( $rootScope.route.originCity ){
            vm.originCity = $rootScope.route.originCity;
            vm.destinationCity = $rootScope.route.destinationCity;
          }else{
            $scope.$watch(function() {
              return $rootScope.route.originCity;
            }, function(originCity) {
                vm.originCity = originCity;
            });

            $scope.$watch(function() {
              return $rootScope.route.destinationCity;
            }, function(destinationCity) {
                vm.destinationCity = destinationCity;
            });
          }

          if( $rootScope.route.departureDate ){
            vm.departureDate = $rootScope.route.departureDate;
            vm.arrivalDate = $rootScope.route.arrivalDate;
          }else{
            $scope.$watch(function() {
              return $rootScope.route.departureDate;
            }, function(departureDate) {
                vm.departureDate = departureDate;
                vm.arrivalMinDate = departureDate;
            });

            $scope.$watch(function() {
                return $rootScope.route.arrivalDate;
            }, function(arrivalDate) {
                vm.arrivalDate = arrivalDate;
            });
          }

          /**
          * Get stations
          */
          vm.stations = {};
          vm.originStations = $rootScope.originStations != undefined ? $rootScope.originStations : [];
          vm.destinationStations = $rootScope.destinationStations != undefined ? $rootScope.destinationStations : [];

          // Gets origin stations
          Stations.origins()
            .then(function(response){
              vm.stations = response.data.stations;

              if ( !angular.isUndefined(vm.stations) ){
                var allStations = [];
                angular.forEach(vm.stations, function(value, key) {
                  if( value.is_origin == true )
                    this.push(value);
                }, allStations);

                vm.originStations = allStations;
                $rootScope.originStations = allStations;
                vm.isDisabledOrigin = false;

              }else{
                $translate('NOTIFICATION.ERRORS.ORIGINS')
                .then(function (error) {
                  msUtils.showNotification(error,'md-yellow-300-bg');
                  _ba.send('error', { "error": error });
                });
              }
            })
            .catch(onError);

          window.prerenderReady = true;
        }

        $rootScope.$on('searchbarController::editSearch', function (){
          if( angular.element('#searchbar').is(':visible') ){
            document.querySelector('#departure_city').focus();
            vm.originCity = null;
          }else{
            $state.go('app.home', {
                lang: $rootScope.selectedLanguage == 'en' ? 'en' : ''
            }, { reload: false });
          }
        });

        $rootScope.$on('searchbarController::editDestinationSearch', function (){
          Stations.destinations(null, $rootScope.route.originCityParam)
            .then(function (response) {
              vm.isDisabledDestination = false;
              vm.destinationStations = response.data.stations;
              $rootScope.destinationStations = vm.destinationStations;
              $timeout(function () { document.querySelector('#destination_city').focus();}, 100, false);
            })
            .catch(onError);
        });

        // Opens calendar date input
        function handleCalendar(open, route, ev){
          switch(route){
            case 'departure':
              vm.departureisOpen = open;
              break;
            case 'arrival':
              if( open == false ){
                vm.arrivalDate = null;
                $rootScope.route.arrivalDate = null;
              }else{
                vm.arrivalisOpen = open;
              }
              break;
          }
        }

        // Toggle mobile searchbar
        function toggleSearchbar () {
          $('.searchbar-container').toggleClass('show');
        }

        /**
         * Search for stations...
         */
        function querySearchOrigin (query) {
          var results = query ? vm.originStations.filter( createFilterFor(query) ) : vm.originStations,
            deferred;
          deferred = $q.defer();
          deferred.resolve(results);
          return deferred.promise;
        }
        function querySearchDestination (query) {
          var results = query ? vm.destinationStations.filter( createFilterFor(query) ) : vm.destinationStations,
              deferred;
          deferred = $q.defer();
          deferred.resolve(results);
          return deferred.promise;
        }

        function originCityChange(item) {
          if ( typeof item !== 'undefined'){
            if ( item.name !== undefined ){
                if ( item.name.length ){
                    $rootScope.route.originCity = item.name;
                    $rootScope.route.originCityId = item.id;
                    $rootScope.route.originCityParam = item.param;
                    clearDestinationField();
		    GTM.sendEvent($state.current.name, 'origen', item.name);
                    _ba.send('origin selected',{ "origin":item.name });

                    Stations.destinations(item.id)
                      .then(function(response){
                        vm.destinationStations = response.data.stations;
                        vm.isDisabledDestination = false;
                        $rootScope.destinationStations = vm.destinationStations;
                        $timeout(function () { document.querySelector('#destination_city').focus();}, 100, false);
                      })
                      .catch(onError);
                }
            }else{
              clearDestinationField();
            }
          }
        }

        function destinationCityChange(item2) {
          if ( item2 !== undefined ){
            if ( item2.name !== undefined ){
              //console.log(item2);
                if ( item2.name.length ){
                  //console.log(item2.name);
                    $rootScope.route.destinationCity = item2.name;
                    $rootScope.route.destinationCityId = item2.id;
                    $rootScope.route.destinationCityParam = item2.param;
  		    GTM.sendEvent($state.current.name, 'destino', item2.name);
                    _ba.send('destination selected',{ "destination":item2.name });

                    var deferred = $q.defer();
                    $timeout(function () { deferred.resolve( angular.element('#route_departure_date button').click() ); }, 0, false);
                    return deferred.promise;
                }
            }
          }
        }

        function clearDestinationField(){
          $timeout(function () {
            angular.element('#destination_city').val('');
            vm.isDisabledDestination = false;
            vm.searchText2 = '';
          }, 0, false);
        }

        /**
        * Create filter function for a query string
        */
        function createFilterFor(query) {
          var lowercaseQuery = msUtils.normalize(angular.lowercase(query));
          return function filterFn(station) {
            var stationLowerCase = msUtils.normalize(angular.lowercase(station.value));
            return (stationLowerCase.indexOf(lowercaseQuery) != -1);
          };

        }

        function departureDateChange(){
          vm.arrivalDate = null;
          $rootScope.route.arrivalDate = null;
          vm.arrivalMinDate = vm.departureDate;
          $rootScope.route.departureDate = vm.departureDate;
          GTM.sendEvent($state.current.name, 'fechas-ida', $scope.departureDate);
          _ba.send('departure date selected',{ "departure_date":vm.departureDate });
        }

        function arrivalDateChange(){
          $rootScope.route.arrivalDate = vm.arrivalDate;
	  GTM.sendEvent($state.current.name, 'fechas-vuelta', $scope.arrivalDate);
          _ba.send('arrival date selected',{ "arrival_date":vm.arrivalDate });
        }

        function getCurrentDate(){
          if( vm.departureDate == null || vm.departureDate == undefined ){
            vm.departureDate = new Date(
              vm.currentDate.getFullYear(),
              vm.currentDate.getMonth(),
              vm.currentDate.getDate()
            );
            $rootScope.route.departureDate = vm.departureDate;
          }
        }

        function reloadPage(){
          $rootScope.returnTravel = false;
          $rootScope.returnTicket = false;
          $rootScope.storedRoutes = false;
          if( vm.departureDate == null || vm.departureDate == undefined ){
            getCurrentDate();
            _ba.send('default date selected');
          }
          if( $rootScope.route.originCity != null && $rootScope.route.destinationCity != null ){
            var dates = $filter('date')($rootScope.route.departureDate, "yyyy-MM-dd");
            if($rootScope.route.arrivalDate){
              dates += ","+$filter('date')($rootScope.route.arrivalDate, "yyyy-MM-dd");
            }
            _ba.send('search for routes');
	    GTM.sendEvent($state.current.name, 'buscar');
            $state.go('app.routes', {
              //origin: $rootScope.route.originCityParam,
              //destination: $rootScope.route.destinationCityParam,
              dates: dates
            }, { reload: true });
          }
        }

        /*
        *   ERROR HANDLING
        */

        // Handles the error callback
        function onError(error) {
          if(error !== undefined && error.status !== 500){
            if( error.data != null ){
              var param = error.data.errors[0].param_name != null ? error.data.errors[0].param_name : '';
              var title = error.data.errors[0].message != undefined ? error.data.errors[0].message : error.data.errors[0].title;
              var message = param != '' ? param+', '+title : title;
              msUtils.showNotification(message,'md-yellow-300-bg');
              _ba.send('error', { "error": message });
            }else{
              $translate('NOTIFICATION.ERRORS.TIMEOUT').then(function (error) {
                msUtils.showNotification(error,'md-yellow-300-bg');
                _ba.send('error', { "error": error });
              });
            }
          }else{
            $translate('NOTIFICATION.ERROR500.NOTIFICATION').then(function (error) {
                msUtils.showNotification(error,'md-yellow-300-bg');
                _ba.send('error', { "error": error });
              });
          }
          angular.element('#subscribe_btn').removeAttr('disabled','disabled');
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.footer', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }
})();

(function() {
    'use strict';

    angular
        .module('app.footer')
        .controller('FooterController', FooterController);

    /** @ngInject */
    function FooterController($scope, $rootScope, $state, $http, $window, $document, $translate, $injector) {

        var vm = this;
        var APP_NAME = $injector.get('APP_NAME');

        var defaultFooterData = {
            es: [{
                    title: 'Aliados',
                    labels: [{
                            label: 'Futura',
                            link: 'https://busolinea.com.mx/autobuses/futura'
                        },
                        {
                            label: 'Chihuahuenses',
                            link: 'https://busolinea.com.mx/autobuses/chihuahuenses'
                        },
                        {
                            label: 'Grupo Estrella Blanca',
                            link: 'https://busolinea.com.mx/autobuses/estrella-blanca'
                        }
                    ]
                },
                {
                    title: 'Sobre Nosotros',
                    labels: [{
                            label: '¿Quiénes somos?',
                            link: 'https://busolinea.com.mx/quienes-somos'
                        },
                        {
                            label: 'Privacidad',
                            link: 'https://busolinea.com.mx/privacidad'
                        },
                        {
                            label: 'Términos y Condiciones',
                            link: 'https://busolinea.com.mx/terminos-y-condiciones'
                        }
                    ]
                },
                {
                    title: 'Contacto',
                    labels: [{
                            label: 'Atención a clientes:',
                            link: ''
                        },
                        {
                            label: 'DF. (55) 12-09-16-98',
                            link: 'tel:+525512091698'
                        }
                    ]
                }
            ],
            en: [{
                    title: 'Our Allies',
                    labels: [{
                            label: 'Futura',
                            link: 'https://busolinea.com.mx/autobuses/futura'
                        },
                        {
                            label: 'Chihuahuenses',
                            link: 'https://busolinea.com.mx/autobuses/chihuahuenses'
                        },
                        {
                            label: 'Grupo Estrella Blanca',
                            link: 'https://busolinea.com.mx/autobuses/estrella-blanca'
                        }
                    ]
                },
                {
                    title: 'Our company',
                    labels: [{
                            label: 'About us',
                            link: 'https://busolinea.com.mx/quienes-somos'
                        },
                        {
                            label: 'Data privacy',
                            link: 'https://busolinea.com.mx/privacidad'
                        },
                        {
                            label: 'Terms and conditions',
                            link: 'https://busolinea.com.mx/terminos-y-condiciones'
                        }
                    ]
                },
                {
                    title: 'Contact',
                    labels: [{
                            label: 'Customer Care:',
                            link: ''
                        },
                        {
                            label: 'Mexico City (55) 12-09-16-98',
                            link: 'Tel:+525512091698'
                        }
                    ]
                }
            ]
        }

        var socialMedia = [{
                name: 'icon-facebook',
                link: 'https://www.facebook.com/Busolinea',
                iconPath: 'https://s3.amazonaws.com/dullahan-production-bucket-18fzipqvl42tn/wp-content/uploads/2018/11/05211441/icon-facebook-square.svg'
            },
            {
                name: 'icon-twitter',
                link: 'https://twitter.com/busolinea',
                iconPath: 'https://s3.amazonaws.com/dullahan-production-bucket-18fzipqvl42tn/wp-content/uploads/2018/11/05211450/icon-twitter.svg'
            },
            {
                name: 'icon-instagram',
                link: 'https://www.instagram.com/busolinea',
                iconPath: 'https://s3.amazonaws.com/dullahan-production-bucket-18fzipqvl42tn/wp-content/uploads/2018/11/05211451/instagram_icon.svg'
            },
            {
                name: 'icon-email',
                link: 'mailto:soporte@busolinea.com.mx',
                iconPath: 'https://s3.amazonaws.com/dullahan-production-bucket-18fzipqvl42tn/wp-content/uploads/2018/11/05211449/icon-email.svg'
            }
        ]

        var copy = 'Busolinea © Copyright 2018. Todos los derechos reservados'

        $scope.dataFromApi = {
            en: {},
            es: {}
        }

        $scope.currentLanguage = $rootScope.selectedLanguage

        function obtainDataBothLanguages() {
            var languageAPI = ['en', 'es']
            languageAPI.map(function(language) {
                return getData(language)
            })
        }

        obtainDataBothLanguages()

        function getData(language) {
            if (APP_NAME === 'busolinea') {
                var params = {
                    method: 'GET',
                    url: 'https://dullahan.eb.digital/wp-json/wp/v2/' + APP_NAME + '?lang=' + language
                }

                $http(params)
                    .then(function(response) {
                        var infoRetrieved = response.data[0].acf
                        $scope.dataFromApi[language] = infoRetrieved.columns
                        $scope.dataSocialApi = infoRetrieved.social_media
                        $scope.copyright = infoRetrieved.copy
                        assignSocialIcon($scope.dataSocialApi)
                    }, function myError(err) {
                        $scope.dataFromApi[language] = defaultFooterData[language]
                        $scope.dataSocialApi = socialMedia
                        $scope.copyright = copy
                        assignSocialIcon($scope.dataSocialApi)
                    });
            }
        }

        function assignSocialIcon(data) {
            var dataSocial = data.map(function(element) {
                element.icon = getIcon(element.name)
            })
        }

        function getIcon(name) {
            switch (name) {
                case 'icon-facebook':
                    return 'fa fa-facebook'
                case 'icon-twitter':
                    return 'fa fa-twitter'
                case 'icon-email':
                    return 'fa fa-envelope'
                case 'icon-instagram':
                    return 'fa fa-instagram'
                case 'icon-pinterest':
                    return 'fa fa-pinterest'
                case 'icon-youtube':
                    return 'fa fa-youtube'
                case 'icon-linkedin':
                    return 'fa fa-linkedin'
                default:
                    return ''
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('timeoutHttpIntercept', timeoutHttpInterceptService);

    /** @ngInject */
    function timeoutHttpInterceptService($q, $location,localStorageService)
    {
        return {
            'request': function(config) {
                config.timeout = 180000;
                if (localStorageService.get("token")) {
                    config.headers['Authorization'] = localStorageService.get("token");
                }
                return config;
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('Stations', stationsService);

    /** @ngInject */
    function stationsService($q, api)
    {   
        // Makes a origin stations api request
        function getOrigins(){
            var defered = $q.defer();
            var promise = defered.promise;
            // API request for origins
            api.stations.origins.get(
               function (response){
                   defered.resolve(response);
               },
               function (error){
                   defered.reject(error);
               }
            );
            return promise;
        }

        // Makes a destinations stations api request
        function getDestinations(id, param){
            var defered = $q.defer();
            var promise = defered.promise;

            if (id) {
              // API request for destinations
              api.stations.destinations.get({id: id},
                 function (response){
                     defered.resolve(response);
                 },
                 function (error){
                     defered.reject(error);
                 }
              );
            } else {
              if (param) {
                // API request for destinations
                getStation(param)
                  .then(function(response) {
                    // Recursive call to get destination stations
                    getDestinations(response.data.station.id, null)
                      .then(function(response) {
                        defered.resolve(response);
                      })
                      .catch(function(error){
                        defered.reject(error);
                      })
                  })
                  .catch( function(error){
                    defered.reject(error);
                  });
              }
            }
            return promise;
        }

        // Gets the station information from the API
        function getStation(station){
          var defered = $q.defer();
          var promise = defered.promise;
          api.stations.find.get({station: station},
            function(response){
                defered.resolve(response);
            },
            function(error){
                defered.reject(error);
            }
          );
          return promise;
        }

        return {
            origins: getOrigins,
            destinations: getDestinations,
            station: getStation
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($rootScope, $window, $timeout, $http, $q)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists: exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile: isMobile,
            mobileOs: mobileOs,
            toggleInArray: toggleInArray,
            showNotification: showNotification,
            closeNotification: closeNotification,
            normalize: normalize,
            scrollToElement: scrollToElement,
            setMainSearchHeight: setMainSearchHeight,
            myIp: myIp
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists (item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser ()
        {
            // If we already tested, do not test again
            if (browserInfo) {
                return browserInfo;
            }

            var browserData = [
                {
                    string: $window.navigator.userAgent,
                    subString: 'Edge',
                    versionSearch: 'Edge',
                    identity: 'Edge'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity: 'Chrome'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity: 'OmniWeb'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'Apple',
                    versionSearch: 'Version',
                    identity: 'Safari'
                },
                {
                    prop: $window.opera,
                    identity: 'Opera'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'iCab',
                    identity: 'iCab'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'KDE',
                    identity: 'Konqueror'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity: 'Firefox'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'Camino',
                    identity: 'Camino'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity: 'Netscape'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'MSIE',
                    identity: 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Trident/7',
                    identity: 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Gecko',
                    identity: 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Mozilla',
                    identity: 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string: $window.navigator.platform,
                    subString: 'Win',
                    identity: 'Windows'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Mac',
                    identity: 'Mac'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Linux',
                    identity: 'Linux'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPhone',
                    identity: 'iPhone'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPod',
                    identity: 'iPod'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPad',
                    identity: 'iPad'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Android',
                    identity: 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString (data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if (dataString) {
                        if (dataString.indexOf(data[i].subString) !== -1) {
                            return data[i].identity;
                        }
                    } else if (dataProp) {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion (dataString) {
                var index = dataString.indexOf(versionSearchString);

                if (index === -1) {
                    return;
                }

                return dataString.substring(index + versionSearchString.length + 1);
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os: os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator () {
            var S4 = function () {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile () {
            return mobileDetect.mobile();
        }

        /**
         * Return mobile OS
         */
        function mobileOs () {
            var mobi = isMobile();
            switch (mobi) {
                case 'iPhone': var os = 'ios'; break;
                case 'iPad': var os = 'ios'; break;
                default: var os = 'android'; break;
            }
            return os;
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray (item, array) {
            if (array.indexOf(item) === -1) {
                array.push(item);
            } else {
                array.splice(array.indexOf(item), 1);
            }
        }

        // ////////

        /**
         * Creates a new notification
         *
         * @param color
         * @param text
         * @returns none
         */
        function showNotification (text, colorBg) {
            var limit = 8000;
            
            if ($rootScope.closeTimer !== undefined) {
                $timeout.cancel($rootScope.closeTimer);
            }

            var notificationEl = angular.element('#notifications');
            var notificationWrapper = notificationEl.find('#notification_wrapper');
            if (colorBg) {
                var oldColor = notificationWrapper.attr('data-color');
                notificationWrapper.attr('data-color', colorBg);
            }

            notificationWrapper.find('.message').html(text);
            notificationEl.addClass('visible');
            angular.element('.template-layout').animate({
                scrollTop:  0
            }, 300);

            $rootScope.closeTimer = $timeout(function(){
                    closeNotification();
            }, limit);

            /*var timer = function() {
                if( $rootScope.time < limit ) {
                    $rootScope.time += 1000;
                    $rootScope.runTimer = $timeout(timer, 1000);
                }
            }
            $rootScope.runTimer = $timeout(timer, 1000);  
            */
        }

        /**
         * Close the notification
         */
        function closeNotification () {
            var notificationEl = angular.element('#notifications');
            var notificationWrapper = notificationEl.find('#notification_wrapper');
            notificationEl.removeClass('visible');
            notificationWrapper.find('.message').html('');
        }

        /**
        * Normalize string accents
        */
        function normalize (str) {
            var from = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç',
                to = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc',
                mapping = {};
             
            for (var i = 0, j = from.length; i < j; i++)
                mapping[from.charAt(i)] = to.charAt(i);
    
            var ret = [];
            for (var i = 0, j = str.length; i < j; i++) {
                var c = str.charAt(i);
                if (mapping.hasOwnProperty(str.charAt(i)))
                    ret.push(mapping[c]);
                else
                    ret.push(c);
            }      
            return ret.join('');
        }

        /**
        * Set correct height to main search in home page
        */
        function setMainSearchHeight (mobile, desktop) {
          if (isMobile()) {
            angular.element('#main_search').css('height', (angular.element('body').height() - 128 - mobile) + 'px');
          } else {
            angular.element('#main_search').css('height', (angular.element('body').height() - 205 - desktop) + 'px');
          }
        }

         /**
         * ScrollTo element
         *
         * @param id
         * @param time
         * @returns none
         */
        function scrollToElement (id, time) {
            angular.element('.template-layout').animate({
                scrollTop: angular.element('#' + id).offset().top
            }, time);
        }

        function myIp () {
            var defered = $q.defer();
            var promise = defered.promise;
            $http({
                method: 'GET',
                url: 'https://api.ipify.org?format=json'
            }).then(function successCallback (response) {
                defered.resolve(response.data);
            }, function errorCallback (response) {
                defered.reject(error);
            });
            return promise;
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log, $resource)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('httpErrorResponseInterceptor', httpErrorResponseInterceptorService);

    /** @ngInject */
    function httpErrorResponseInterceptorService($q, $location)
    {
        return {
            request: function (config) {
                //console.log(config);
                config.headers = config.headers || {};
                return config;
            },
            requestError: function(rejection) {
                // console.log(rejection);
                return $q.reject(rejection);
            },
            response: function(responseData) {
                //console.log(responseData);
                return responseData;
            },
            responseError: function error(response) {
                // console.log(response);
                switch (response.status) {
                    case 503:
                        $location.path('error/503');
                }
                return $q.reject(response);
            }
        };
    }

})();
(function ()
 {
     'use strict';

     angular
         .module('app.core')
         .factory('GTM', GTMFactory);

     /** @ngInject */
     function GTMFactory(CONST, _ba) {
         var products     = [];

         return {
	     sendEvent: function(category, action, label, value){
		 if (category === "app.routes"){
		     category = "results";
		 }
		 if (category === "app.seats"){
		     category = "seats";
		 }

		 dataLayer.push({
                     'event': 'interaction',
		     'action': action,
		     'target': category, //category
		     'target-properties': label, //label
		     'value': value
                 });
	     },
             sendSearchResults: function(searchInfo){
                 products = [];
                 try {
                     dataLayer.push({
                         'requisition_id' : searchInfo.requisition_id,
                         'client_id'      : ga.getAll()[0].get('clientId')
                     });
                 }catch(e){}

                 dataLayer.push({
                     'event': 'searchResults',
		     'search_origin': searchInfo.originCityParam,
		     'search_destination': searchInfo.destinationCityParam
                 });

             },

             sendPurchase: function(reservation){
                 var coupon = (reservation.coupon != undefined) ? reservation.coupon.code : "";

                 dataLayer.push({
                     'event' : 'purchase',
                     'ecommerce': {
                         'purchase' : {
                             'actionField': {
                                 'id'         : reservation.id,
                                 'affiliation': 'geb',
                                 'revenue'    : reservation.total,
                                 'tax'        : reservation.iva,
                                 'coupon'     : coupon
                             },
                             'products': products
                         }
                     },
		     'cart_total': reservation.total,
                     'reservation_id' : reservation.id
                 });

                 _ba.send('conversion', { "total":reservation.total, "reservation_id":reservation.id });

             },

             sendCheckout: function(pds, total){
                 $.each(pds, function(i, pd){
                     if (pd != undefined) {
                         $.each(products, function(i2, pd2){
                             if(pd.id == pd2.seat_id) {
                                 products[i2]['price'] = pd.total;
                                 products[i2]['variant'] = pd.ticket_type;
                             }
                         });
                     }
                 });

                 dataLayer.push({
                     'event' : 'checkout',
                     'ecommerce': {
                         'checkout' : {
                             'products': products
                         }
                     },
		     'cart_total': total
                 });

             },

             sendRemoveCart: function(seat_id){
                 var pid = this.findProductIndex(seat_id);
                 if (pid >= 0) {
                     var pd = products[pid];
                     products.splice(pid, 1);

                     dataLayer.push({
                         'event' :"removeFromCart",
                         'ecommerce': {
                             'remove' : {
                                 'products': [pd]
                             }
                         },
			 'product': pd
                     });
                 }
             },

             findProductIndex: function(seat_id){
                 var index = -1;
                 $.each(products, function(i, pd){
                     if (pd.seat_id == seat_id) {
                         index = i;
                     }
                 });
                 return index;
             },

             sendAddToCart: function(searchInfo, product){
		 var pd = this.newProduct(searchInfo, product);
                 products.push(pd);

                 dataLayer.push({
                     'event' : 'addToCart',
                     'ecommerce': {
                         'currencyCode': 'MXN',
                         'add' : {
                             'products': products
                         }
                     },
		     'product': pd
                 });

             },

             newProduct: function (searchInfo, product){
                 var route;
                 var pd = {};

                 if (product.company != undefined) {
                     route = product;
                     pd['name']                   = searchInfo.originCityParam + "->" + searchInfo.destinationCityParam;
                     pd[CONST.GTM.ORIGIN]         = searchInfo.originCityParam;
                     pd[CONST.GTM.DESTINATION]    = searchInfo.destinationCityParam;
                 } else if (searchInfo.outbound_route.id == product.route_id) {
                     route = searchInfo.outbound_route;

                     pd['name']                   = searchInfo.originCityParam + "->" + searchInfo.destinationCityParam;
                     pd[CONST.GTM.ORIGIN]         = searchInfo.originCityParam;
                     pd[CONST.GTM.DESTINATION]    = searchInfo.destinationCityParam;

                 } else {
                     route = searchInfo.return_route;

                     pd['name']                   = searchInfo.destinationCityParam + "->" + searchInfo.originCityParam;
                     pd[CONST.GTM.ORIGIN]         = searchInfo.destinationCityParam;
                     pd[CONST.GTM.DESTINATION]    = searchInfo.originCityParam;
                 }

                 pd[CONST.GTM.LOCAL_PASO]     = (route.local == true) ? 'local' : 'paso';
                 pd['seat_id']                = product.seat_id;
                 pd['price']                  = route.price;
                 pd[CONST.GTM.REQUISITION_ID] = searchInfo.requisition_id;
                 pd['brand']                  = route.company.name;
                 pd[CONST.GTM.DEPARTURE_TIME] = route.departure_time;
                 pd[CONST.GTM.COMPANY]        = route.company.name;
                 pd['category']               = route.cabin_type_ws;
                 pd['quantity']               = 1;

                 return pd;
             },

             sendDetail: function (searchInfo, product) {
                 var pd = this.newProduct(searchInfo, product);

                 dataLayer.push({
                     'event':'selectProduct',
                     'ecommerce': {
                         'detail' : {
                             'actionField': {
                                 'list': 'Search Results'
                             },
                             'products': [pd]
                         }
                     },
		     'product': pd
                 });

                 return true;
             },

             pageTrack: function ( path ){
                 dataLayer.push({
                     'event': 'content-view',
                     'content-name': path
                 });
             },

             eventTrack: function ( action, properties ){
                 properties = properties || {};

                 dataLayer.push({
                     'event': 'interaction',
                     'target': properties.category,
                     'action': action,
                     'target-properties': properties.label,
                     'value': properties.value != undefined ? properties.value : 0,
                     'interaction-type': properties.noninteraction
                 });
             }
         };
     }

 })();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('Galerux', galeruxService);

    /** @ngInject */
    function galeruxService($q, api)
    {
         // Gets galerux album's elements
        function get_elements(album_id){
            var defered = $q.defer();
            var promise = defered.promise;

            api.galerux.elements.get({album_id: album_id},
              function(response){
                defered.resolve(response);
              },
              function(error){
                defered.reject(error);
              }
            );
            return promise;
        }

        return {
            get_elements: get_elements
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('_ba', _baService);

    /** @ngInject */
    function _baService($q, api, $cookies, msUtils, $filter, $state, $location)
    {   
        function baIdCookie(){
            if( angular.isUndefined($cookies.get('_baid')) ){
                var baid = msUtils.guidGenerator();
                var expireDate = new Date();
                expireDate.setDate(expireDate.getDate() + 1);
                $cookies.put('_baid', baid, {'expires': expireDate});  
            }
            return $cookies.get('_baid');
        }

        function baData(event, data){
       
            if( angular.isUndefined(data) ){
                data = {}
            }

            data.browser = msUtils.detectBrowser().browser;
            data.version = msUtils.detectBrowser().version;
            data.os = msUtils.detectBrowser().os;
            data.mobile = msUtils.isMobile() != null ? msUtils.isMobile() : '';
            data.current = $state.current.name;
            data.path = $location.path();
            data.dates = $state.params.dates;
            data.destination = $state.params.destination;
            data.gclid = $state.params.gclid;
            data.lang = $state.params.lang;
            data.origin = $state.params.origin;
            data.utm_campaign = $state.params.utm_campaign;
            data.utm_medium = $state.params.utm_medium;
            data.utm_source = $state.params.utm_source;
            data.utm_temporary = $state.params.utm_temporary;

            return data;
        }

        function toTimeZone(time, zone) {
            var format = 'YYYY-MM-DDTHH:mm:ssZ';
            return moment(time, format).tz(zone).format(format);
        }

        function send(event, data){
            var sid = baIdCookie();
            var ts = toTimeZone( $filter('date')(Date.now(), "yyyy-MM-ddTHH:mm:ssZ"), 'America/Mexico_City');
            var domain = $location.host();
            var data = baData(event, data);

            var defered = $q.defer();
            var promise = defered.promise;
            
            api.analytics.data.create({ sid:sid, ts:ts, event:event, domain:domain, data:data},
               function (response){
                   defered.resolve(response);
               },
               function (error){
                   defered.reject(error);
               }
            );

            return promise;
            
        }

        function get(){
           var defered = $q.defer();
            var promise = defered.promise;
            
            api.analytics.data.get({},
               function (response){
                   defered.resolve(response);
               },
               function (error){
                   defered.reject(error);
               }
            );

            return promise;
        }

        return {
            send:   send,
            get:    get
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('auth', initService);

    /** @ngInject */
    function initService($rootScope, $state, CONST, $http, localStorageService)
    {
        var self = this;

        self.on = {

          login: function(user) {
            var promise = $http({
              url: CONST.BUS_API_URL + "sessions",
              method: "POST",
              data: {
                "email": user.email,
                "password": user.password,
                "deviceprint": user.deviceprint
              }
            })

            return promise

          },

          logout: function(){
            localStorageService.clearAll()
          },

          signup: function(user){
            var promise = $http({
              url: CONST.BUS_API_URL + "users",
              method: "POST",
              data: {
                "email": user.email,
                "password": user.password
              }
            })

            return promise
          }
        }

        return self;
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/* global define */

(function ($) {
  'use strict'

  /*
  * Add integers, wrapping at 2^32. This uses 16-bit operations internally
  * to work around bugs in some JS interpreters.
  */
  function safeAdd (x, y) {
    var lsw = (x & 0xffff) + (y & 0xffff)
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16)
    return (msw << 16) | (lsw & 0xffff)
  }

  /*
  * Bitwise rotate a 32-bit number to the left.
  */
  function bitRotateLeft (num, cnt) {
    return (num << cnt) | (num >>> (32 - cnt))
  }

  /*
  * These functions implement the four basic operations the algorithm uses.
  */
  function md5cmn (q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b)
  }
  function md5ff (a, b, c, d, x, s, t) {
    return md5cmn((b & c) | (~b & d), a, b, x, s, t)
  }
  function md5gg (a, b, c, d, x, s, t) {
    return md5cmn((b & d) | (c & ~d), a, b, x, s, t)
  }
  function md5hh (a, b, c, d, x, s, t) {
    return md5cmn(b ^ c ^ d, a, b, x, s, t)
  }
  function md5ii (a, b, c, d, x, s, t) {
    return md5cmn(c ^ (b | ~d), a, b, x, s, t)
  }

  /*
  * Calculate the MD5 of an array of little-endian words, and a bit length.
  */
  function binlMD5 (x, len) {
    /* append padding */
    x[len >> 5] |= 0x80 << (len % 32)
    x[((len + 64) >>> 9 << 4) + 14] = len

    var i
    var olda
    var oldb
    var oldc
    var oldd
    var a = 1732584193
    var b = -271733879
    var c = -1732584194
    var d = 271733878

    for (i = 0; i < x.length; i += 16) {
      olda = a
      oldb = b
      oldc = c
      oldd = d

      a = md5ff(a, b, c, d, x[i], 7, -680876936)
      d = md5ff(d, a, b, c, x[i + 1], 12, -389564586)
      c = md5ff(c, d, a, b, x[i + 2], 17, 606105819)
      b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330)
      a = md5ff(a, b, c, d, x[i + 4], 7, -176418897)
      d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426)
      c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341)
      b = md5ff(b, c, d, a, x[i + 7], 22, -45705983)
      a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416)
      d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417)
      c = md5ff(c, d, a, b, x[i + 10], 17, -42063)
      b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162)
      a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682)
      d = md5ff(d, a, b, c, x[i + 13], 12, -40341101)
      c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290)
      b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329)

      a = md5gg(a, b, c, d, x[i + 1], 5, -165796510)
      d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632)
      c = md5gg(c, d, a, b, x[i + 11], 14, 643717713)
      b = md5gg(b, c, d, a, x[i], 20, -373897302)
      a = md5gg(a, b, c, d, x[i + 5], 5, -701558691)
      d = md5gg(d, a, b, c, x[i + 10], 9, 38016083)
      c = md5gg(c, d, a, b, x[i + 15], 14, -660478335)
      b = md5gg(b, c, d, a, x[i + 4], 20, -405537848)
      a = md5gg(a, b, c, d, x[i + 9], 5, 568446438)
      d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690)
      c = md5gg(c, d, a, b, x[i + 3], 14, -187363961)
      b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501)
      a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467)
      d = md5gg(d, a, b, c, x[i + 2], 9, -51403784)
      c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473)
      b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734)

      a = md5hh(a, b, c, d, x[i + 5], 4, -378558)
      d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463)
      c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562)
      b = md5hh(b, c, d, a, x[i + 14], 23, -35309556)
      a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060)
      d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353)
      c = md5hh(c, d, a, b, x[i + 7], 16, -155497632)
      b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640)
      a = md5hh(a, b, c, d, x[i + 13], 4, 681279174)
      d = md5hh(d, a, b, c, x[i], 11, -358537222)
      c = md5hh(c, d, a, b, x[i + 3], 16, -722521979)
      b = md5hh(b, c, d, a, x[i + 6], 23, 76029189)
      a = md5hh(a, b, c, d, x[i + 9], 4, -640364487)
      d = md5hh(d, a, b, c, x[i + 12], 11, -421815835)
      c = md5hh(c, d, a, b, x[i + 15], 16, 530742520)
      b = md5hh(b, c, d, a, x[i + 2], 23, -995338651)

      a = md5ii(a, b, c, d, x[i], 6, -198630844)
      d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415)
      c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905)
      b = md5ii(b, c, d, a, x[i + 5], 21, -57434055)
      a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571)
      d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606)
      c = md5ii(c, d, a, b, x[i + 10], 15, -1051523)
      b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799)
      a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359)
      d = md5ii(d, a, b, c, x[i + 15], 10, -30611744)
      c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380)
      b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649)
      a = md5ii(a, b, c, d, x[i + 4], 6, -145523070)
      d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379)
      c = md5ii(c, d, a, b, x[i + 2], 15, 718787259)
      b = md5ii(b, c, d, a, x[i + 9], 21, -343485551)

      a = safeAdd(a, olda)
      b = safeAdd(b, oldb)
      c = safeAdd(c, oldc)
      d = safeAdd(d, oldd)
    }
    return [a, b, c, d]
  }

  /*
  * Convert an array of little-endian words to a string
  */
  function binl2rstr (input) {
    var i
    var output = ''
    var length32 = input.length * 32
    for (i = 0; i < length32; i += 8) {
      output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff)
    }
    return output
  }

  /*
  * Convert a raw string to an array of little-endian words
  * Characters >255 have their high-byte silently ignored.
  */
  function rstr2binl (input) {
    var i
    var output = []
    output[(input.length >> 2) - 1] = undefined
    for (i = 0; i < output.length; i += 1) {
      output[i] = 0
    }
    var length8 = input.length * 8
    for (i = 0; i < length8; i += 8) {
      output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32)
    }
    return output
  }

  /*
  * Calculate the MD5 of a raw string
  */
  function rstrMD5 (s) {
    return binl2rstr(binlMD5(rstr2binl(s), s.length * 8))
  }

  /*
  * Calculate the HMAC-MD5, of a key and some data (raw strings)
  */
  function rstrHMACMD5 (key, data) {
    var i
    var bkey = rstr2binl(key)
    var ipad = []
    var opad = []
    var hash
    ipad[15] = opad[15] = undefined
    if (bkey.length > 16) {
      bkey = binlMD5(bkey, key.length * 8)
    }
    for (i = 0; i < 16; i += 1) {
      ipad[i] = bkey[i] ^ 0x36363636
      opad[i] = bkey[i] ^ 0x5c5c5c5c
    }
    hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8)
    return binl2rstr(binlMD5(opad.concat(hash), 512 + 128))
  }

  /*
  * Convert a raw string to a hex string
  */
  function rstr2hex (input) {
    var hexTab = '0123456789abcdef'
    var output = ''
    var x
    var i
    for (i = 0; i < input.length; i += 1) {
      x = input.charCodeAt(i)
      output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f)
    }
    return output
  }

  /*
  * Encode a string as utf-8
  */
  function str2rstrUTF8 (input) {
    return unescape(encodeURIComponent(input))
  }

  /*
  * Take string arguments and return either raw or hex encoded strings
  */
  function rawMD5 (s) {
    return rstrMD5(str2rstrUTF8(s))
  }
  function hexMD5 (s) {
    return rstr2hex(rawMD5(s))
  }
  function rawHMACMD5 (k, d) {
    return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d))
  }
  function hexHMACMD5 (k, d) {
    return rstr2hex(rawHMACMD5(k, d))
  }

  function md5 (string, key, raw) {
    if (!key) {
      if (!raw) {
        return hexMD5(string)
      }
      return rawMD5(string)
    }
    if (!raw) {
      return hexHMACMD5(key, string)
    }
    return rawHMACMD5(key, string)
  }

  if (typeof define === 'function' && define.amd) {
    define(function () {
      return md5
    })
  } else if (typeof module === 'object' && module.exports) {
    module.exports = md5
  } else {
    $.md5 = md5
  }
})(this);

/*!
 * jQuery.BgSwitcher
 *
 * @version  0.4.3
 * @author   rewish <rewish.org@gmail.com>
 * @license  MIT License (https://github.com/rewish/jquery-bgswitcher/blob/master/LICENSE.md)
 * @link     https://github.com/rewish/jquery-bgswitcher
 */
(function($) {
  'use strict';

  var loadedImages = {},

      slice = Array.prototype.slice,
      toString = Object.prototype.toString,

      corners = ['Top', 'Right', 'Bottom', 'Left'],
      backgroundProperties = [
        'Attachment', 'Color', 'Image', 'Repeat',
        'Position', 'Size', 'Clip', 'Origin'
      ];

  $.fn.bgswitcher = function() {
    var args = arguments,
        instanceKey = BgSwitcher.keys.instance;

    return this.each(function() {
      var instance = $.data(this, instanceKey);

      if (!instance) {
        instance = new BgSwitcher(this);
        $.data(this, instanceKey, instance);
      }

      instance.dispatch.apply(instance, args);
    });
  };

  // Backward Compatibility
  $.fn.bgSwitcher = $.fn.bgswitcher;

  /**
   * BgSwitcher
   *
   * @param {HTMLElement} el
   * @constructor
   */
  function BgSwitcher(el) {
    this.$el = $(el);
    this.index = 0;
    this.config = $.extend({}, BgSwitcher.defaultConfig);

    this._setupBackgroundElement();
    this._listenToResize();
  }

  $.extend(BgSwitcher.prototype, {
    /**
     * Dispatch
     *
     * @param {string|Array} one
     */
    dispatch: function(one) {
      switch (toString.call(one)) {
        case '[object Object]':
          this.setConfig(one);
          break;
        case '[object String]':
          this[one].apply(this, slice.call(arguments, 1));
          break;
        default:
          throw new Error('Please specify a Object or String');
      }
    },

    /**
     * Set config
     *
     * @param {Object} config
     */
    setConfig: function(config) {
      this.config = $.extend(this.config, config);

      if (typeof this.config.random !== 'undefined') {
        this.config.shuffle = this.config.random;
      }

      this.refresh();
    },

    /**
     * Set images
     *
     * @param {Array} images
     */
    setImages: function(images) {
      this.imageList = new this.constructor.ImageList(images);

      if (this.config.shuffle) {
        this.imageList.shuffle();
      }
    },

    /**
     * Set switch handler
     *
     * @param {Function} fn
     */
    setSwitchHandler: function(fn) {
      this.switchHandler = $.proxy(fn, this);
    },

    /**
     * Default switch handler
     *
     * @param {string} type
     * @returns {Function}
     */
    getBuiltInSwitchHandler: function(type) {
      return this.constructor.switchHandlers[type || this.config.effect];
    },

    /**
     * Refresh
     */
    refresh: function() {
      this.setImages(this.config.images);
      this.setSwitchHandler(this.getBuiltInSwitchHandler());
      this._prepareSwitching();

      if (this.config.start) {
        this.start();
      }
    },

    /**
     * Start switching
     */
    start: function() {
      if (!this._timerID) {
        this._timerID = setTimeout($.proxy(this, 'next'), this.config.interval);
      }
    },

    /**
     * Stop switching
     */
    stop: function() {
      if (this._timerID) {
        clearTimeout(this._timerID);
        this._timerID = null;
      }
    },

    /**
     * Toggle between start/stop
     */
    toggle: function() {
      if (this._timerID) {
        this.stop();
      } else {
        this.start();
      }
    },

    /**
     * Reset switching
     */
    reset: function() {
      this.index = 0;
      this._prepareSwitching();
    },

    /**
     * Go to next switching
     */
    next: function() {
      var max = this.imageList.count();

      if (!this.config.loop && this.index + 1 === max) {
        return;
      }

      if (++this.index === max) {
        this.index = 0;
      }

      this.switching();
    },

    /**
     * Go to previous switching
     */
    prev: function() {
      if (!this.config.loop && this.index === 0) {
        return;
      }

      if (--this.index === -1) {
        this.index = this.imageList.count() - 1;
      }

      this.switching();
    },

    /**
     * Select the switching at index
     *
     * @param {number} index
     */
    select: function(index) {
      if (index === -1) {
        index = this.imageList.count() - 1;
      }

      this.index = index;
      this.switching();
    },

    /**
     * Switching the background image
     */
    switching: function() {
      var started = !!this._timerID;

      if (started) {
        this.stop();
      }

      this._createSwitchableElement();
      this._prepareSwitching();
      this.switchHandler && this.switchHandler(this.$switchable);

      if (started) {
        this.start();
      }
    },

    /**
     * Destroy...
     */
    destroy: function() {
      this.stop();
      this._stopListeningToResize();

      if (this.$switchable) {
        this.$switchable.stop();
        this.$switchable.remove();
        this.$switchable = null;
      }

      if (this.$bg) {
        this.$bg.remove();
        this.$bg = null;
      }

      this.$el.removeAttr('style');
      this.$el.removeData(this.constructor.keys.instance);
      this.$el = null;
    },

    /**
     * Adjust rectangle
     */
    _adjustRectangle: function() {
      var corner,
          i = 0,
          length = corners.length,
          offset = this.$el.position(),
          copiedStyles = {
            top: offset.top,
            left: offset.left,
            width: this.$el.innerWidth(),
            height: this.$el.innerHeight()
          };

      for (; i < length; i++) {
        corner = corners[i];
        copiedStyles['margin' + corner] = this.$el.css('margin' + corner);
        copiedStyles['border' + corner] = this.$el.css('border' + corner);
      }

      this.$bg.css(copiedStyles);
    },

    /**
     * Setup background element
     */
    _setupBackgroundElement: function() {
      this.$bg = $(document.createElement('div'));
      this.$bg.css({
        position: 'absolute',
        zIndex: (parseInt(this.$el.css('zIndex'), 10) || 0) - 1,
        overflow: 'hidden'
      });

      this._copyBackgroundStyles();
      this._adjustRectangle();

      if (this.$el[0].tagName === 'BODY') {
        this.$el.prepend(this.$bg);
      } else {
        this.$el.before(this.$bg);
        this.$el.css('background', 'none');
      }
    },

    /**
     * Create switchable element
     */
    _createSwitchableElement: function() {
      if (this.$switchable) {
        this.$switchable.remove();
      }

      this.$switchable = this.$bg.clone();
      this.$switchable.css({top: 0, left: 0, margin: 0, border: 'none'});
      this.$switchable.appendTo(this.$bg);
    },

    /**
     * Copy background styles
     */
    _copyBackgroundStyles: function () {
      var prop,
          copiedStyle = {},
          i = 0,
          length = backgroundProperties.length,
          backgroundPosition = 'backgroundPosition';

      for (; i < length; i++) {
        prop = 'background' + backgroundProperties[i];
        copiedStyle[prop] = this.$el.css(prop);
      }

      // For IE<=9
      if (copiedStyle[backgroundPosition] === undefined) {
        copiedStyle[backgroundPosition] = [
          this.$el.css(backgroundPosition + 'X'),
          this.$el.css(backgroundPosition + 'Y')
        ].join(' ');
      }

      this.$bg.css(copiedStyle);
    },

    /**
     * Listen to the resize event
     */
    _listenToResize: function() {
      var that = this;
      this._resizeHandler = function() {
        that._adjustRectangle();
      };
      $(window).on('resize', this._resizeHandler);
    },

    /**
     * Stop listening to the resize event
     */
    _stopListeningToResize: function() {
      $(window).off('resize', this._resizeHandler);
      this._resizeHandler = null;
    },

    /**
     * Prepare the Switching
     */
    _prepareSwitching: function() {
      if (this.imageList) {
        this.$bg.css('backgroundImage', this.imageList.url(this.index)); 
      }      
    }
  });

  /**
   * Data Keys
   * @type {Object}
   */
  BgSwitcher.keys = {
    instance: 'bgSwitcher'
  };

  /**
   * Default Config
   * @type {Object}
   */
  BgSwitcher.defaultConfig = {
    images: [],
    interval: 5000,
    start: true,
    loop: true,
    shuffle: false,
    effect: 'fade',
    duration: 1000,
    easing: 'swing'
  };

  /**
   * Built-In switch handlers (effects)
   * @type {Object}
   */
  BgSwitcher.switchHandlers = {
    fade: function($el) {
      $el.animate({opacity: 0}, this.config.duration, this.config.easing);
    },

    blind: function($el) {
      $el.animate({height: 0}, this.config.duration, this.config.easing);
    },

    clip: function($el) {
      $el.animate({
        top: parseInt($el.css('top'), 10) + $el.height() / 2,
        height: 0
      }, this.config.duration, this.config.easing);
    },

    slide: function($el) {
      $el.animate({top: -$el.height()}, this.config.duration, this.config.easing);
    },

    drop: function($el) {
      $el.animate({
        left: -$el.width(),
        opacity: 0
      }, this.config.duration, this.config.easing);
    },

    hide: function($el) {
      $el.hide();
    }
  };

  /**
   * Define effect
   *
   * @param {String} name
   * @param {Function} fn
   */
  BgSwitcher.defineEffect = function(name, fn) {
    this.switchHandlers[name] = fn;
  };

  /**
   * BgSwitcher.ImageList
   *
   * @param {Array} images
   * @constructor
   */
  BgSwitcher.ImageList = function(images) {
    this.images = images;
    this.createImagesBySequence();
    this.preload();
  };

  $.extend(BgSwitcher.ImageList.prototype, {
    /**
     * Images is sequenceable
     *
     * @returns {boolean}
     */
    isSequenceable: function() {
      return typeof this.images[0] === 'string' &&
          typeof this.images[1] === 'number' &&
          typeof this.images[2] === 'number';
    },

    /**
     * Create an images by sequence
     */
    createImagesBySequence: function() {
      if (!this.isSequenceable()) {
        return;
      }

      var images = [],
          base = this.images[0],
          min = this.images[1],
          max = this.images[2];

      do {
        images.push(base.replace(/\.\w+$/, min + '$&'));
      } while (++min <= max);

      this.images = images;
    },

    /**
     * Preload an images
     */
    preload: function() {
      var path,
          length = this.images.length,
          i = 0;

      for (; i < length; i++) {
        path = this.images[i];
        if (!loadedImages[path]) {
          loadedImages[path] = new Image();
          loadedImages[path].src = path;
        }
      }
    },

    /**
     * Shuffle an images
     */
    shuffle: function() {
      var j, t,
          i = this.images.length,
          original = this.images.join();

      if (!i) {
        return;
      }

      while (i) {
        j = Math.floor(Math.random() * i);
        t = this.images[--i];
        this.images[i] = this.images[j];
        this.images[j] = t;
      }

      if (this.images.join() === original) {
        this.shuffle();
      }
    },

    /**
     * Get the image from index
     *
     * @param {number} index
     * @returns {string}
     */
    get: function(index) {
      return this.images[index];
    },

    /**
     * Get the URL with function of CSS
     *
     * @param {number} index
     * @returns {string}
     */
    url: function(index) {
      return 'url(' + this.get(index) + ')';
    },

    /**
     * Count of images
     *
     * @returns {number}
     */
    count: function() {
      return this.images.length;
    }
  });

  $.BgSwitcher = BgSwitcher;
}(jQuery));

!function(){var t;if(void 0===window.jQuery||"1.4.2"!==window.jQuery.fn.jquery){var e=document.createElement("script");e.setAttribute("type","text/javascript"),e.setAttribute("src","https://ajax.googleapis.com/ajax/libs/jquery/1.4.2/jquery.min.js"),e.readyState?e.onreadystatechange=function(){"complete"!=this.readyState&&"loaded"!=this.readyState||i()}:e.onload=i,(document.getElementsByTagName("head")[0]||document.documentElement).appendChild(e)}else t=window.jQuery,o();function i(){t=window.jQuery.noConflict(!0),o()}function o(){t(document).ready(function(t){window.CPLPY=new c})}function n(t){try{var e=JSON.parse(t.data),i=e.action;"cancel"==i&&isCoppelCancel(),"response"==i&&(window.CPLPY.blackbox=e.blackbox,window.CPLPY.token=e.token,isCoppelReady())}catch(t){}}var c=function(){};c.prototype.init=function(t){this.solicitud=t,this.cpplDiv=document.getElementById("cpplPay"),window.addEventListener("message",n)},c.prototype.open=function(){window.CPLPY.sandbox?this.cpplDiv.innerHTML='<iframe src="https://sdk.coppelpay.com/coppelpaysdk/ccplpytest.html?solicitud='+this.solicitud+'" frameborder="0" allowfullscreen style="display:block; width:580; height:790;"></iframe>':this.cpplDiv.innerHTML='<iframe src="https://sdk.coppelpay.com/coppelpaysdk/ccplpy.html?solicitud='+this.solicitud+'" frameborder="0" allowfullscreen style="display:block; width:580; height:790;"></iframe>'},c.prototype.close=function(){},c.prototype.isOpen=function(){},c.prototype.setDimensions=function(t,e){this.width=t,this.height=e,this.content.style.width=t+"px",this.content.style.height=e+"px"}}();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('cabinType', cabinTypeFilter)
        .filter('localPaso', localpasoFilter)
        .filter('busCompany', busCompanyFilter)
        .filter('timeRange', timeRangeFilter)
        .filter('timeRangeSlider', timeRangeSliderFilter)
        .filter('orinfo', orinfoFilter);

    /** @ngInject */
  function cabinTypeFilter(msUtils)
    {
        return function (items, cabinTypes) {
            var filtered = [];
            var flag = 0;
            angular.forEach(items, function(item) {

                angular.forEach(cabinTypes, function(cabin) {
                    if(cabin.check == true && msUtils.normalize(item.cabin_type_ws.toLowerCase().replace(/ /g, '')) == cabin.type ){
                      filtered.push(item);
                    }
                });

            });

            return filtered;
        }
    }

    /** @ngInject */
    function localpasoFilter()
    {
        return function (items, localPaso) {
            var filtered = [];
            var flag = 0;

            angular.forEach(items, function(item) {

                angular.forEach(localPaso, function(type) {
                    if( type.check == true && item.local == type.local){
                      filtered.push(item);
                    }
                });

            });

            return filtered;
        }
    }

    /** @ngInject */
    function busCompanyFilter()
    {
        return function (items, busCompanies) {
            var filtered = [];
            var flag = 0;

            angular.forEach(items, function(item) {

                angular.forEach(busCompanies, function(bus) {
                    if(bus.check == true && item.company.name.toLowerCase() == bus.id ){
                      filtered.push(item);
                    }
                });

            });

            return filtered;
        }
    }

    var c = 0;

    /** @ngInject */
    function timeRangeFilter() {
      return function (items, filterTime) {
        if (!filterTime || filterTime[4]['value']) {
          return items;
        }

        return items.filter(function (item) {
			var departureTime = item.departure_time.replace(':', "");
            return filterTime.some(function (filter) {
                return filter.value && filter.range.min*100 <= departureTime && departureTime < filter.range.max*100;
            });

        });
      };
    }

       /** @ngInject */
    function timeRangeSliderFilter()
    {
        return function (items, minTime, maxTime){
            var filtered = [];

            angular.forEach(items, function(item) {
                var hour = item.departure_time.split(':');
                if(hour[0] >= minTime && hour[0] <= maxTime){
                    filtered.push(item);
                }
            });

            return filtered;
        }

    }


     /** @ngInject */
    function orinfoFilter()
    {
        return function (items, orinfo) {
            var filtered = [];
            var flag = 0;
            angular.forEach(items, function(item) {
                if( item.orinfo == orinfo || orinfo == '-1') {
                    filtered.push(item);
                }
            });

            return filtered;
        }
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter)
        .filter('clockString', clockStringFilter)
        .filter('normalizeTime', normalizeTimeFilter)
        .filter('formatPrice', formatPriceFilter)
        .filter('money', moneyFilter)
        .filter('formatDuration', formatDurationFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

    /** @ngInject */
    function clockStringFilter()
    {
        return function (text)
        {
            var hour = text < 10 ? '0'+text : text;
            var min = '00';
            if( hour == 24 ){
                --hour;
                min = 59;
            }

            return hour < 10 ? hour+':'+min : hour+':'+min;
        };
    }

    /** @ngInject */
    function normalizeTimeFilter()
    {
        return function (time)
        {
            var time = time.toString().split(".");
            time[1] = time[1] != undefined ? time[1] :'00';
            var timeString = time[0]+'h '+time[1]+'min';
            return timeString;
        };
    }

    function formatPriceFilter() {
        return function(price, digits, thoSeperator, decSeperator, bdisplayprice) {
            var i;
            digits = (typeof digits === "undefined") ? 2 : digits;
            bdisplayprice = (typeof bdisplayprice === "undefined") ? true : bdisplayprice;
            thoSeperator = (typeof thoSeperator === "undefined") ? "." : thoSeperator;
            decSeperator = (typeof decSeperator === "undefined") ? "," : decSeperator;
            price = price.toString();
            var _temp = price.split(".");
            var dig = (typeof _temp[1] === "undefined") ? "00" : _temp[1];
            if (bdisplayprice && parseInt(dig,10)===0) {
                dig = "-";
            } else {
                dig = dig.toString();
                if (dig.length > digits) {
                    dig = (Math.round(parseFloat("0." + dig) * Math.pow(10, digits))).toString();
                }
                for (i = dig.length; i < digits; i++) {
                    dig += "0";
                }
            }
            var num = _temp[0];
            var s = "",
                ii = 0;
            for (i = num.length - 1; i > -1; i--) {
                s = ((ii++ % 3 === 2) ? ((i > 0) ? thoSeperator : "") : "") + num.substr(i, 1) + s;
            }
            return s + decSeperator + dig;
        };
    }

    function moneyFilter() {
        return function (input) {
            return '$ ' + input.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        };
    }

    function formatDurationFilter(){
        return function (time) {
    	    var time = time.toString().split(".");
    	    time[1] = time[1] != undefined ? time[1] :'00';
    	    var timeString = time[0]+'h '+time[1]+'min';
            return timeString;
    	};
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('busolineaConfig', busolineaConfigProvider);

    /** @ngInject */
    function busolineaConfigProvider()
    {
        // Default configuration
        var busolineaConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            busolineaConfiguration = angular.extend({}, busolineaConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(busolineaConfiguration[configName]) )
                {
                    return false;
                }

                return busolineaConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                busolineaConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, busolineaConfig, $rootScope)
    {

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( busolineaConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.core')
    .constant('CONST', {
      APP_NAME: 'transportamex',
      HOST_URL: location.origin,
      BUS_API_URL: 'https://z8am40yb42.execute-api.us-east-1.amazonaws.com/prod4/v1/',
      BUS_API_KEY: 'OvwxpNfw4x9MUmsVrNqIy3CTedSU09S9cz1uiCOj',
      DEPLOYMENT_ENVIRONMENT: 'production',
      CONEKTA_API_KEY: 'key_U2VHJZnz2XGy6ygo6UJ2WXA',
      OPENPAY_ID: 'ma8iqlbegu8qoqbcgycf',
      OPENPAY_API_KEY: 'pk_930ad039a217406f98c0f4037894df7c',
      OPENPAY_TEST: false,
      PAYMENT_GATEWAY: 'conekta',
      GTM: {
        ORIGIN: 'dimension3',
        DESTINATION: 'dimension4',
        DEPARTURE_DATE: 'dimension5',
        REQUISITION_ID: 'dimension6',
        COMPANY: 'dimension8',
        DEPARTURE_TIME: 'dimension7',
        LOCAL_PASO: 'dimension9'
      },
      GALERUX_API_KEY: 'JucYRo3c0T8R5IDBE75Xs4ZHO03gXt068Z93Y5W5',
      GALERUX_URL: 'https://22uid7n4nl.execute-api.us-east-1.amazonaws.com/production/albums/',
      SLIDESHOW_ID: '57b04490-bd81-11e7-95f1-dbbe6d4de9f2',
      BG_ID: '57b04490-bd81-11e7-95f1-dbbe6d4de9f2',
      NEWSLETTER_API_URL: 'https://l93k4b06hj.execute-api.us-east-1.amazonaws.com/production/',
      NEWSLETTER_API_KEY: 'K0hwdmyx6va6MtsmDHt3Ka8PMGAcJr3C6AedQDPS',
      COPPELPAY_BASE_URL: 'https://api.coppelpay.com/CoppelPay/',
      COPPELPAY_TEST: false,
      COPPELPAY_PUBLIC_KEY: '76928bddd8377b6c28195ff92616677734a3a5b4',
      COPPELPAY_PRIVATE_KEY: 'ELh6ehQPQF2euPXqJ/9g2RRZ/bK6UQ3xzlDOCrBr5EFArB/8z7pBZfzXri1k65RGrtt1V3t/H6z7HxfeFFQCUoyjGAENGts5XW7QZAPFGmMmT=BxEq8xOGRtetfVXH/SB6GzHucmQYIIYhdAHl6t0XXfoa8kR7ardR/Ujaf86XQ2c1DUnKmnFhC2rKmhSxJ3nHYHSbPZ7D0kFEc0mzo=Q/2gJoxzWeDhWAYMMLKTnKb0mo0IXoIMnK057yF1MhiHResB/atlUFlf1mYZLFJ6nJcvgRw16PIY18y0j=mcEHrG2oEN1lUp35VjWpk1c1/eawftvBF8h5Pjur5vN/VR3O9/ct=pvZDFtT7ZsM6JSV1kl6Q74JY8w56Jz5623KIxBPv2ABMqvNKRUyYZgU5NZbuxhBAkkgSV4lYEWI2q'
    });
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .config(config);

  /** @ngInject */
  function config ($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, $provide,
    busolineaConfigProvider, tmhDynamicLocaleProvider, $mdDateLocaleProvider, CONST) {
    // Please verify PAYMENT_GATEWAY constant on index.constants.js after change APP_NAME
    // var APP_NAME = "futura";
    var APP_NAME = CONST.APP_NAME;
    var APP_TITLE = '';
    switch (APP_NAME) {
      case 'busolinea': APP_TITLE = 'Busolinea'; break;
      case 'futura': APP_TITLE = 'Futura'; break;
      case 'geb': APP_TITLE = 'Grupo Estrella Blanca'; break;
      case 'chihuahuenses': APP_TITLE = 'Chihuahuenses'; break;
      case 'transportamex': APP_TITLE = 'Transportamex'; break;
      case 'anahuac': APP_TITLE = 'Anahuac'; break;
      case 'frontera': APP_TITLE = 'Frontera';
    }

    $provide.constant('APP_NAME', APP_NAME);
    $provide.constant('APP_TITLE', APP_TITLE);

    // i18 path
    tmhDynamicLocaleProvider.localeLocationPattern('./bower_components/angular-i18n/{{locale}}.js');

    $mdDateLocaleProvider.formatDate = function (date) {
      return date ? moment(date).format('DD / MM / YYYY') : null;
    };

    // Enable debug logging
    $logProvider.debugEnabled(true);

    // toastr configuration
    toastr.options.timeOut = 3000;
    toastr.options.positionClass = 'toast-top-right';
    toastr.options.preventDuplicates = true;
    toastr.options.progressBar = true;

    // angular-translate configuration
    $translateProvider.useStaticFilesLoader({
      prefix: 'app/views/' + APP_NAME + '/i18n/',
      suffix: '.json'
    });
    $translateProvider.preferredLanguage('es');
    $translateProvider.useSanitizeValueStrategy('escaped');
    // $translateProvider.useLocalStorage();

    /*eslint-disable */

    // ng-aria configuration
    $ariaProvider.config({
      tabindex: false
    });

    // Busolinea theme configurations
    busolineaConfigProvider.config({
      'disableCustomScrollbars'        : true,
      'disableCustomScrollbarsOnMobile': true,
      'disableMdInkRippleOnMobile'     : true
    });

    // msScroll configuration
    msScrollConfigProvider.config({
      wheelPropagation: true
    });
  }
})();

(function ()
{
    'use strict';

    /**
     * Main module
     */
    angular
        .module('busolinea', [

            // Core
            'app.core',

            // Toolbar
            'app.toolbar',

             // Searchbar
            'app.searchbar',

            // Notifications
            'app.notification',

            // Footer
            'app.footer',

            // Sidebars
            'app.sidebar_left',

            // States
            'app.home',
            'app.routes',
            'app.seats',
            'app.payment',
            'app.confirmation',
            'app.profile',
            'app.about',
            'app.mobile',
            'app.privacy',
            'app.terms',
            'app.error-404',
            'app.error-500',
            'app.error-503',

	    // FUTURA
	    'app.static',


        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('busolinea')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, msUtils)
    {
        // Data

        //////////

    }
})();
(function ()
{
    'use strict';

    angular
        .module('busolinea')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $translate, $state, msUtils, $mdDialog, tmhDynamicLocale, $mdDateLocale, $locale, ngMeta, $location, _ba, GTM)
    {
        ngMeta.init();        
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams)
        {
            
           var flag = 0;
            // Valida salida del proceso de pago
            if ( fromState.name === 'app.payment' && toState.name !== 'app.confirmation' && $rootScope.reservationActive === true ){
                event.preventDefault();
                flag = 1;
                $rootScope.paymentExitDialog = true;
                $rootScope.uistate = toState.name;
                if( toState.name == 'app.seats' ){
                  $rootScope.uistate = 'app.routes';
                }
                _ba.send('payment page exit attempt');
                $state.go('app.payment');
            }
            // Valida route seats solo desde routes
            if ( toState.name === 'app.seats' && fromState.name !== 'app.routes' ){
                event.preventDefault();
                flag = 1;
                _ba.send('direct attempt to enter seats page');
                if( fromState.name != 'app.payment' ){
                    $state.go('app.home');
                }
            }
            // Valida route payment solo desde seats
            if ( toState.name === 'app.payment' && fromState.name !== 'app.seats' ){
                event.preventDefault();
                flag = 1;
                _ba.send('direct attempt to enter payment page');
                $state.go('app.home');
            }
            // Valida route confirmation solo desde payment
            if ( toState.name === 'app.confirmation' && fromState.name !== 'app.payment' ){
                event.preventDefault();
                flag = 1;
                _ba.send('direct attempt to enter confirmation page');
                $state.go('app.home');
            }

            if ( flag === 0 ){
                $rootScope.loadingProgress = true;
                angular.element('.template-layout').animate({
                    scrollTop:  0
                }, 100);
            }
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams)
        {   

            GTM.pageTrack( $location.path() );
            _ba.send('pageview', { "from":fromState.name });

            $timeout(function (){
                $rootScope.loadingProgress = false;
            });

            // Close the mobile menu on $stateChangeSuccess
            angular.element('body').removeClass('ms-navigation-mobile-menu-active');

            // Close notification bar
            msUtils.closeNotification();

        });

        // Init global variables
        // Store state in the root scope for easy access
        $rootScope.state = $state;
        $rootScope.loggedIn = false;
        $rootScope.selectedLanguage = $translate.preferredLanguage();

        $rootScope.storedRoutes = false;
        $rootScope.returnTicket = false;
        $rootScope.paymentExitDialog = false;
        $rootScope.reservationActive = false;

        $rootScope.adActive = true;

        $rootScope.analytics = {
            ga_id: null,
            campaign: null
        };

        // Set the local language for date
        if (typeof tmhDynamicLocale.get() === 'undefined'){
            tmhDynamicLocale.set($rootScope.selectedLanguage);
        };

        // Calendar configuration
        $mdDateLocale.firstDayOfWeek = 1;
        $mdDateLocale.shortDays = $locale.DATETIME_FORMATS.SHORTDAY;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

    }
})();

(function () {
  'use strict';

  angular
    .module('busolinea')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig ($stateProvider, $urlRouterProvider, $locationProvider, ngMetaProvider, $injector) {
    $locationProvider.html5Mode(true);

    $urlRouterProvider.otherwise(function ($injector, $location) {
      var $state = $injector.get('$state')
      var stateName = $location.path() === '/index.html'
        ? 'app.home'
        : 'app.errors_error-404'
      $state.go(stateName)
    });

    // Inject $cookies
    var $cookies;

    angular.injector(['ngCookies']).invoke([
      '$cookies', function (_$cookies) {
        $cookies = _$cookies;
      }
    ]);

    var APP_NAME = $injector.get('APP_NAME');
    // State definitions
    $stateProvider
      .state('app', {
        abstract: true,
        views: {
          'main@': {
            templateUrl: 'app/views/' + APP_NAME + '/layouts/default-navigation.html',
            controller: 'MainController as vm'
          },
          'toolbar@app': {
            templateUrl: 'app/views/' + APP_NAME + '/elements/toolbar/toolbar.html',
            controller: 'ToolbarController as vm'
          },
          'searchbar@app': {
            templateUrl: 'app/views/' + APP_NAME + '/elements/searchbar/searchbar.html',
            controller: 'SearchbarController as vm'
          },
          'notifications@app': {
            templateUrl: 'app/views/' + APP_NAME + '/elements/notifications/notification.html',
            controller: 'NotificationController as vm'
          },
          'sidebar_left@app': {
            templateUrl: 'app/views/' + APP_NAME + '/elements/sidebar_left/sidebar_left.html',
            controller: 'SideBarLeftController as vm'
          },
          'footer@app': {
            templateUrl: 'app/views/' + APP_NAME + '/elements/footer/footer.html',
            controller: 'FooterController as vm'
          }
        },
        bodyClass: {app: APP_NAME + '_app', page: ''},
        data: {
          meta: {
            'busolinea': {
              page_title: 'META.TITLE',
              favicon: '/assets/busolinea/busolinea.png',
              tags: {
                'title': 'META.TAGS.TITLE',
                'publisher': 'Busolinea',
                'url': 'https://busolinea.com/',
                'site_name': APP_NAME,
                'classification': 'META.TAGS.CLASIFICATION',
                'keywords': 'META.TAGS.KEYWORDS',
                'description': 'META.TAGS.DESCRIPTION'
              },
              properties: {
                'fb:app_id': '1421953818035498',
                'og:type': 'website',
                'og:url': 'https://busolinea.com/',
                'og:title': 'META.TAGS.TITLE',
                'og:description': 'META.TAGS.DESCRIPTION',
                'og:image': 'https://busolinea.com/assets/busolinea/images/logos/busolinea_logo.png'
              }
            },
            'futura': {
              page_title: 'Venta de Boletos | Futura',
              favicon: '/assets/futura/favicon.png',
              tags: {
                'title': 'Futura : Venta de Boletos de Autobús | Sitio Oficial',
                'publisher': 'Futura',
                'url': 'https://futura.com.mx/',
                'site_name': 'Autobuses Futura',
                'classification': 'Boletos de autobus, Boletos de autobuses, Renta de Autobuses, vacaciones, viajes, destinos, hoteles',
                'generator': 'Autobuses Futura - Grupo Estrella Blanca',
                'keywords': 'Boletos de autobus, Boletos de autobuses, Renta de Autobuses, servicio mix, servicio plus, servicio dos pisos',
                'description': 'Compra Boletos de Autobuses Futura en el Sitio Oficial. Viaja en una de las líneas más modernas y seguras de México. COMPRA HOY.'
              },
              properties: {
                'fb:app_id': '',
                'og:type': 'website',
                'og:url': 'https://futura.com.mx/',
                'og:title': 'META.TAGS.TITLE',
                'og:description': 'META.TAGS.DESCRIPTION',
                'og:image': 'https://futura.com.mx/assets/futura/svg/futura/logo.svg'
              }
            },
            'geb': {
              page_title: 'Venta de Boletos | Grupo Estrella Blanca',
              favicon: '/assets/geb/favicon.ico',
              tags: {
                'title': 'Estrella Blanca : Venta de Boletos de Autobús | Sitio Oficial',
                'publisher': 'Grupo Estrella Blanca',
                'url': 'https://estrellablanca.com.mx/',
                'site_name': 'Autobuses Estrella Blanca',
                'classification': 'Boletos de autobus, Boletos de autobuses, Renta de Autobuses, vacaciones, viajes, destinos, hoteles',
                'generator': 'Autobuses Estrella Blanca - Grupo Estrella Blanca',
                'keywords': 'Boletos de autobus, Boletos de autobuses, Renta de Autobuses, servicio mix, servicio plus, servicio dos pisos',
                'description': 'Compra Boletos de Autobuses Estrella Blanca en el Sitio Oficial. Viaja en una de las líneas más modernas y seguras de México. COMPRA HOY'
              },
              properties: {
                'fb:app_id': '',
                'og:type': 'website',
                'og:url': 'https://estrellablanca.com.mx/',
                'og:title': 'META.TAGS.TITLE',
                'og:description': 'META.TAGS.DESCRIPTION',
                'og:image': 'https://estrellablanca.com.mx/assets/images/logo_white.png'
              }
            },
            'chihuahuenses': {
              page_title: 'Venta de Boletos | Chihuahuenses',
              favicon: '/assets/chihuahuenses/favicon.png',
              tags: {
                'title': 'Chihuahuenses : Venta de Boletos de Autobús | Sitio Oficial',
                'publisher': 'Chihuahuenses',
                'url': 'https://chihuahuenses.com.mx/',
                'site_name': 'Autobuses Chihuahuenses',
                'classification': 'Boletos de autobus, Boletos de autobuses, Renta de Autobuses, vacaciones, viajes, destinos, hoteles',
                'generator': 'Autobuses Chihuahuenses - Grupo Estrella Blanca',
                'keywords': 'Boletos de autobus, Boletos de autobuses, Renta de Autobuses, servicio mix, servicio plus, servicio dos pisos',
                'description': 'Compra Boletos de Autobuses Chihuahuenses en el Sitio Oficial. Viaja en una de las líneas más modernas y seguras de México. COMPRA HOY.'
              },
              properties: {
                'fb:app_id': '',
                'og:type': 'website',
                'og:url': 'https://chihuahuenses.com.mx',
                'og:title': 'META.TAGS.TITLE',
                'og:description': 'META.TAGS.DESCRIPTION',
                'og:image': 'https://chihuahuenses.com.mx/assets/chihuahuenses/images/logos/logo-chihuahuenses.svg'
              }
            },
            'transportamex': {
              page_title: 'META.TITLE',
              favicon: '/assets/transportamex/busolinea.png',
              tags: {
                'title': 'META.TAGS.TITLE',
                'publisher': 'Busolinea',
                'url': 'https://busolinea.com/',
                'site_name': APP_NAME,
                'classification': 'META.TAGS.CLASIFICATION',
                'keywords': 'META.TAGS.KEYWORDS',
                'description': 'META.TAGS.DESCRIPTION'
              },
              properties: {
                'fb:app_id': '1421953818035498',
                'og:type': 'website',
                'og:url': 'https://busolinea.com/',
                'og:title': 'META.TAGS.TITLE',
                'og:description': 'META.TAGS.DESCRIPTION',
                'og:image': 'https://busolinea.com/assets/busolinea/images/logos/busolinea_logo.png'
              }
            },
            'anahuac': {
              page_title: 'Venta de Boletos | Anahuac',
              favicon: '/assets/anahuac/favicon.ico',
              tags: {
                'title': 'Anahuac: Venta de Boletos de Autobús | Sitio Oficial',
                'publisher': 'Grupo Estrella Blanca',
                'url': 'https://autobusesanahuac.com.mx/',
                'site_name': 'Autobuses Anahuac',
                'classification': 'Boletos de autobus, Boletos de autobuses, Renta de Autobuses, vacaciones, viajes, destinos, hoteles',
                'generator': 'Autobuses Anahuac - Grupo Estrella Blanca',
                'keywords': 'Boletos de autobus, Boletos de autobuses, Renta de Autobuses, servicio mix, servicio plus, servicio dos pisos',
                'description': 'Compra Boletos de Autobuses Anahuac en el Sitio Oficial. Viaja en una de las líneas más modernas y seguras de México. COMPRA HOY'
              },
              properties: {
                'fb:app_id': '',
                'og:type': 'website',
                'og:url': 'https://autobusesanahuac.com.mx/',
                'og:title': 'META.TAGS.TITLE',
                'og:description': 'META.TAGS.DESCRIPTION',
                'og:image': ''
              }
            },
            'frontera': {
              page_title: 'Venta de Boletos | Frontera',
              favicon: '/assets/frontera/favicon.ico',
              tags: {
                'title': 'Frontera: Venta de Boletos de Autobús | Sitio Oficial',
                'publisher': 'Grupo Estrella Blanca',
                'url': 'https://transportesfrontera.com.mx/',
                'site_name': 'Autobuses Frontera',
                'classification': 'Boletos de autobus, Boletos de autobuses, Renta de Autobuses, vacaciones, viajes, destinos, hoteles',
                'generator': 'Autobuses Frontera - Grupo Estrella Blanca',
                'keywords': 'Boletos de autobus, Boletos de autobuses, Renta de Autobuses, servicio mix, servicio plus, servicio dos pisos',
                'description': 'Compra Boletos de Autobuses Frontera en el Sitio Oficial. Viaja en una de las líneas más modernas y seguras de México. COMPRA HOY'
              },
              properties: {
                'fb:app_id': '',
                'og:type': 'website',
                'og:url': 'https://transportesfrontera.com.mx/',
                'og:title': 'META.TAGS.TITLE',
                'og:description': 'META.TAGS.DESCRIPTION',
                'og:image': ''
              }
            }
          }
        }
      });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('busolinea')
        .controller('IndexController', IndexController);

    /** @ngInject */
  function IndexController($scope, $rootScope, $mdSidenav, msUtils, $injector, Galerux, CONST)
    {
        var vm = this;

        // Data
        vm.app_name = $injector.get('APP_NAME')
        vm.host_url = window.location.href.replace(/[\?&]lang=../g, '')
        vm.isMobile = msUtils.isMobile()
        var isEnglishLang = window.location.href.indexOf('lang=en') >= 0
        // Methods


        /////////////

        if (vm.app_name === 'busolinea') {
            // Gets the Busolinea home background
            Galerux.get_elements(CONST.BG_ID)
                .then(function (response) {
                  if (response !== undefined) {
                    $rootScope.background = response._embedded.items.length > 0 ? response._embedded.items[0].resourceUrl : ''
                  }
                }, function (error) {
                  console.log(error)
                })
        } else {
            if (isEnglishLang) {
                window.location.href = vm.host_url
            }
        }

        $scope.$on('clearAllSeats', function (params) {
          $scope.$broadcast('clearAllSeatsEvent',{})
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('busolinea')
        .config(config);

    /** @ngInject */
    function config ($httpProvider, CONST, localStorageServiceProvider) {
        localStorageServiceProvider.setPrefix('angubus').setStorageType('sessionStorage');
        $httpProvider.interceptors.push('httpErrorResponseInterceptor');
        $httpProvider.interceptors.push('timeoutHttpIntercept');
        // Api key header for busolinea requests
        // $httpProvider.defaults.headers.common['x-api-key'] = CONST.BUS_API_KEY;
        // Api key for Conekta transactions
        Conekta.setPublicKey(CONST.CONEKTA_API_KEY);
	    OpenPay.setId(CONST.OPENPAY_ID);
        OpenPay.setApiKey(CONST.OPENPAY_API_KEY);
        OpenPay.setSandboxMode(CONST.OPENPAY_TEST);
    }

})();

(function ()
{
    'use strict';

    angular
        .module('busolinea')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, $http, $rootScope, CONST)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

         // Api settings

         var api = {};
         
         $http.defaults.headers.get = {'Accept-Language' : $rootScope.selectedLanguage};

         // Base Url
         api.baseUrl = CONST.BUS_API_URL;

         // ///////API

         // Stations
         api.stations = {
            origins: $resource(api.baseUrl + 'stations/origins'),
            destinations: $resource(api.baseUrl + 'stations/origins/:id/destinations', {id: '@id'}),
            find: $resource(api.baseUrl + 'stations/param/:station', {station: '@station'})
         }

         // Routes
         api.routes = {
            routes: $resource(api.baseUrl + 'routes', {}, {
               get: {
                  method: 'GET',
                  headers: {
                     'x-api-key': CONST.BUS_API_KEY
                  }
               }
            }),
            last: $resource(api.baseUrl + 'reservations/last'),
            requisition: $resource(api.baseUrl + 'seat_reservations', {}, {
               clear: {
                  method: 'DELETE',
                  headers: {
                     'x-api-key': CONST.BUS_API_KEY
                  }
               }
            })
         }

         // Seats
         api.seats = {
            seats: $resource(api.baseUrl + 'seats', {}, {
               get: {
                  method: 'GET',
                  headers: {
                     'x-api-key': CONST.BUS_API_KEY
                  }
               }
            }),
            seat_reservation: $resource(api.baseUrl + 'seat_reservations/:id', {id: '@seat_id'}, {
               create: {
                  method: 'POST',
                  headers: {
                     'x-api-key': CONST.BUS_API_KEY
                  }
               },
               update: {
                  method: 'PUT',
                  headers: {
                     'x-api-key': CONST.BUS_API_KEY
                  }
               },
               delete: {
                  method: 'DELETE',
                  headers: {
                     'x-api-key': CONST.BUS_API_KEY
                  }
               }
            }),
            profile:$resource(api.baseUrl + 'profile', {}, {
               create: {
                  method: 'POST',
                  headers: {
                     'x-api-key': CONST.BUS_API_KEY
                  }
               }
            }),
            prereservation: $resource(api.baseUrl + 'prereservations', {}, {
               make: {
                  method: 'POST',
                  headers: {
                     'x-api-key': CONST.BUS_API_KEY
                  }
               }
            }),
            reservation: $resource(api.baseUrl + 'reservations', {}, {
               make: {
                  method: 'POST',
                  headers: {
                     'x-api-key': CONST.BUS_API_KEY
                  }
               }
            })
         }

         // Confirmation
         api.confirmation = {
            sendmail: $resource(api.baseUrl + 'reservations/:reservation_code/send_tickets', {reservation_code: '@reservation_code'}, {
               create: {
                  method: 'POST',
                  headers: {
                     'x-api-key': CONST.BUS_API_KEY
                  }
               }
            })
         }
         
         // Coupons
         api.coupons = {
            validate: $resource(api.baseUrl + 'coupons/:code/validate', {code: '@code'}, {
                get: {
                  method: 'GET',
                  headers: {
                     'x-api-key': CONST.BUS_API_KEY
                  }
               }
            })
         }

         // Newsletter
         api.newsletter = {
            subscribe: $resource(CONST.NEWSLETTER_API_URL + 'subscriptions', {}, {
               create: {
                  method: 'POST',
                  params: {
                     name: '@name',
                     email: '@email'
                  },
                  headers: {
                    'x-api-key': CONST.NEWSLETTER_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  }
               }
            })
         }

         // Contact by email
         api.contact = {
            sendmail: $resource(api.baseUrl + 'contact', {name: '@name', email: '@email', phone: '@phone', message: '@message', domain: '@domain'}, {
               create: {
                  method: 'POST',
                  headers: {
                     'x-api-key': CONST.BUS_API_KEY
                  }
               }
            })
         }

         // Analytics
         api.analytics = {
            data: $resource(api.baseUrl + 'analytics', {sid: '@sid', ts: '@ts', event: '@event', domain: '@domain', data: '@data'}, {
               create: {
                  method: 'POST',
                  headers: {
                     'x-api-key': CONST.BUS_API_KEY
                  }
               },
               get: {
                  method: 'GET',
                  headers: {
                     'x-api-key': CONST.BUS_API_KEY
                  }
               }
            })
         }

         api.galerux = {
            elements: $resource(CONST.GALERUX_URL + ':album_id/elements', {album_id: '@album_id'}, {
               get: {
                  method: 'GET',
                  headers: {
                     'x-api-key': CONST.GALERUX_API_KEY,
                     'Accept': 'application/json',
                     'Content-Type': 'application/json'
                  }
                }
            })
         }

         api.coppelPay = {
            solicitud: $resource(CONST.COPPELPAY_BASE_URL + 'solicitud-compra', {
                  cpl_business: '@cpl_business',
                  cpl_transaction: '@cpl_transaction',
                  cpl_signature: '@cpl_signature',
                  cpl_amount: '@cpl_amount',
                  cpl_currency: '@cpl_currency',
                  cpl_description: '@cpl_description',
                  cpl_url_redirect: '@cpl_url_redirect'
               }, {
               create: {
                  method: 'POST',
                  headers: {
                     'Accept': 'application/json',
                     'Content-Type': 'application/json'
                  }
               }
            })
         }

         return api;
    }

})();
(function () {
  'use strict';

  angular
    .module('app.static', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msApiProvider, $injector) {
    var APP_NAME = $injector.get('APP_NAME');
    var pages = [];

    // Busolinea
    var pagesForBusolinea = [];

    // Futura
    var pagesForFutura = [
      ['aviso_privacidad', 'Aviso de Privacidad'],
      ['contacto', 'Contáctanos'],
      ['faq', 'Preguntas Frecuentes'],
      ['historia', 'Historia'],
      ['nosotros', 'Misión y Visión'],
      ['politicas', 'Políticas de Compra'],
      ['renta', 'Renta de Autobuses'],
      ['terminos', 'Términos y condiciones']
    ];

    // Geb
    var pagesForGeb = [
      ['aviso_privacidad', 'Aviso de Privacidad'],
      ['contacto', 'Contáctanos'],
      ['faq', 'Preguntas Frecuentes'],
      ['historia', 'Historia'],
      ['mision-y-vision', 'Misión y Visión'],
      ['directorio', 'Directorio de puntos de venta'],
      ['politicas', 'Políticas de Compra'],
      ['renta', 'Renta de Autobuses'],
      ['terminos', 'Términos y condiciones'],
      ['valores-y-creencias', 'Valores y Creencias']
    ];

    // Chihuahuenses
    var pagesForChihuahuenses = [
      ['aviso_privacidad', 'Aviso de Privacidad'],
      ['bolsa-de-trabajo', 'Bolsa de Trabajo'],
      ['contacto', 'Contáctanos'],
      ['envia', 'Paquetería y Mensajería'],
      ['facturacion', 'Facturación'],
      ['faq', 'Preguntas Frecuentes'],
      ['historia', 'Historia'],
      ['mision-y-vision', 'Misión y Visión'],
      ['politicas', 'Políticas de Compra'],
      ['renta-autobus', 'Renta de Autobuses'],
      ['terminos', 'Términos y condiciones'],
      ['valores-y-creencias', 'Valores y Creencias']
    ];

    // Anahuac
    var pagesForAnahuac = [
      ['aviso_privacidad', 'Aviso de Privacidad'],
      ['bolsa-de-trabajo', 'Bolsa de Trabajo'],
      ['contacto', 'Contáctanos'],
      ['envia', 'Paquetería y Mensajería'],
      ['facturacion', 'Facturación'],
      ['faq', 'Preguntas Frecuentes'],
      ['historia', 'Historia'],
      ['mision-y-vision', 'Misión y Visión'],
      ['politicas', 'Políticas de Compra'],
      ['renta-autobus', 'Renta de Autobuses'],
      ['terminos', 'Términos y condiciones'],
      ['valores-y-creencias', 'Valores y Creencias']
    ];

    // Frontera
    var pagesForFrontera = [
      ['aviso_privacidad', 'Aviso de Privacidad'],
      ['bolsa-de-trabajo', 'Bolsa de Trabajo'],
      ['contacto', 'Contáctanos'],
      ['envia', 'Paquetería y Mensajería'],
      ['facturacion', 'Facturación'],
      ['faq', 'Preguntas Frecuentes'],
      ['historia', 'Historia'],
      ['mision-y-vision', 'Misión y Visión'],
      ['politicas', 'Políticas de Compra'],
      ['renta-autobus', 'Renta de Autobuses'],
      ['terminos', 'Términos y condiciones'],
      ['valores-y-creencias', 'Valores y Creencias']
    ];

    switch (APP_NAME) {
      case 'busolinea':
        pages = pagesForBusolinea;
        break;
      case 'futura':
        pages = pagesForFutura;
        break;
      case 'geb':
        pages = pagesForGeb;
        break;
      case 'chihuahuenses':
        pages = pagesForChihuahuenses;
        break;
      case 'transportamex':
        pages = pagesForBusolinea;
        break;
      case 'anahuac':
        pages = pagesForAnahuac;
        break;
      case 'frontera':
        pages = pagesForFrontera;
    }

    pages.forEach(function (page) {
      // State
      $stateProvider.state('app.static' + page[0], {
        url: '/' + page[0] + '?lang',
        views: {
          'content@app': {
            templateUrl: 'app/views/' + APP_NAME + '/pages/static/' + page[0] + '.html',
            controller: function ($scope, api, $q, $translate, msUtils) {
              $scope.title = page[1];
              $scope.link = page[0];
              $scope.pages = pages;
              window.prerenderReady = true;

              // Methods
              $scope.getMail = getMail;

              $scope.points = [
                {"code": "GEB02 ", "address": "Calle La Paz S/N  Centro", "locality": "Actocpan ", "admin": "Hidalgo","postal": "42600", "latitude": "20.27569444", "longitude": "-98.95184722",},
                {"code": "GEB03", "address": "Actopan-Ixmiquilpan El Oro", "locality": "Ixmiquilpan ", "admin": "Hidalgo","postal": "42305", "latitude": "20.47969722", "longitude": "-99.23435556",},
                {"code": "GEB04", "address": "Jorge Rojo Lugo Abundio Martínez", "locality": "Huichapa ", "admin": "Hidalgo","postal": "42400", "latitude": "20.37563889", "longitude": "-99.65513611",},
                {"code": "GEB05", "address": "Morelos ", "locality": "Tecozautla ", "admin": "Hidalgo","postal": "42443", "latitude": "20.53837778", "longitude": "-99.63611389",},
                {"code": "GEB06", "address": "Hidalgo Guadalupe de las Peñas", "locality": "San Juan Del Río ", "admin": "Querétaro ","postal": "76800", "latitude": "20.37586667", "longitude": "-100.0016833",},
                {"code": "GEB07", "address": "Acceso a La Central Terminal de Autobuses", "locality": "Santiago de Queretaro ", "admin": "Querétaro ", "postal": "76063", "latitude": "20.57856944", "longitude": "-100.3592556",},
                {
                  "code": "GEB08",
                  "address": "Montes de Oca 122-200  El Vergel",
                  "locality": "Celaya ",
                  "admin": "Guanajuato ",
                  "postal": "38078",
                  "latitude": "20.51488056",
                  "longitude": "-100.8067472",
                },
                {
                  "code": "GEB09",
                  "address": "Zona Centro",
                  "locality": "Acámbaro ",
                  "admin": "Guanajuato ",
                  "postal": "38600",
                  "latitude": "20.02151389",
                  "longitude": "-100.7291028",


                },
                {
                  "code": "GEB10",

                  "address": "Blvrd Valle de Santiago Villas del Valle",
                  "locality": "Salamanca",
                  "admin": "Guanajuato ",

                  "postal": "36786",
                  "latitude": "20.54253889",
                  "longitude": "-101.2051",


                },
                {
                  "code": "GEB11",

                  "address": "La Central",
                  "locality": "San Luis de la Paz ",
                  "admin": "Guanajuato ",

                  "postal": "37900",
                  "latitude": "21.29571667",
                  "longitude": "-100.5252611",


                },
                {
                  "code": "GEB12",

                  "address": "36513 Irapuato",
                  "locality": "Irapuato ",
                  "admin": "Guanajuato ",

                  "postal": "36513",
                  "latitude": "20.67589167",
                  "longitude": "-101.3413",


                },
                {
                  "code": "GEB13",

                  "address": "Blvd. Uriangato 238 Colinas",
                  "locality": "Uriangato ",
                  "admin": "Guanajuato ",

                  "postal": "38980",
                  "latitude": "20.122175",
                  "longitude": "-101.1784806",


                },
                {
                  "code": "GEB14",

                  "address": "Xicoténcatl 110 Tamazunchale Barrio de San Juan",
                  "locality": "Tamazunchale ",
                  "admin": "San Luis Potosí ",

                  "postal": "79960",
                  "latitude": "21.26126944",
                  "longitude": "-98.79071111",


                },
                {
                  "code": "GEB15",

                  "address": "Av Luis H. Ducoing 105 Centro",
                  "locality": "Silao ",
                  "admin": "Guanajuato ",

                  "postal": "36100",
                  "latitude": "20.95316667",
                  "longitude": "-101.4255",


                },
                {
                  "code": "GEB16",

                  "address": "Calle José del Río 17 ",
                  "locality": "Morelia ",
                  "admin": "Michoacán ",

                  "postal": "58140",
                  "latitude": "19.71777222",
                  "longitude": "-101.2254833",


                },
                {
                  "code": "GEB17",

                  "address": "Burocrata",
                  "locality": "Marfil ",
                  "admin": "Guanajuato ",

                  "postal": "36251",
                  "latitude": "20.98321389",
                  "longitude": "-101.2865694",


                },
                {
                  "code": "GEB18",

                  "address": "Zona Centro",
                  "locality": "Salvatierra",
                  "admin": "Guanajuato ",

                  "postal": "38900",
                  "latitude": "20.21894722",
                  "longitude": "-100.8798833",


                },
                {
                  "code": "GEB19",

                  "address": "Libramiento Fco J Múgica Héroes Ferrocarrileros",
                  "locality": "Zitacuaro",
                  "admin": "Michoacán ",

                  "postal": "61508",
                  "latitude": "19.43639444",
                  "longitude": "-100.3442944",


                },
                {
                  "code": "GEB20",

                  "address": "Españita",
                  "locality": "León ",
                  "admin": "Guanajuato ",

                  "postal": "37270",
                  "latitude": "21.12176111",
                  "longitude": "-101.6608222",


                },
                {
                  "code": "GEB21",

                  "address": "Peña",
                  "locality": "La Piedad de Cavadas ",
                  "admin": "Michoacán ",

                  "postal": "59389",
                  "latitude": "20.34810556",
                  "longitude": "-102.0322778",


                },
                {
                  "code": "GEB22",

                  "address": "Av Industrias 95A Central",
                  "locality": "San Luis ",
                  "admin": "San Luis Potosí ",

                  "postal": "78399",
                  "latitude": "22.14550833",
                  "longitude": "-100.9525111",


                },
                {
                  "code": "GEB23",

                  "address": "Padre Torres 416 Del Carmen",
                  "locality": "Lagos de Moreno ",
                  "admin": "Jalisco ",

                  "postal": "47490",
                  "latitude": "21.358075",
                  "longitude": "-101.9241389",


                },
                {
                  "code": "GEB24",

                  "address": "Luis Venegas Contreras 123 San Luis",
                  "locality": "Cd. Valles ",
                  "admin": "San Luis Potosí ",

                  "postal": "79097",
                  "latitude": "21.96963889",
                  "longitude": "-98.99750833",


                },
                {
                  "code": "GEB25",

                  "address": "Michoacán 123 La Esperanza",
                  "locality": "Encarnación de Diaz ",
                  "admin": "Jalisco ",

                  "postal": "47270",
                  "latitude": "21.532375",
                  "longitude": "-102.2437611",


                },
                {
                  "code": "GEB26",

                  "address": "Luis Donaldo Colosio Murrieta 150 Rita Pérez de Moreno",
                  "locality": "San Juan de los Lagos ",
                  "admin": "Jalisco ",

                  "postal": "47090",
                  "latitude": "21.24380833",
                  "longitude": "-102.3239",


                },
                {
                  "code": "GEB27",

                  "address": "Dr. Azuela 24-15, Centro",
                  "locality": "Ojuelos ",
                  "admin": "Jalisco ",

                  "postal": "47540",
                  "latitude": "21.86591389",
                  "longitude": "-101.5927944",


                },
                {
                  "code": "GEB28",

                  "address": "Abasolo 42-18 Centro",
                  "locality": "Salinas ",
                  "admin": "San Luis Potosí ",

                  "postal": "78625",
                  "latitude": "22.62704444",
                  "longitude": "-101.7141167",


                },
                {
                  "code": "GEB29",

                  "address": "Quinta Avenida # 1006 Las Américas",
                  "locality": "Aguascalientes ",
                  "admin": "Aguascalientes ",

                  "postal": "20235",
                  "latitude": "21.86464444",
                  "longitude": "-102.2986083",


                },
                {
                  "code": "GEB30",

                  "address": "Lope de Vega Comercial del Sur",
                  "locality": "Tepatitlán de Morelos ",
                  "admin": "Jalisco ",

                  "postal": "47655",
                  "latitude": "20.80134444",
                  "longitude": "-102.7644361",


                },
                {
                  "code": "GEB31",

                  "address": "Calle Hidalgo 27-2 Centro",
                  "locality": "Zapotalejo ",
                  "admin": "Jalisco ",

                  "postal": "45430",
                  "latitude": "20.62263611",
                  "longitude": "-103.0695972",


                },
                {
                  "code": "GEB32",

                  "address": "Manuel Cavazos Lerma 106-114 Zona Centro",
                  "locality": "Paila ",
                  "admin": "Tamaulipas ",

                  "postal": "89800",
                  "latitude": "22.74471389",
                  "longitude": "-98.97565556",


                },
                {
                  "code": "GEB33",

                  "address": "Dr Fco Guel Jiménez 123 Centro Histórico",
                  "locality": "Rincón de Romos ",
                  "admin": "Aguascalientes ",

                  "postal": "20400",
                  "latitude": "22.22740556",
                  "longitude": "-102.3197083",


                },
                {
                  "code": "GEB34",

                  "address": "Las Conchas",
                  "locality": "Guadalajara ",
                  "admin": "Jalisco ",

                  "postal": "44460",
                  "latitude": "20.66267778",
                  "longitude": "-103.3436444",


                },
                {
                  "code": "GEB35",

                  "address": "Nueva Central Camionera",
                  "locality": "San Pedro Tlaquepaque ",
                  "admin": "Jalisco ",

                  "postal": "45580",
                  "latitude": "20.62252222",
                  "longitude": "-103.284575",


                },
                {
                  "code": "GEB36",

                  "address": "Castorena 94-104 Centro",
                  "locality": "Luis de Moya ",
                  "admin": "Zacatecas ",

                  "postal": "98770",
                  "latitude": "22.43213056",
                  "longitude": "-102.2482833",


                },
                {
                  "code": "GEB37",

                  "address": "Av. Cartero 23-16 Luis Reyes",
                  "locality": "Ojocaliente ",
                  "admin": "Zacatecas ",

                  "postal": "98700",
                  "latitude": "22.57088611",
                  "longitude": "-102.2479583",


                },
                {
                  "code": "GEB38",

                  "address": "Tenamaxtle Zona A Tecnologica",
                  "locality": "Zacatecas ",
                  "admin": "Zacatecas ",

                  "postal": "98099",
                  "latitude": "22.75469167",
                  "longitude": "-102.5755056",


                },
                {
                  "code": "GEB39",

                  "address": "Heroes Potosinos Providencia",
                  "locality": "Matehuala ",
                  "admin": "San Luis Potosí ",

                  "postal": "78796",
                  "latitude": "23.62970556",
                  "longitude": "-100.6407444",


                },
                {
                  "code": "GEB40",

                  "address": "Centro",
                  "locality": "Victor Rosales ",
                  "admin": "Zacatecas ",

                  "postal": "98500",
                  "latitude": "22.94492778",
                  "longitude": "-102.6996333",


                },
                {
                  "code": "GEB41",

                  "address": "Abasolo 102-111 Los Naranjos",
                  "locality": "Ameca ",
                  "admin": "Jalisco ",

                  "postal": "46600",
                  "latitude": "20.54520556",
                  "longitude": "-104.0427361",


                },
                {
                  "code": "GEB42",

                  "address": "Paseo del Mineral 8 Centro 99000 Centro",
                  "locality": "Centro ",
                  "admin": "Zacatecas ",

                  "postal": "99000",
                  "latitude": "23.17424722",
                  "longitude": "-102.8589056",


                },
                {
                  "code": "GEB43",

                  "address": "Av Rosalio Bustamante 104 Col. allende Azteca",
                  "locality": "Tampico ",
                  "admin": "Tamaulipas ",

                  "postal": "89190",
                  "latitude": "22.24823333",
                  "longitude": "-97.85791667",


                },
                {
                  "code": "GEB44",

                  "address": "Centro",
                  "locality": "Ixtlán de Río ",
                  "admin": "Nayarit ",

                  "postal": "63940",
                  "latitude": "21.03574722",
                  "longitude": "-104.3716528",


                },
                {
                  "code": "GEB45",

                  "address": "Central de Autobuses Río Grande Vicente Guerrero",
                  "locality": "Río Grande ",
                  "admin": "Zacatecas ",

                  "postal": "98400",
                  "latitude": "23.830225",
                  "longitude": "-103.0453528",


                },
                {
                  "code": "GEB46",

                  "address": "Comercial Dos Mil",
                  "locality": "Cd Victoria ",
                  "admin": "Tamaulipas ",

                  "postal": "87099",
                  "latitude": "23.73660556",
                  "longitude": "-99.13262778",


                },
                {
                  "code": "GEB47",

                  "address": "Av. Hidalgo 156-106 Centro",
                  "locality": "Sombrerete",
                  "admin": "Zacatecas ",

                  "postal": "99100",
                  "latitude": "23.63353611",
                  "longitude": "-103.63745",


                },
                {
                  "code": "GEB48",

                  "address": "Av. Centenario Sur 41-21 Zona Centro",
                  "locality": "Juan Aldama",
                  "admin": "Zacatecas ",

                  "postal": "98300",
                  "latitude": "24.28817222",
                  "longitude": "-103.3958361",


                },
                {
                  "code": "GEB49",

                  "address": "7 de Marzo",
                  "locality": "Juan Aldama ",
                  "admin": "Zacatecas ",

                  "postal": "98300",
                  "latitude": "24.28066111",
                  "longitude": "-103.4039194",


                },
                {
                  "code": "GEB50",

                  "address": "Calle Av Preparatoria 13-11 Insurgentes Aviación",
                  "locality": "Tepic ",
                  "admin": "Nayarit ",

                  "postal": "63150",
                  "latitude": "21.49766944",
                  "longitude": "-104.8866333",


                },
                {
                  "code": "GEB51",

                  "address": "Juárez 217-213 Zona Centro",
                  "locality": "Guerrero ",
                  "admin": "Durango ",

                  "postal": "34890",
                  "latitude": "23.73266667",
                  "longitude": "-103.98825",


                },
                {
                  "code": "GEB52",

                  "address": "Fray Gerónimo de Mendoza 303",
                  "locality": "Nombre de Dios ",
                  "admin": "Durango ",

                  "postal": "34846",
                  "latitude": "23.84805556",
                  "longitude": "-104.2456194",


                },
                {
                  "code": "GEB53",

                  "address": "Niños Heroes 911-470 Moderna",
                  "locality": "Linares",
                  "admin": "Nuevo León ",

                  "postal": "67700",
                  "latitude": "24.86376944",
                  "longitude": "-99.57383056",


                },
                {
                  "code": "GEB54",

                  "address": "Gral. Galeana 317 Centro Histórico",
                  "locality": "Cuencamé ",
                  "admin": "Durango ",

                  "postal": "35805",
                  "latitude": "24.87115",
                  "longitude": "-103.7000833",


                },
                {
                  "code": "GEB55",

                  "address": "Las Peñitas",
                  "locality": "Las Peñitas ",
                  "admin": "Nayarit ",

                  "postal": "63512",
                  "latitude": "21.94633333",
                  "longitude": "-105.2210083",


                },
                {
                  "code": "GEB56",

                  "address": "Profesor Rodrigo Ávalos ",
                  "locality": "Durango ",
                  "admin": "Durango ",

                  "postal": "34240",
                  "latitude": "24.03450833",
                  "longitude": "-104.6401194",


                },
                {
                  "code": "GEB57",

                  "address": "Niños Heroes Zona Centro",
                  "locality": "San Fernando ",
                  "admin": "Tamaulipas ",

                  "postal": "87600",
                  "latitude": "24.85174167",
                  "longitude": "-98.15345833",


                },
                {
                  "code": "GEB58",

                  "address": "Primera Mijares",
                  "locality": "Canatlán ",
                  "admin": "Durango ",

                  "postal": "34453",
                  "latitude": "24.52869167",
                  "longitude": "-104.7742861",


                },
                {
                  "code": "GEB59",

                  "address": "Calle Julián Villagrán Industrial",
                  "locality": "Monterrey ",
                  "admin": "Nuevo León ",

                  "postal": "64440",
                  "latitude": "25.68768889",
                  "longitude": "-100.3216056",


                },
                {
                  "code": "GEB60",

                  "address": "Avenida Benito Juárez Oriente, La Central, Las Fuentes",
                  "locality": "Zamora de Hidalgo ",
                  "admin": "Michoacán ",

                  "postal": "59660",
                  "latitude": "19.97395833",
                  "longitude": "-102.268825",


                },
                {
                  "code": "GEB61",

                  "address": "Calz Lázaro Cárdenas La Central Santa Rosa",
                  "locality": "Gomez Palacios ",
                  "admin": "Durango ",

                  "postal": "35069",
                  "latitude": "25.56303611",
                  "longitude": "-103.4762833",


                },
                {
                  "code": "GEB62",

                  "address": "Sin nombre No 831 El Brillante",
                  "locality": "El salto ",
                  "admin": "Durango ",

                  "postal": "34945",
                  "latitude": "23.78273611",
                  "longitude": "-105.3546972",


                },
                {
                  "code": "GEB63",

                  "address": "Av. Palma Real Guadalupe Victoria",
                  "locality": "Puerto Vallarta ",
                  "admin": "Jalisco ",

                  "postal": "48317",
                  "latitude": "20.68580556",
                  "longitude": "-105.2320139",


                },
                {
                  "code": "GEB64",

                  "address": "Armando del Castillo Franco Libertad",
                  "locality": "Nuevo Ideal ",
                  "admin": "Durango ",

                  "postal": "34420",
                  "latitude": "24.89082778",
                  "longitude": "-105.0690278",


                },
                {
                  "code": "GEB65",

                  "address": "Washington 380 Centro de Sabinas Hidalgo",
                  "locality": "Sabinas Hidalgo ",
                  "admin": "Nuevo León ",

                  "postal": "65200",
                  "latitude": "26.50825833",
                  "longitude": "-100.1758917",


                },
                {
                  "code": "GEB66",

                  "address": "Panamericana ",
                  "locality": "Rodeo",
                  "admin": "Durango ",

                  "postal": "35760",
                  "latitude": "25.18078333",
                  "longitude": "-104.5617639",


                },
                {
                  "code": "GEB67",

                  "address": "Calle Ferrocarril Zona Centro",
                  "locality": "Santiago de Papasquiaro ",
                  "admin": "Durango ",

                  "postal": "34635",
                  "latitude": "25.04581944",
                  "longitude": "-105.4179028",


                },
                {
                  "code": "GEB68",

                  "address": "Luis Aguilar 8-14 Modelo",
                  "locality": "Matamoros",
                  "admin": "Tamaulipas ",

                  "postal": "87360",
                  "latitude": "25.871725",
                  "longitude": "-97.49763056",


                },
                {
                  "code": "GEB69",

                  "address": "Guadalupe López Velarde 105 Unidad y Progreso",
                  "locality": "Reynosa ",
                  "admin": "Tamaulipas ",

                  "postal": "88500",
                  "latitude": "26.08580833",
                  "longitude": "-98.27217778",


                },
                {
                  "code": "GEB70",

                  "address": "Felipe Carrillo Puerto 109 Zona Centro",
                  "locality": "Guadalupe Victoria ",
                  "admin": "Durango ",

                  "postal": "34700",
                  "latitude": "24.44766667",
                  "longitude": "-104.122825",


                },
                {
                  "code": "GEB71",

                  "address": "Río Baluarte Palos Prietos",
                  "locality": "Mazatlán ",
                  "admin": "Sinaloa ",

                  "postal": "82010",
                  "latitude": "23.22557778",
                  "longitude": "-106.4234194",


                },
                {
                  "code": "GEB72",

                  "address": "México",
                  "locality": "Nuevo Laredo ",
                  "admin": "Tamaulipas ",

                  "postal": "88280",
                  "latitude": "27.46234167",
                  "longitude": "-99.51735",


                },
                {
                  "code": "GEB73",

                  "address": "Villa las Nieves",
                  "locality": "Villa las nieves ",
                  "admin": "Durango ",

                  "postal": "35381",
                  "latitude": "26.40316944",
                  "longitude": "-105.3888889",


                },
                {
                  "code": "GEB74",

                  "address": "Av Pedro de Lille Baca",
                  "locality": "Parral ",
                  "admin": "Chihuahua ",

                  "postal": "33880",
                  "latitude": "26.92700833",
                  "longitude": "-105.6513917",


                },
                {
                  "code": "GEB75",

                  "address": "Bernardo Antonio Bustamante y Tagle 104 Abraham González",
                  "locality": "Cd. Jimenez ",
                  "admin": "Chihuahua ",

                  "postal": "33980",
                  "latitude": "27.12938056",
                  "longitude": "-104.9200667",


                },
                {
                  "code": "GEB76",

                  "address": "Reforma Lourdes",
                  "locality": "Saltillo ",
                  "admin": "Coahuila ",

                  "postal": "25070",
                  "latitude": "25.39764167",
                  "longitude": "-101.0069694",


                },
                {
                  "code": "GEB77",

                  "address": "Villa California",
                  "locality": "Torreón ",
                  "admin": "Coahuila ",

                  "postal": "27085",
                  "latitude": "25.53883889",
                  "longitude": "-103.40375",


                },
                {
                  "code": "GEB78",

                  "address": "Calle Aquiles Serdan Centro",
                  "locality": "Francisco I Madero",
                  "admin": "Durango ",

                  "postal": "34790",
                  "latitude": "24.40104722",
                  "longitude": "-104.3177972",


                },
                {
                  "code": "GEB79",

                  "address": "Hidalgo",
                  "locality": "Ejido Revolución ",
                  "admin": "Durango ",

                  "postal": "34129",
                  "latitude": "26.20566389",
                  "longitude": "-105.0783528",


                },
                {
                  "code": "GEB80",

                  "address": "González Ortega 623 Centro",
                  "locality": "Cd. Camargo ",
                  "admin": "Chihuahua ",

                  "postal": "33700",
                  "latitude": "27.69153889",
                  "longitude": "-105.1715556",


                },
                {
                  "code": "GEB81",

                  "address": "45 Norte",
                  "locality": "Cd. Delicias ",
                  "admin": "Chihuahua ",

                  "postal": "33000",
                  "latitude": "28.19895833",
                  "longitude": "-105.4696472",


                },
                {
                  "code": "GEB82",

                  "address": "México 45 721-713 Centro",
                  "locality": "Cd meoqui ",
                  "admin": "Chihuahua ",

                  "postal": "33130",
                  "latitude": "28.27021667",
                  "longitude": "-105.481525",


                },
                {
                  "code": "GEB83",

                  "address": "Cerro Cnel II Robinson",
                  "locality": "Chihuahua ",
                  "admin": "Chihuahua ",

                  "postal": "31074",
                  "latitude": "28.62595",
                  "longitude": "-106.0251972",


                },
                {
                  "code": "GEB84",

                  "address": "México 45 508-405 Arroyo del Carmen Zona Centro",
                  "locality": "Villa Ahumada ",
                  "admin": "Chihuahua ",

                  "postal": "32800",
                  "latitude": "30.62153611",
                  "longitude": "-106.5143028",


                },
                {
                  "code": "GEB85",

                  "address": "Del Acero 2549 El Vergel",
                  "locality": "Cd. Juaréz ",
                  "admin": "Chihuahua ",

                  "postal": "32650",
                  "latitude": "31.69245",
                  "longitude": "-106.4355722",


                },
                {
                  "code": "GEB86",

                  "address": "Av Constitución 215 Río Bravo",
                  "locality": "Rio Bravo ",
                  "admin": "Tampico ",

                  "postal": "88950",
                  "latitude": "25.98556667",
                  "longitude": "-98.09347778",


                },
                {
                  "code": "GEB87",

                  "address": "Av. Progreso 1 Centro",
                  "locality": "Cossío ",
                  "admin": "Aguascalientes ",

                  "postal": "20460",
                  "latitude": "22.36674444",
                  "longitude": "-102.2971472",


                },
                {
                  "code": "GEB88",

                  "address": "Insurgentes 1 Zona Centro Comercial",
                  "locality": "Estación Manuel ",
                  "admin": "Tampico ",

                  "postal": "89736",
                  "latitude": "22.73101944",
                  "longitude": "-98.31428056",


                },
                {
                  "code": "GEB89",

                  "address": "La Villa",
                  "locality": "Cd. Del Maíz ",
                  "admin": "San Luis Potosi ",

                  "postal": "79300",
                  "latitude": "22.40135",
                  "longitude": "-99.60826389",


                },
                {
                  "code": "GEB90",

                  "address": "México 80 95 Centro",
                  "locality": "El naranjo ",
                  "admin": "San Luis Potosi ",

                  "postal": "79310",
                  "latitude": "22.522625",
                  "longitude": "-99.32361111",


                },
                {
                  "code": "GEB91",

                  "address": "Sinaloa 50-14 Sin Nombre Loc. San Blas Centro",
                  "locality": "San Blas",
                  "admin": "Nayarit ",

                  "postal": "63744",
                  "latitude": "21.54211944",
                  "longitude": "-105.2858278",


                },
                {
                  "code": "GEB92",

                  "address": "Centro",
                  "locality": "Tuxpan ",
                  "admin": "Nayarit ",

                  "postal": "63200",
                  "latitude": "21.94247778",
                  "longitude": "-105.3009972",


                },
                {
                  "code": "GEB93",

                  "address": "Efraín González Centro",
                  "locality": "Arandas ",
                  "admin": "Jalisco ",

                  "postal": "47180",
                  "latitude": "20.70451944",
                  "longitude": "-102.3558139",


                },
                {
                  "code": "GEB94",

                  "address": "Blvrd Pleasenton Los Pinos",
                  "locality": "Tulancingo ",
                  "admin": "Hidalgo ",

                  "postal": "43626",
                  "latitude": "20.09924444",
                  "longitude": "-98.35858889",


                },
                {
                  "code": "GEB95",

                  "address": "Tulancingo - Huauchinango Carretera Centro",
                  "locality": "Huauchinango",
                  "admin": "Puebla ",

                  "postal": "73160",
                  "latitude": "20.17467778",
                  "longitude": "-98.05910556",


                },
                {
                  "code": "GEB96",

                  "address": "1º de Mayo Nuevo Necaxa",
                  "locality": "Nuevo Necaxa ",
                  "admin": "Puebla ",

                  "postal": "73200",
                  "latitude": "20.21166667",
                  "longitude": "-98.0022",


                },
                {
                  "code": "GEB97",

                  "address": "Blvrd Benito Juárez Las Flores Col Centro",
                  "locality": "Xicotepec ",
                  "admin": "Puebla ",

                  "postal": "73080",
                  "latitude": "20.275675",
                  "longitude": "-97.96434722",


                },
                {
                  "code": "GEB98",

                  "address": "Poza Rica de Hidalgo - Xicotepec de Juárez 26 El Salto",
                  "locality": "Villa Ávila Camacho",
                  "admin": "Puebla ",

                  "postal": "73090",
                  "latitude": "20.386525",
                  "longitude": "-97.882525",


                },
                {
                  "code": "GEB99",

                  "address": "Viad la Providencia 88-52 Col Centro",
                  "locality": "Villa Lazaro ",
                  "admin": "Puebla ",

                  "postal": "73049",
                  "latitude": "20.46356944",
                  "longitude": "-97.70436667",


                },
                {
                  "code": "GEB100",

                  "address": " Calle Álamo Palma Sola",
                  "locality": "Poza Rica ",
                  "admin": "Veracruz ",

                  "postal": "93320",
                  "latitude": "20.54031944",
                  "longitude": "-97.46847222",


                },
                {
                  "code": "GEB101",

                  "address": " Viad la Providencia Cedro",
                  "locality": "Tihuatlan ",
                  "admin": "Veracruz ",

                  "postal": "92930",
                  "latitude": "20.7109",
                  "longitude": "-97.53459167",


                },
                {
                  "code": "GEB102",

                  "address": "Vista Hermosa",
                  "locality": "Alamo ",
                  "admin": "Veracruz ",

                  "postal": "92737",
                  "latitude": "20.91564444",
                  "longitude": "-97.67450278",


                },
                {
                  "code": "GEB103",

                  "address": "Carr Tuxpan - Tampico 5 de Julio",
                  "locality": "Tuxpam ",
                  "admin": "Veracruz ",

                  "postal": "92820",
                  "latitude": "20.96401944",
                  "longitude": "-97.41626667",


                },
                {
                  "code": "GEB104",

                  "address": "México 70 Tamasopo ",
                  "locality": "Tamasopo",
                  "admin": "San Luis Potosi ",

                  "postal": "79710",
                  "latitude": "21.85132222",
                  "longitude": "-99.62790278",


                },
                {
                  "code": "GEB105",

                  "address": "Av. Constitucio Alazán  ",
                  "locality": "Potrero del llano ",
                  "admin": "Veracruz ",

                  "postal": "92750",
                  "latitude": "21.08163333",
                  "longitude": "-97.73130833",


                },
                {
                  "code": "GEB106",

                  "address": "Gral Heriberto Jara Corona 113 Deportiva",
                  "locality": "Cerro Azul ",
                  "admin": "Veracruz ",

                  "postal": "92514",
                  "latitude": "21.18884444",
                  "longitude": "-97.74008056",


                },
                {
                  "code": "GEB107",

                  "address": "Alamo - Tantoyuca",
                  "locality": "Tepetzintla ",
                  "admin": "Veracruz ",

                  "postal": "92530",
                  "latitude": "21.160575",
                  "longitude": "-97.85311667",


                },
                {
                  "code": "GEB108",

                  "address": "Álvaro Obregón Progreso",
                  "locality": "Naranjos ",
                  "admin": "Veracruz ",

                  "postal": "92350",
                  "latitude": "21.35308056",
                  "longitude": "-97.68237778",


                },
                {
                  "code": "GEB109",

                  "address": "Avenida de la Juventud 48, Morelos",
                  "locality": "Cardenas ",
                  "admin": "San Luis Potosi ",

                  "postal": " 79387",
                  "latitude": "22.00163333",
                  "longitude": "-99.64272778",


                },
                {
                  "code": "GEB110",

                  "address": "Alamo - Tantoyuca Buenos Aires",
                  "locality": "San Sebastián ",
                  "admin": "Veracruz ",

                  "postal": "92103",
                  "latitude": "21.21637778",
                  "longitude": "-98.13175",


                },
                {
                  "code": "GEB111",

                  "address": "Platanal",
                  "locality": "Tantoyuca ",
                  "admin": "Veracruz ",

                  "postal": "92125",
                  "latitude": "21.34688889",
                  "longitude": "-98.22686667",


                },
                {
                  "code": "GEB112",

                  "address": "Carr Tuxpan - Tampico Loma Alta, Ver.",
                  "locality": "Ozuluama ",
                  "admin": "Veracruz ",

                  "postal": "13042",
                  "latitude": "21.6754",
                  "longitude": "-97.86004444",


                },
                {
                  "code": "GEB113",

                  "address": "La Reforma 22",
                  "locality": "Chicontepec ",
                  "admin": "Veracruz ",

                  "postal": "92700",
                  "latitude": "20.97096944",
                  "longitude": "-98.16901944",


                },
                {
                  "code": "GEB114",

                  "address": "Hidalgo 39 Centro",
                  "locality": "Platón Sánchez ",
                  "admin": "Veracruz ",

                  "postal": "92140",
                  "latitude": "21.27345",
                  "longitude": "-98.37423611",


                },
                {
                  "code": "GEB115",

                  "address": "Calle Melchor Ocampo 1-4 Juárez",
                  "locality": "Huejutla ",
                  "admin": "Hidalgo ",

                  "postal": "43000",
                  "latitude": "21.14594167",
                  "longitude": "-98.41866111",


                },
                {
                  "code": "GEB116",

                  "address": "Av 5 de Mayo La Gloria",
                  "locality": "Tempoal",
                  "admin": "Veracruz ",

                  "postal": "92064",
                  "latitude": "21.51893333",
                  "longitude": "-98.391",


                },
                {
                  "code": "GEB117",

                  "address": "5 de Febrero Centro",
                  "locality": "El higo ",
                  "admin": "Veracruz ",

                  "postal": "92400",
                  "latitude": "21.76938333",
                  "longitude": "-98.45267222",


                },
                {
                  "code": "GEB118",

                  "address": "1° de Mayo Adolfo Lopez Mateos",
                  "locality": "Pánuco ",
                  "admin": "Veracruz ",

                  "postal": "93995",
                  "latitude": "22.04670833",
                  "longitude": "-98.19058611",


                },
                {
                  "code": "GEB119",

                  "address": "Sain Alto Zacatecas",
                  "locality": "Saín Alto ",
                  "admin": "Zacatecas ",

                  "postal": "87670",
                  "latitude": "23.57870833",
                  "longitude": "-98.19058611",


                },
                {
                  "code": "GEB120",

                  "address": "Melchor Ocampo",
                  "locality": "Jaumave ",
                  "admin": "Tamaulipas ",

                  "postal": "87930",
                  "latitude": "23.40997222",
                  "longitude": "-99.38069167",


                },
                {
                  "code": "GEB121",

                  "address": "Francisco Javier Mina 101 Zona Centro",
                  "locality": "Soto la Marina ",
                  "admin": "tamaulipas ",

                  "postal": " 87760",
                  "latitude": "23.76675556",
                  "longitude": "-98.20483056",


                },
                {
                  "code": "GEB122",

                  "address": " Pedro Antonio de Los Santos Centro",
                  "locality": "Tamuín ",
                  "admin": "San Luis Potosi ",

                  "postal": "79200",
                  "latitude": "22.00313056",
                  "longitude": "-98.77649167",


                },
                {
                  "code": "GEB123",

                  "address": "Policarpo Olvera San Jose",
                  "locality": "Jalpan ",
                  "admin": "Querétaro ",

                  "postal": "76340",
                  "latitude": "21.215725",
                  "longitude": "-99.46298889",


                },
                {
                  "code": "GEB124",

                  "address": "Carretera Tula-Cd Victoria km 38 s/n Barrio el Jicote.",
                  "locality": "Cd. Tula ",
                  "admin": "Tamaulipas ",

                  "postal": "87900",
                  "latitude": "22.98995278",
                  "longitude": "-99.73248889",


                },
                {
                  "code": "GEB125",

                  "address": "Lateral Carr Rioverde - San Ciro de Acosta 402A Isla de San Pablo",
                  "locality": "Rio Verde ",
                  "admin": "San Luis Potosi ",

                  "postal": "79620",
                  "latitude": "21.92062222",
                  "longitude": "-99.99449722",


                },
                {
                  "code": "GEB126",

                  "address": "Valle Verde y Terminal",
                  "locality": "Toluca ",
                  "admin": "Estado de México ",

                  "postal": "50140",
                  "latitude": "19.27715",
                  "longitude": "-99.64185",


                },
                {
                  "code": "GEB127",

                  "address": "Vicente Villagrán, Centro",
                  "locality": "Nopala ",
                  "admin": "Hidalgo ",

                  "postal": "42470",
                  "latitude": "20.25154167",
                  "longitude": "-99.64863889",


                },
                {
                  "code": "GEB128",

                  "address": "Jilotepec",
                  "locality": "Maravillas ",
                  "admin": "Hidalgo ",

                  "postal": " 42470",
                  "latitude": "20.20360833",
                  "longitude": "-99.58885278",


                },
                {
                  "code": "GEB129",

                  "address": "Venustiano Carranza 1 Guadalupe",
                  "locality": "Cerritos ",
                  "admin": "San Luis Potosi ",

                  "postal": "79445",
                  "latitude": "22.42778333",
                  "longitude": "-100.2866444",


                },
                {
                  "code": "GEB130",

                  "address": "Ave Adolfo Lopez Mateos 111 Zona Centro",
                  "locality": "Xilitla ",
                  "admin": "San Luis Potosi ",

                  "postal": "79900",
                  "latitude": "21.38474722",
                  "longitude": "-98.99153333",


                },
                {
                  "code": "GEB131",

                  "address": "Calle Hidalgo Sur N Herrera 35600 ",
                  "locality": "Catarina de Tepehuanes ",
                  "admin": "Durango ",

                  "postal": "35600",
                  "latitude": "25.33403611",
                  "longitude": "-105.7207083",


                },
                {
                  "code": "GEB132",

                  "address": "Hidalgo 56 Centro",
                  "locality": "Villanueva ",
                  "admin": "Zacatecas ",

                  "postal": "99500",
                  "latitude": "22.35804444",
                  "longitude": "-102.8837639",


                },
                {
                  "code": "GEB133",

                  "address": "16 de Septiembre, Centro",
                  "locality": "Concepción de oro ",
                  "admin": "Zacatecas ",

                  "postal": "98200",
                  "latitude": "24.61233611",
                  "longitude": "-101.4174278",


                },
                {
                  "code": "GEB134",

                  "address": "Revolución Téul de González Ortega",
                  "locality": "Teúl gonzalez Ortega ",
                  "admin": "Zacatecas ",

                  "postal": "99800",
                  "latitude": "21.46414167",
                  "longitude": "-103.4630333",


                },
                {
                  "code": "GEB135",

                  "address": "Agua Azul Tepeyac",
                  "locality": "Las Varas ",
                  "admin": "Nayarit ",

                  "postal": "63715",
                  "latitude": "21.17966389",
                  "longitude": "-105.1360056",


                },
                {
                  "code": "GEB136",

                  "address": "Av Vallarta Eje Poniente 379 Rinconada del Bosque",
                  "locality": "Zapopan Periférico ",
                  "admin": "Jalisco ",

                  "postal": "45019",
                  "latitude": "20.70306944",
                  "longitude": "-103.4606139",


                },
                {
                  "code": "GEB137",

                  "address": "Calle Niños Héroes Huejuquilla El Alto Centro",
                  "locality": "Huejuquilla El alto centro ",
                  "admin": "Jalisco ",

                  "postal": "46000",
                  "latitude": "22.62532222",
                  "longitude": "-103.8961111",


                },
                {
                  "code": "GEB138",

                  "address": "Melchor Ocampo 13-97 Nueva Reforma",
                  "locality": "Jerez de Garcias Salinas",
                  "admin": "Zacatecas ",

                  "postal": "99340",
                  "latitude": "22.64831944",
                  "longitude": "-102.9731861",


                },
                {
                  "code": "GEB139",

                  "address": "Miguel Hidalgo  Centro",
                  "locality": "Colotlan ",
                  "admin": "Jalisco ",

                  "postal": "46200",
                  "latitude": "22.11458056",
                  "longitude": "-103.2679917",


                },
                {
                  "code": "GEB140",

                  "address": "Guadalupe Victoria Cuencamé ",
                  "locality": "Yerbaniz ",
                  "admin": "Durango ",

                  "postal": "35801",
                  "latitude": "24.73551389",
                  "longitude": "-103.8416944",


                },
                {
                  "code": "GEB141",

                  "address": "El jagúey HGO 21 La Estancia",
                  "locality": "El Jagüey ",
                  "admin": "Hidalgo ",

                  "postal": " 42470",
                  "latitude": "20.239925",
                  "longitude": "-99.60613611",


                },
                {
                  "code": "GEB142",

                  "address": "Boulevard Nte H, Blvrd Héroes del 5 de Mayo 4222, Las Cuartillas",
                  "locality": "Puebla ",
                  "admin": "Puebla ",

                  "postal": "72050",
                  "latitude": "19.07634167",
                  "longitude": "-98.20580833",


                },
                {
                  "code": "GEB143",

                  "address": "Av Norte 17B, Centro",
                  "locality": "Dolores Hidalgo ",
                  "admin": "Guanajuato ",

                  "postal": "37800",
                  "latitude": "21.162175",
                  "longitude": "-100.9365972",


                },
                {
                  "code": "GEB144",

                  "address": "Calz. de la Estación Zona Centro",
                  "locality": "San Miguel de Allende ",
                  "admin": "Guanajuato ",

                  "postal": "37700",
                  "latitude": "20.91496389",
                  "longitude": "-100.7594444",


                },
                {
                  "code": "GEB145",

                  "address": "Revolución 174, Centro",
                  "locality": "Atlapexco ",
                  "admin": "Hidalgo ",

                  "postal": "43060",
                  "latitude": "21.01818056",
                  "longitude": "-98.34809167",


                },
                {
                  "code": "GEB146",

                  "address": "Huejutla de Reyes - Pachuca, Sta Cecilia",
                  "locality": "Zacualtipan ",
                  "admin": "Hidalgo ",

                  "postal": "43203",
                  "latitude": "20.66136944",
                  "longitude": "-98.66133333",


                },
                {
                  "code": "GEB147",

                  "address": "Calle Hidalgo, Sta Cruz 2da Secc",
                  "locality": "Molango ",
                  "admin": "Hidalgo ",

                  "postal": "43100",
                  "latitude": "20.78552778",
                  "longitude": "-98.72527222",


                },
                {
                  "code": "GEB148",

                  "address": "Av, Gustavo Arvizu Ávila",
                  "locality": "San Felipe Orizatlán ",
                  "admin": "Hidalgo ",

                  "postal": "43020",
                  "latitude": "21.17130556",
                  "longitude": "-98.60380278",


                },
                {
                  "code": "GEB149",

                  "address": "16 de Septiembre 10-365, Tlachiquetl",
                  "locality": "San Agustin Metzquititlán ",
                  "admin": "Hidalgo ",

                  "postal": "43385",
                  "latitude": "20.53104444",
                  "longitude": "-98.63606667",


                },
                {
                  "code": "GEB150",

                  "address": "Central de Autobuses de, Barrio San Bartolo",
                  "locality": "Zacatlán ",
                  "admin": "Puebla ",

                  "postal": "73310",
                  "latitude": "19.92190278",
                  "longitude": "-97.96969167",


                },
                {
                  "code": "GEB151",

                  "address": "COAH 15 209-203 Zona Centro",
                  "locality": "Allende ",
                  "admin": "Coahuila ",

                  "postal": "26230",
                  "latitude": "28.34353889",
                  "longitude": "-100.8531333",


                },
                {
                  "code": "GEB152",

                  "address": "Saltillo - Matamoros 100, Zona Centro, 27990 Paila, Coah.",
                  "locality": "Cuatro Cienegas ",
                  "admin": "Coahuila ",

                  "postal": "27990",
                  "latitude": "25.64960278",
                  "longitude": "-102.1453139",


                },
                {
                  "code": "GEB153",

                  "address": "Miguel Hidalgo 100, Cuatro Ciénegas de Carranza, Zona Centro",
                  "locality": "Crucero Palomas ",
                  "admin": "Coahuila ",

                  "postal": "27640",
                  "latitude": "26.986125",
                  "longitude": "-102.0664806",


                },
                {
                  "code": "GEB154",

                  "address": "Carretera Cd.Juarez A Casas Grandes",
                  "locality": "Nuevo Casas Grandes ",
                  "admin": "Chihuahua ",

                  "postal": "32676",
                  "latitude": "31.46923611",
                  "longitude": "-107.6123806",


                },
                {
                  "code": "GEB155",

                  "address": "Álvaro Obregón, Centro.",
                  "locality": "Ricardo Flores Mágon ",
                  "admin": "Chihuahua ",

                  "postal": "31700",
                  "latitude": "30.41457778",
                  "longitude": "-107.9107694",


                },
                {
                  "code": "GEB76",

                  "address": "Reforma Lourdes",
                  "locality": "Saltillo ",
                  "admin": "Coahuila ",

                  "postal": "25070",
                  "latitude": "25.39764167",
                  "longitude": "-101.0069694",


                },
                {
                  "code": "GEB77",

                  "address": "Villa California",
                  "locality": "Torreón ",
                  "admin": "Coahuila ",

                  "postal": "27085",
                  "latitude": "25.53883889",
                  "longitude": "-103.40375",


                },
                {
                  "code": "GEB151",

                  "address": " 15 209-203 Zona Centro",
                  "locality": "Allende ",
                  "admin": "Coahuila de Zaragoza",

                  "postal": "26230",
                  "latitude": "28.34353889",
                  "longitude": "-100.8531333",


                },
                {
                  "code": "GEB152",

                  "address": "Saltillo - Matamoros 100, Zona Centro",
                  "locality": "Cuatro Cienegas ",
                  "admin": "Coahuila de Zaragoza",

                  "postal": "27990",
                  "latitude": "25.64960278",
                  "longitude": "-102.1453139",


                },
                {
                  "code": "GEB153",

                  "address": "Miguel Hidalgo 100, Cuatro Ciénegas de Carranza, Zona Centro",
                  "locality": "Crucero Palomas ",
                  "admin": "Coahuila de Zaragoza",

                  "postal": "27640",
                  "latitude": "26.986125",
                  "longitude": "-102.0664806",


                },
                {
                  "code": "GEB156",

                  "address": "S. Luis, Centro Ascensión",
                  "locality": "Ascensión ",
                  "admin": "Chihuahua ",

                  "postal": "31820",
                  "latitude": "31.09292222",
                  "longitude": "-107.9955139",


                },
                {
                  "code": "GEB157",

                  "address": "Calle Matamoros  Zona Centro",
                  "locality": "Cd. Acuña ",
                  "admin": "Coahuila de Zaragoza",

                  "postal": "26200",
                  "latitude": "29.32218056",
                  "longitude": "-100.9312278",


                },
                {
                  "code": "GEB158",

                  "address": "Calle Quinta, Centro",
                  "locality": "Cd. Madera ",
                  "admin": "Chihuahua ",

                  "postal": "31940",
                  "latitude": "29.18923889",
                  "longitude": "-108.1421722",


                },
                {
                  "code": "GEB159",

                  "address": "Calle Cuauhtemoc , Zona Centro",
                  "locality": "Monclova ",
                  "admin": "Coahuila de Zaragoza",

                  "postal": "25700",
                  "latitude": "26.90251389",
                  "longitude": "-101.4194528",


                },
                {
                  "code": "GEB160",

                  "address": "Venustiano Carranza, Zona Centro",
                  "locality": "Nava ",
                  "admin": "Coahuila de Zaragoza",

                  "postal": "26170",
                  "latitude": "28.421975",
                  "longitude": "-100.7683972",


                },
                {
                  "code": "GEB161",

                  "address": "Av Adolfo Lopez Mateos s/n, Independencia    ",
                  "locality": "Nueva Rosita ",
                  "admin": "Coahuila de Zaragoza",

                  "postal": "26830",
                  "latitude": "27.93746111",
                  "longitude": "-101.2117889",


                },
                {
                  "code": "GEB162",

                  "address": "20 de noviembre",
                  "locality": "La Junta ",
                  "admin": "Chihuahua ",

                  "postal": "31690",
                  "latitude": "28.47899722",
                  "longitude": "-107.3288861",


                },
                {
                  "code": "GEB163",

                  "address": "Zona Centro",
                  "locality": "Piedras Negras ",
                  "admin": "Coahuila de Zaragoza",

                  "postal": "26000",
                  "latitude": "28.702275",
                  "longitude": "-100.5192556",


                },
                {
                  "code": "GEB164",

                  "address": "Mariano Abasolo 133, Flores Magón",
                  "locality": "Sabina ",
                  "admin": "Coahuila de Zaragoza",

                  "postal": "26780",
                  "latitude": "27.85579444",
                  "longitude": "-101.1270278",


                },
                {
                  "code": "GEB165",

                  "address": "Nuevo Casas Grandes ",
                  "locality": "Janos ",
                  "admin": "Chihuahua ",

                  "postal": "31840",
                  "latitude": "30.88817222",
                  "longitude": "-108.1880278",


                },
                {
                  "code": "GEB166",

                  "address": "Carr. 30 101-125, Zona Centro",
                  "locality": "San Buenaventura ",
                  "admin": "Coahuila de Zaragoza",

                  "postal": "25500",
                  "latitude": "27.06079722",
                  "longitude": "-101.5493139",


                },
                {
                  "code": "GEB167",

                  "address": "Pachuca - Huejutla de Reyes, Tlanchinol Centro, 43150 Tlanchinol, Hgo.",
                  "locality": "tlanchinol ",
                  "admin": "Hidalgo ",

                  "postal": "43150",
                  "latitude": "20.988125",
                  "longitude": "-98.66244722",


                },
                {
                  "code": "GEB168",

                  "address": "Calle Leonardo Bravo 1, Centro",
                  "locality": "Ahuazotepec ",
                  "admin": "Puebla ",

                  "postal": "73180",
                  "latitude": "20.04790278",
                  "longitude": "-98.16210556",


                },
                {
                  "code": "GEB169",

                  "address": "Central, San José",
                  "locality": "San José Atlán ",
                  "admin": "Ciudad de México",

                  "postal": "7630",
                  "latitude": "20.338525",
                  "longitude": "-99.67111111",


                },
                {
                  "code": "GEB170",

                  "address": "Pino Suárez 349, El Vigía",
                  "locality": "Zapopan ",
                  "admin": "Jalisco ",

                  "postal": "45140",
                  "latitude": "20.72933333",
                  "longitude": "-103.3902694",


                },
                {
                  "code": "GEB171",

                  "address": "Calle Av. Morelos Coahuila  Centro",
                  "locality": "San pedro de las Colonias ",
                  "admin": "Coahuila de Zaragoza",

                  "postal": "27800",
                  "latitude": "25.75968889",
                  "longitude": "-102.9786333",


                },
                {
                  "code": "GEB172",

                  "address": "Eje Metropolitano 3 335, Sin Nombre de Col 3",
                  "locality": "Santa Catarina ",
                  "admin": "Nuevo León ",

                  "postal": "66376",
                  "latitude": "25.67575833",
                  "longitude": "-100.4435472",


                },
                {
                  "code": "GEB173",

                  "address": "Calle Emiliano Zapata",
                  "locality": "Matlapa ",
                  "admin": "San Luis Potosí ",

                  "postal": "79970",
                  "latitude": "21.33818333",
                  "longitude": "-98.82847222",


                },
                {
                  "code": "GEB174",

                  "address": "Antigua Carretera Entronque Torreón - San Pedro, Madero",
                  "locality": "Francisco I Madero ",
                  "admin": "Coahuila de Zaragoza",

                  "postal": "27904",
                  "latitude": "25.76490556",
                  "longitude": "-103.2771722",


                },
                {
                  "code": "GEB175",

                  "address": "Los Naranjos",
                  "locality": "Hermosillo ",
                  "admin": "Sonora ",

                  "postal": "43050",
                  "latitude": "29.07682778",
                  "longitude": "-110.9299389",


                },
                {
                  "code": "GEB176",

                  "address": "Arquitecto Guillermo Rossell de la Lama 220-214, Barrio Alto",
                  "locality": "Huautla ",
                  "admin": "Hidalgo ",

                  "postal": "43050",
                  "latitude": "21.03094722",
                  "longitude": "-98.28776944",


                },
                {
                  "code": "GEB177",

                  "address": "Blvrd E Zapata 100, San José Caltengo",
                  "locality": "IMSS Tulancingo ",
                  "admin": "Hidalgo ",

                  "postal": "43624",
                  "latitude": "20.09244167",
                  "longitude": "-98.36653889",


                },
                {
                  "code": "GEB178",

                  "address": " Saltillo",
                  "locality": "Sierra Vieja ",
                  "admin": "Zacatecas ",

                  "postal": "98460",
                  "latitude": "23.49711111",
                  "longitude": "-102.1316556",


                },
                {
                  "code": "GEB179",

                  "address": "Carr. Guadalajara - Tepic 57",
                  "locality": "Chapalilla ",
                  "admin": "Nayarit ",

                  "postal": "63870",
                  "latitude": "21.18928611",
                  "longitude": "-104.6370278",


                },
                {
                  "code": "GEB180",

                  "address": "El Llano Ahuacatlán",
                  "locality": "Ahuacatlán ",
                  "admin": "Nayarit ",

                  "postal": "63900",
                  "latitude": "21.05751667",
                  "longitude": "-104.4819306",


                },
                {
                  "code": "GEB181",

                  "address": "Villa Textil",
                  "locality": "Villa Hidalgo ",
                  "admin": "Jalisco ",

                  "postal": "47250",
                  "latitude": "21.68084167",
                  "longitude": "-102.5838083",


                },
                {
                  "code": "GEB182",

                  "address": "Calle Independencia 69b",
                  "locality": "Ent. El Huizache ",
                  "admin": "San Luis Potosí ",

                  "postal": "78870",
                  "latitude": "22.92051944",
                  "longitude": "-100.4636722",


                },
                {
                  "code": "GEB183",

                  "address": "Francisco Villa, Centro",
                  "locality": "Creel ",
                  "admin": "Chihuahua ",

                  "postal": "33200",
                  "latitude": "27.75411944",
                  "longitude": "-107.6351917",


                },
                {
                  "code": "GEB184",

                  "address": "Toluca 177, Hab Valle Ceylan",
                  "locality": "Ceylán ",
                  "admin": "Estado de México ",

                  "postal": "54150",
                  "latitude": "19.53402222",
                  "longitude": "-99.18054167",


                },
                {
                  "code": "GEB185",

                  "address": "Gran Visión, Sector 1",
                  "locality": "Bocoyna ",
                  "admin": "Chihuahua ",

                  "postal": "33201",
                  "latitude": "27.84104167",
                  "longitude": "-107.5904472",


                },
                {
                  "code": "GEB186",

                  "address": "Silvestre Terrazas,  Esperanza",
                  "locality": "Zootecnia ",
                  "admin": "Chihuahua ",

                  "postal": "31000",
                  "latitude": "28.58986389",
                  "longitude": "-106.1107389",


                },
                {
                  "code": "GEB187",

                  "address": "Cuauhtémoc Yecora ",
                  "locality": "Tomochic ",
                  "admin": "Chihuahua ",

                  "postal": "31691",
                  "latitude": "28.35365833",
                  "longitude": "-107.8459639",


                },
                {
                  "code": "GEB188",

                  "address": "Mal Paso 12, Aguas Blancas, Hogar Moderno",
                  "locality": "Acapulco Ejido ",
                  "admin": "Guerrero ",

                  "postal": "39590",
                  "latitude": "16.861525",
                  "longitude": "-99.90809722",


                },
                {
                  "code": "GEB189",

                  "address": "Calle Principal ",
                  "locality": "El largo ",
                  "admin": "Chihuahua ",

                  "postal": "31940",
                  "latitude": "29.68340556",
                  "longitude": "-108.2718806",


                },
                {
                  "code": "GEB190",

                  "address": "Berriozabal, Centro",
                  "locality": "Arcelia ",
                  "admin": "Guerrero ",

                  "postal": "40500",
                  "latitude": "18.31768889",
                  "longitude": "-100.2830139",


                },
                {
                  "code": "GEB191",

                  "address": "Ayutla - Cruz Grande, San Jose",
                  "locality": "Ayutla de los Libres ",
                  "admin": "Guerrero ",

                  "postal": "39200",
                  "latitude": "16.96402222",
                  "longitude": "-99.09996389",


                },
                {
                  "code": "GEB192",

                  "address": "Calle 14 Nte. 205-207, San Jose",
                  "locality": "Chilapa ",
                  "admin": "Guerrero ",

                  "postal": "41100",
                  "latitude": "17.59293333",
                  "longitude": "-99.17410556",


                },
                {
                  "code": "GEB193",

                  "address": "Benito Juárez",
                  "locality": "Chilpancingo ",
                  "admin": "Guerrero ",

                  "postal": "39010",
                  "latitude": "17.56245833",
                  "longitude": "-99.5095",


                },
                {
                  "code": "GEB194",

                  "address": "México 200 32-49, Arriba",
                  "locality": "Cuajinicuilapa ",
                  "admin": "Guerrero ",

                  "postal": "41940",
                  "latitude": "16.47059167",
                  "longitude": "-98.41151667",


                },
                {
                  "code": "GEB195",

                  "address": "José Ma. Morelos y Pavón 230, Cuernavaca Centro",
                  "locality": "Cuernavaca ",
                  "admin": "Morelos ",

                  "postal": "62000",
                  "latitude": "18.92601389",
                  "longitude": "-99.23825556",


                },
                {
                  "code": "GEB196",

                  "address": "Ing Mongoy 63-51, Centro",
                  "locality": "Cuautla ",
                  "admin": "Morelos ",

                  "postal": "62740",
                  "latitude": "18.81216389",
                  "longitude": "-98.95254444",


                },
                {
                  "code": "GEB197",

                  "address": "Hermenegildo Galeana 58, Centro",
                  "locality": "Iguala ",
                  "admin": "Guerrero ",

                  "postal": "40000",
                  "latitude": "18.33995278",
                  "longitude": "-99.54131944",


                },
                {
                  "code": "GEB198",

                  "address": "Carretera Acapulco - Salina Cruz Km. 30, 5ta",
                  "locality": "Jamiltepec ",
                  "admin": "Oaxaca ",

                  "postal": "71700",
                  "latitude": "16.28406944",
                  "longitude": "-97.82963889",


                },
                {
                  "code": "GEB199",

                  "address": "Zona Centro",
                  "locality": "Lazaro Cárdenas ",
                  "admin": "Michoacán ",

                  "postal": "60950",
                  "latitude": "17.95685278",
                  "longitude": "-102.1947",


                },
                {
                  "code": "GEB200",

                  "address": "Federal Acapulco - Pinotepa Nacional 82",
                  "locality": "Marquelia ",
                  "admin": "Guerrero ",

                  "postal": "41930",
                  "latitude": "16.58171667",
                  "longitude": "-98.81304722",


                },
                {
                  "code": "GEB201",

                  "address": "Jose Agustín Ramírez, Barrio de la Cruz Chiquita",
                  "locality": "Ometepec ",
                  "admin": "Guerrero ",

                  "postal": "41706",
                  "latitude": "16.69125",
                  "longitude": "-98.40936111",


                },
                {
                  "code": "GEB202",

                  "address": "Pinotepa Nacional - Acapulco, Aviacion",
                  "locality": "Pinotepa Nacional ",
                  "admin": "Oaxaca ",

                  "postal": "71605",
                  "latitude": "16.35362778",
                  "longitude": "-98.0672",


                },
                {
                  "code": "GEB203",

                  "address": "Av Hidalgo 105, Centro",
                  "locality": "Puente de Ixtla ",
                  "admin": "Morelos ",

                  "postal": "62660",
                  "latitude": "18.61762778",
                  "longitude": "-99.32410556",


                },
                {
                  "code": "GEB204",

                  "address": "Tangolunda, Agua Marina",
                  "locality": "Puerto Escondido ",
                  "admin": "Oaxaca ",

                  "postal": "71980",
                  "latitude": "15.87372222",
                  "longitude": "-97.07535556",


                },
                {
                  "code": "GEB205",

                  "address": "  AV. OAXACA, S/N, ESQ. CARR. COSTERA, CENTRO RÍO GRANDE O PIEDRA PARADA",
                  "locality": "Rio Grande ",
                  "admin": "Oaxaca ",

                  "postal": "71830",
                  "latitude": "16.011",
                  "longitude": "-97.43710556",


                },
                {
                  "code": "GEB206",

                  "address": "De Los Plateros 386, Centro",
                  "locality": "Taxco ",
                  "admin": "Guerrero ",

                  "postal": "40200",
                  "latitude": "18.55553611",
                  "longitude": "-99.60236111",


                },
                {
                  "code": "GEB207",

                  "address": "México 200 5-4, Centro",
                  "locality": "Tecpan de Galeana ",
                  "admin": "Guerrero ",

                  "postal": "40900",
                  "latitude": "17.22264444",
                  "longitude": "-100.6299778",


                },
                {
                  "code": "GEB208",

                  "address": "De La Parota, Zona Industrial",
                  "locality": "Zihuatanejo ",
                  "admin": "Guerrero ",

                  "postal": "40880",
                  "latitude": "17.64854722",
                  "longitude": "-101.5441556",


                },
                {
                  "code": "GEB209",

                  "address": "Calle Morelos 220, San Francisco",
                  "locality": "Tlapa ",
                  "admin": "Guerrero ",

                  "postal": "41300",
                  "latitude": "17.547875",
                  "longitude": "-98.57505",


                },
                {
                  "code": "GEB210",

                  "address": "Venustiano Carranza 8E, Col del Centro",
                  "locality": "Huetamo ",
                  "admin": "Michoacán ",

                  "postal": "61940",
                  "latitude": "18.62546111",
                  "longitude": "-100.898875",


                },
                {
                  "code": "GEB211",

                  "address": "Frontera 23, Las Hormigas",
                  "locality": "Salina Cruz ",
                  "admin": "Oaxaca ",

                  "postal": "70670",
                  "latitude": "16.18096111",
                  "longitude": "-95.19568889",


                },
                {
                  "code": "GEB212",

                  "address": "Carpinteros, ",
                  "locality": "Huatulco ",
                  "admin": "Oaxaca ",

                  "postal": "70987",
                  "latitude": "15.77304167",
                  "longitude": "-96.14438611",


                },
                {
                  "code": "GEB213",

                  "address": " Tututepec, La Luz",
                  "locality": "Santa Rosa ",
                  "admin": "Oaxaca ",

                  "postal": "71800",
                  "latitude": "16.07341111",
                  "longitude": "-97.62354722",


                },
                {
                  "code": "GEB214",

                  "address": " Calz. Rey Irepan Ote. 300",
                  "locality": "Cd. Altamirano ",
                  "admin": "Guerrero ",

                  "postal": "40660",
                  "latitude": "18.35381944",
                  "longitude": "-100.6668778",


                },
                {
                  "code": "GEB215",

                  "address": "Calle Miguel Hidalgo y Costilla, Las Palmas",
                  "locality": "San Marcos ",
                  "admin": "Guerrero ",

                  "postal": "39960",
                  "latitude": "16.79282778",
                  "longitude": "-99.389725",


                },
                {
                  "code": "GEB216",

                  "address": "Acapulco - Copala, El Crucero",
                  "locality": "Copala ",
                  "admin": "Guerrero ",

                  "postal": "41873",
                  "latitude": "16.60293333",
                  "longitude": "-98.9765",


                },
                {
                  "code": "GEB217",

                  "address": "México 200 2702, Libertad",
                  "locality": "Cruz Grande ",
                  "admin": "Guerrero ",

                  "postal": "41800",
                  "latitude": "16.71799167",
                  "longitude": "-99.12334167",


                },
                {
                  "code": "GEB218",

                  "address": "Avenida Lázaro Cárdenas 94, Centro, 70900 San Pedro Pochutla, Oax.",
                  "locality": "Pochutla ",
                  "admin": "Oaxaca ",

                  "postal": "70900",
                  "latitude": "15.74254167",
                  "longitude": "-96.46695278",


                },
                {
                  "code": "GEB219",

                  "address": "Av. Insurgentes Nte., Santa Isabel Tola, Gustavo A. Madero, 07010 Ciudad de México, CDMX",
                  "locality": "Indios Verdes ",
                  "admin": "Ciudad de México",

                  "postal": "7010",
                  "latitude": "19.4946",
                  "longitude": "-99.11895556",


                },
                {
                  "code": "GEB220",

                  "address": "41920 México 200, Juchitán, Gro.",
                  "locality": "Juchitán ",
                  "admin": "Guerrero ",

                  "postal": "41920",
                  "latitude": "16.62548333",
                  "longitude": "-98.63460278",


                },
                {
                  "code": "GEB221",

                  "address": "Cd Renacimiento, 39715 Acapulco de Juárez, Gro.",
                  "locality": "Las Cruces ",
                  "admin": "Guerrero ",

                  "postal": "39715",
                  "latitude": "16.88809167",
                  "longitude": "-99.83681944",


                },
                {
                  "code": "GEB222",

                  "address": "85780 Yecora - Cuauhtémoc, Chihuahua",
                  "locality": "Cahuisori ",
                  "admin": "Chihuahua ",

                  "postal": "85780",
                  "latitude": "28.21431111",
                  "longitude": "-108.2411583",


                },
                {
                  "code": "GEB223",

                  "address": "Flavio Bórquez 371, Cortinas 1 Secc",
                  "locality": "Cd. Obregón ",
                  "admin": "Sonora ",

                  "postal": "85150",
                  "latitude": "27.48058889",
                  "longitude": "-109.9469389",


                },
                {
                  "code": "GEB224",

                  "address": "Gonzalez Ortega Pinos ",
                  "locality": "El Pino ",
                  "admin": "Zacatecas ",

                  "postal": "98920",
                  "latitude": "22.29834722",
                  "longitude": "-101.5762917",


                },
                {
                  "code": "GEB225",

                  "address": "Salgado 90-2, Centro",
                  "locality": "Los Reyes ",
                  "admin": "Michoacán ",

                  "postal": "60300",
                  "latitude": "19.59223056",
                  "longitude": "-102.4732417",


                },
                {
                  "code": "GEB226",

                  "address": "Calle Calz. Benito Juárez, Pablo Padilla",
                  "locality": "nueva Italia ",
                  "admin": "Michoacán ",

                  "postal": "61760",
                  "latitude": "19.02081944",
                  "longitude": "-102.0944694",


                },
                {
                  "code": "GEB227",

                  "address": "Centro Uno",
                  "locality": "Sahuayo ",
                  "admin": "Michoacán ",

                  "postal": "59000",
                  "latitude": "20.0552",
                  "longitude": "-102.7169083",


                },
                {
                  "code": "GEB228",

                  "address": "Guerrero 41, Centro",
                  "locality": "Puruándiro ",
                  "admin": "Michoacán ",

                  "postal": "58500",
                  "latitude": "20.087825",
                  "longitude": "-101.5178528",


                },
                {
                  "code": "GEB229",

                  "address": "Terminal de Autobuses",
                  "locality": "Uruapan ",
                  "admin": "Michoacán ",

                  "postal": "60110",
                  "latitude": "19.42703889",
                  "longitude": "-102.043",


                },
                {
                  "code": "GEB230 ",

                  "address": "Lib. Ignacio Zaragoza s/n, Central Camionera",
                  "locality": "Pátzcuaro ",
                  "admin": "Michoacán ",
                  "Country / Region": "MX",
                  "postal": "61600",
                  "latitude": "19.50925278",
                  "longitude": "-101.6171972",


                },
                {
                  "code": "GEB231",

                  "address": "Calle José Sotero de Castañeda , Centro, 60600 ",
                  "locality": "Apatzingán ",
                  "admin": "Michoacán ",
                  "Country / Region": "MX",
                  "postal": "60600",
                  "latitude": "19.08425",
                  "longitude": "-102.3536",


                },
                {
                  "code": "GEB232",

                  "address": "Ignacio Zaragoza 494, Villa Ruiz, La Tanda",
                  "locality": "Purépero ",
                  "admin": "Michoacán ",
                  "Country / Region": "MX",
                  "postal": "58760",
                  "latitude": "19.91048333",
                  "longitude": "-101.9980611",


                },
                {
                  "code": "GEB233",

                  "address": "Av Juárez, Valle Verde, 58688 Zacapu, Mich.",
                  "locality": "Zacapu ",
                  "admin": "Michoacán ",
                  "Country / Region": "MX",
                  "postal": "58688",
                  "latitude": "19.81410278",
                  "longitude": "-101.7855861",


                },
                {
                  "code": "GEB234",

                  "address": "Av. Miguel de la Madrid, Cd Guzmán",
                  "locality": "Cd. Guzmán ",
                  "admin": "Jalisco ",
                  "Country / Region": "MX",
                  "postal": "49000",
                  "latitude": "19.70071667",
                  "longitude": "-103.484625",


                },
                {
                  "code": "GEB235",

                  "address": "Av. Ignacio Zaragoza  Colonia Centro entre Avenida Francisco Zarco y Andador Nautilius",
                  "locality": "Ocatlán ",
                  "admin": "Tlaxcala ",
                  "Country / Region": "MX",
                  "postal": "47800",
                  "latitude": "20.34782778",
                  "longitude": "-102.7769528",


                },
                {
                  "code": "GEB236",

                  "address": "Calle Progreso 725, Unión Sur",
                  "locality": "Tecomán ",
                  "admin": "Colima ",
                  "Country / Region": "MX",
                  "postal": "28130",
                  "latitude": "18.91426389",
                  "longitude": "-103.879425",


                },
                {
                  "code": "GEB237",

                  "address": "Libramiento Guadalajara-Manzanillo s/n, Infraestructura Urbana",
                  "locality": "Colima ",
                  "admin": "Colima ",
                  "Country / Region": "MX",
                  "postal": "28040",
                  "latitude": "19.23313333",
                  "longitude": "-103.7032667",


                },
                {
                  "code": "GEB238",

                  "address": "Atún 12, Valle de Las Garzas, Océano",
                  "locality": "Manzanillo ",
                  "admin": "Colima ",
                  "Country / Region": "MX",
                  "postal": "28219",
                  "latitude": "19.08764444",
                  "longitude": "-104.2912806",


                },
                {
                  "code": "GEB239",

                  "address": "Lázaro Cárdenas 602, Centro",
                  "locality": "La Barca ",
                  "admin": "Jalisco ",
                  "Country / Region": "MX",
                  "postal": "47910",
                  "latitude": "20.28687222",
                  "longitude": "-102.5504972",


                },
                {
                  "code": "GEB240",

                  "address": "Primera Corregidora Nte, Centro",
                  "locality": "Santiago Ixcuintla ",
                  "admin": "Nayarit",
                  "Country / Region": "MX",
                  "postal": "63330",
                  "latitude": "21.80892222",
                  "longitude": "-105.2026861",


                },
                {
                  "code": "GEB241",

                  "address": "Veracruz 55-423, Centro,",
                  "locality": "Ruiz ",
                  "admin": "Nayarit",
                  "Country / Region": "MX",
                  "postal": "63626",
                  "latitude": "21.94965833",
                  "longitude": "-105.1423694",


                },
                {
                  "code": "GEB242",

                  "address": "Boulevard, Blvrd Alfonso G. Calderón, Desarrollo Urbano Tres Ríos",
                  "locality": "Culiacán Rosales",
                  "admin": "Sinaloa",
                  "Country / Region": "MX",
                  "postal": "80020",
                  "latitude": "24.79899167",
                  "longitude": "-107.4331028",


                },
                {
                  "code": "GEB243",

                  "address": "Agustina Ramírez SN-S CENTRAL DEL PACIFICO, Zona Centro",
                  "locality": "Guamúchil ",
                  "admin": "Sinaloa",
                  "Country / Region": "MX",
                  "postal": "81400",
                  "latitude": "25.46066944",
                  "longitude": "-108.0827667",


                },
                {
                  "code": "GEB244",

                  "address": "Pino Suárez 407-291, Centro",
                  "locality": "Los Mochis ",
                  "admin": "Sinaloa",
                  "Country / Region": "MX",
                  "postal": "81200",
                  "latitude": "25.79119722",
                  "longitude": "-108.9928917",


                },
                {
                  "code": "GEB245",

                  "address": "Av Juárez, Centro",
                  "locality": "Tecuala ",
                  "admin": "Michoacán ",
                  "Country / Region": "MX",
                  "postal": "58680",
                  "latitude": "22.39445556",
                  "longitude": "-105.4607167",


                },
                {
                  "code": "GEB246",

                  "address": "Calle Ignacio Ramirez 350, Centro",
                  "locality": "Guasave ",
                  "admin": "Sinaloa",
                  "Country / Region": "MX",
                  "postal": "81000",
                  "latitude": "25.56998611",
                  "longitude": "-108.4667056",


                },
                {
                  "code": "GEB247",

                  "address": "Bravo 98, Centro",
                  "locality": "Villa Hidalgo Nay ",
                  "admin": "Nayarit ",
                  "Country / Region": "MX",
                  "postal": "63550",
                  "latitude": "21.74046944",
                  "longitude": "-105.2357944",


                },
                {
                  "code": "GEB248",

                  "address": "Calle 16, INFONAVIT Industrial",
                  "locality": "Agua Prieta ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "84269",
                  "latitude": "31.31983333",
                  "longitude": "-109.5493194",


                },
                {
                  "code": "GEB249",

                  "address": "San Fernando",
                  "locality": "Benjamín hill ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "83905",
                  "latitude": "30.17203333",
                  "longitude": "-111.0989278",


                },
                {
                  "code": "GEB250",

                  "address": "Blvd. Benito Juárez 71, Centro",
                  "locality": "Caborca ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "83600",
                  "latitude": "30.71560278",
                  "longitude": "-112.1457139",


                },
                {
                  "code": "GEB251",

                  "address": "Quinta Este 4-S, Burocrata",
                  "locality": "Cananea ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "84623",
                  "latitude": "30.98511111",
                  "longitude": "-110.300975",


                },
                {
                  "code": "GEB252",

                  "address": "km Dos (Oriente), Poniente Kilometro 2",
                  "locality": "Empalme ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "85349",
                  "latitude": "27.95223333",
                  "longitude": "-110.8131083",


                },
                {
                  "code": "GEB253",

                  "address": "Av. XII Pte. 390, Centro",
                  "locality": "Guaymas ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "85400",
                  "latitude": "27.92118889",
                  "longitude": "-110.8985472",


                },
                {
                  "code": "GEB254",

                  "address": "Ignacio Allende 12, Centro Comercial",
                  "locality": "Huatabampo ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "85900",
                  "latitude": "26.82851944",
                  "longitude": "-109.6411833",


                },
                {
                  "code": "GEB255",

                  "address": "Av. Niños Héroes, San Felipe",
                  "locality": "Magdalena de Kino ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "84160",
                  "latitude": "30.62776667",
                  "longitude": "-110.9666611",


                },
                {
                  "code": "GEB256",

                  "address": "Calle 16 s/n, Ímuris Centro",
                  "locality": "Imuris ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "84200",
                  "latitude": "30.78063611",
                  "longitude": "-110.8542333",


                },
                {
                  "code": "GEB257",

                  "address": "20 de Noviembre 385",
                  "locality": "Naco ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "84180",
                  "latitude": "31.31611111",
                  "longitude": "-109.94595",


                },
                {
                  "code": "GEB258",

                  "address": "Allende 313, Centro, Reforma",
                  "locality": "Navojoa ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "85800",
                  "latitude": "27.07880556",
                  "longitude": "-109.4423528",


                },
                {
                  "code": "GEB259",

                  "address": "Av. Alvaro Obregon 2562, El Greco",
                  "locality": "Nogales ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "84000",
                  "latitude": "31.289125",
                  "longitude": "-110.9368722",


                },
                {
                  "code": "GEB260",

                  "address": "Ignacio Aldama 304-300, Col del Rio",
                  "locality": "Santa Ana ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "84600",
                  "latitude": "30.54735278",
                  "longitude": "-111.1199722",


                },
                {
                  "code": "GEB261",
                  "address": "Sonoyta - San Luis Río Colorado, Centro",
                  "locality": "Sonoyta ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "83570",
                  "latitude": "31.85993611",
                  "longitude": "-112.8505667",
                },
                {
                  "code": "GEB262",
                  "address": "Calle 5, Comercial",
                  "locality": "San Luis Río Colorado ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "83449",
                  "latitude": "32.48051667",
                  "longitude": "-114.7782278",
                },
                {
                  "code": "GEB263",
                  "address": "Av Riveroll 1017, Zona Centro",
                  "locality": "Ensenada ",
                  "admin": "Baja california ",
                  "Country / Region": "MX",
                  "postal": "22800",
                  "latitude": "31.87203056",
                  "longitude": "-116.619375",
                },
                {
                  "code": "GEB264",
                  "address": "Av B.C. Esq, Av Francisco Sarabia, Centro Cívico, Mexicali, B.C",
                  "locality": "Mexicali ",
                  "admin": "Baja California ",
                  "Country / Region": "MX",
                  "postal": "21000",
                  "latitude": "32.63589722",
                  "longitude": "-115.4700222",
                },
                {
                  "code": "GEB265",
                  "address": "Presidente Abelardo L. Rodríguez, Primera",
                  "locality": "Tecate ",
                  "admin": "baja California ",
                  "Country / Region": "MX",
                  "postal": "21400",
                  "latitude": "32.57364167",
                  "longitude": "-116.6246667",
                },
                {
                  "code": "GEB266",
                  "address": "Acceso Foraneo Central Camionera, Chapultepec Alamar",
                  "locality": "Tijuana ",
                  "admin": "Baja California ",
                  "Country / Region": "MX",
                  "postal": "22110",
                  "latitude": "32.51653333",
                  "longitude": "-116.9599111",
                },
                {
                  "code": "GEB267",
                  "address": "Real del Monte, Central Camionera Poniente, Álvaro Obregón",
                  "locality": "México Poniente ",
                  "admin": "Ciudad de México ",
                  "Country / Region": "MX",
                  "postal": "1180",
                  "latitude": "19.39606389",
                  "longitude": "-99.20023611",
                },
                {
                  "code": "GEB268",
                  "address": "Emiliano Zapata, Centro",
                  "locality": "La peñita de Jaltemba",
                  "admin": "Nayarit ",
                  "Country / Region": "MX",
                  "postal": "63720",
                  "latitude": "21.03892222",
                  "longitude": "-105.2470889",
                },
                {
                  "code": "GEB269",
                  "address": "Calle 24 Lazaro Cardenas del Río, Centro",
                  "locality": "Puerto Peñasco ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "83550",
                  "latitude": "31.32393333",
                  "longitude": "-113.5342111",
                },
                {
                  "code": "GEB270",
                  "address": "Arboledas San Carlos",
                  "locality": "Acaponeta",
                  "admin": "Nayarit",
                  "Country / Region": "MX",
                  "postal": "63400",
                  "latitude": "22.48953611",
                  "longitude": "-105.3725278",
                },
                {
                  "code": "GEB271",
                  "address": "Av. Héroes de Nacozari, Flamingos",
                  "locality": "Bucerías ",
                  "admin": "Nayarit ",
                  "Country / Region": "MX",
                  "postal": "63732",
                  "latitude": "20.75691111",
                  "longitude": "-105.3387861",
                },
                {
                  "code": "GEB272",
                  "address": "Blvrd Niños Heroes, Villa Unión",
                  "locality": "Villa Unión ",
                  "admin": "Sinaloa ",
                  "Country / Region": "MX",
                  "postal": "82210",
                  "latitude": "23.18869167",
                  "longitude": "-106.2184556",
                },
                {
                  "code": "GEB273",
                  "address": "Est. Vicam Sonora MX, Nainari s/n. Termoelectrica",
                  "locality": "Vicam ",
                  "admin": "Sonora ",
                  "Country / Region": "MX",
                  "postal": "85430",
                  "latitude": "27.64079722",
                  "longitude": "-110.2952111",
                },
                {
                  "code": "GEB274",
                  "address": "Martinez de la Torre-Canoas",
                  "locality": "Piedras Clavadas ",
                  "admin": "Veracruz ",
                  "Country / Region": "MX",
                  "postal": "95263",
                  "latitude": "21.16666667",
                  "longitude": "-97.99184444",
                },
                {
                  "code": "GEB275",
                  "address": "Hidalgo",
                  "locality": "Topia ",
                  "admin": "Durango ",
                  "Country / Region": "MX",
                  "postal": "34540",
                  "latitude": "25.20714722",
                  "longitude": "-106.5712139",
                },
                {
                  "code": "GEB276",
                  "address": " Gro. Av Diego Hurtado de Mendoza, Equipamiento",
                  "locality": "Acapulco Cuauhtemoc",
                  "admin": "Acapulco ",
                  "Country / Region": "MX",
                  "postal": "39300",
                  "latitude": "16.85714444",
                  "longitude": "-99.90167778",
                },
                {
                  "code": "GEB277",
                  "address": "Hornos Insurgentes",
                  "locality": "Acapulco Papagayo ",
                  "admin": "Acapulco ",
                  "Country / Region": "MX",
                  "postal": "39350",
                  "latitude": "16.86186667",
                  "longitude": "-99.88873333",
                },
                {
                  "code": "GEB278",
                  "address": "Guadalupe - Zacatecas, Zacatecas Centro",
                  "locality": "Ex Central Zacatecas ",
                  "admin": "Zacatecas ",
                  "Country / Region": "MX",
                  "postal": "98000",
                  "latitude": "22.76924444",
                  "longitude": "-102.5716",
                },
                {
                  "code": "GEB279",
                  "address": "Hidalgo 51",
                  "locality": "Villa de Romos ",
                  "admin": "San Luis Potosi ",
                  "Country / Region": "MX",
                  "postal": "78690",
                  "latitude": "22.830425",
                  "longitude": "-101.9111944",
                },
                {
                  "code": "GEB280",
                  "address": "Boulevar Blvrd Felipe Angeles 20, Venta Prieta",
                  "locality": "Venta Prieta ",
                  "admin": "Pachuca ",
                  "Country / Region": "MX",
                  "postal": "42080",
                  "latitude": "20.08812778",
                  "longitude": "-98.77163611",
                },
                {
                  "code": "GEB281",
                  "address": "Carr Mezcales - San Vicente, Ica",
                  "locality": "Mezcales ",
                  "admin": "Nayarit ",
                  "Country / Region": "MX",
                  "postal": "63735",
                  "latitude": "20.73175556",
                  "longitude": "-105.2824472",
                },
                {
                  "code": "GEB282",
                  "address": " Rosendo G. Castro Pte., La Bienestar",
                  "locality": "Los Mochis Boulevard ",
                  "admin": "Sinaloa ",
                  "Country / Region": "MX",
                  "postal": "81280",
                  "latitude": "25.78243889",
                  "longitude": "-108.9884861",
                },
                {
                  "code": "GEB283",
                  "address": "Campestre Churubusco, Coyoacán",
                  "locality": "México Sur ",
                  "admin": "Ciudad de México ",
                  "Country / Region": "MX",
                  "postal": "4200",
                  "latitude": "19.34331111",
                  "longitude": "-99.13835556",
                },
                {
                  "code": "GEB284",
                  "address": "Paseo de las Gaviotas",
                  "locality": "Ixtapa Zihuatanejo",
                  "admin": "Guerrero ",
                  "Country / Region": "MX",
                  "postal": "40880",
                  "latitude": "17.66265833",
                  "longitude": "-101.6013667",
                },
                {
                  "code": "GEB285",
                  "address": "Paseo de las Gaviotas, Ixtapa Zihuatanejo, Gro",
                  "locality": "Valle Hermosos ",
                  "admin": "Guerrero ",
                  "Country / Region": "MX",
                  "postal": "40882",
                  "latitude": "25.67538056",
                  "longitude": "-97.81566944",
                },
                {
                  "code": "GEB286",
                  "address": "Av. Tecnologico, Deportiva José Pistolas Meneses",
                  "locality": "Pistola Meneses ",
                  "admin": "Chihuahua",
                  "Country / Region": "MX",
                  "postal": "31137",
                  "latitude": "28.73095556",
                  "longitude": "-106.1492139",
                },
                {
                  "code": "GEB287",
                  "address": "Calle Juárez Pte. 106, Ojos de Agua",
                  "locality": "Cd. Hidalgo ",
                  "admin": "Michoacán ",
                  "Country / Region": "MX",
                  "postal": "61128",
                  "latitude": "19.68974444",
                  "longitude": "-100.5655944",
                },
                {
                  "code": "GEB288",
                  "address": "Av Guadalupe Victoria Centro",
                  "locality": "Centro Tepic ",
                  "admin": "Nayarit ",
                  "Country / Region": "MX",
                  "postal": "63000",
                  "latitude": "21.51489722",
                  "longitude": "-104.8899778",
                },
                {
                  "code": "GEB289",
                  "address": "Ignacio López Rayon, La Sabana",
                  "locality": "Las Cruces Costa Chica",
                  "admin": "Guerrero ",
                  "Country / Region": "MX",
                  "postal": "39799",
                  "latitude": "16.88544722",
                  "longitude": "-99.83605556",
                },
                {
                  "code": "GEB290",
                  "address": "Ent. del Real 5, Ent del Real",
                  "locality": "Guanaceví",
                  "admin": "Durango ",
                  "Country / Region": "MX",
                  "postal": "35400",
                  "latitude": "25.93588611",
                  "longitude": "-105.9492389",
                },
                {
                  "code": "GEB291",
                  "address": "Av. Capitán Carlos León, Internacional Benito Juárez, Venustiano Carranza",
                  "locality": "México Aeropuerto ",
                  "admin": "Ciudad de México ",
                  "Country / Region": "MX",
                  "postal": "15620",
                  "latitude": "19.43624722",
                  "longitude": "-99.08172222",
                },
                {
                  "code": "GEB292",
                  "address": "Autopista México - Pachuca, San Cristóbal Centro",
                  "locality": "Ecatepec ",
                  "admin": "Estado de México ",
                  "Country / Region": "MX",
                  "postal": "55040",
                  "latitude": "19.59951667",
                  "longitude": "-99.03921111",
                },
                {
                  "code": "GEB293",
                  "address": "Autopista Querétaro - México, Cedros",
                  "locality": "Tepotzotlán ",
                  "admin": "Estado de México ",
                  "Country / Region": "MX",
                  "postal": "54605",
                  "latitude": "19.7058",
                  "longitude": "-99.20553333",
                },
                {
                  "code": "GEB294",
                  "address": "Av. Niños Heroes 140, San Pedro, Zona Centro II.",
                  "locality": "Chihuahua Centro ",
                  "admin": "Chihuahua",
                  "Country / Region": "MX",
                  "postal": "31000",
                  "latitude": "28.63500556",
                  "longitude": "-106.08355",
                },
                {
                  "code": "GEB295",
                  "address": "Calle 13a., Zona Centro",
                  "locality": "Cd. Cuauhtemoc",
                  "admin": "Chihuahua",
                  "Country / Region": "MX",
                  "postal": "31500",
                  "latitude": "28.41009444",
                  "longitude": "-106.8609306",
                },
                {
                  "code": "GEB296",
                  "address": "Hidalgo, Centro",
                  "locality": "Aldama ",
                  "admin": "Chihuahua",
                  "Country / Region": "MX",
                  "postal": "32910",
                  "latitude": "28.83886944",
                  "longitude": "-105.9127194",
                },
                {
                  "code": "GEB297",
                  "address": "Acapulco - Aeropuerto Acapulco 34, Granjas del Marqués",
                  "locality": "Acapulco Diamante ",
                  "admin": "Guerrero ",
                  "Country / Region": "MX",
                  "postal": "39890",
                  "latitude": "16.80151111",
                  "longitude": "-99.82088056",
                },
                {
                  "code": "GEB298",
                  "address": "Av Plaza del Sol 25, Plaza del Sol",
                  "locality": "Condo Plaza del Sol ",
                  "admin": "Jalisco ",
                  "Country / Region": "MX",
                  "postal": "45050",
                  "latitude": "20.65234444",
                  "longitude": "-103.4006417",
                },
                {
                  "code": "GEB299",
                  "address": "Blvd. Felipe Ángeles 2-D, Carlos Rovirosa",
                  "locality": "Ag. Plaza de Toros ",
                  "admin": "Hidalgo ",
                  "Country / Region": "MX",
                  "postal": "42082",
                  "latitude": "20.06480556",
                  "longitude": "-98.78245278",
                },
                {
                  "code": "GEB300",
                  "address": "El Paraíso",
                  "locality": "Nueva Central Huauchinango ",
                  "admin": "Puebla ",
                  "Country / Region": "MX",
                  "postal": "73160",
                  "latitude": "20.17904444",
                  "longitude": "-98.05222778",
                },
                {
                  "code": "GEB301",
                  "address": "Carrt mex pach, Matilde",
                  "locality": "Ag. Matilde Pachuca ",
                  "admin": "Hidalgo ",
                  "Country / Region": "MX",
                  "postal": "42000",
                  "latitude": "20.03060278",
                  "longitude": "-98.803275",
                },
                {
                  "code": "GEB302",
                  "address": "México 99, Geovillas",
                  "locality": "Ag. Blvd. Nuevo Hidalgo Pachuca ",
                  "admin": "Hidalgo ",
                  "Country / Region": "MX",
                  "postal": "42083",
                  "latitude": "20.06083611",
                  "longitude": "-98.77535833",
                },
                {
                  "code": "GEB303",
                  "address": "San Francisco de Los Romo-Aguascalientes Carretera Federal, 45 norte Km, 11",
                  "locality": "Terminal Ribier ",
                  "admin": "Aguascalientes",
                  "Country / Region": "MX",
                  "postal": "20920",
                  "latitude": "21.97273333",
                  "longitude": "-102.2888722",
                },
                {
                  "code": "GEB304",
                  "address": "Blvd. Antonio Cárdenas 2970, 26 de Marzo 4to Sector",
                  "locality": "Ag. Gasolinera Lourdes ",
                  "admin": "Coahuila ",
                  "Country / Region": "MX",
                  "postal": "25070",
                  "latitude": "25.39070278",
                  "longitude": "-101.0055556",
                },
                {
                  "code": "GEB305",
                  "address": " Av Juárez, Centro",
                  "locality": "Ag. Terminal Sarape ",
                  "admin": "Michoacán ",
                  "Country / Region": "MX",
                  "postal": "58680",
                  "latitude": "25.43022222",
                  "longitude": "-100.9704611",
                },
                {
                  "code": "GEB306",
                  "address": "México (Lic. Benito Juárez), Venustiano Carranza",
                  "locality": "México Aeropuerto ",
                  "admin": "Ciudad de México ",
                  "Country / Region": "MX",
                  "postal": "15620",
                  "latitude": "19.42061944",
                  "longitude": "-99.07792778",
                },
                {
                  "code": "GEB307",
                  "address": "Blvd. Felipe Ángeles, Venta Prieta",
                  "locality": "Fiesta Inn Pachuca ",
                  "admin": "hidalgo ",
                  "Country / Region": "MX",
                  "postal": "42080",
                  "latitude": "20.07996389",
                  "longitude": "-98.77384444",
                },
                {
                  "code": "GEB308",
                  "address": "Tepic - Puerto Vallarta",
                  "locality": "Nuevo Vallarta ",
                  "admin": "Nayarit ",
                  "Country / Region": "MX",
                  "postal": "63735",
                  "latitude": "20.71046111",
                  "longitude": "-105.2759806",
                },
                {
                  "code": "GEB309",
                  "address": "Maclovio Herrera S/n, Centro",
                  "locality": "Guachochi",
                  "admin": "Chihuahua",
                  "Country / Region": "MX",
                  "postal": "33180",
                  "latitude": "26.82330556",
                  "longitude": "-107.0712944",
                },
                {
                  "code": "GEB310",
                  "address": "Carretera Calnali - Tostlamantla ",
                  "locality": "Calnali ",
                  "admin": "hidalgo ",
                  "Country / Region": "MX",
                  "postal": "43230",
                  "latitude": "20.89967778",
                  "longitude": "-98.59148056",
                },
                {
                  "code": "GEB311",
                  "address": " calle principal Mecatlan Yahualica ",
                  "locality": "Mecatlan ",
                  "admin": "Hidalgo ",
                  "Country / Region": "MX",
                  "postal": "43080",
                  "latitude": "20.93406389",
                  "longitude": "-98.40218889",
                },
                {
                  "code": "GEB312",
                  "address": "Galeana, Centro de Galeana",
                  "locality": "Galeana ",
                  "admin": "Nuevo León ",
                  "Country / Region": "MX",
                  "postal": "67850",
                  "latitude": "24.82702222",
                  "longitude": "-100.0769694",
                },
                {
                  "code": "GEB313",
                  "address": "Julián Hernández 39",
                  "locality": "Temastian ",
                  "admin": "Jalisco ",
                  "Country / Region": "MX",
                  "postal": "46180",
                  "latitude": "21.98034444",
                  "longitude": "-103.5268667",
                },
                {
                  "code": "GEB314",
                  "address": "Reforma",
                  "locality": "Totatiche ",
                  "admin": "Jalisco ",
                  "Country / Region": "MX",
                  "postal": "48130",
                  "latitude": "21.9295",
                  "longitude": "-103.4406167",
                },
                {
                  "code": "GEB315",
                  "address": "Segunda 14398, Contreras",
                  "locality": "5 y 10 ",
                  "admin": "Baja California ",
                  "Country / Region": "MX",
                  "postal": "22106",
                  "latitude": "32.49822222",
                  "longitude": "-116.9681333",
                }];

              // ////////

              /*
              *  FOR EMAIL ELEMENT
              */

              // Handles the event to send a mail
              function getMail(domain) {
                angular.element('.buttons').addClass('loading');
                if (angular.element('#email').val().length > 0) {
                  sendMail(domain)
                    .then(function (response) {
                      $scope.form_name = '';
                      $scope.form_email = '';
                      $scope.form_phone = '';
                      $scope.form_message = '';
                      $translate('NOTIFICATION.CONTACT.EMAIL').then(function (message) {
                        msUtils.showNotification(message, 'md-yellow-300-bg');
                      });
                      angular.element('.buttons').removeClass('loading');
                    })
                    .catch(onError);
                } else {
                  angular.element('.buttons').removeClass('loading');
                }
              }

              // Makes an API request to send a mail
              function sendMail(domain) {
                var defered = $q.defer();
                var promise = defered.promise;
                // API request for sendmail
                api.contact.sendmail.create({
                    name: $scope.form_name,
                    email: $scope.form_email,
                    phone: $scope.form_phone,
                    message: $scope.form_message,
                    domain: domain
                  },
                  function (response) {
                    defered.resolve(response);
                  },
                  function (error) {
                    defered.reject(error);
                  });
                return promise;
              }

              /*
              *   ERROR HANDLING
              */

              // Handles the error callback
              function onError(error) {
                if (error !== undefined && error.status !== 500) {
                  if (error.data !== null) {
                    var param = error.data.errors[0].param_name !== null ? error.data.errors[0].param_name : '';
                    var title = error.data.errors[0].message !== undefined ? error.data.errors[0].message : error.data.errors[0].title;
                    var message = param !== '' ? param + ', ' + title : title;
                    msUtils.showNotification(message, 'md-yellow-300-bg');
                  } else {
                    $translate('NOTIFICATION.ERRORS.TIMEOUT').then(function (error) {
                      msUtils.showNotification(error, 'md-yellow-300-bg');
                    });
                  }
                } else {
                  $translate('NOTIFICATION.ERROR500.NOTIFICATION').then(function (error) {
                    msUtils.showNotification(error, 'md-yellow-300-bg');
                  });
                }
                angular.element('.buttons').removeClass('loading');
              }
            } // controller
          } // 'content@app'
        }, // views
        bodyClass: {app: APP_NAME + '_app', page: 'static'}
      }); // state
    }) // page
  }
})();

angular.module("busolinea").run(["$templateCache", function($templateCache) {$templateCache.put("app/core/directives/image-fadera/image-fadera.html","<div class=\"ng-fader\"><div class=\"ng-fader-pagination\"><ul><li ng-repeat=\"i in dots(numberOfImages) track by $index\" \nng-class=\"{current: selectedImage==$index}\" ng-click=\"setSelected($index)\"></li></ul></div><div \nng-if=\"showControls==\'true\'\" class=\"ng-fader-controls\"><ul><li ng-click=\"sliderBack()\"><i class=\"ngfader-back\"></i>\n</li><li ng-click=\"stopSlider()\"><i class=\"ngfader-pause\" ng-class=\"{\'active\': activePause}\"></i></li><li \nng-click=\"startSlider()\"><i class=\"ngfader-play\" ng-class=\"{\'active\': activeStart}\"></i></li><li \nng-click=\"sliderForward()\"><i class=\"ngfader-forward\"></i></li></ul></div></div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"$root.global.search\" ng-model-options=\"{\'debounce\': debounce}\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div>");
$templateCache.put("app/core/directives/video-slider/video-slider.html","<div class=\"video-slider\"><div id=\"carousel\" class=\"carousel\"><img ng-click=\"showVideo(\'TF93Z0VBf0o\', 1)\" \nng-src=\"/assets/images/poster.jpeg\" style=\"width: 60%\" class=\"cloud9-item\" alt=\"Item #0\"></div><svg \nclass=\"play-button\" version=\"1.1\" id=\"IconsRepoEditor\" xmlns=\"http://www.w3.org/2000/svg\" \nxmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 60 60\" style=\"enable-background:new 0 0 60 60\" \nxml:space=\"preserve\" width=\"100px\" height=\"100px\" fill=\"#000000\" stroke=\"#000000\" stroke-width=\"0\"><g \nid=\"IconsRepo_bgCarrier\"></g><path \nd=\"M45.563,29.174l-22-15c-0.307-0.208-0.703-0.231-1.031-0.058C22.205,14.289,22,14.629,22,15v30 c0,0.371,0.205,0.711,0.533,0.884C22.679,45.962,22.84,46,23,46c0.197,0,0.394-0.059,0.563-0.174l22-15 C45.836,30.64,46,30.331,46,30S45.836,29.36,45.563,29.174z M24,43.107V16.893L43.225,30L24,43.107z\">\n</path><path \nd=\"M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30 S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z\">\n</path></svg></div>");
$templateCache.put("app/views/transportamex/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\"><md-content id=\"content\" class=\"md-background md-hue-1\" \nui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/views/transportamex/layouts/default-navigation-nosearchbar.html","<div id=\"layout-default-navigation-nosearchbar\" class=\"template-layout\"><md-content id=\"content\" ui-view=\"content\">\n</md-content></div>");
$templateCache.put("app/views/transportamex/layouts/default-navigation.html","<div id=\"layout-default-navigation\" class=\"template-layout\"><md-content id=\"searchbar\" ui-view=\"searchbar\">\n</md-content><md-content id=\"content\" ui-view=\"content\"></md-content></div>");
$templateCache.put("app/core/directives/filter-inline/templates/filter-inline.html","<div class=\"filter-inline\"><span class=\"label\" translate=\"ROUTES.SORT\">Ordenar por</span> <span \nclass=\"filter-inline-option\" data-ng-repeat=\"option in collection\" \ndata-ng-class=\"{\'selected\': selection.id === option.id}\" data-ng-click=\"filterClick(option)\" \ntranslate=\"ROUTES.SORTS.{{option.id}}\">{{option.name}}</span></div>");
$templateCache.put("app/core/directives/filter-sidebar/templates/filter-sidebar.html","<div id=\"filters\" layout=\"column\" flex=\"auto\" layout-align=\"start none\"><div class=\"filter hour\" flex=\"nogrow\"><header>\n<span translate=\"ROUTES.DEPARTURE\">SALIENDO</span><div>{{routes.origin.name}}</div></header><div class=\"hours\"><div \nclass=\"line\"><div class=\"midle-line\"></div><span id=\"from_hour\" class=\"hour left\">{{timeMin | clockString}} </span>\n<span id=\"to_hour\" class=\"hour right\">{{timeMax | clockString}}</span></div><div class=\"range-field\"><div range-slider \nmin=\"0\" max=\"24\" model-min=\"timeMin\" model-max=\"timeMax\" analytics-on analytics-category=\"filter\" \nanalytics-label=\"hours-slider\" analytics-event=\"Time Filter Clicked\"></div></div><div class=\"clearfix\"></div></div>\n</div><div class=\"filter cabin_type\" flex=\"nogrow\"><h5 translate=\"ROUTES.CABIN_TYPE\">Tipo de cabina</h5><div \nclass=\"check\" ng-repeat=\"cabin in cabinTypesRoute\"><input class=\"filled-in\" type=\"checkbox\" \nid=\"cabin_type_{{cabin.id}}\" name=\"cabin_type\" ng-model=\"cabin.check\" analytics-on analytics-category=\"filter\" \nanalytics-label=\"cabin-type\" analytics-event=\"{{cabin.name}} Clicked\" analytics-value=\"{{cabin.name}}\"><label \nclass=\"css-label lrg.web-two-style\" for=\"cabin_type_{{cabin.id}}\">{{cabin.name}}</label></div></div><div \nclass=\"filter local_paso\" flex=\"nogrow\"><h5 translate=\"ROUTES.LOCAL_PASO\">Local / Paso</h5><div class=\"check\" \nng-repeat=\"localpaso in localpasoRoute\"><input class=\"filled-in\" type=\"checkbox\" id=\"local_paso_{{localpaso.id}}\" \nname=\"local_paso\" ng-model=\"localpaso.check\" analytics-on analytics-category=\"filter\" analytics-label=\"local-paso\" \nanalytics-event=\"{{localpaso.name}} Clicked\" analytics-value=\"{{localpaso.name}}\"><label \nclass=\"css-label lrg.web-two-style\" for=\"local_paso_{{localpaso.id}}\">{{localpaso.name}}</label></div></div><div \nclass=\"filter companies\" flex=\"nogrow\"><h5 translate=\"ROUTES.BUS_COMPANIES\">Empresas de Autobuses</h5><div \nclass=\"clearfix\"><div class=\"check\" ng-repeat=\"bus1 in busCompaniesOutboundRoute\" ng-if=\"$root.returnTicket==false\">\n<input type=\"checkbox\" id=\"bus_{{bus1.id}}\" name=\"company\" rel=\"{{bus1.name}}\" class=\"filled-in\" ng-model=\"bus1.check\" \nanalytics-on analytics-category=\"filter\" analytics-label=\"busline\" analytics-event=\"{{bus1.name}} Clicked\" \nanalytics-value=\"{{bus1.name}}\"><label class=\"css-label lrg web-two-style\" for=\"bus_{{bus1.id}}\">{{bus1.name}}</label>\n</div><div class=\"check\" ng-repeat=\"bus2 in busCompaniesReturnRoute\" ng-if=\"$root.returnTicket\"><input type=\"checkbox\" \nid=\"bus_{{bus2.id}}\" name=\"company\" rel=\"{{bus2.name}}\" class=\"filled-in\" ng-model=\"bus2.check\" analytics-on \nanalytics-category=\"filter\" analytics-label=\"busline\" analytics-event=\"{{bus2.name}} Clicked\" \nanalytics-value=\"{{bus2.name}}\"><label class=\"css-label lrg web-two-style\" for=\"bus_{{bus2.id}}\">{{bus2.name}}</label>\n</div></div></div></div>");
$templateCache.put("app/core/directives/mobile-banner/templates/mobile-banner.html","<div id=\"mobile-{{position}}-section\" style=\"display:none\"><div class=\"mobile-banner\"><a href=\"{{ app_url }}\" \nng-click=\"adClick()\" analytics-on analytics-category=\"home\" analytics-label=\"app_banner\" analytics-value=\"{{ os }}\">\n<img src=\"{{ ad_src }}\"></a><md-icon md-font-icon=\"icon-close\" class=\"icon s25 close\" ng-click=\"closeAd(position)\">\n</md-icon></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/time-selector/templates/time-selector.html","<div class=\"time-selector\"><div class=\"time-selector-option\" data-ng-class=\"{ \'selected\': option.value }\" \ndata-ng-repeat=\"option in ngModel\" data-ng-if=\"option.show\"><label class=\"time-selector-label\"><input type=\"checkbox\" \nng-model=\"option.value\"> <span ng-if=\"option.label\" translate=\"ROUTES.TIME.{{option.label}}\">{{option.label}}</span>\n</label><div class=\"time-selector-footer\" data-ng-if=\"option.footer\">{{option.footer}}</div><div \nclass=\"time-selector-display\" data-ng-click=\"toggleOptionValue(option, $last)\">{{option.display}}</div></div></div>");
$templateCache.put("app/views/transportamex/elements/footer/footer.html","<div class=\"container\" layout=\"column\" layout-align=\"start none\" flex=\"initial\" ng-controller=\"FooterController\"><div \nclass=\"social\" layout-xs=\"column\" layout-align-xs=\"start center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"center start\" \nflex=\"initial\"><div flex-sm=\"initial\" flex-gt-sm=\"50\" ng-repeat=\"item in dataFromApi[selectedLanguage]\"><h3 \ntranslate=\"FOOTER_DYNAMIC.ITEM\" translate-values=\"{item: item.title}\"></h3><ul><li \nng-repeat=\"component in item.labels\"><a ng-href=\"{{component.link}}\" analytics-on analytics-category=\"footer\" \nanalytics-label=\"about\" translate=\"FOOTER_DYNAMIC.ITEM\" translate-values=\"{item: component.label}\" target=\"_self\"></a>\n</li></ul></div></div><div layout=\"column\" layout-align=\"start none\" flex=\"initial\"><div layout=\"row\" \nlayout-align=\"center none\" flex=\"initial\" class=\"social-links\"><a ng-repeat=\"item in dataSocialApi\" \nng-href=\"{{item.link}}\" flex=\"initial\" analytics-on analytics-category=\"footer\" analytics-label=\"social-media\" \nanalytics-event=\"facebook\"><i class=\"{{item.icon}}\" aria-hidden=\"true\"></i></a></div><div class=\"rights\" \nflex=\"initial\">{{ copyright }}</div></div></div>");
$templateCache.put("app/views/transportamex/elements/notifications/notification.html","");
$templateCache.put("app/views/transportamex/elements/searchbar/searchbar.html","<div class=\"top_searchbar\"><div class=\"departure_destination clearfix\" hide-gt-sm ng-click=\"vm.toggleSearchbar()\"><div \nclass=\"container\"><md-icon class=\"edit-date\" md-svg-src=\"/assets/transportamex/images/icons/icon_edit.svg\"></md-icon>\n<div class=\"route-info\" layout=\"row\" layout-align=\"center-stretch\"><h2 class=\"text-right\" flex=\"grow\">\n{{ $root.route.originCity }}</h2><md-icon md-svg-src=\"/assets/transportamex/images/icons/keyboard_arrow_right.svg\" \nflex=\"initial\"></md-icon><h2 flex=\"grow\">{{ $root.route.destinationCity }}</h2></div><div class=\"departure-date\" \nlayout=\"row\" layout-align=\"center-center\"><h4 class=\"date\">{{ $root.route.departureDate | date:\'dd / MM / yyyy\' }}</h4>\n</div></div></div><div class=\"container searchbar-container\" show-gt-sm><div id=\"inside_search\"><form \nname=\"SearchForm\" layout-gt-sm=\"row\" layout=\"column\" flex=\"100\" layout-align-gt-sm=\"space-around center\" \nlayout-align=\"start-stretch\" layout-padding><div flex=\"grow\"><div class=\"input-field\"><md-autocomplete md-no-cache \nmd-select-on-match md-match-case-insensitive md-selected-item=\"vm.originCity\" md-search-text=\"vm.searchText\" \nmd-selected-item-change=\"vm.originCityChange(item)\" md-items=\"item in vm.querySearchOrigin(vm.searchText)\" \nmd-item-text=\"item.name\" md-min-length=\"0\" ng-disabled=\"vm.isDisabledOrigin\" \nplaceholder=\"{{ \'SEARCHBAR.SEARCH.ORIGIN\' | translate }}\" md-input-id=\"departure_city\" md-dropdown-position=\"bottom\">\n<md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{ item.name }}</span>\n</md-item-template><md-not-found>{{ \'SEARCHBAR.SEARCH.NOT_FOUND\' | translate }}</md-not-found></md-autocomplete></div>\n</div><div flex=\"grow\"><div class=\"input-field\"><md-autocomplete md-no-cache md-select-on-match \nmd-match-case-insensitive md-selected-item=\"vm.destinationCity\" md-search-text=\"vm.searchText2\" \nmd-selected-item-change=\"vm.destinationCityChange(item2)\" \nmd-items=\"item2 in vm.querySearchDestination(vm.searchText2)\" md-item-text=\"item2.name\" md-min-length=\"0\" \nng-disabled=\"vm.isDisabledDestination\" placeholder=\"{{ \'SEARCHBAR.SEARCH.DESTINATION\' | translate }}\" \nmd-input-id=\"destination_city\" md-dropdown-position=\"bottom\"><md-item-template><span \nmd-highlight-text=\"vm.searchText2\" md-highlight-flags=\"^i\">{{ item2.name }}</span></md-item-template><md-not-found>\n<span class=\"not-found-text\">{{ \'SEARCHBAR.SEARCH.NOT_FOUND\' | translate }}</span></md-not-found></md-autocomplete>\n</div></div><div flex=\"grow\"><div class=\"input-field\"><md-datepicker id=\"route_departure_date\" \nname=\"route_departure_date\" ng-model=\"vm.departureDate\" md-min-date=\"vm.departureMinDate\" \nng-change=\"vm.departureDateChange()\" md-placeholder=\"{{ \'SEARCHBAR.SEARCH.DEPARTURE\' | translate }}\" \nmd-is-open=\"vm.departureisOpen\"></md-datepicker><div class=\"departure-date-overlay\" \nng-click=\"vm.handleCalendar(true, \'departure\', $event)\"></div></div></div><div flex=\"grow\"><div class=\"input-field\">\n<md-datepicker id=\"route_arrival_date\" name=\"route_arrival_date\" ng-model=\"vm.arrivalDate\" \nmd-min-date=\"vm.arrivalMinDate\" ng-change=\"vm.arrivalDateChange()\" \nmd-placeholder=\"{{ \'SEARCHBAR.SEARCH.RETURN\' | translate }}\" md-is-open=\"vm.arrivalisOpen\"></md-datepicker><div \nclass=\"arrival-date-overlay\" ng-click=\"vm.handleCalendar(true, \'arrival\', $event)\"></div><md-icon \nng-if=\"vm.arrivalDate != null\" md-font-icon=\"icon-close\" class=\"icon s24 close-arrival-date\" \nng-click=\"vm.handleCalendar(false, \'arrival\', $event)\"></md-icon></div></div><div flex=\"initial\" class=\"search-wrap\">\n<md-button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.reloadPage()\" aria-label=\"Buscar\" \ntranslate=\"SEARCHBAR.SEARCH.SEARCH\">BUSCAR</md-button></div></form></div></div></div>");
$templateCache.put("app/views/transportamex/elements/sidebar_left/sidebar_left.html","sidebar_left.html");
$templateCache.put("app/views/transportamex/elements/toolbar/toolbar.html","toolbar.html");
$templateCache.put("app/views/transportamex/pages/about/about.html","<div id=\"about_content\" layout=\"row\" layout-align=\"center start\"><div layout=\"column\" layout-align=\"start-none\" \nflex=\"90\"><h1 translate=\"ABOUT.TITLE\">Sobre Nosotros</h1><h2 translate=\"ABOUT.SUBTITLE\">Quiénes somos</h2><p \ntranslate=\"ABOUT.P1\">\nBusolinea es una nueva plataforma de internet que te ayudara a buscar, comparar y comprar las mejores ofertas de boletos de autobús en México. También contamos con aplicaciones gratuitas para smartphones Android y iOS y tendrás la opción de navegar en inglés o en español. Este sitio web ha sido diseñado para aquellos que disfrutan y desean viajar en autobús.\n</p><p translate=\"ABOUT.P2\">\nSi conoces tu destino y la fecha en la cual deseas viajar, Busolinea te mostrará las diferentes opciones disponibles para que puedas elegir la que más te convenga. Además, tendrás la opción de comprar tus boletos en línea con el dispositivo de tu preferencia desde la comodidad de tu hogar o cualquier otro lugar.\n</p></div></div>");
$templateCache.put("app/views/transportamex/pages/confirmation/confirmation.html","<div id=\"reservations_content\"><div class=\"container\"><div id=\"confirmation\" layout=\"column\" layout-align=\"start none\">\n<div class=\"confirmation\" layout=\"column\" layout-align=\"start none\" flex=\"initial\"><div class=\"info\" flex-auto><img \nclass=\"envelope\" src=\"/assets/transportamex/images/confirmation/envelope.png\" alt=\"Envelope\"><h3 \ntranslate=\"CONFIRMATION.THANKS\">¡Gracias por tu compra!</h3><p class=\"ready\"><b translate=\"CONFIRMATION.READY\">\n¿Listo para viajar? Tu boleto ha sido enviado al correo electrónico que nos proporcionaste.</b><br><span \ntranslate=\"CONFIRMATION.SPAM\">\nSi no encuentras tu boleto por favor revisa tu carpeta de “Spam” o escríbenos a soporte@busolinea.com.</span><br></p>\n<div class=\"contact_us\" translate=\"CONFIRMATION.CONTACT\">\nSu transacción fue pagada con éxito y estamos esperando la verificación de la línea de autobús. Para evitar doble cargos a su tarjeta por favor NO intente pagar su boleto nuevamente. Si usted no recibe su boleto en los próximos 30 minutos por favor comuníquese con nosotros.\n</div><ul><li translate=\"CONFIRMATION.WRITE_US\">Escribiéndonos a: soporte@busolinea.com ó</li><li \ntranslate=\"CONFIRMATION.CALL_US\">Llamandándonos a: 800 507 5500 / En México D.F. 5729 0807</li></ul><p></p></div><div \nclass=\"emails\" layout-sm=\"column\" layout-gt-sm=\"row\" layout-align=\"start none\" layout-padding flex-auto><div \nclass=\"right_border\" flex=\"100\" flex-gt-sm=\"50\"><label translate=\"CONFIRMATION.EMAIL\">Email:</label><br><img \nsrc=\"/assets/transportamex/images/confirmation/check.png\" alt=\"Check\"> {{ $root.route.reservation.email }}</div><div \nclass=\"form-horizontal\" flex=\"100\" flex-gt-sm=\"50\"><form name=\"email_form\"><label \ntranslate=\"CONFIRMATION.ADDITIONAL_EMAIL\">Email Adicional:</label><div layout=\"row\" layout-align=\"start none\"><div \nflex=\"grow\"><input type=\"email\" name=\"email\" id=\"email\" value=\"\" class=\"form-control\" ng-model=\"vm.aditionalEmail\">\n</div><div flex=\"initial\"><md-button class=\"md-button btn-default btn send\" type=\"button\" ng-click=\"vm.getMail()\" \nanalytics-on analytics-category=\"thank you\" analytics-event=\"enviar-email\" translate=\"CONFIRMATION.SEND\">ENVIAR\n</md-button></div></div></form></div></div></div><div class=\"line\"></div><div class=\"confirmation\" flex=\"initial\"><div \nclass=\"trip_details\" layout=\"column\" layout-align=\"start none\"><h3 translate=\"CONFIRMATION.TRIP_DETAILS\">\nDetalles del Viaje</h3><div class=\"reservation_number\"><div class=\"icon\"></div><p \ntranslate=\"CONFIRMATION.RESERVATION_NUMBER\">Número de Reservación</p><strong>\n{{ $root.route.reservation.outbound_route.reservation_number }}</strong></div><div class=\"divider\" \ntranslate=\"CONFIRMATION.GO\">IDA</div><div class=\"route_info\" layout=\"row\" layout-align=\"start none\"><div \nclass=\"origin\" flex=\"50\"><h4>{{ $root.route.reservation.outbound_route.departure_name }}</h4><img \nsrc=\"/assets/transportamex/images/confirmation/calendar.png\" alt=\"Calendar\"> <span>\n{{ $root.route.reservation.outbound_route.departure_date }}</span> <img \nsrc=\"/assets/transportamex/images/confirmation/time.png\" alt=\"Time\"> <span>\n{{ $root.route.reservation.outbound_route.departure_time }}</span></div><div class=\"destination\" flex=\"50\"><h4>\n{{ $root.route.reservation.outbound_route.destination_name }}</h4><img \nsrc=\"/assets/transportamex/images/confirmation/calendar.png\" alt=\"Calendar\"> <span>\n{{ $root.route.reservation.outbound_route.arrival_date }}</span> <img \nsrc=\"/assets/transportamex/images/confirmation/time.png\" alt=\"Time\"> <span>\n{{ $root.route.reservation.outbound_route.arrival_time }}</span></div></div><div class=\"line\"></div><div \nclass=\"passenger_list\" layout=\"row\" layout-align=\"start none\" layout-padding><div flex=\"auto\"><div class=\"visible-xs\" \nng-repeat=\"ticket in $root.route.reservation.outbound_tickets\"><div flex=\"33\" layout=\"row\" layout-align=\"start none\">\n<label flex=\"50\" translate=\"CONFIRMATION.PASSENGER\">Nombre del Pasajero</label><div class=\"detail\" flex=\"50\">\n{{ticket.name}}</div></div><div flex=\"33\" layout=\"row\" layout-align=\"start none\"><label flex=\"50\" \ntranslate=\"CONFIRMATION.SEAT\">Asiento</label><div flex=\"50\" class=\"detail\">{{ticket.seat}}</div></div><div flex=\"33\" \nlayout=\"row\" layout-align=\"start none\"><label flex=\"50\" translate=\"CONFIRMATION.TYPE\">Tipo</label><div flex=\"50\" \nclass=\"detail\" ng-switch on=\"ticket.type\"><span ng-switch-when=\"ad\" translate=\"CONFIRMATION.AD\">Adulto</span> <span \nng-switch-when=\"es\" translate=\"CONFIRMATION.ES\">Estudiante</span> <span ng-switch-when=\"ma\" \ntranslate=\"CONFIRMATION.MA\">Maestro</span> <span ng-switch-when=\"in\" translate=\"CONFIRMATION.IN\">INAPAM</span> <span \nng-switch-when=\"ni\" translate=\"CONFIRMATION.NI\">Niño</span></div></div></div><div class=\"hidden-xs\" layout=\"column\">\n<div layout=\"row\"><h4 flex=\"50\" translate=\"CONFIRMATION.PASSENGER\">Nombre del Pasajero</h4><h4 flex=\"15\" \ntranslate=\"CONFIRMATION.SEAT\">Asiento</h4><h4 flex=\"30\" translate=\"CONFIRMATION.TYPE\">Tipo</h4></div><div \nng-repeat=\"ticket in $root.route.reservation.outbound_tickets\" layout=\"row\"><p flex=\"50\">{{ticket.name}}</p><p \nflex=\"15\">{{ticket.seat}}</p><p flex=\"30\" ng-switch on=\"ticket.type\"><span ng-switch-when=\"ad\" \ntranslate=\"CONFIRMATION.AD\">Adulto</span> <span ng-switch-when=\"es\" translate=\"CONFIRMATION.ES\">Estudiante</span> <span\n ng-switch-when=\"ma\" translate=\"CONFIRMATION.MA\">Maestro</span> <span ng-switch-when=\"in\" translate=\"CONFIRMATION.IN\">\nINAPAM</span> <span ng-switch-when=\"ni\" translate=\"CONFIRMATION.NI\">Niño</span></p></div></div></div></div><div \nng-if=\"$root.route.reservation.return_route\"><div class=\"divider\" translate=\"CONFIRMATION.RETURN\">REGRESO</div><div \nclass=\"route_info\" layout=\"row\" layout-align=\"start none\"><div class=\"origin\" flex=\"50\"><h4>\n{{ $root.route.reservation.return_route.departure_name }}</h4><img \nsrc=\"/assets/transportamex/images/confirmation/calendar.png\" alt=\"Calendar\"> <span>\n{{ $root.route.reservation.return_route.departure_date }}</span> <img \nsrc=\"/assets/transportamex/images/confirmation/time.png\" alt=\"Time\"> <span>\n{{ $root.route.reservation.return_route.departure_time }}</span> <img class=\"visible-xs down_arrow\" \nsrc=\"/assets/transportamex/images/support/down-arrow.png\" alt=\"Down arrow\"></div><div class=\"destination\" flex=\"50\">\n<h4>{{ $root.route.reservation.return_route.destination_name }}</h4><img \nsrc=\"/assets/transportamex/images/confirmation/calendar.png\" alt=\"Calendar\"> <span>\n{{ $root.route.reservation.return_route.arrival_date }}</span> <img \nsrc=\"/assets/transportamex/images/confirmation/time.png\" alt=\"Time\"> <span>\n{{ $root.route.reservation.return_route.arrival_time }}</span></div></div><div class=\"line\"></div><div \nclass=\"passenger_list\" layout=\"row\" layout-align=\"start none\" layout-padding><div flex><div class=\"visible-xs\" \nng-repeat=\"ticket in $root.route.reservation.return_tickets\"><div flex=\"33\" layout=\"row\" layout-align=\"start none\">\n<label flex=\"50\" translate=\"CONFIRMATION.PASSENGER\">Nombre del Pasajero</label><div class=\"detail\" flex=\"50\">\n{{ticket.name}}</div></div><div flex=\"33\" layout=\"row\" layout-align=\"start none\"><label flex=\"50\" \ntranslate=\"CONFIRMATION.SEAT\">Asiento</label><div flex=\"50\" class=\"detail\">{{ticket.seat}}</div></div><div flex=\"33\" \nlayout=\"row\" layout-align=\"start none\"><label flex=\"50\" translate=\"CONFIRMATION.TYPE\">Tipo</label><div flex=\"50\" \nclass=\"detail\" ng-switch on=\"ticket.type\"><span ng-switch-when=\"ad\" translate=\"CONFIRMATION.AD\">Adulto</span> <span \nng-switch-when=\"es\" translate=\"CONFIRMATION.ES\">Estudiante</span> <span ng-switch-when=\"ma\" \ntranslate=\"CONFIRMATION.MA\">Maestro</span> <span ng-switch-when=\"in\" translate=\"CONFIRMATION.IN\">INAPAM</span> <span \nng-switch-when=\"ni\" translate=\"CONFIRMATION.NI\">Niño</span></div></div></div><div class=\"hidden-xs\" layout=\"column\">\n<div layout=\"row\"><h4 flex=\"50\" translate=\"CONFIRMATION.PASSENGER\">Nombre del Pasajero</h4><h4 flex=\"15\" \ntranslate=\"CONFIRMATION.SEAT\">Asiento</h4><h4 flex=\"30\" translate=\"CONFIRMATION.TYPE\">Tipo</h4></div><div \nng-repeat=\"ticket in $root.route.reservation.return_tickets\" layout=\"row\"><p flex=\"50\">{{ticket.name}}</p><p flex=\"15\">\n{{ticket.seat}}</p><p flex=\"30\" ng-switch on=\"ticket.type\"><span ng-switch-when=\"ad\" translate=\"CONFIRMATION.AD\">Adulto\n</span> <span ng-switch-when=\"es\" translate=\"CONFIRMATION.ES\">Estudiante</span> <span ng-switch-when=\"ma\" \ntranslate=\"CONFIRMATION.MA\">Maestro</span> <span ng-switch-when=\"in\" translate=\"CONFIRMATION.IN\">INAPAM</span> <span \nng-switch-when=\"ni\" translate=\"CONFIRMATION.NI\">Niño</span></p></div></div></div></div></div></div></div><div \nclass=\"totals\" layout=\"row\" layout-align=\"start none\"><div flex><label translate=\"CONFIRMATION.SUBTOTAL\">Subtotal\n</label><div class=\"detail\">${{ $root.route.reservation.subtotal }}</div></div><div flex><label \ntranslate=\"CONFIRMATION.TAX\">IVA</label><div class=\"detail\">${{ $root.route.reservation.iva }}</div></div><div \nclass=\"total\"><span><label translate=\"CONFIRMATION.TOTAL\">Total</label><div class=\"detail\">\n${{ $root.route.reservation.total }}</div></span></div></div></div></div></div>");
$templateCache.put("app/views/transportamex/pages/home/home.html","<div id=\"home_content\"><div id=\"main_search\" layout=\"column\" layout-align=\"center center\"><div class=\"container\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"hide-xs hide-sm welcome\" flex=\"auto\"><h2 \ntranslate=\"HOME.WELCOME.LOVE\">¿Te gusta viajar en autobús?</h2><h1 translate=\"HOME.WELCOME.BUY\">Compra con Busolinea.\n</h1><h3 translate=\"HOME.WELCOME.EASY\">Fácil. Rápido. Seguro.</h3></div><div class=\"hide-gt-sm\" flex=\"auto\"><h1 \ntranslate=\"HOME.WELCOME.ONLINE\">Boletos de autobús en línea</h1></div><home-search-box></home-search-box></div></div>\n</div>");
$templateCache.put("app/views/transportamex/pages/mobile/mobile.html","<div id=\"mobile_content\" layout=\"row\" layout-align=\"center start\"><div id=\"mobiles\"><div id=\"mobile_apps\"><div \nclass=\"container\" layout-sm=\"column\" layout-gt-sm=\"row\"><div class=\"text\" flex-sm=\"initial\" flex-gt-sm=\"50\"><h1 \ntranslate=\"MOBILE.TITLE\">Siempre disponible sin importar donde estés.</h1><h2 translate=\"MOBILE.SUBTITLE\">\nExperimenta todas nuestras funciones en iPhone, iPad y Android.</h2><p translate=\"MOBILE.P1\">\nReserva tu viaje en autobús y accede a tus boletos de manera inmediata. Guarda tus boletos y organiza tu viaje desde tu smartphone.\n</p><div class=\"buttons\" layout-sm=\"column\" layout-gt-sm=\"row\"><div flex-sm=\"initial\" flex-gt-sm=\"50\"><a \ntarget=\"_blank\" href=\"https://play.google.com/store/apps/details?id=com.busolinea.app\"><img \nng-src=\"/assets/transportamex/images/home/android-btn.png\" alt=\"Android btn\"></a></div><div flex-sm=\"initial\" \nflex-gt-sm=\"50\"><a target=\"_blank\" href=\"https://itunes.apple.com/us/app/busolinea-compare-bus-tickets/id957028884\">\n<img ng-src=\"/assets/transportamex/images/home/ios-btn.png\" alt=\"Ios btn\"></a></div></div></div><div class=\"phones\" \nflex-sm=\"initial\" flex-gt-sm=\"50\"><img style=\"max-width:100%;height:auto\" \nng-src=\"/assets/transportamex/images/home/phones_es.png\" alt=\"Phones es\"></div></div></div></div></div>");
$templateCache.put("app/views/transportamex/pages/payment/payment.html","<div id=\"payment_content\"><div class=\"payment_content container\" layout=\"column\" layout-align=\"start none\"><div \nclass=\"breadcrumb hide-xs hide-sm\" flex=\"initial\" analytics-on analytics-category=\"payment\" analytics-label=\"steps\">\n<span>{{ \'SEATS.BREADCRUMB.ITINERARY\' | translate }}</span> <span>{{ \'SEATS.BREADCRUMB.SEATS\' | translate }}</span> \n<span class=\"selected\">{{ \'SEATS.BREADCRUMB.PAYMENT\' | translate }}</span></div><div class=\"payment\" layout=\"column\" \nlayout-align=\"start none\" flex=\"initial\"><div class=\"alert alert-warning\" flex=\"initial\"><span \ntranslate=\"PAYMENT.REMINDER\">Recuerda que tienes 6 minutos para finalizar la compra.</span><div id=\"timer\"><div><timer \ncountdown=\"vm.remainReservationTime || 360\" max-time-unit=\"\'minute\'\" interval=\"1000\">{{mminutes}}:{{sseconds}}</timer>\n</div></div></div><div layout-sm=\"column\" layout-gt-sm=\"row\" layout-align=\"start none\" flex=\"initial\"><div \nlayout=\"column\" flex=\"auto\" flex-gt-sm=\"65\"><h3 translate=\"PAYMENT.PAYMENT_DATA\">Datos De Pago</h3><div \nclass=\"payment-info\" layout=\"column\" layout-align=\"start none\"><div layout-sm=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start none\" flex=\"initial\"><div flex=\"grow\"><div class=\"form-group\"><label translate=\"PAYMENT.NAME\">\nNombre</label><input class=\"form-control\" name=\"fname\" type=\"text\" value=\"\" analytics-on=\"blur\" \nanalytics-category=\"payment\" analytics-event=\"campos\" analytics-label=\"fname\"></div></div><div flex=\"grow\" \nflex-offset-gt-sm=\"5\"><div class=\"form-group\"><label translate=\"PAYMENT.LAST_NAME\">Apellidos</label><input \nclass=\"form-control\" name=\"lname\" type=\"text\" value=\"\" analytics-on=\"blur\" analytics-category=\"payment\" \nanalytics-event=\"campos\" analytics-label=\"lname\"></div></div></div><div layout-sm=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start none\" flex=\"initial\"><div flex=\"grow\"><div class=\"form-group\"><label translate=\"PAYMENT.ADDRESS\">\nDirección</label><input class=\"form-control\" maxlength=\"40\" name=\"address\" type=\"text\" value=\"\" analytics-on=\"blur\" \nanalytics-category=\"payment\" analytics-event=\"campos\" analytics-label=\"address\"></div></div><div flex=\"grow\" \nflex-offset-gt-sm=\"5\"><div class=\"form-group\"><label translate=\"PAYMENT.ZIP\">Código Postal</label><input \nclass=\"form-control\" maxlength=\"6\" name=\"cust_postal_cd\" type=\"text\" value=\"\" analytics-on=\"blur\" \nanalytics-category=\"payment\" analytics-event=\"campos\" analytics-label=\"postal_cd\"></div></div></div><div \nlayout-sm=\"column\" layout-gt-sm=\"row\" layout-align=\"start none\" flex=\"initial\"><div flex=\"grow\"><div \nclass=\"form-group\"><label translate=\"PAYMENT.COUNTRY\">País</label><select name=\"cust_cntry_cd\" id=\"cust_cntry_cd\" \nclass=\"form-control\" ng-model=\"vm.country\" ng-change=\"vm.setState()\" analytics-on analytics-category=\"payment\" \nanalytics-event=\"campos\" analytics-label=\"country\"><option value=\"MX\">México</option><option value=\"US\">Estados Unidos\n</option><option value=\"AF\">Afganistán</option><option value=\"AX\">Islas Åland</option><option value=\"AL\">Albania\n</option><option value=\"DE\">Alemania</option><option value=\"AD\">Andorra</option><option value=\"AO\">Angola</option>\n<option value=\"AI\">Anguila</option><option value=\"AQ\">Antártida</option><option value=\"AG\">Antigua y Barbuda</option>\n<option value=\"SA\">Arabia Saudita</option><option value=\"DZ\">Argelia</option><option value=\"AR\">Argentina</option>\n<option value=\"AM\">Armenia</option><option value=\"AW\">Aruba</option><option value=\"AU\">Australia</option><option \nvalue=\"AT\">Austria</option><option value=\"AZ\">Azerbaiyán</option><option value=\"BS\">Bahamas (las)</option><option \nvalue=\"BD\">Bangladés</option><option value=\"BB\">Barbados</option><option value=\"BH\">Baréin</option><option value=\"BE\">\nBélgica</option><option value=\"BZ\">Belice</option><option value=\"BJ\">Benín</option><option value=\"BM\">Bermudas</option>\n<option value=\"BY\">Bielorrusia</option><option value=\"MM\">Myanmar</option><option value=\"Es\">Bolivia</option><option \nvalue=\"BA\">Bosnia y Herzegovina</option><option value=\"BW\">Botsuana</option><option value=\"BR\">Brasil</option><option \nvalue=\"BN\">Brunéi Darussalam</option><option value=\"BG\">Bulgaria</option><option value=\"BF\">Burkina Faso</option>\n<option value=\"BI\">Burundi</option><option value=\"BT\">Bután</option><option value=\"CV\">Cabo Verde</option><option \nvalue=\"KH\">Camboya</option><option value=\"CM\">Camerún</option><option value=\"CA\">Canadá</option><option value=\"QA\">\nCatar</option><option value=\"Sa\">Bonaire</option><option value=\"TD\">Chad</option><option value=\"CL\">Chile</option>\n<option value=\"CN\">China</option><option value=\"CY\">Chipre</option><option value=\"CO\">Colombia</option><option \nvalue=\"KM\">Comoras</option><option value=\"KP\">Corea (la República Democrática Popular de)</option><option value=\"KR\">\nCorea (la República de)</option><option value=\"CR\">Costa Rica</option><option value=\"HR\">Croacia</option><option \nvalue=\"CU\">Cuba</option><option value=\"CW\">Curaçao</option><option value=\"DK\">Dinamarca</option><option value=\"DM\">\nDominica</option><option value=\"EC\">Ecuador</option><option value=\"EG\">Egipto</option><option value=\"SV\">El Salvador\n</option><option value=\"AE\">Emiratos Árabes Unidos (Los)</option><option value=\"ER\">Eritrea</option><option value=\"SK\">\nEslovaquia</option><option value=\"SI\">Eslovenia</option><option value=\"ES\">España</option><option value=\"US\">\nEstados Unidos (los)</option><option value=\"EE\">Estonia</option><option value=\"ET\">Etiopía</option><option value=\"PH\">\nFilipinas (las)</option><option value=\"FI\">Finlandia</option><option value=\"FJ\">Fiyi</option><option value=\"FR\">Francia\n</option><option value=\"GA\">Gabón</option><option value=\"GM\">Gambia (La)</option><option value=\"GE\">Georgia</option>\n<option value=\"GH\">Ghana</option><option value=\"GI\">Gibraltar</option><option value=\"GD\">Granada</option><option \nvalue=\"GR\">Grecia</option><option value=\"GL\">Groenlandia</option><option value=\"GP\">Guadalupe</option><option \nvalue=\"GU\">Guam</option><option value=\"GT\">Guatemala</option><option value=\"GF\">Guayana Francesa</option><option \nvalue=\"GG\">Guernsey</option><option value=\"GN\">Guinea</option><option value=\"GW\">Guinea-Bisáu</option><option \nvalue=\"GQ\">Guinea Ecuatorial</option><option value=\"GY\">Guyana</option><option value=\"HT\">Haití</option><option \nvalue=\"HN\">Honduras</option><option value=\"HK\">Hong Kong</option><option value=\"HU\">Hungría</option><option value=\"IN\">\nIndia</option><option value=\"ID\">Indonesia</option><option value=\"IQ\">Irak</option><option value=\"IR\">\nIrán (la República Islámica de)</option><option value=\"IE\">Irlanda</option><option value=\"BV\">Isla Bouvet</option>\n<option value=\"IM\">Isla de Man</option><option value=\"CX\">Isla de Navidad</option><option value=\"NF\">Isla Norfolk\n</option><option value=\"IS\">Islandia</option><option value=\"KY\">Islas Caimán (las)</option><option value=\"CC\">\nIslas Cocos (Keeling)</option><option value=\"CK\">Islas Cook (las)</option><option value=\"FO\">Islas Feroe (las)</option>\n<option value=\"GS\">Georgia del sur y las islas sandwich del sur</option><option value=\"HM\">Isla Heard e Islas McDonald\n</option><option value=\"FK\">Islas Malvinas [Falkland] (las)</option><option value=\"MP\">Islas Marianas del Norte (las)\n</option><option value=\"MH\">Islas Marshall (las)</option><option value=\"PN\">Pitcairn</option><option value=\"SB\">\nIslas Salomón (las)</option><option value=\"TC\">Islas Turcas y Caicos (las)</option><option value=\"UM\">\nIslas de Ultramar Menores de Estados Unidos (las)</option><option value=\"VG\">Islas Vírgenes (Británicas)</option>\n<option value=\"VI\">Islas Vírgenes (EE.UU.)</option><option value=\"IL\">Israel</option><option value=\"IT\">Italia</option>\n<option value=\"JM\">Jamaica</option><option value=\"JP\">Japón</option><option value=\"JE\">Jersey</option><option \nvalue=\"JO\">Jordania</option><option value=\"KZ\">Kazajistán</option><option value=\"KE\">Kenia</option><option value=\"KG\">\nKirguistán</option><option value=\"KI\">Kiribati</option><option value=\"KW\">Kuwait</option><option value=\"(l\">Lao\n</option><option value=\"LS\">Lesoto</option><option value=\"LV\">Letonia</option><option value=\"LB\">Líbano</option><option\n value=\"LR\">Liberia</option><option value=\"LY\">Libia</option><option value=\"LI\">Liechtenstein</option><option \nvalue=\"LT\">Lituania</option><option value=\"LU\">Luxemburgo</option><option value=\"MO\">Macao</option><option value=\"MG\">\nMadagascar</option><option value=\"MY\">Malasia</option><option value=\"MW\">Malaui</option><option value=\"MV\">Maldivas\n</option><option value=\"ML\">Malí</option><option value=\"MT\">Malta</option><option value=\"MA\">Marruecos</option><option \nvalue=\"MQ\">Martinica</option><option value=\"MU\">Mauricio</option><option value=\"MR\">Mauritania</option><option \nvalue=\"YT\">Mayotte</option><option value=\"MX\">México</option><option value=\"FM\">Micronesia (los Estados Federados de)\n</option><option value=\"MD\">Moldavia (la República de)</option><option value=\"MC\">Mónaco</option><option value=\"MN\">\nMongolia</option><option value=\"ME\">Montenegro</option><option value=\"MS\">Montserrat</option><option value=\"MZ\">\nMozambique</option><option value=\"NA\">Namibia</option><option value=\"NR\">Nauru</option><option value=\"NP\">Nepal\n</option><option value=\"NI\">Nicaragua</option><option value=\"NE\">Níger (el)</option><option value=\"NG\">Nigeria</option>\n<option value=\"NU\">Niue</option><option value=\"NO\">Noruega</option><option value=\"NC\">Nueva Caledonia</option><option \nvalue=\"NZ\">Nueva Zelanda</option><option value=\"OM\">Omán</option><option value=\"NL\">Países Bajos (los)</option><option \nvalue=\"PK\">Pakistán</option><option value=\"PW\">Palaos</option><option value=\"Es\">Palestina</option><option value=\"PA\">\nPanamá</option><option value=\"PG\">Papúa Nueva Guinea</option><option value=\"PY\">Paraguay</option><option value=\"PE\">\nPerú</option><option value=\"PF\">Polinesia Francesa</option><option value=\"PL\">Polonia</option><option value=\"PT\">\nPortugal</option><option value=\"PR\">Puerto Rico</option><option value=\"GB\">Reino Unido (el)</option><option value=\"CF\">\nRepública Centroafricana (la</option><option value=\"CZ\">República Checa (la)</option><option value=\"MK\">\nMacedonia (la antigua República Yugoslava de)</option><option value=\"CG\">Congo</option><option value=\"CD\">\nCongo (la República Democrática del)</option><option value=\"DO\">República Dominicana (la)</option><option value=\"RE\">\nReunión</option><option value=\"RW\">Ruanda</option><option value=\"RO\">Rumania</option><option value=\"RU\">Rusia</option>\n<option value=\"EH\">Sahara Occidental</option><option value=\"WS\">Samoa</option><option value=\"AS\">Samoa Americana\n</option><option value=\"BL\">San Bartolomé</option><option value=\"KN\">San Cristóbal y Nieves</option><option value=\"SM\">\nSan Marino</option><option value=\"MF\">San Martín (parte francesa)</option><option value=\"PM\">San Pedro y Miquelón\n</option><option value=\"VC\">San Vicente y las Granadinas</option><option value=\"As\">Santa Helena</option><option \nvalue=\"LC\">Santa Lucía</option><option value=\"ST\">Santo Tomé y Príncipe</option><option value=\"SN\">Senegal</option>\n<option value=\"RS\">Serbia</option><option value=\"SC\">Seychelles</option><option value=\"SL\">Sierra leona</option><option\n value=\"SG\">Singapur</option><option value=\"SX\">Sint Maarten (parte holandesa)</option><option value=\"(l\">Siria\n</option><option value=\"SO\">Somalia</option><option value=\"LK\">Sri Lanka</option><option value=\"SZ\">Suazilandia\n</option><option value=\"ZA\">Sudáfrica</option><option value=\"SD\">Sudán (el)</option><option value=\"SS\">Sudán del Sur\n</option><option value=\"SE\">Suecia</option><option value=\"CH\">Suiza</option><option value=\"SR\">Surinam</option><option \nvalue=\"SJ\">Svalbard y Jan Mayen</option><option value=\"TH\">Tailandia</option><option value=\"TW\">\nTaiwán (Provincia de China)</option><option value=\"Re\">Tanzania</option><option value=\"TJ\">Tayikistán</option><option \nvalue=\"IO\">Territorio Británico del Océano Índico (el)</option><option value=\"TF\">Territorios Australes Franceses (los)\n</option><option value=\"TL\">Timor-Leste</option><option value=\"TG\">Togo</option><option value=\"TK\">Tokelau</option>\n<option value=\"TO\">Tonga</option><option value=\"TT\">Trinidad y Tobago</option><option value=\"TN\">Túnez</option><option \nvalue=\"TM\">Turkmenistán</option><option value=\"TR\">Turquía</option><option value=\"TV\">Tuvalu</option><option \nvalue=\"UA\">Ucrania</option><option value=\"UG\">Uganda</option><option value=\"UY\">Uruguay</option><option value=\"UZ\">\nUzbekistán</option><option value=\"VU\">Vanuatu</option><option value=\"Re\">Venezuela</option><option value=\"VN\">Viet Nam\n</option><option value=\"WF\">Wallis y Futuna</option><option value=\"YE\">Yemen</option><option value=\"DJ\">Yibuti</option>\n<option value=\"ZM\">Zambia</option><option value=\"ZW\">Zimbabue</option></select></div></div><div flex=\"grow\" \nflex-offset-gt-sm=\"5\"><div class=\"form-group\"><label translate=\"PAYMENT.STATE\">Estado</label><select \nname=\"cust_stpr_cd\" id=\"cust_stpr_cd\" class=\"form-control\" ng-model=\"vm.city\" analytics-on \nanalytics-category=\"payment\" analytics-event=\"campos\" analytics-label=\"state\"><option value=\"AS\">Aguascalientes\n</option><option value=\"BC\">Baja California</option><option value=\"BS\">Baja California Sur</option><option value=\"CC\">\nCampeche</option><option value=\"CS\">Chiapas</option><option value=\"CH\">Chihuahua</option><option value=\"DF\">\nCiudad de México</option><option value=\"CL\">Coahuila</option><option value=\"CM\">Colima</option><option value=\"DG\">\nDurango</option><option value=\"GT\">Guanajuato</option><option value=\"GR\">Guerrero</option><option value=\"HG\">Hidalgo\n</option><option value=\"JC\">Jalisco</option><option value=\"MC\">México</option><option value=\"MN\">Michoacán</option>\n<option value=\"MS\">Morelos</option><option value=\"NT\">Nayarit</option><option value=\"NL\">Nuevo León</option><option \nvalue=\"OC\">Oaxaca</option><option value=\"PL\">Puebla</option><option value=\"QT\">Querétaro</option><option value=\"QR\">\nQuintana Roo</option><option value=\"SP\">San Luis Potosí</option><option value=\"SL\">Sinaloa</option><option value=\"SR\">\nSonora</option><option value=\"TC\">Tabasco</option><option value=\"TS\">Tamaulipas</option><option value=\"TL\">Tlaxcala\n</option><option value=\"VZ\">Veracruz</option><option value=\"YN\">Yucatán</option><option value=\"ZS\">Zacatecas</option>\n<option value=\"NA\">OTHER</option></select></div></div></div><div layout=\"row\" layout-align=\"start none\" flex=\"initial\">\n<div flex><div class=\"form-group\"><label translate=\"PAYMENT.CITY\">Ciudad</label><input class=\"form-control\" \nname=\"cust_city\" type=\"text\" value=\"\" analytics-on=\"blur\" analytics-category=\"payment\" analytics-event=\"campos\" \nanalytics-label=\"city\"></div></div></div><div layout-sm=\"column\" layout-gt-sm=\"row\" layout-align=\"start none\" \nflex=\"initial\"><div flex=\"grow\"><div class=\"form-group\"><label translate=\"PAYMENT.EMAIL\">Email</label><input \nclass=\"form-control\" name=\"email\" type=\"text\" value=\"\" analytics-on=\"blur\" analytics-category=\"payment\" \nanalytics-event=\"campos\" analytics-label=\"email\"></div></div><div flex=\"grow\" flex-offset-gt-sm=\"5\"><div \nclass=\"form-group\"><label translate=\"PAYMENT.PHONE\">Teléfono</label><input class=\"form-control\" name=\"phone\" \ntype=\"text\" value=\"\" analytics-on=\"blur\" analytics-category=\"payment\" analytics-event=\"campos\" analytics-label=\"phone\">\n</div></div></div></div><div class=\"select_card\" layout=\"column\" layout-align=\"start none\" flex=\"initial\"><div \nclass=\"card_options\" layout=\"column\" layout-align=\"start none\" flex=\"initial\"><div class=\"amount\"><span \ntranslate=\"PAYMENT.QUANTITY\">Cantidad por Pagar</span> <span class=\"number\">$<i class=\"total_amount\">\n{{ $root.route.coupon.total ? ($root.route.coupon.total | formatPrice:2:\',\':\'.\':false ) : ($root.route.total_amount | formatPrice:2:\',\':\'.\':false ) }}\n</i></span> MEX</div><div class=\"new_card\" layout=\"column\" layout-align=\"start none\" flex=\"initial\"><h4 \ntranslate=\"PAYMENT.CARD\">Selecciona Tarjeta</h4><div class=\"card_type\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start none\" layout-align-gt-xs=\"start end\" flex=\"initial\" analytics-on analytics-category=\"payment\" \nanalytics-event=\"campos\" analytics-label=\"card_type\"><div class=\"check\" flex=\"auto\"><input \nclass=\"css-checkbox lrg with-gap\" id=\"visa_check\" name=\"card_type\" type=\"radio\" value=\"visa\" checked=\"checked\"><label \nclass=\"css-label lrg web-two-style\" for=\"visa_check\" name=\"checkbox67_lbl\">Visa</label></div><div class=\"check\" \nflex=\"auto\"><input class=\"css-checkbox lrg with-gap\" id=\"master_check\" name=\"card_type\" type=\"radio\" \nvalue=\"mastercard\"><label class=\"css-label lrg web-two-style\" for=\"master_check\" name=\"checkbox67_lbl\">Mastercard\n</label></div><div class=\"check\" flex=\"auto\"><input class=\"css-checkbox lrg with-gap\" id=\"amex_check\" name=\"card_type\" \ntype=\"radio\" value=\"amex\"><label class=\"css-label lrg web-two-style\" for=\"amex_check\" name=\"checkbox67_lbl\">AMEX\n</label></div></div><div class=\"form-group\" flex=\"initial\"><label translate=\"PAYMENT.NUMBER\">Núm. Tarjeta</label><input\n class=\"form-control\" maxlength=\"16\" name=\"card_num\" type=\"text\" analytics-on=\"blur\" analytics-category=\"payment\" \nanalytics-event=\"campos\" analytics-label=\"card_num\"></div><div class=\"form-group\" flex=\"initial\"><label \ntranslate=\"PAYMENT.EXP\">Expiración</label><div layout-sm=\"column\" layout-gt-sm=\"row\" layout-align=\"start none\"><div \nflex=\"grow\"><input class=\"form-control\" maxlength=\"2\" name=\"card_exp_month\" placeholder=\"Ej: mm\" type=\"text\" \nanalytics-on=\"blur\" analytics-category=\"payment\" analytics-label=\"card_month\"></div><div flex=\"grow\" \nflex-offset-gt-sm=\"5\"><input class=\"form-control\" maxlength=\"2\" name=\"card_exp_year\" placeholder=\"Ej: aa\" type=\"text\" \nanalytics-on=\"blur\" analytics-category=\"payment\" analytics-event=\"campos\" analytics-label=\"card_year\"></div></div>\n</div><div class=\"form-group\" flex=\"initial\"><label>CVV</label><div layout-sm=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start none\"><div flex=\"grow\"><input class=\"form-control\" maxlength=\"4\" name=\"card_cvv\" type=\"text\" \nanalytics-on=\"blur\" analytics-category=\"payment\" analytics-event=\"campos\" analytics-label=\"card_cvv\"></div><div \nflex=\"grow\" flex-offset-gt-sm=\"5\" layout=\"row\" layout-align=\"start center\"><img \nsrc=\"/assets/transportamex/images/support/cvv.png\" alt=\"Cvv\" flex=\"initial\"><div flex=\"initial\" flex-offset=\"5\" \ntranslate=\"PAYMENT.DIGITS\">3 dígitos detrás de la tarjeta</div></div></div></div><div class=\"form-group cvv\" \nflex=\"initial\"><div class=\"check\"><input type=\"checkbox\" id=\"terms_check2\" class=\"filled-in\" name=\"terms_check2\" \nanalytics-on analytics-category=\"payment\" analytics-event=\"campos\" analytics-label=\"terminos\"><label class=\"pull-left\" \nfor=\"terms_check2\"></label><div class=\"pull-left\">Acepto <a target=\"_blank\" href=\"/terminos-y-condiciones\" \ntranslate=\"PAYMENT.TERMS\">Términos y condiciones</a> y <a target=\"_blank\" href=\"/privacidad\" \ntranslate=\"PAYMENT.PRIVACY\">Aviso de privacidad</a></div></div></div><div class=\"form-group\" flex=\"initial\"><img \nclass=\"card_logos\" src=\"/assets/transportamex/images/support/credit_card_logos.png\" alt=\"Credit card logos\" \nflex=\"initial\"></div></div></div></div></div><div layout=\"column\" flex=\"auto\" flex-gt-sm=\"30\" flex-offset-gt-sm=\"5\" \nlayout-align=\"start none\"><div class=\"itinerary review\"><h3 translate=\"PAYMENT.ITINERARY\">ITINERARIO</h3><div \nclass=\"leaving_returning_toggle\" ng-if=\"$root.returnTravel\"><div \nclass=\"returning {{$root.returnTicket == false ? \'selected\' : \'\'}}\" ng-click=\"vm.toggleTicket()\"><span \ntranslate=\"PAYMENT.GO\">IDA</span></div><div class=\"leaving {{$root.returnTicket ? \'selected\' : \'\'}}\" \nng-click=\"vm.toggleTicket()\"><span translate=\"PAYMENT.RETURN\">VUELTA</span></div></div><div class=\"leaving_details\" \nng-if=\"$root.returnTicket == false\"><div><label>{{$root.route.outbound_route.origin_name}}</label>\n, {{$root.route.outbound_route.departure_time_ampm}} • <span class=\"text-capitalize\">\n{{$root.route.outbound_route.departure_date | date:\'dd MMM\'}}</span></div><img \nsrc=\"/assets/transportamex/images/support/down-arrow.png\" class=\"margin-bottom-10\" alt=\"Down arrow\"><div><label>\n{{$root.route.outbound_route.destination_name}}</label>, {{$root.route.outbound_route.arrival_time_ampm}} • <span \nclass=\"text-capitalize\">{{$root.route.outbound_route.arrival_date | date:\'dd MMM\'}}</span></div><div class=\"company\">\n<img ng-src=\"{{ $root.route.outbound_route.company.logo_url }}\"></div><div class=\"details\"><div><label \ntranslate=\"PAYMENT.SEATS\">ASIENTO(S)</label><span \nng-repeat=\"seat in $root.route.prereservation.outbound_route.seat_reservations\">\n{{seat.print_number}}{{{true: \'\', false: \', \'}[$last]}}</span></div></div></div><div class=\"returning_details\" \nng-if=\"$root.returnTicket\"><div><label>{{$root.route.return_route.origin_name}}</label>\n, {{$root.route.return_route.departure_time_ampm}} • <span class=\"text-capitalize\">\n{{$root.route.return_route.departure_date | date:\'dd MMM\'}}</span></div><img \nsrc=\"/assets/transportamex/images/support/down-arrow.png\" class=\"margin-bottom-10\" alt=\"Down arrow\"><div><label>\n{{$root.route.return_route.destination_name}}</label>, {{$root.route.return_route.arrival_time_ampm}} • <span \nclass=\"text-capitalize\">{{$root.route.return_route.arrival_date | date:\'dd MMM\'}}</span></div><div class=\"company\"><img\n ng-src=\"{{ $root.route.return_route.company.logo_url }}\"></div><div class=\"details\"><div><label \ntranslate=\"PAYMENT.SEATS\">ASIENTO(S)</label><span \nng-repeat=\"seat in $root.route.prereservation.return_route.seat_reservations\">\n{{seat.print_number}}{{{true: \'\', false: \', \'}[$last]}}</span></div></div></div></div><div \nclass=\"payment_details review\"><div><h3><span translate=\"PAYMENT.DETAILS\">Detalles del Pago<span> <img \nsrc=\"/assets/transportamex/images/icons/select.png\" alt=\"Select\"></span></span></h3><div \nclass=\"payment_details_wrapper\"><div class=\"passenger_total\"><span ng-if=\"$root.returnTicket == false\">\n{{ $root.route.prereservation.outbound_route.seat_reservations.length }}</span><span ng-if=\"$root.returnTicket\">\n{{ $root.route.prereservation.return_route.seat_reservations.length }}</span> <span translate=\"PAYMENT.PASSENGER\">\nPasajero(s)</span></div><div class=\"details\"><div><label translate=\"PAYMENT.SUBTOTAL\">Subtotal</label><span>\n${{ vm.subtotal | formatPrice:2:\',\':\'.\':false }} MXN</span></div><div><label translate=\"PAYMENT.TAX\">IVA</label><span>\n${{ vm.iva | formatPrice:2:\',\':\'.\':false }} MXN</span></div><div layout=\"column\" layout-align=\"start none\" \nclass=\"margin-top-20\"><label flex=\"initial\" translate=\"PAYMENT.CODE\">Código de Descuento</label><div layout=\"row\" \nlayout-align=\"start none\" flex=\"initial\" ng-if=\"vm.couponApplied == false\"><input class=\"form-control\" id=\"coupon\" \nmaxlength=\"14\" name=\"coupon\" type=\"text\" flex=\"grow\" ng-model=\"vm.coupon\" ng-change=\"vm.validateCoupon()\"></div><div \nng-if=\"vm.couponApplied\"><span>{{vm.coupon}}</span> <a class=\"removecoupon\" href=\"#\" ng-click=\"vm.removeCoupon()\" \ntranslate=\"PAYMENT.DELETE\">remover</a></div></div></div><div class=\"total\"><div><label translate=\"PAYMENT.TOTAL\">Total\n</label><span>$<i class=\"total_amount\">\n{{ $root.route.coupon.total ? ($root.route.coupon.total | formatPrice:2:\',\':\'.\':false ) : ($root.route.total_amount | formatPrice:2:\',\':\'.\':false ) }}\n</i> MXN</span></div></div></div></div></div><p translate=\"PAYMENT.WAIT\">\nPor favor no cierres el navegador hasta que la reservación haya sido confirmada. Tomará algunos segundos.</p><div \nclass=\"buttons\"><md-button class=\"md-button btn-default btn margin-0\" id=\"complete_payment\" type=\"button\" \nng-click=\"vm.validatePaymentData()\" analytics-on analytics-category=\"payment\" analytics-event=\"confirmar\" \ntranslate=\"PAYMENT.FINISH\">Terminar Compra</md-button></div></div></div></div></div></div>");
$templateCache.put("app/views/transportamex/pages/privacy/privacy.html","<div id=\"privacy_content\" layout=\"row\" layout-align=\"center start\"><div layout=\"column\" layout-align=\"start-none\" \nflex=\"50\"><h2>\nAVISO DE PRIVACIDAD relacionado con los datos personales, recabados por EB DIGITAL MEDIA, S.A. DE C.V. y sus filiales o subsidiarias (en adelante denominada como “BUSOLINEA”).\n</h2><h2>1.- Generales</h2><p><strong class=\"bold\">1.1.- <strong>BUSOLINEA</strong> </strong>\nES UNA SOCIEDAD COMPROMETIDA Y RESPETUOSA DE LOS DERECHOS SOBRE LOS DATOS PERSONALES DE LAS PERSONAS FÍSICAS, RECONOCIDOS EN EL ARTÍCULO 16 FRACCIÓN II DE LA CONSTITUCIÓN POLÍTICA DE LOS ESTADOS UNIDOS MEXICANOS, ASÍ COMO DE LAS DISPOSICIONES DE LA LEY FEDERAL DE PROTECCIÓN DE DATOS PERSONALES EN POSESIÓN DE LOS PARTICULARES, SU REGLAMENTO Y LA DEMÁS NORMATIVA APLICABLE. POR LO ANTERIOR, PONE A SU DISPOSICIÓN EL PRESENTE AVISO DE PRIVACIDAD, EN ARAS DE QUE EL TITULAR DE LOS DATOS PERSONALES, SE ENCUENTRE FACULTADO A EJERCITAR SU DERECHO A LA AUTODETERMINACIÓN INFORMATIVA.\n</p><p><strong>1.2.-</strong> AL INGRESAR Y UTILIZAR LA PÁGINA DE INTERNET, CUYO NOMBRE DE DOMINIO ES <a \nhref=\"www.busolinea.com.mx\" target=\"_blank\">www.busolinea.com.mx</a>\n, EN LA SECCIÓN CORRESPONDIENTE A “AVISO DE PRIVACIDAD”, EN ADELANTE DENOMINADA COMO “LA PÁGINA DE INTERNET”, PROPIEDAD DE \n<strong>BUSOLINEA</strong>\n , USTED (EL TITULAR) DECLARA QUE ESTÁ ENTENDIENDO Y ACEPTANDO LOS TÉRMINOS Y LAS CONDICIONES CONTENIDOS EN ESTE AVISO Y DECLARA Y OTORGA EXPRESAMENTE SU ACEPTACIÓN Y CONSENTIMIENTO UTILIZANDO PARA TAL EFECTO MEDIOS ELECTRÓNICOS, EN TÉRMINOS DE LO DISPUESTO POR EL ARTÍCULO 1803 DEL CÓDIGO CIVIL FEDERAL.\n</p><p><strong>1.3.-</strong>\n SI EL TITULAR NO ACEPTA EN FORMA ABSOLUTA Y COMPLETA LOS TÉRMINOS Y CONDICIONES DE ESTE AVISO, DEBERÁ ABSTENERSE DE COMPARTIR CUALQUIER TIPO DE INFORMACIÓN A \n<strong>BUSOLINEA</strong> POR CUALQUIER MEDIO INCLUYENDO SU PÁGINA DE INTERNET.</p><p><strong>1.4.-</strong>\n PARA EL CASO QUE EL TITULAR CONTINÚE EN EL USO DE LA PÁGINA DE INTERNET DE <strong><strong>BUSOLINEA</strong> \n</strong>\n, SEA EN FORMA TOTAL O PARCIAL, DICHA ACCIÓN SE CONSIDERARÁ COMO SU ABSOLUTA Y EXPRESA ACEPTACIÓN A LOS TÉRMINOS Y CONDICIONES AQUÍ ESTIPULADOS.\n</p><p><strong>1.5.-</strong> LA SOLA UTILIZACIÓN DE LA PÁGINA DE INTERNET DE <strong>BUSOLINEA</strong>\n LE OTORGA AL PÚBLICO TITULAR LA CALIDAD DE TITULAR (EN ADELANTE REFERIDO COMO EL \"TITULAR\" O LOS \"TITULARES\") E IMPLICA LA ACEPTACIÓN, PLENA E INCONDICIONAL, DE TODAS Y CADA UNA DE LAS CONDICIONES GENERALES Y PARTICULARES INCLUIDAS EN ESTE AVISO DE PRIVACIDAD EN LA VERSIÓN PUBLICADA POR \n<strong>BUSOLINEA</strong> , EN EL MOMENTO MISMO EN QUE EL TITULAR ACCEDA A LA MENCIONADA PÁGINA.</p><p>\nLAS PARTES DECLARAN QUE, AL NO EXISTIR, ERROR, DOLO, MALA FE O CUALQUIER OTRO VICIO DE LA VOLUNTAD QUE PUDIERA NULIFICAR LA VALIDEZ DEL PRESENTE INSTRUMENTO, AMBAS ACUERDAN EN SUJETARSE AL TENOR DE LO ESTIPULADO EN LOS SIGUIENTES:\n</p><h2>2.- Definiciones</h2><p><strong>2.1.- Titular.-</strong>\n La persona física (TITULAR) a quien identifican o corresponden los datos personales.</p><p><strong>2.2.- Responsable.-\n</strong> Persona física o moral (<strong>BUSOLINEA</strong>\n ) de carácter privado que decide sobre el tratamiento de los datos personales.</p><p><strong>2.3.- Encargado.-\n</strong>\n La persona física o moral que sola o conjuntamente con otras trate datos personales por cuenta del responsable.</p><p>\n<strong>2.4.- Tratamiento.-</strong>\n La obtención, uso (que incluye el acceso, manejo, aprovechamiento, transferencia o disposición de datos personales), divulgación o almacenamiento de datos personales por cualquier medio.\n</p><p class=\"col-md-offset-1\"><strong>2.4.1.- Transferencia.-</strong>\n Toda comunicación de datos realizada a persona distinta del responsable o encargado del tratamiento.</p><p \nclass=\"col-md-offset-1\"><strong>2.4.2.- Remisión.-</strong>\n La comunicación de datos personales entre el responsable y el encargado, dentro o fuera del territorio mexicano.</p>\n<p><strong>2.5.- Tercero.-</strong>\n La persona física o moral, nacional o extranjera, distinta del titular o del responsable de los datos.</p><p><strong>\n2.6.- Derechos ARCO.-</strong> Derechos de Acceso, Rectificación, Cancelación y Oposición.</p><p><strong>\n2.7.- Consentimiento Tácito.-</strong>\n Se entenderá que EL TITULAR ha consentido en el tratamiento de los datos, cuando habiéndose puesto a su disposición el Aviso de Privacidad, no manifieste su oposición.\n</p><p><strong>2.8.- Finalidades Primarias.-</strong>\n Aquellas finalidades para las cuales se solicitan principalmente los datos personales y por lo que se da origen a la relación entre \n<strong>BUSOLINEA</strong> y EL TITULAR.</p><p><strong>2.9.- Finalidades Secundarias.-</strong>\n Aquellas finalidades que no son imprescindibles para la relación entre <strong>BUSOLINEA</strong>\n y EL TITULAR, pero que con su tratamiento contribuye al cumplimiento del objeto social de <strong>BUSOLINEA</strong> .\n</p><h2>3.- Identidad y domicilio del responsable que recaba los datos personales</h2><p><strong>3.1.-</strong>\n El responsable de la obtención de los datos personales de los TITULARES es <strong>\nEB DIGITAL MEDIA, S.A. DE C.V. (en adelante denominada como BUSOLINEA )</strong>\n, quien se compromete a respetar lo establecido en el presente Aviso de Privacidad (en lo sucesivo el “Aviso”), mismo que está puesto a su disposición en cumplimiento a lo establecido en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (en lo sucesivo la “Ley” o “LFPDPPP” indistintamente) y es aplicable respecto a los datos personales de las personas físicas tales como candidatos, empleados, clientes y/o prospectos de clientes, proveedores y/o prospectos de proveedores, distribuidores así como de los usuarios de la PÁGINA DE INTERNET DE \n<strong>BUSOLINEA</strong> , que <strong>BUSOLINEA</strong>\n obtiene con motivo de las actividades de reservación y venta de boletos de autobuses que realiza.</p><p><strong>3.2.-\n</strong> El domicilio que para los efectos del presente aviso establece <strong>BUSOLINEA</strong>\n es el ubicado en calle Poniente No. 140 - 859, colonia Industrial Vallejo, delegación Azcapotzalco, c.p. 02300, Ciudad de México, México.\n</p><h2>4.- Datos personales que se recaban</h2><p><strong>4.1.-</strong> El TITULAR reconoce y acepta que <strong>\nBUSOLINEA</strong>\n podrá directamente y/o a través de encargados, los siguientes datos personales, atendiendo a la relación con cada TITULAR:\n</p><p class=\"col-md-offset-1 highlight\">\n4.1.1.- Candidatos: Generales: nombre completo, fecha y lugar de nacimiento, edad, sexo, nacionalidad, estado civil, profesión, identificación oficial con fotografía, imagen o fotografía, domicilio (calle, número exterior e interior, colonia, código postal, delegación o municipio), teléfono local y/o móvil, correo electrónico, número de seguridad social, RFC, CURP. Académicos: nivel de estudios, escuela, período de estudios. Datos familiares: nombres, edad, escolaridad, teléfono y profesión de padres, hermanos, hijos y cónyuge. Datos económicos: datos de cuentas bancarias (número de cuenta, CLABE, banco), nivel de ingresos y gastos actuales. Experiencia profesional: nombre de la empresa, tiempo que prestó sus servicios, dirección, teléfono, puesto desempeñado, motivo de separación, nombre de su jefe directo. Referencias personales y laborales: nombre, domicilio, teléfono, profesión. Documentación en copia: curriculum vitae, identificación oficial con fotografía, número de seguro social, acta de nacimiento, comprobante de domicilio y carátula bancaria.\n</p><p class=\"col-md-offset-1 highlight\">\n4.1.2.- Trabajadores: Generales: nombre completo, fecha y lugar de nacimiento, edad, sexo, nacionalidad, estado civil, profesión, identificación oficial con fotografía, imagen o fotografía, huella digital, firma, firma electrónica avanzada, domicilio (calle, número exterior e interior, colonia, código postal, delegación o municipio), teléfono local y/o móvil, correo electrónico, número de seguridad social, RFC, CURP. Académicos: nivel de estudios, escuela, período de estudios. Datos familiares: nombres, edad, escolaridad, teléfono y profesión de padres, hermanos, hijos y cónyuge, datos de contacto en caso de emergencia. Datos económicos: datos de cuentas bancarias (número de cuenta, CLABE, banco), nivel de ingresos y gastos actuales. Experiencia profesional: nombre de la empresa, tiempo que prestó sus servicios, dirección, teléfono, puesto desempeñado, motivo de separación, nombre de su jefe directo. Referencias personales y laborales: nombre, domicilio, teléfono, profesión. Documentación en copia: curriculum vitae, identificación oficial con fotografía, cédula de RFC, CURP, número de seguro social, acta de nacimiento, comprobante de domicilio, comprobante de estudios o cédula profesional, carátula bancaria.\n</p><p class=\"col-md-offset-1 highlight\">\n4.1.3.- Clientes y/o Prospectos de clientes: Nombre completo, nacionalidad, fecha y lugar de nacimiento, edad, sexo, domicilio (calle, número, colonia, ciudad, estado, delegación o municipio, código postal), teléfono fijo y/o móvil, correo electrónico, datos de tarjeta de crédito y/o débito, datos de cuenta bancaria (número de cuenta, CLABE, banco), datos y domicilio de facturación. Documentación en copia: identificación oficial con fotografía, credencial de profesor, credencial escolar, carátula bancaria, copia de tarjeta de crédito y/o débito.\n</p><p class=\"col-md-offset-1 highlight\">\n4.1.4.- Proveedores, Prospectos de proveedores y Prestadores de servicios: Nombre completo, fecha y lugar de nacimiento, edad, nacionalidad, profesión, identificación oficial con fotografía, teléfono local y/o móvil, correo electrónico, CURP, RFC, datos bancarios (nombre del banco, cuenta, CLABE, SWIFT, ABBA, en caso de transferencias internacionales), datos fiscales, estados de cuenta bancarios, nombre del representante legal de la empresa, acta constitutiva de la empresa, poder legal del representante legal inscrito en el Registro Público de la Propiedad y Comercio, datos de contacto y puestos en la empresa, datos y domicilio de facturación (código postal, estado, país, ciudad o municipio, colonia, localidad, calle, número exterior e interior), factura electrónica. Documentación en copia: identificación oficial con fotografía, cédula de identificación fiscal, cédula de RFC, CURP, comprobante de domicilio, carátula bancaria, acta constitutiva de la empresa, poder legal del representante legal inscrito en el Registro Público de la Propiedad y Comercio.\n</p><p class=\"col-md-offset-1 highlight\">\n4.1.5.- Distribuidores: Nombre completo, fecha y lugar de nacimiento, edad, sexo, nacionalidad, identificación oficial con fotografía, domicilio (código postal, estado, país, ciudad o municipio, colonia, localidad, calle, número exterior e interior), teléfono fijo o móvil, correo electrónico, RFC, CURP, datos bancarios (nombre del banco, cuenta, CLABE, SWIFT, ABBA, en caso de transferencias internacionales), datos fiscales, estados de cuenta bancarios. Documentación en copia: Identificación oficial con fotografía, cédula de identificación fiscal, cédula de RFC, CURP, comprobante de domicilio, carátula bancaria.\n</p><p class=\"col-md-offset-1 highlight\">4.1.6.- USUARIO DE LA PÁGINA DE INTERNET DE <strong>BUSOLINEA</strong>\n : Nombre completo, fecha y lugar de nacimiento, edad, sexo, nacionalidad, profesión, identificación oficial con fotografía, imagen o fotografía, domicilio (código postal, estado, país, ciudad o municipio, colonia, localidad, calle, número exterior e interior), correo electrónico, teléfono fijo o móvil, nombre de usuario de redes sociales, datos de tarjeta de crédito y/o débito, datos bancarios (nombre del banco, cuenta, CLABE, SWIFT, ABBA, en caso de transferencias internacionales). Documentación en copia: Identificación oficial con fotografía, comprobante de domicilio, carátula bancaria, copia de tarjeta de crédito y/o débito.\n</p><p><strong>4.2.-</strong>\n EL TITULAR en este acto, otorga su consentimiento expreso en términos del artículo 8 de la LFPDPPP, para que <strong>\nBUSOLINEA</strong>\n , trate sus datos personales, incluidos los denominados datos personales financieros y/o patrimoniales contenidos en ésta cláusula, para cumplir con las finalidades que establece el presente Aviso de Privacidad.\n</p><p><strong>4.3.-</strong> <strong>BUSOLINEA</strong>\n manifiesta que no dará tratamiento a datos personales sensibles de EL TITULAR de ningún tipo.</p><p><strong>4.4.-\n</strong> El TITULAR en este acto, bajo protesta de decir verdad, acepta que los datos que ha proporcionado a <strong>\nBUSOLINEA</strong> , son veraces, actuales y correctos. Además, se compromete a sacar en paz y a salvo a <strong>\nBUSOLINEA</strong> de cualquier demanda o reclamación, derivada de los errores en los datos que le haya entregado.</p>\n<p><strong>4.5.-</strong> <strong>BUSOLINEA</strong>\n manifiesta que podrá obtener los datos personales de EL TITULAR mediante las denominadas fuentes de acceso público, a efecto de validar y actualizar los datos de EL TITULAR, respetando en todo momento la expectativa razonable de privacidad, a que se refiere el artículo 7 de la LFPDPPP.\n</p><p><strong>4.6.-</strong> <strong>BUSOLINEA</strong>\n manifiesta que el Encargado única y exclusivamente accederá y tratará los datos personales del TITULAR, a efecto de llevar a cabo la contratación y administración del personal, así como los procesos de nóminas, debiendo realizar el tratamiento de los datos personales de conformidad con las instrucciones que \n<strong>BUSOLINEA</strong>\n le comunique por escrito, exclusivamente para el cumplimiento de las finalidades del presente Aviso.</p><p><strong>\n4.7.-</strong> <strong>BUSOLINEA</strong>\n usará información IP (Protocolo de Internet, por sus siglas en inglés Internet Protocol) para analizar cualquier tipo de amenazas a LA PÁGINA DE INTERNET DE \n<strong>BUSOLINEA</strong>\n , para recabar información demográfica así como para el procesamiento del módulo anti-fraude de <strong>BUSOLINEA\n</strong>\n y el uso de herramientas anti-fraude de terceros, para analizar y verificar la información. Sin embargo, la información IP, en ningún caso será utilizada para identificar a los TITULARES, excepto cuando haya probabilidades de actividad fraudulenta.\n</p><h2>5.- Finalidades del tratamiento de los datos personales</h2><p><strong>5.1.-</strong> <strong>BUSOLINEA\n</strong>\n acepta y reconoce que podrá tratar los datos personales de EL TITULAR, directamente y/o a través de encargados, de conformidad al tipo de relación que tiene con EL TITULAR, para las siguientes \n<strong>finalidades primarias:</strong></p><p><strong>5.1.1.-</strong> EL TITULAR –Candidato:</p>\na) Ponerse en contacto con EL TITULAR- Candidato, vía correo electrónico, teléfono fijo o móvil, o por cualquier otro medio que exista o pueda llegar a existir, a efecto de dar seguimiento y evaluar la experiencia y, estudios de EL TITULAR- Candidato, para conocer la viabilidad de ser seleccionado y las posibilidades de éxito del mismo en el puesto que pretende desempeñar.\n<br><br>\nb) Conocer la experiencia laboral del candidato así como sus competencias para el puesto que está intentando cubrir.\n<br><br>\nc) Realizar un expediente en formato físico y electrónico de EL TITULAR-Candidato que será resguardado en el domicilio de \n<strong>BUSOLINEA</strong> , hasta por 1-un año, en caso de no ser seleccionado para el puesto que pretende desempeñar.\n<br><br>\nd) Para realizar los trámites de selección y administración de personal en las instituciones gubernamentales que se requiera.\n<br><br>e) Para contactar a las personas que el candidato haya indicado como referencias personales y/o laborales.<br>\n<br><p><strong>5.1.2.-</strong> EL TITULAR –Trabajador:</p>\na) Realizar un expediente físico y electrónico del TITULAR-Trabajador que será conservado en el domicilio de <strong>\nBUSOLINEA</strong> .<br><br>\nb) Realizar los trámites necesarios de alta, baja o modificaciones al registro de EL TITULAR-Trabajador ante el Instituto Mexicano del Seguro Social y/o las instituciones gubernamentales que se requiera.\n<br><br>\nc) Realizar los trámites necesarios para obtener la tarjeta de débito, para el depósito del salario y/o comisiones y demás prestaciones generadas a favor de EL TITULAR-Trabajador.\n<br><br>\nd)  Llevar a cabo el control de asistencias y horarios de entrada y salida del TITULAR-Trabajador al lugar de trabajo de \n<strong>BUSOLINEA</strong> .<br><br>\ne) Elaboración de cartas o contratos de asignación de herramientas de trabajo que requiera el TITULAR-Trabajador para la ejecución de sus actividades laborales.\n<br><br>\nf) Llevar a cabo el proceso de pago de salario y de prestaciones de EL TITULAR-Trabajador, así como descuentos de pensiones alimenticias requeridas por mandato judicial.\n<br><br>g) Gestionar con aerolíneas y hoteles los viajes de negocios que requiera hacer el TITULAR- Trabajador.<br><br>\nh) Expedir las constancias laborales que le requiera el TITULAR-Trabajador.<br><br>\ni) Emitir constancias de participación en cursos, capacitaciones, seminarios o talleres que organice <strong>BUSOLINEA\n</strong> .<br><br><p><strong>5.1.3.-</strong> EL TITULAR–Cliente y/o Prospecto de Cliente:</p>\na) Contactarlo vía telefónica, por correo electrónico, por redes sociales o por cualquier otro medio, para atender y dar seguimiento a las solicitudes de productos y/o servicios.\n<br><br>b) Para brindar al TITULAR-Cliente los productos y/o servicios que <strong>BUSOLINEA</strong>\n comercializa, conforme a las solicitudes formuladas a través de cualquier medio, para que el TITULAR-Cliente pueda beneficiarse de los servicios y/o productos ofrecidos.\n<br><br>\nc) Contactar al TITULAR-Cliente por cualquier medio, a fin de realizar aclaraciones y seguimiento sobre pagos o cualquier otra situación derivada de los productos y/o servicios proporcionados por \n<strong>BUSOLINEA</strong> , tales como quejas o comentarios sobre los mismos.<br><br>\nd) Registrarlos y actualizar los datos en el sistema de administración empresarial interno, para el acceso a los datos personales por las personas autorizadas para ello.\n<br><br>e) Realizar contacto con el TITULAR-Cliente para llevar a cabo la gestión y cobranza de adeudos.<br><br>\nf) Realizar y almacenar un expediente físico del TITULAR-Cliente durante el tiempo que dure la relación comercial y por hasta 10-diez años posteriores a la terminación de la relación comercial.\n<br><br>\ng) Elaboración de facturación electrónica y notas de crédito derivadas de los productos o servicios que comercializa \n<strong>BUSOLINEA</strong>\n . Dichas facturas, tanto en formato físico como electrónico y las notas de crédito, serán conservadas por <strong>\nBUSOLINEA</strong>\n  durante el plazo de vigencia de las relaciones comerciales, y por 10-diez años posteriores a finalizadas las mismas.\n<br><br>\nh) Coordinar juntas con el TITULAR-Cliente vía telefónica, por correo electrónico, redes sociales, Skype o a través de cualquier otro medio, ya sea en soporte físico o digital.\n<br><br>i) Generar un registro en las bases de datos de clientes de <strong>BUSOLINEA</strong>\n que serán conservados por 5-cinco años.<br><br>\nj) Realizar transacciones con instituciones de crédito que resulten con motivo de las operaciones comerciales.<br><br>\nk) En caso de ser foráneo el realizar los trámites necesarios para el envío de los productos o la entrega de los servicios que comercializa \n<strong>BUSOLINEA</strong> .<br><br>\nl) Utilizar servicios en la nube a efecto de hacer eficientes los procesos internos de <strong>BUSOLINEA</strong> .<br>\n<br>m) Para evaluar y verificar la información del TITULAR-Cliente para mitigación de fraude.<br><br>\nn) Para verificar la información del TITULAR– Cliente en el sistema antifraude de <strong>BUSOLINEA</strong>\n y/o con las herramientas antifraude de terceros.<br><br>\no) Para contactar al TITULAR– Cliente con procesadores de pago tales como Conekta y OpenPay.<br><br><p><strong>5.1.4.-\n</strong> EL TITULAR- Proveedor, Prospecto de Proveedor y/o Prestador de Servicios:</p>\na) Registrarlos en su sistema contable para el acceso a los datos personales por las personas autorizadas para ello.\n<br><br>b) Realizar los pagos correspondientes a los productos o servicios otorgados a <strong>BUSOLINEA</strong>\n , ya sea en efectivo, cheque, depósito o transferencia bancaria.<br><br>\nc) Conocer los datos de ubicación de EL TITULAR- Proveedor para la distribución de los pagos correspondientes.<br><br>\nd) Contactar al TITULAR- Proveedor vía telefónica, por correo electrónico o por cualquier otro medio, a fin de realizar aclaraciones y seguimiento solicitudes de servicios y/o productos, sobre pagos o cualquier otra situación derivada de los productos o servicios otorgados a \n<strong>BUSOLINEA</strong> .<br><br>e) Generar un registro y control en la base de datos de Proveedores de <strong>\nBUSOLINEA</strong>\n , que será conservada durante toda la vigencia de la relación comercial y por 10-diez años posteriores a finalizada la misma.\n<br><br>\nf) Llevar un expediente físico y/o electrónico del TITULAR-Proveedor durante el tiempo que dure la relación comercial y por 10-diez años posteriores a su terminación por cualquier causa.\n<br><br>g) Utilizar servicios en la nube a efecto de hacer eficientes los procesos internos de <strong>BUSOLINEA\n</strong> .<br><br><p><strong>5.1.5.-</strong> EL TITULAR- Distribuidor:</p>\na) Contactarlo vía telefónica, por correo electrónico, por redes sociales o por cualquier otro medio, para atender y dar seguimiento a las solicitudes de productos y/o servicios.\n<br><br>\nb) Dar tratamiento a los datos personales patrimoniales y/o financieros del TITULAR-Distribuidor para brindar los productos y/o servicios que comercializa \n<strong>BUSOLINEA</strong> .<br><br>\nc) Contactar al TITULAR- Distribuidor por cualquier medio, a fin de realizar aclaraciones y seguimiento sobre pagos o cualquier otra situación derivada de los productos y/o servicios proporcionados por \n<strong>BUSOLINEA</strong> , tales como quejas o comentarios sobre los mismos.<br><br>\nd) Registrarlos y actualizar anualmente los datos en los softwares internos, plataformas y/o portales de <strong>\nBUSOLINEA</strong> , para el acceso a los datos personales por las personas autorizadas para ello.<br><br>\ne) Realizar y almacenar un expediente físico del TITULAR- Distribuidor durante el tiempo que dure la relación comercial y por hasta 10-diez años posteriores a la terminación de dicha relación.\n<br><br>\nf) Elaboración de facturación electrónica y notas de crédito derivadas de los productos y/o servicios que comercializa \n<strong>BUSOLINEA</strong>\n . Dichas facturas, tanto en formato físico como electrónico y las notas de crédito, serán conservadas por <strong>\nBUSOLINEA</strong>\n durante el plazo de vigencia de las relaciones comerciales, y por 10-diez años posteriores a finalizadas las mismas.\n<br><br>g) Realizar transacciones con instituciones de crédito, que resulten con motivo de las operaciones comerciales.\n<br><br>h) Utilizar servicios en la nube a efecto de hacer eficientes los procesos internos de <strong>BUSOLINEA\n</strong> .<br><br>i) Generar un registro en las bases de datos de distribuidores de <strong>BUSOLINEA</strong>\n que serán conservados por 10-diez años.<br><br><p><strong>5.1.6.-</strong>\n EL TITULAR–Usuario de la PÁGINA DE INTERNET DE <strong>BUSOLINEA</strong> :</p>\na) Contactar vía telefónica, por correo electrónico, redes sociales, Skype o por cualquier otro medio al TITULAR-Usuario, para atender y dar seguimiento a sus comentarios o solicitudes realizadas a través de la PÁGINA DE INTERNET DE \n<strong>BUSOLINEA</strong> .<br><br>b) Para acceder a las redes sociales en las que participa <strong>BUSOLINEA\n</strong> .<br><br>\nc) Enviar información y promociones, previa solicitud que haya realizado el TITULAR–Usuario, a través del formulario disponible en la PÁGINA DE INTERNET DE \n<strong>BUSOLINEA</strong> , bajo la pestaña “Contacto”.<br><br>\nd) Almacenar en diferentes bases de datos, en formato físico o electrónico, la información del TITULAR-Usuario; dichos registros serán almacenados por un término de 5-cinco años contados a partir de su obtención, siempre que no se concreten las operaciones comerciales con \n<strong>BUSOLINEA</strong> .<br><br>e) Para verificar la información del TITULAR–Usuario en el sistema antifraude de \n<strong>BUSOLINEA</strong> y/o con las herramientas antifraude de terceros.<br><br>\nf) Para contactar al TITULAR–Usuario con procesadores de pago tales como Conekta y OpenPay.<br><br><p><strong>\n5.1.7.- BUSOLINEA</strong> podrá tratar los datos personales del TITULAR para las siguientes finalidades secundarias:\n</p>\na) Para el caso del TITULAR-Cliente, evaluar la calidad de los servicios y/o productos ofrecidos, así como la calidad de atención a sus comentarios o solicitudes.\n<br><br>b) Realizar estudios internos sobre hábitos de consumo.<br><br>\nc) Para proporcionarle comunicaciones adicionales, información y promociones, lanzamiento de nuevos productos, cambios de imagen, boletines informativos y de noticias.\n<br><br>\nd) Informar vía correo electrónico sobre cambios o nuevos productos o servicios que estén relacionados con el solicitado por el TITULAR.\n<br><br>e) Generar informes internos sobre la utilización de LA PÁGINA DE INTERNET DE <strong>BUSOLINEA</strong> .<br>\n<br>f) Envíos masivos de mail marketing.<br><br>\ng) Para contactar al TITULAR-Usuario a fin de informarle de actualizaciones LA PÁGINA DE INTERNET DE <strong>BUSOLINEA\n</strong> , mensajes informativos y relativos a servicios, incluyendo actualizaciones de seguridad importantes.<br><br>\nh) Para mencionar al TITULAR-Cliente con ese carácter en el perfil corporativo y en la LA PÁGINA DE INTERNET DE \n<strong>BUSOLINEA</strong> .<br><br>\ni) Para informarles y/o invitarlos a participar de cursos, capacitaciones y/o eventos organizados por <strong>BUSOLINEA\n</strong> .<br><br>j) Enviar correos electrónicos de salutaciones de fin de año al TITULAR-Cliente.<br><br>\nk) Para compartir información del TITULAR-Cliente y del TITULAR-Usuario con otras empresas del grupo de <strong>\nBUSOLINEA</strong> para promocionar servicios y promociones.<br><br><p><strong>5.2.-</strong>\n En caso de que EL TITULAR no desee que sus datos personales sean utilizados para todas o algunas de las Finalidades Secundarias que se establecen en el apartado 5.1.7., deberá enviar una solicitud de eliminación de sus datos, especificando las finalidades para las que desea que no sean tratados sus datos personales, al siguiente correo electrónico: privacidad@busolinea.com.mx.\n</p><h2>6.- Uso de “Cookies” y “web beacons”</h2><p><strong>6.1.-</strong> Es posible que LA PÁGINA DE INTERNET DE \n<strong>BUSOLINEA</strong>\n haga uso de \"cookies\" en conexión con ciertas características o funciones. Las cookies son tipos específicos de información que un sitio web transmite al disco duro de la computadora del TITULAR con el fin de mantener los registros. Las cookies pueden servir para facilitar el uso de un sitio web, al guardar contraseñas y preferencias mientras EL TITULAR navega en Internet. LA PÁGINA DE INTERNET DE \n<strong>BUSOLINEA</strong>\n no usa cookies para obtener datos de identificación personal de la computadora del TITULAR que no se hayan enviado originalmente como parte de la cookie.\n</p><p><strong>6.2.-</strong>\n Por su parte, las “web beacons” son imágenes insertadas en una página de Internet o correo electrónico, que puede ser utilizado para monitorear el comportamiento de un visitante, como almacenar información sobre la dirección IP del usuario, duración del tiempo de interacción en dicha página y el tipo de navegador utilizado, entre otros.\n</p><p><strong>6.3.-</strong>\n Aunque la mayoría de los navegadores aceptan cookies y web beacons automáticamente, EL TITULAR puede configurar su navegador para que no los acepte.\n</p><p><strong>6.4.-</strong> Para desactivar las cookies, debe seguir las siguientes instrucciones:</p><p \nclass=\"col-md-offset-1\"><strong>6.4.1.-</strong>\n En una PC: abrir el explorador de Internet, entrar al menú de “Herramientas”, entrar a “Opciones de Internet”, escoger la pestaña de “Privacidad”, mover el cursor de la Configuración hacia “Bloquear todas las Cookies”.\n</p><p class=\"col-md-offset-1\"><strong>6.4.2.-</strong>\n En un Mac: abrir la aplicación de Internet, ir a “Preferencias”, escoger la opción de “Seguridad”, escoger “Nunca” en la opción de “Aceptar Cookies”.\n</p><p><strong>6.5.- BUSOLINEA</strong>\n le informa al TITULAR que aunque es su facultad desactivar las cookies, si lo hace, la PÁGINA DE INTERNET DE <strong>\nBUSOLINEA</strong> no funcionará para la venta de boletos de autobuses.</p><h2>\n7.- Limitaciones para el acceso y divulgación de los datos personales</h2><p><strong>7.1.- BUSOLINEA</strong>\n , se compromete a realizar su mejor esfuerzo para proteger la seguridad de los datos personales que EL TITULAR le está entregando, mediante la celebración de actos jurídicos, el uso de tecnologías que controlen el acceso, uso o divulgación sin autorización de la información personal así como la encriptación de los datos personales a los que les den tratamiento; para tal efecto, se almacena la información personal en bases de datos con acceso limitado que se encuentran en instalaciones controladas con mecanismos de seguridad; \n<strong>BUSOLINEA</strong>\n se compromete a que la información proporcionada por EL TITULAR, sea considerada con carácter confidencial, y utilizada bajo plena privacidad.\n</p><p><strong>7.2.-</strong> En este tenor, <strong>BUSOLINEA</strong>\n se obliga a tomar las medidas necesarias para garantizar que los Encargados que utilice cumplan con lo establecido en el presente Aviso de Privacidad, con las obligaciones a su cargo y particularmente, con las disposiciones establecidas en el artículo 50 del Reglamento de la LFPDPPP.\n</p><p><strong>7.3.-</strong> Asimismo, <strong>BUSOLINEA</strong>\n se obliga a contratar servicios de cómputo en la nube que realicen el tratamiento de los datos personales de los TITULARES, siempre que los mismos respeten las previsiones del artículo 52 del Reglamento de la LFPDPPP.\n</p><p><strong>7.4.-</strong>\n Adicionalmente, se le informa que para efectos de evitar recibir publicidad en general, puede realizar su inscripción en el Registro Público para Evitar Publicidad, para mayor información podrá revisar el sitio web de la Procuraduría Federal de Consumidor (PROFECO) y adicionalmente, otra forma en la que puede limitar el tratamiento de sus datos personales es el Registro Público de Usuarios que tiene la Comisión Nacional para la Defensa del Usuario de Servicios Financieros (CONDUSEF).\n</p><h2>8.- Designado de tramitar las solicitudes</h2><p><strong>8.1.-</strong>\n En caso de que EL TITULAR necesite revocar su consentimiento, así como Acceder, Rectificar, Cancelar, Oponerse al tratamiento de los datos personales que ha proporcionado, lo deberá hacer a través de la persona designada por \n<strong>BUSOLINEA</strong> cuyos datos se describen a continuación:</p><p>Designado: <strong>\n[Departamento de Operaciones]</strong></p><p>Correo electrónico: <a href=\"mailto:privacidad@busolinea.com.mx\">\nprivacidad@busolinea.com.mx</a>.</p><h2>9.- Medios para revocar el consentimiento</h2><p>\nEL TITULAR de los datos personales podrá revocar el consentimiento que se otorga con la aceptación del presente. Dicha revocación del consentimiento que se otorga por medios electrónicos, se deberá de hacer observando el siguiente procedimiento, utilizando el siguiente \n<a href=\"https://s3.amazonaws.com/angubus-data/formato-baja.pdf\" style=\"color:#F39823\" target=\"_blank\">formato</a>:</p>\n<p><strong>9.1.-</strong>\n Enviar un correo electrónico en atención al Designado en el punto 8-ocho del presente Aviso, mediante el cual serán atendidas dichas solicitudes.\n</p><p><strong>9.2.-</strong>\n Enviar una solicitud o mensaje de datos al correo electrónico antes precisado, en el que señale:</p><p \nclass=\"col-md-offset-1\"><strong>9.2.1.-</strong>\n El nombre completo del TITULAR, domicilio y correo electrónico para recibir la respuesta que se genere con motivo de su solicitud;\n</p><p class=\"col-md-offset-1\"><strong>9.2.2.-</strong> El motivo de su solicitud;</p><p class=\"col-md-offset-1\">\n<strong>9.2.3.-</strong> Los argumentos que sustenten su solicitud o petición;</p><p class=\"col-md-offset-1\"><strong>\n9.2.4.-</strong> Documento oficial que acredite su identidad y que demuestre que es quien dice ser; y</p><p \nclass=\"col-md-offset-1\"><strong>9.2.5.-</strong>\n Fecha a partir de la cual, se hace efectiva la revocación de su consentimiento.</p><p><strong>9.3.- BUSOLINEA</strong>\n notificará a EL TITULAR, en un plazo máximo de 20-veinte días, contados desde la fecha en que se recibió la solicitud sobre el ejercicio de los derechos ARCO, la resolución adoptada, a efecto de que, si resulta procedente, se haga efectiva la misma dentro de los 15-quince días siguientes a la fecha en que se comunica la respuesta, mediante un mensaje que contenga que ha ejecutado de todos los actos tendientes a no tratar los datos personales de EL TITULAR.\n</p><h2>10.- Medios para ejercer los derechos ARCO</h2><p><strong>10.1.-</strong>\n En caso de que EL TITULAR necesite Acceder, Rectificar, Cancelar u Oponerse a los datos personales que ha proporcionado a \n<strong>BUSOLINEA</strong> , el TITULAR deberá seguir el siguiente procedimiento, utilizando el siguiente <a \nhref=\"https://s3.amazonaws.com/angubus-data/formato-baja.pdf\" style=\"color:#F39823\" target=\"_blank\">formato</a>:</p><p>\n<strong>10.2.-</strong>\n Enviar un correo electrónico en atención al Designado del punto 8-ocho del presente Aviso, mediante el cual serán atendidas dichas solicitudes, señalando lo siguiente:\n</p><p class=\"col-md-offset-1\"><strong>10.2.1.-</strong>\n El nombre completo del TITULAR, domicilio y correo electrónico para recibir la respuesta que se genere con motivo de su solicitud;\n</p><p class=\"col-md-offset-1\"><strong>10.2.2.-</strong> El motivo de su solicitud;</p><p class=\"col-md-offset-1\">\n<strong>10.2.3.-</strong> Los argumentos que sustenten su solicitud o petición;</p><p class=\"col-md-offset-1\"><strong>\n10.2.4.-</strong> Documento oficial que acredite su identidad y que demuestre que es quien dice ser;</p><p \nclass=\"col-md-offset-1\"><strong>10.2.5.-</strong>\n Descripción clara y precisa de los datos personales respecto de los que se busca ejercer alguno de los derechos ARCO, y cualquier otro elemento o documento que facilite la localización de los datos personales.\n</p><p class=\"col-md-offset-1\"><strong>10.2.6.-</strong>\n Tratándose de solicitudes de rectificación de datos personales, el TITULAR deberá indicar, además de lo señalado, las modificaciones a realizarse y aportar la documentación que sustente su petición.\n</p><p><strong>10.3.- BUSOLINEA</strong>\n notificará al TITULAR, en un plazo máximo de 20-veinte días contados desde la fecha en que se recibió la solicitud de acceso, rectificación, cancelación u oposición, la resolución adoptada, a efecto de que, si resulta procedente, se haga efectiva la misma dentro de los 15-quince días siguientes a la fecha en que se comunica la respuesta. Tratándose de solicitudes de acceso a datos personales, procederá la entrega previa acreditación de la identidad del solicitante o representante legal, según corresponda.\n</p><h2>11.- Transferencia de datos personales</h2><p><strong>11.1.- BUSOLINEA</strong>\n se obliga a no transferir o compartir los datos a que se refiere el presente Aviso, a favor de terceros, salvo en los casos que resulte necesario para cumplir con las finalidades del presente aviso, o bien, sean necesarios en cumplimiento de un requerimiento de autoridad.\n</p><p><strong>11.2.-</strong>\n Asimismo, en cumplimiento de sus obligaciones legales, y con efectos informativos al TITULAR, se le indica que \n<strong>BUSOLINEA</strong> podrá realizar las siguientes transferencias:</p><p class=\"col-md-offset-1\"><strong>11.2.1.-\n</strong>\n IMSS, INFONAVIT y SAT, a efecto de dar cumplimiento a la legislación laboral, de seguridad social, así como el pago de impuestos.\n</p><p class=\"col-md-offset-1\"><strong>11.2.2.-</strong>\n Instituciones bancarias, a efecto realizar el cobro o el pago de los productos o servicios, o el pago de los salarios de trabajadores, que requiere u ofrece \n<strong>BUSOLINEA</strong> para sus clientes, proveedores y trabajadores.</p><p><strong>11.3.-</strong>\n No obstante lo anterior y, en caso de que se presenten vulneraciones de seguridad ocurridas en cualquier fase del tratamiento, que afecten de forma significativa los derechos patrimoniales o morales de los TITULARES, éstos serán informados por correo electrónico, de forma inmediata, a fin de que estos últimos puedan tomar las medidas correspondientes a la defensa de sus derechos, deslindando de cualquier responsabilidad a \n<strong>BUSOLINEA</strong> , si la vulneración no es imputable a él.</p><h2>12.- Otras políticas de privacidad</h2><p>\n<strong>12.1.-</strong> Adicionalmente, <strong>BUSOLINEA</strong>\n le informa que utilizará los servicios ofrecidos por Google@ Analytics para la prestación de sus servicios y/o entrega de productos, los cuales se regirán por las Políticas de Privacidad de Google® que se encuentran en la siguiente dirección electrónica: www.google.com/policies/privacy.\n</p><p>\nEL TITULAR otorga su consentimiento expreso para que sus datos personales sean tratados por Google® conforme a sus Políticas de Privacidad descritas en el apartado anterior.\n</p><h2>13.- Modificaciones</h2><p><strong>13.1.-</strong>\n Las partes acuerdan que el Aviso de Privacidad, puede ser modificado en el tiempo y forma que <strong>BUSOLINEA\n</strong>\n lo determine, atendiendo al estudio y las regulaciones en materia de protección de datos personales surjan, por lo que se obliga a mantener actualizado el presente aviso, para su consulta LA PÁGINA DE INTERNET DE \n<strong>BUSOLINEA</strong>\n a efecto de que en su caso, EL TITULAR se encuentre en posibilidad de ejercer sus derechos ARCO.</p><h2>\n14.- Autoridad garante</h2><p><strong>14.1.-</strong>\n Si usted considera que su derecho a la protección de sus datos personales ha sido lesionado por alguna conducta u omisión de nuestra parte, o presume alguna violación a las disposiciones previstas en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, su Reglamento y demás ordenamientos aplicables, podrá interponer su inconformidad o denuncia ante el Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI). Para mayor información, le sugerimos visitar su página oficial de Internet \n<a href=\"www.inai.org.mx\">www.inai.org.mx</a>.</p><h2>15.- Ley aplicable y jurisdicción</h2><p><strong>15.1.-</strong>\n Las partes expresan que el presente aviso, se regirá por las disposiciones legales aplicables en la República Mexicana, en especial, por lo dispuesto en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, su Reglamento y la demás normativa vinculada aplicable.\n</p><p><strong>15.2.-</strong>\n Para el caso de que exista una disputa o controversia, derivada de la interpretación, ejecución o cumplimiento del aviso o de cualquiera de los documentos que del mismo se deriven, o que guarden relación con éste, las partes amigablemente, buscarán llegar a un acuerdo dentro de un plazo de 30-treinta días naturales, contados a partir de la fecha en que surja cualquier diferencia y se notifique por escrito sobre dicho evento a la contraparte, deduciendo el proceso de mediación ante el Centro de Justicia Alternativa de la Ciudad de México, antes Distrito Federal, llevándose al amparo de la Ley de Justicia Alternativa del Tribunal Superior de Justicia de la Ciudad de México, antes Distrito Federal y su Reglamento Interno, vigente al momento de que se presente la controversia.\n</p><p><strong>15.3.-</strong>\n En caso de que las partes no lleguen a un acuerdo, convienen en este acto en someter todas las desavenencias que deriven del presente Aviso de Privacidad o de cualquiera de los documentos que del mismo se deriven, o que guarden relación con éste o con aquéllos, a ser resueltas de manera definitiva, sometiéndose a la competencia y leyes de las Autoridades Administrativas Federales o Tribunales de la Ciudad de México, antes Distrito Federal renunciando expresamente a cualquier fuero distinto que por razones de sus domicilios presentes o futuros pudieren corresponderles.\n</p><p class=\"text-right\"><strong>Versión 2.0 [Fecha de actualización 25/Mayo/2017]</strong></p></div></div>");
$templateCache.put("app/views/transportamex/pages/profile/profile.html","<div class=\"content\" id=\"users_content\"><div class=\"container\"><div class=\"col-sm-12\"><div id=\"profile\"><div \nclass=\"col-sm-2 tab\"><ul><li class=\"about active\" style=\"top: 0px\"><a href=\"#about\"><img \nsrc=\"/assets/transportamex/images/profile/about_icon.png\" alt=\"About icon\"><br>Acerca de Ti</a></li><li class=\"card\" \nstyle=\"top: 0px\"><a href=\"#card\"><img src=\"/assets/transportamex/images/profile/credit_icon.png\" alt=\"Credit icon\"><br>\nPago</a></li><li class=\"billing\" style=\"top: 0px\"><a href=\"#billing\"><img \nsrc=\"/assets/transportamex/images/profile/billing_icon.png\" alt=\"Billing icon\"><br>Facturación</a></li><li \nclass=\"security\" style=\"top: 0px\"><a href=\"#security\"><img \nsrc=\"/assets/transportamex/images/profile/security_icon.png\" alt=\"Security icon\"><br>Contraseña</a></li></ul></div><div\n class=\"col-sm-10 data\"><div class=\"hello_profile\"><h1>¡Hola!</h1><h3>\nCompleta tu perfil para recibir las mejores ofertas de Busolinea.</h3></div><div id=\"profile_data\"></div><div \nid=\"profile_about\"><div><div class=\"panel profile_panel\"><div class=\"panel-heading\"><a class=\"edit_btn\" \nhref=\"#aboutEdit\"><md-icon md-font-icon=\"icon-pencil\" class=\"icon s16\"></md-icon>editar </a>Acerca de Ti</div><div \nclass=\"panel-body\"><p class=\"note\">Crea tu cuenta para comprar tus boletos más rápido y fácil</p><div class=\"row\"><div \nclass=\"col-sm-5 social_info\"><div class=\"social_login\"><a class=\"btn col-xs-12 facebook_btn\">Conectado con Facebook \n</a><a class=\"btn col-xs-12 google_btn\" href=\"/users/auth/google_oauth2\">Usar Google</a></div></div><div \nclass=\"col-sm-7 about_info info\"><form class=\"form-horizontal\"><div class=\"form-group\"><label \nclass=\"control-label col-sm-4\">Nombre</label><label class=\"control-label col-sm-8\">Julio</label></div><div \nclass=\"form-group\"><label class=\"control-label col-sm-4\">Apellidos</label><label class=\"control-label col-sm-8\">Ponce\n</label></div><div class=\"form-group\"><label class=\"control-label col-sm-4\">Correo</label><label \nclass=\"control-label col-sm-8\">jcsp_30@hotmail.com</label></div></form></div></div></div></div></div></div><div \nid=\"profile_card\"><div><div class=\"panel profile_panel\"><div class=\"panel-heading\"><a class=\"edit_btn\" href=\"#card\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"icon s16\"></md-icon>editar </a>Pago</div><div class=\"panel-body\"><p \nclass=\"note\">Guarda los datos de tu tarjeta de crédito para no tener que ingresarla una y otra vez.<br>\nTu información es guardada de una manera segura y confiable.</p><form class=\"form-horizontal\"><div class=\"row\"><div \nclass=\"col-sm-8\"><div class=\"form-group\"><label class=\"control-label col-sm-3\">Seleccionar tipo</label><div \nclass=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"check\"><input class=\"css-checkbox lrg with-gap\" \nid=\"visa_check\" name=\"card_type\" type=\"radio\" value=\"visa\"><label class=\"css-label lrg web-two-style\" for=\"visa_check\" \nname=\"checkbox67_lbl\">Visa</label></div><div class=\"check\"><input class=\"css-checkbox lrg with-gap\" id=\"master_check\" \nname=\"card_type\" type=\"radio\" value=\"mastercard\"><label class=\"css-label lrg web-two-style\" for=\"master_check\" \nname=\"checkbox67_lbl\">Mastercard</label></div><div class=\"check\"><input class=\"css-checkbox lrg with-gap\" \nid=\"amex_check\" name=\"card_type\" type=\"radio\" value=\"amex\"><label class=\"css-label lrg web-two-style\" for=\"amex_check\" \nname=\"checkbox67_lbl\">AMEX</label></div></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-sm-3\">Nombre:</label><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-12\"><input \nclass=\"form-control\" name=\"card_name\"></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-sm-3\">No. de tarjeta</label><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-12\">\n<input class=\"form-control\" name=\"card_number\"></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-sm-3\">Fecha de Expiración</label><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-4\">\n<input class=\"form-control\" maxlength=\"2\" name=\"card_exp_month\" placeholder=\"mm\"></div><div class=\"col-sm-4\"><input \nclass=\"form-control\" maxlength=\"2\" name=\"card_exp_year\" placeholder=\"aa\"></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-sm-3\">CVV</label><div class=\"col-sm-9\"><div class=\"row\"><div \nclass=\"col-sm-4\"><input class=\"form-control\" name=\"card_cvv\"></div><div class=\"col-sm-8\"><img class=\"cvv\" \nsrc=\"/assets/transportamex/images/support/cvv.png\" alt=\"Cvv\"><div>3 dígitos detrás de la tarjeta</div></div></div>\n</div></div></div><div class=\"col-sm-4\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"cards\"><img \nsrc=\"/assets/transportamex/images/profile/cards.png\" alt=\"Cards\"></div></div><div class=\"col-sm-6\"><md-button \nclass=\"btn md-button btn-default z-depth-1 col-sm-12 cancel_btn\">Cancelar</md-button></div><div class=\"col-sm-6\">\n<md-button class=\"btn md-button btn-default z-depth-1 col-sm-12 save_btn\">Guardar</md-button></div></div></div></div>\n</form></div></div></div></div><div id=\"profile_billing\"><div><div class=\"panel profile_panel\"><div \nclass=\"panel-heading\"><a class=\"edit_btn\" href=\"#billingEdit\"><md-icon md-font-icon=\"icon-pencil\" class=\"icon s16\">\n</md-icon>editar </a>Facturación</div><div class=\"panel-body\"><p class=\"note\">\nGuarda los datos de tu tarjeta de crédito para no tener que ingresarla una y otra vez.<br>\nPor favor asegúrate que ingreses la dirección donde te llega tu estado de cuenta.</p><form \nclass=\"form-horizontal info\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"form-group\"><label \nclass=\"control-label col-sm-2\">Dirección</label><label class=\"control-label col-sm-10\">Manuel de la Llata</label></div>\n</div><div class=\"row\"><div class=\"form-group\"><label class=\"control-label col-sm-2\">Ciudad</label><label \nclass=\"control-label col-sm-4\">Queretaro</label><label class=\"control-label col-sm-2\">Estado</label><label \nclass=\"control-label col-sm-4\">QT</label></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">País\n</label><label class=\"control-label col-sm-4\">MX</label><label class=\"control-label col-sm-2\">Código Postal</label>\n<label class=\"control-label col-sm-4\">76117</label></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">\nTeléfono</label><label class=\"control-label col-sm-4\">3333333333</label></div></div></div></form></div></div></div>\n</div><div id=\"profile_security\"><div><div class=\"panel profile_panel\"><div class=\"panel-heading\">Contraseña</div><div \nclass=\"panel-body\"><p class=\"note\">Recuerda mantener tu contraseña segura cambiándola de vez en cuando.</p><div \nclass=\"col-sm-4 col-sm-offset-4\"><a href=\"#securityEdit\"><md-button \nclass=\"btn md-button btn-default z-depth-1 md-ink-ripple\">RETABLECER MI CONTRASEÑA</md-button></a></div></div></div>\n</div></div></div><div class=\"clearfix\"></div></div></div></div></div>");
$templateCache.put("app/views/transportamex/pages/routes/routes.html","<div id=\"routes_content\" class=\"view-content\"><div class=\"routes_content\" layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start none\"><div class=\"container\" layout=\"row\" layout-align=\"start none\" flex=\"initial\"><div \nid=\"sidebar-wrapper\" hide-xs hide-sm show-gt-sm layout=\"column\" flex=\"30\" layout-align=\"start none\"><filter-sidebar \ndata-routes=\"vm.routes\" data-time-min=\"vm.timeMin\" data-time-max=\"vm.timeMax\" \ndata-cabin-types-route=\"vm.cabinTypesRoute\" data-localpaso-route=\"vm.localpasoRoute\" \ndata-bus-companies-outbound-route=\"vm.busCompaniesOutboundRoute\" \ndata-bus-companies-return-route=\"vm.busCompaniesReturnRoute\"></filter-sidebar></div><md-sidenav id=\"sidebar_right\" \nclass=\"md-sidenav-right\" md-component-id=\"sidebar-right\" md-is-open=\"$root.foldedRight\" ms-scroll><md-toolbar \nclass=\"navigation-header\" layout=\"row\" layout-align=\"space-between center\"><md-button class=\"close-sidebar\" \naria-label=\"close\" ng-click=\"vm.toggleSidebar(\'sidebar-right\')\"><md-icon md-font-icon=\"icon-close\" class=\"icon s25\">\n</md-icon></md-button></md-toolbar><filter-sidebar data-routes=\"vm.routes\" data-time-min=\"vm.timeMin\" \ndata-time-max=\"vm.timeMax\" data-cabin-types-route=\"vm.cabinTypesRoute\" data-localpaso-route=\"vm.localpasoRoute\" \ndata-bus-companies-outbound-route=\"vm.busCompaniesOutboundRoute\" \ndata-bus-companies-return-route=\"vm.busCompaniesReturnRoute\"></filter-sidebar></md-sidenav><div id=\"routes\" \nclass=\"clearfix\" layout=\"column\" flex-gt-sm=\"65\" flex=\"100\" flex-offset-gt-sm=\"5\"><div id=\"loader\" \nng-show=\"!vm.routes\"><div class=\"quick_loader\"><div class=\"rect1\"></div><div class=\"rect2\"></div><div class=\"rect3\">\n</div><div class=\"rect4\"></div><div class=\"rect5\"></div></div></div><div id=\"routes-wrapper\" ng-show=\"vm.routes\"><div \nclass=\"list\" layout=\"column\" layout-align=\"start none\" flex=\"auto\"><routes-list \nng-if=\"$root.returnTicket==false && vm.routes.outbound_routes\" data-label-translate=\"ROUTES.CHOOSE_OUTBOUND\" \ndata-routes=\"vm.routes.outbound_routes\" data-cabin-types=\"vm.cabinTypesRoute\" data-localpaso=\"vm.localpasoRoute\" \ndata-bus-companies=\"vm.busCompaniesOutboundRoute\" data-time-min=\"vm.timeMin\" data-time-max=\"vm.timeMax\" \non-route-selection=\"vm.selectRoute(item, central_buy)\" data-orinfo-server=\"vm.orinfo\"></routes-list><routes-list \nng-if=\"$root.returnTravel && $root.returnTicket\" data-label-translate=\"ROUTES.CHOOSE_RETURN\" \ndata-routes=\"vm.routes.return_routes\" data-cabin-types=\"vm.cabinTypesRoute\" data-localpaso=\"vm.localpasoRoute\" \ndata-bus-companies=\"vm.busCompaniesReturnRoute\" data-time-min=\"vm.timeMin\" data-time-max=\"vm.timeMax\" \non-route-selection=\"vm.selectRoute(item, central_buy)\" data-orinfo-server=\"vm.orinfo\"></routes-list></div></div></div>\n</div></div></div>");
$templateCache.put("app/views/transportamex/pages/seats/seats.html","<div id=\"seats_content\" class=\"view-content\"><div class=\"seats_content container\" layout=\"column\" \nlayout-align=\"start none\" flex><div id=\"loader\" ng-show=\"!vm.seatsIda.length\"><div class=\"quick_loader\"><div \nclass=\"rect1\"></div><div class=\"rect2\"></div><div class=\"rect3\"></div><div class=\"rect4\"></div><div class=\"rect5\">\n</div></div></div><div class=\"seat_wrapper\" ng-show=\"vm.seatsIda.length\" layout=\"column\" layout-align=\"start none\" \nflex=\"initial\"><div class=\"breadcrumb hide-xs hide-sm\" flex=\"initial\" analytics-on analytics-category=\"seats\" \nanalytics-label=\"steps\"><span>{{ \'SEATS.BREADCRUMB.ITINERARY\' | translate }}</span> <span class=\"selected\">\n{{ \'SEATS.BREADCRUMB.SEATS\' | translate }}</span> <span>{{ \'SEATS.BREADCRUMB.PAYMENT\' | translate }}</span></div>\n<seat-selection ng-if=\"!$root.returnTicket\" data-route=\"$root.route.outbound_route\" data-seats=\"vm.seatsIda\" \ndata-selected-seats=\"vm.selectedSeatsOutboundRoute\" data-is-selection-complete=\"vm.outboundRouteIsComplete\" \ndata-show-timer=\"vm.showTimer\" data-remain-time=\"null\" \ndata-on-seat-click=\"vm.seatSelection({seat:seat}, vm.selectedSeatsOutboundRoute, $root.route.outbound_route.id)\" \ndata-on-seat-update=\"vm.seatUpdate({seat:seat}, vm.selectedSeatsOutboundRoute)\" \ndata-on-seat-remove=\"vm.removeSelection({seat:seat}, vm.selectedSeatsOutboundRoute)\" \ndata-on-click-continue=\"vm.continueToCheckout()\"></seat-selection><seat-selection \nng-if=\"$root.returnTicket && vm.outboundRouteIsComplete\" data-route=\"$root.route.return_route\" \ndata-seats=\"vm.seatsRegreso\" data-selected-seats=\"vm.selectedSeatsReturnRoute\" \ndata-is-selection-complete=\"vm.returnRouteIsComplete\" data-show-timer=\"vm.showTimer\" \ndata-remain-time=\"vm.remainReservationTime\" \ndata-on-seat-click=\"vm.seatSelection({seat:seat}, vm.selectedSeatsReturnRoute, $root.route.return_route.id)\" \ndata-on-seat-update=\"vm.seatUpdate({seat:seat}, vm.selectedSeatsReturnRoute)\" \ndata-on-seat-remove=\"vm.removeSelection({seat:seat}, vm.selectedSeatsReturnRoute)\" \ndata-ng-show=\"$root.route.return_route\" data-on-click-continue=\"vm.continueToCheckout()\"></seat-selection></div></div>\n</div>");
$templateCache.put("app/views/transportamex/pages/terms/terms.html","<div id=\"terms_content\" layout=\"row\" layout-align=\"center start\"><div layout=\"column\" layout-align=\"start-none\" \nflex=\"50\"><h2>CONTRATO DE ADHESIÓN RESPECTO DE LA PÁGINA DE INTERNET <a href=\"www.busolinea.com.mx\" target=\"_blank\">\nWWW.BUSOLINEA.COM.MX</a>\n, EN ADELANTE “EL PORTAL” Y DE LA APPLICACIÓN MÓVIL, EN ADELANTE “LA APLICACIÓN”, QUE CELEBRAN POR UNA PARTE EB DIGITAL MEDIA, S.A. DE C.V. Y AUTOBUSES ESTRELLA BLANCA, S.A. DE C.V., EN ADELANTE DENOMINADAS EN CONJUNTO COMO “BUSOLINEA” Y, POR LA OTRA, EL USUARIO, SUJETÁNDOSE AMBAS PARTES, A LO ESTABLECIDO EN EL TEXTO DEL PRESENTE CONTRATO.\n</h2><h2>Términos y condiciones de uso</h2><h2>1.- Aceptación y adopción de los términos</h2><p><strong>1.1.-</strong>\n Al ingresar y utilizar este portal de Internet, cuyo nombre de dominio es <a href=\"http://www.busolinea.com.mx\">\nwww.busolinea.com.mx</a>\n (en adelante “EL PORTAL”), o la aplicación móvil, cuyo nombre es Busolinea (en adelante “LA APLICACIÓN” o la “APP”, indistintamente), ambos propiedad de \n<strong>BUSOLINEA</strong>\n , usted (en adelante “el Usuario” o “los Usuarios”) está aceptando los términos y las condiciones contenidos en este convenio y declara expresamente su aceptación utilizando para tal efecto medios electrónicos, en términos de lo dispuesto por el artículo 1803 y 1834bis del Código Civil Federal, 80, 81, 89 y demás relativos y aplicables del Código de Comercio y demás relativos y aplicables de la legislación aplicable.\n</p><p><strong>1.2.-</strong>\n Si el Usuario no acepta en forma absoluta y completa los términos y condiciones de este convenio, deberá abstenerse de acceder, usar y ver EL PORTAL y/o LA APLICACIÓN.\n</p><p><strong>1.3.-</strong>\n Para el caso que el Usuario continúe en el uso de EL PORTAL y/o LA APLICACIÓN, dicha acción se considerará como su absoluta y expresa aceptación a los términos y condiciones aquí estipulados.\n</p><p><strong>1.4.-</strong>\n El sólo hecho de que el público usuario (en adelante referido como el \"Usuario\" o “Usuario Final”, indistintamente) haga uso de EL PORTAL y/o LA APLICACIÓN le otorga e implica la aceptación, plena e incondicional, de todas y cada una de las condiciones generales y particulares incluidas en estos términos y condiciones de uso en la versión publicada y administrada por \n<strong>BUSOLINEA</strong>\n , que son elaborados expresamente para el Usuario en el momento mismo en que el Usuario acceda a la página. Cualquier modificación a los presentes términos y condiciones será realizada cuando \n<strong>BUSOLINEA</strong>\n , lo considere apropiado, siendo exclusiva responsabilidad del Usuario asegurarse de tomar conocimiento de tales modificaciones.\n</p><p><strong>1.5.</strong>\n El Usuario se obliga a no reproducir ni copiar el contenido de EL PORTAL y/o LA APLICACIÓN ya que reconoce que es de propiedad exclusiva de \n<strong>BUSOLINEA</strong>\n y/o de sus Afiliados y/o Proveedores, comprometiéndose a no realizar ninguna actividad no permitida, tales como, de manera enunciativa más no limitativa, crawling del contenido de EL PORTAL y/o LA APLICACIÓN para ningún tipo de uso, ni la elaboración de bases de datos obtenidas de actividades de rastreo e indexación.\n</p><p><strong>1.6.-</strong>\n Las partes declaran que al no existir error, dolo, mala fe o cualquier otro vicio de la voluntad que pudiera nulificar la validez del presente instrumento, ambas acuerdan en sujetarse al tenor de lo estipulado en el presente documento.\n</p><h2>2.- Descripción del servicio</h2><p><strong>2.1.-</strong> <strong>BUSOLINEA</strong>\n a través de EL PORTAL y/o LA APLICACIÓN ofrece los siguientes servicios:</p><p class=\"col-md-offset-1\"><strong>2.1.1.-\n</strong>\n Consulta de horarios disponibles y de precios de boletos de autobuses en corridas realizadas dentro del territorio de los Estados Unidos Mexicanos.\n</p><p class=\"col-md-offset-1\"><strong>2.1.2.-</strong>\n Reservación y venta de boletos de autobuses en todo el territorio de los Estados Unidos Mexicanos.</p><p \nclass=\"col-md-offset-1\"><strong>2.1.3.-</strong>\n Facilitar el pago en línea a través de un sistema de pago confiable y seguro.</p><p><strong>2.2.- BUSOLINEA</strong>\n a través de EL PORTAL y/o LA APLICACIÓN, también ofrecerá, bajo determinadas condiciones, cupones de descuentos para la compra de los boletos de autobuses. Dichos cupones se aplicarán sobre el precio que se muestra en EL PORTAL y/o LA APLICACIÓN, sólo serán válidos para la compra de boletos de autobuses en EL PORTAL y/o LA APLICACIÓN y no serán canjeables por dinero en efectivo; tampoco serán retroactivos, no aplican con otras promociones y en determinados casos pueden tener sus propio términos y condiciones, los cuales les serán informados al Usuario a través de EL PORTAL y/o LA APLICACIÓN.\n</p><p><strong>2.3.-</strong>\n El uso de EL PORTAL y/o LA APLICACIÓN está sujeto a las condiciones establecidas en los presentes términos y condiciones.\n</p><p><strong>2.4.- BUSOLINEA</strong>\n otorga y concede al Usuario el derecho no exclusivo, revocable y no transferible de ver y usar EL PORTAL y/o LA APLICACIÓN de conformidad con los términos y condiciones que aquí se establecen.\n</p><p><strong>2.5.-</strong> Sin perjuicio de lo expuesto, <strong>BUSOLINEA</strong>\n se reserva el derecho a no aceptar, a su sólo criterio, la reservación y venta de los boletos de autobuses al Usuario en los casos en que las transacciones realizadas a través de EL PORTAL y/o LA APLICACIÓN sean identificadas, a criterio exclusivo de \n<strong>BUSOLINEA</strong>\n , como fraudulentas o como sospechosas de estarse cometiendo alguna conducta fraudulenta y/o ilícita a través de la misma. En estos casos \n<strong>BUSOLINEA</strong> dará aviso de dicha transacción a las autoridades correspondientes.</p><p><strong>2.6.-\n</strong> Asimismo, <strong>BUSOLINEA</strong>\n se reserva el derecho de cancelar cualquier transacción realizada y completada por el Usuario, si <strong>BUSOLINEA\n</strong> , a su criterio exclusivo, la identifica como fraudulenta.</p><h2>3.- Obligaciones del Usuario</h2><p>\n<strong>3.1.- </strong>\nPara los efectos del presente convenio, las partes acuerdan que por Usuario se entenderá a cualquier persona de cualquier naturaleza que ingrese a EL PORTAL y/o LA APLICACIÓN y/o a cualquiera de las subpáginas que despliegan su contenido y/o a cualquiera de las APP propias o de terceros, y/o páginas de Internet de terceros a través de las cuales ofrezca sus productos y/o servicios, y/o que ingrese y utilice redes sociales, y/o contrate los productos y/o servicios ofrecidos por \n<strong>BUSOLINEA</strong>\n a través de EL PORTAL y/o LA APLICACIÓN, y/o a la persona de cualquier naturaleza que use cualquiera de los servicios que se ofrecen a través de EL PORTAL y/o LA APLICACIÓN.\n</p><p><strong>3.2.-</strong>\n El Usuario sólo podrá imprimir y/o copiar cualquier información contenida o publicada en EL PORTAL y/o LA APLICACIÓN exclusivamente para su uso personal, no comercial. En caso de ser persona moral se estará a lo dispuesto por el artículo 148, fracción IV de la Ley Federal del Derecho de Autor. Se le recuerda al Usuario que todas las fotografías, imágenes, obras artísticas, marcas y/o logotipos de las mismas, bases de datos, insignias, símbolos, señales distintivas, textos y/o descripciones, manuales así como cualquier otro tipo de material publicado en EL PORTAL y/o LA APLICACIÓN se encuentran debidamente protegidas en términos de la legislación en materia de Propiedad Intelectual y/o Industrial y son propiedad de sus respectivos titulares y que \n<strong>BUSOLINEA</strong>\n puede haber utilizado imágenes, propiedad de terceros, por lo que la propiedad de ellas les corresponde a sus respectivos titulares y no se usan en términos de lo dispuesto por el artículo 62 del Reglamento de la Ley de la Propiedad Industrial.\n</p><p><strong>3.3.-</strong>\n La reimpresión, re-publicación, distribución, asignación, sublicencia, venta, reproducción electrónica o por cualquier otro medio de cualquier información, documento o gráfico de o que aparezca en EL PORTAL y/o LA APLICACIÓN en todo o en parte, para cualquier uso distinto al personal no comercial le está expresamente prohibido al Usuario, a menos que \n<strong>BUSOLINEA</strong> o sus respectivos titulares le haya otorgado su autorización previamente y por escrito.</p>\n<p><strong>3.4.-</strong>\n El Usuario es el único responsable de las actividades que se lleven a cabo dentro de las diferentes plataformas que \n<strong>BUSOLINEA</strong>\n pone a disposición del Usuario. Si el Usuario encuentra cualquier uso no autorizado de sus datos de acceso o cualquier otra violación a la seguridad, deberá de contactar a \n<strong>BUSOLINEA</strong>\n , en los datos de contacto que se ponen a su disposición en el punto 18.1. El Usuario es el único responsable de mantener la confidencialidad sobre sus datos de acceso y por tanto será el único responsable sobre los daños y perjuicios que su mal uso pudieran causar.\n</p><p><strong>3.5.-</strong>\n El Usuario será el único responsable del contenido que publique dentro de EL PORTAL y/o LA APLICACIÓN o dentro de las páginas de propiedad de los terceros respecto de los cuales \n<strong>BUSOLINEA</strong>\n ofrece sus productos y/o servicios ya que declara ser el titular de los derechos patrimoniales de autor sobre el mismo o contar con la autorización de su legítimo titular para incluirlo dentro de EL PORTAL y/o LA APLICACIÓN, mismo que puede incluir información, datos de ubicación, gráficos, imágenes, videos, etc.\n</p><p><strong>3.6.- BUSOLINEA</strong>\n busca mantener un ambiente amigable y seguro para los Usuarios de EL PORTAL y/o LA APLICACIÓN, así como para los servicios ofrecidos a través de EL PORTAL y/o LA APLICACIÓN, por lo que enunciamos algunas conductas que el Usuario deberá evitar, al hacer uso de los servicios que se ofrecen a través de dicho sitio:\n</p><p class=\"col-md-offset-1\"><strong>3.6.1.-</strong>\n Evitar ser abusivo, insultante, amenazante, intimidante, y/o promover el racismo, sexismo, odio y/o intolerancia.</p>\n<p class=\"col-md-offset-1\"><strong>3.6.2.-</strong> Evitar faltar el respeto a los operadores de <strong>BUSOLINEA\n</strong> que lo atienden para la provisión de los productos y/o servicios que <strong>BUSOLINEA</strong> ofrece.</p><p\n class=\"col-md-offset-1\"><strong>3.6.3.-</strong>\n No deberá publicar contenido que sea inapropiado, difamatorio, obsceno, vulgar, racista, pornográfico o que incite a la intolerancia y/u odio o que promueva actividades que se encuentren fuera del marco de la ley.\n</p><p class=\"col-md-offset-1\"><strong>3.6.4.-</strong>\n No deberá publicar contenido que infrinja y/o violente derechos de terceros, como podrían ser derechos de propiedad industrial, incluyendo marcas, patentes, diseños industriales, avisos comerciales, secretos industriales; así como derechos de propiedad intelectual, incluyendo derechos de autor o reservas de derechos al uso exclusivo, lo anterior, sin contar con la previa autorización del titular de dichos derechos.\n</p><p class=\"col-md-offset-1\"><strong>3.6.5.-</strong>\n No deberá hacerse pasar por otra para ingresar a EL PORTAL y/o LA APLICACIÓN.</p><p class=\"col-md-offset-1\"><strong>\n3.6.6.-</strong>\n No deberá publicar contenido que incluya o contenga programas espía (spyware), adware, virus, documentos corruptos, programas gusano o cualquier otro código destinado a interrumpir, dañar, y/o limitar el funcionamiento de cualquier software, hardware, telecomunicaciones, redes, servidores u otros equipos.\n</p><p class=\"col-md-offset-1\"><strong>3.6.7.-</strong>\n No deberá publicar contenido que esté relacionado con el envío de correo electrónico no deseado o “spam”.</p><p \nclass=\"col-md-offset-1\"><strong>3.6.8.-</strong>\n Su conducta deberá cumplir con todas las leyes Federales y Locales dentro de la República Mexicana. Si usted reside fuera de este país, deberá de cumplir con todas las leyes dentro de su lugar de residencia.\n</p><p class=\"col-md-offset-1\"><strong>3.6.9.-</strong>\n No deberá eliminar ni modificar contenido que se encuentre publicado en EL PORTAL y/o LA APLICACIÓN ni en las páginas de Internet o plataformas de terceros cuyos servicios son ofrecidos a través de EL PORTAL y/o LA APLICACIÓN. Se exceptúa el contenido que sea propio del Usuario.\n</p><p class=\"col-md-offset-1\"><strong>3.6.10.-</strong>\n No deberá de registrarse a ninguno de los servicios, plataformas, páginas de Internet ni APP usando nombres falsos ni brindando información falsa.\n</p><p class=\"col-md-offset-1\"><strong>3.6.11.-</strong> No deberá violentar el derecho a la privacidad de otros.</p><p\n class=\"col-md-offset-1\"><strong>3.6.12.-</strong>\n No deberá de publicar ningún dato de contacto o bancario, ya sean propios o de terceros, como por ejemplo: direcciones, códigos postales, número de teléfono, correos electrónicos, URL, datos de tarjetas de crédito/débito o bancarios, etc. Si el Usuario decide revelar ese tipo de información, es bajo su propia responsabilidad.\n</p><p><strong>3.7.-</strong> Aún y cuando <strong>BUSOLINEA</strong>\n prohíbe las conductas antes mencionadas, el Usuario reconoce que puede estar expuesto a dichas conductas y contenido, por lo que, el uso de EL PORTAL y/o LA APLICACIÓN o de los servicios ofrecidos a través de EL PORTAL y/o LA APLICACIÓN es bajo su propio riesgo y responsabilidad, liberando a \n<strong>BUSOLINEA</strong> de todo tipo de responsabilidad.</p><p><strong>3.8.-</strong> Los servicios que ofrece \n<strong>BUSOLINEA</strong>\n , sólo pueden ser utilizados por mayores de edad, según las leyes aplicables en la República Mexicana.</p><p><strong>\n3.9.-</strong> El Usuario deberá contar con un correo electrónico activo y en funcionamiento para que <strong>BUSOLINEA\n</strong> pueda realizar la entrega de los productos y/o servicios solicitados a <strong>BUSOLINEA</strong>\n a través de EL PORTAL y/o LA APLICACIÓN.</p><p><strong>3.10.-</strong> El Usuario manifiesta que se obliga frente a \n<strong>BUSOLINEA</strong>\n y a terceros, a compartir información veraz, correcta, completa, actualizada, sin errores y respecto de la cual se encuentra autorizado a compartirla, ya que la misma es necesaria para la prestación de los servicios provistos por \n<strong>BUSOLINEA</strong> . En todo momento el Usuario cuenta con las herramientas que <strong>BUSOLINEA</strong>\n pone a su disposición para actualizar, modificar y/o rectificar sus datos personales que hayan sido entregados a \n<strong>BUSOLINEA</strong> .</p><p><strong>3.11.-</strong>\n El Usuario, al solicitar los productos y/o servicios ofrecidos por <strong>BUSOLINEA</strong>\n , acepta someterse a los términos y condiciones de uso de los respectivos proveedores, quienes son los responsables por la calidad, seguridad e integridad de los productos y/o servicios entregados.\n</p><p><strong>3.12.-</strong>\n Adicionalmente, el Usuario se obliga a utilizar los servicios ofrecidos a través de EL PORTAL y/o LA APLICACIÓN, como la compra de boletos de autobuses, para su uso exclusivo, estándole prohibido realizar la reventa de los mismos.\n</p><h2>4.- Información contenida en EL PORTAL y/o LA APLICACIÓN</h2><p><strong>4.1.-</strong>\n El Usuario reconoce y acepta que la información publicada o contenida en EL PORTAL y/o LA APLICACIÓN generada por \n<strong>BUSOLINEA</strong>\n , por los proveedores o por sus aliados comerciales, será claramente identificada de forma tal que se reconozca que la misma proviene de \n<strong>BUSOLINEA</strong> , de los proveedores o de los aliados comerciales.</p><p><strong>4.2.-</strong>\n Las informaciones, conceptos y opiniones publicadas en EL PORTAL y/o LA APLICACIÓN no necesariamente reflejan la posición de \n<strong>BUSOLINEA</strong>\n ni de sus empleados, oficiales, directores, accionistas, licenciatarios y concesionarios (en lo sucesivo los afiliados). Por esta razón, \n<strong>BUSOLINEA</strong>\n no se hace responsable por ninguna de las informaciones, opiniones y conceptos que se emitan en EL PORTAL y/o LA APLICACIÓN o de cualquier otro espacio o servicio que se preste a través del sitio. Asimismo, \n<strong>BUSOLINEA</strong>\n no se hace responsable de las consecuencias que se puedan derivar del uso de consejos, procedimientos, etc., en EL PORTAL y/o LA APLICACIÓN, en el entendido de que es bajo el propio riesgo y responsabilidad del Usuario el uso y seguimiento a dichos consejos, comentarios, procedimientos, tips, etc., que se den en los espacios referidos.\n</p><p><strong>4.3.-</strong> <strong>BUSOLINEA</strong>\n se reserva el derecho de bloquear el acceso o remover en forma parcial o total, toda información, comunicación o material que a su exclusivo juicio pueda resultar: (i) abusivo, difamatorio u obsceno, sexual, racial (ii) fraudulento, artificioso o engañoso, (iii) violatorio de derechos de autor, marcas o cualquier derecho de propiedad intelectual de un tercero, (iv) ofensivo o (v) de cualquier forma contravenga lo establecido en este contrato. Si el Usuario desea obtener mayor información de un tema en específico proveído por \n<strong>BUSOLINEA</strong>\n , los proveedores o los aliados comerciales, el Usuario deberá consultarlo directamente con cada uno de ellos, según corresponda y/o con un especialista en la materia.\n</p><p><strong>4.4.-</strong> El Usuario reconoce que <strong>BUSOLINEA</strong>\n no trata de controlar o censurar previamente el contenido disponible en el sitio. Por tal motivo, <strong>BUSOLINEA\n</strong> no asume ninguna responsabilidad por el contenido provisto al sitio por proveedores independientes ajenos a \n<strong>BUSOLINEA</strong> . <strong>BUSOLINEA</strong>\n no tiene el control editorial sobre el contenido y quedará exento de cualquier responsabilidad por información y/o material generado y/o provisto por terceros. Todas las opiniones, consejos, declaraciones, servicios, ofertas, u otras informaciones o contenidos expresados o puestos a disposición del público por terceros, pertenecen a su respectivo autor y \n<strong>BUSOLINEA</strong> no asume responsabilidad alguna frente a ello.</p><p><strong>4.5.-</strong> <strong>\nBUSOLINEA</strong>\n no garantiza la exactitud, veracidad, amplitud y/o utilidad de cualquier contenido provisto por tales terceros. Adicionalmente, \n<strong>BUSOLINEA</strong>\n no es responsable ni garantiza la exactitud, exhaustividad, veracidad y/o confiabilidad de cualquier opinión, información, consejo o declaración provistos por \n<strong>BUSOLINEA</strong> a través de EL PORTAL y/o LA APLICACIÓN. Bajo ninguna circunstancia <strong>BUSOLINEA\n</strong>\n será responsable de cualquier daño y/o perjuicio, directo o indirecto, causado en virtud de la confianza del Usuario en información obtenida a través de este EL PORTAL y/o LA APLICACIÓN. \n<strong>BUSOLINEA</strong>\n se reserva el derecho de suprimir o modificar el contenido de EL PORTAL y/o LA APLICACIÓN que, a exclusivo juicio de \n<strong>BUSOLINEA</strong> , no cumpla con los estándares de <strong>BUSOLINEA</strong>\n o que pudiera resultar contrario al ordenamiento jurídico vigente. <strong>BUSOLINEA</strong>\n no será responsable por cualquier falla o tardanza que se genere al eliminar tal material.</p><h2>5.- Contenido</h2>\n<p><strong>5.1.-</strong> <strong>BUSOLINEA</strong>\n , EL PORTAL y/o LA APLICACIÓN y sus logotipos y todo el material que aparece en EL PORTAL y/o LA APLICACIÓN, como marcas, nombres de dominio y/o nombres comerciales son propiedad de sus respectivos titulares y se encuentran protegidos por los tratados internacionales y leyes aplicables en materia de propiedad intelectual y derechos de autor.\n</p><p><strong>5.2.-</strong>\n Los derechos de autor sobre el contenido, organización, recopilación, compilación, información, logotipos, fotografías, imágenes, programas, aplicaciones, o en general cualquier información contenida o publicada en EL PORTAL y/o LA APLICACIÓN se encuentran debidamente protegidos a favor de \n<strong>BUSOLINEA</strong>\n , sus afiliados, proveedores y/o de sus respectivos propietarios, de conformidad con la legislación aplicable en materia de propiedad intelectual.\n</p><p><strong>5.3.-</strong>\n Se prohíbe expresamente al Usuario modificar, alterar o suprimir, ya sea en forma total o parcial, los avisos, marcas, nombres comerciales, señas, anuncios, logotipos o en general cualquier indicación que se refiera a la propiedad de información contenida en EL PORTAL y/o LA APLICACIÓN.\n</p><p><strong>5.4.-</strong>\n Asimismo, el Usuario será el único responsable del contenido que publique dentro de EL PORTAL y/o LA APLICACIÓN ya que declara ser el titular de los derechos patrimoniales de autor sobre el mismo o contar con la autorización de su legítimo titular para incluirlo dentro de EL PORTAL y/o LA APLICACIÓN. Por lo anterior, se compromete a sacar en paz y a salvo a \n<strong>BUSOLINEA</strong>\n de cualquier reclamación, queja, demanda o denuncia que cualquier tercero inicie en virtud de la originalidad o titularidad de dicho contenido.\n</p><p><strong>5.5.-</strong> Es política de <strong>BUSOLINEA</strong>\n actuar contra las violaciones que en materia de Propiedad Intelectual se pudieran generar u originar, según lo estipulado en la legislación aplicable y en otras leyes de propiedad intelectual aplicables, incluyendo la eliminación o el bloqueo del acceso a material que se encuentra sujeto a actividades que infrinjan el derecho de propiedad intelectual de terceros.\n</p><p><strong>5.6.-</strong>\n En el caso de que algún Usuario o un tercero consideren que cualquiera de los Contenidos que se encuentren o sean introducidos en EL PORTAL y/o LA APLICACIÓN y/o cualquiera de sus Servicios, violen sus derechos de propiedad intelectual, deberán enviar una notificación a \n<strong>BUSOLINEA</strong>\n , a la dirección de correo electrónico, que se menciona en el párrafo siguiente, en la que indiquen, cuando menos: (i) los datos personales verídicos (nombre, dirección, número de teléfono y dirección de correo electrónico del reclamante); (ii) la firma autógrafa o firma electrónica avanzada con los datos personales del titular de los derechos de propiedad intelectual; (iii) la indicación precisa y completa del (los) Contenido(s) protegido(s) mediante los derechos de propiedad intelectual supuestamente infringidos, así como de su localización en EL PORTAL y/o LA APLICACIÓN (iv) una declaración expresa y clara de que la introducción del (los) contenido(s) indicado(s) se ha realizado sin el consentimiento del titular de los derechos de propiedad intelectual supuestamente infringidos; (v) una declaración expresa, clara y bajo la responsabilidad del reclamante de que la información proporcionada en la notificación es exacta y de que la introducción del (los) contenido(s) constituye una violación de sus derechos de propiedad intelectual. Correo electrónico: \n<a href=\"mailto:aclaraciones@busolinea.com.mx\">aclaraciones@busolinea.com.mx</a></p><h2>\n6.- Políticas de entrega, medios de pago, cambio, devolución, cancelación y reembolso de productos y/o servicios</h2>\n<p><strong>6.1-.</strong> Políticas de entrega de los productos y/o servicios</p><p class=\"col-md-offset-1\"><strong>\n6.1.1.-</strong>\n Una vez que el Usuario haya confirmado la compra de los productos y/o servicios a través de EL PORTAL y/o LA APLICACIÓN, recibirá su confirmación de comprar al correo electrónico que haya registrado en el proceso de compra.\n</p><p class=\"col-md-offset-1\"><strong>6.1.2.-</strong> En el correo electrónico enviado por <strong>BUSOLINEA</strong>\n al Usuario recibirá como adjunto el o los boletos adquiridos a través de EL PORTAL y/o LA APLICACIÓN.</p><p \nclass=\"col-md-offset-1\"><strong>6.1.3.-</strong>\n El Usuario podrá imprimir el o los boletos adquiridos y mostrarlos impresos o a través de un dispositivo electrónico tales como, de manera enunciativa más no limitativa, teléfono inteligente (“Smartphone”), tabletas, laptops, \n<strong>\njunto con una identificación oficial vigente, ya que es un requisito para poder ingresar al autobús, por disposición del Gobierno Federal.\n</strong></p><p class=\"col-md-offset-1\"><strong>6.1.4.-</strong>\n En caso de que el Usuario no reciba un correo electrónico con los productos y/o servicios adquiridos, deberá ponerse en contacto con \n<strong>BUSOLINEA</strong> al correo electrónico <a href=\"mailto:soporte@busolinea.com.mx\">soporte@busolinea.com.mx</a>\n para informarle esta situación. <strong>BUSOLINEA</strong>\n se pondrá en contacto de manera inmediata con el Usuario, vía correo electrónico, para el reenvío de los productos y/o servicios adquiridos.\n</p><p><strong>6.2.-</strong> Medios de pago</p><p class=\"col-md-offset-1\"><strong>6.2.1.- BUSOLINEA</strong>\n pone a disposición del Usuario los siguientes medios de pago: tarjetas de crédito y/o débito VISA, MASTERCARD y AMERICAN EXPRESS.\n</p><p class=\"col-md-offset-1\"><strong>6.2.2.-</strong>\n Para realizar los pagos de los productos y/o servicios adquiridos a través de EL PORTAL y/o LA APLICACIÓN, <strong>\nBUSOLINEA</strong>\n utiliza los servicios ofrecidos por CONEKTA.IO cuya dirección electrónica es www.conekta.io/es. CONEKTA.IO es un procesador de pago electrónico para el procesamiento de pago realizado a través de Internet.\n</p><p class=\"col-md-offset-1\"><strong>6.2.3.-</strong>\n Para que el Usuario pueda obtener sus facturas electrónicas por los productos y/o servicios adquiridos a través de EL PORTAL y/o LA APLICACIÓN, podrá ingresar directamente a la dirección electrónica factura.estrellablanca.com.mx y registrar sus datos para realizar la descarga de las facturas electrónicas. \n<strong>BUSOLINEA</strong>\n le informa al Usuario que el tiempo para la emisión de las mencionadas facturas electrónicas es de 7-siete días naturales a partir de la compra de los productos y/o servicios.\n</p><p><strong>6.3.-</strong> Políticas de cambios de los productos y/o servicios y reembolso de los pagos realizados\n</p><p><strong>6.3.1.-</strong>\n En aquellos casos en los que el Usuario se haya equivocado al ingresar la fecha de viaje o el nombre del pasajero, o que por motivos personales o laborales no pueda viajar en la fecha en la que compró su boleto, podrá cambiar su boleto hasta 2-dos horas antes del vencimiento de la compra de dicho boleto, siguiendo el procedimiento que se describe a continuación:\n</p><p class=\"col-md-offset-1\"><strong>6.3.1.1.-</strong>\n El Usuario deberá realizar una nueva comprar con la ruta, horario y/o nombre del pasajero correctos, con la misma o diferente tarjeta de crédito y/o débito con la que se realizó la primera compra.\n</p><p class=\"col-md-offset-1\"><strong>6.3.1.2.-</strong>\n El Usuario deberá enviar un correo electrónico a la dirección <a href=\"mailto:soporte@busolinea.com.mx\">\nsoporte@busolinea.com.mx</a>\n con el número de comprobante de su nuevo boleto y el número de comprobante del boleto a cancelar.</p><p \nclass=\"col-md-offset-1\"><strong>6.3.1.3.-</strong>\n En dicho correo electrónico el Usuario deberá indicar el motivo por el cual se está solicitando el cambio de boleto adquirido.\n</p><p class=\"col-md-offset-1\"><strong>6.3.1.4.-</strong> <strong>BUSOLINEA</strong>\n realizará la confirmación de la cancelación y la devolución del boleto con la línea de autobús en la cual se haya realizado la primera compra.\n</p><p class=\"col-md-offset-1\"><strong>6.3.1.5.-</strong>\n El Usuario recibirá un correo electrónico con la confirmación de la cancelación y el comprobante de la devolución total de su boleto y/o boletos cancelados.\n</p><p><strong>6.3.2.- BUSOLINEA</strong>\n le informa al Usuario que realiza y tramita el reembolso de su pago inmediatamente aunque el Usuario visualizará dicha devolución en un plazo de 2-dos a 30-treinta días hábiles en su cuenta bancaria y/o estado de cuenta de su tarjeta de crédito y/o débito debido a que este proceso y plazos de devolución son ajenos a \n<strong>BUSOLINEA</strong>\n y dependen de cada institución bancaria; en consecuencia, con algunas instituciones bancarias los plazos mencionados pueden ser diferentes, siendo absoluta responsabilidad de la institución bancaria acreditar el reembolso en las cuentas bancarias y/o estados de cuenta de los Usuarios.\n</p><p><strong>6.3.3.-</strong> Adicionalmente, <strong>BUSOLINEA</strong>\n le informa al Usuario que en sus políticas de cambio no se encuentra permitido dejar abiertas las fechas de sus boletos ni tampoco se permite ceder los boletos adquiridos a terceras personas. Si el Usuario se encuentra en alguna de estas situaciones deberá proceder tal como se describe en el numeral 6.3.1. de los presentes términos y condiciones de uso.\n</p><p><strong>6.4.-</strong>\n Políticas de devoluciones y cancelaciones de los productos y/o servicios y reembolso de los pagos realizados</p><p>\n<strong>6.4.1.-</strong>\n El Usuario podrá cancelar los productos y/o servicios adquiridos a través de EL PORTAL y/o LA APLICACIÓN hasta 2-dos horas antes del vencimiento de la compra de dicho boleto, siguiendo el procedimiento que se describe a continuación:\n</p><p class=\"col-md-offset-1\"><strong>6.4.1.1.-</strong> Deberá enviar un correo electrónico a la dirección <a \nhref=\"mailto:soporte@busolinea.com.mx\">soporte@busolinea.com.mx</a>, adjuntando el boleto a cancelar.</p><p \nclass=\"col-md-offset-1\"><strong>6.4.1.2.-</strong>\n En dicho correo electrónico el Usuario deberá indicar el importe de compra, el Banco que le provee la tarjeta de crédito y/o débito con el que se realizó el pago de los productos y/o servicios adquiridos, los últimos cuatro dígitos de la tarjeta de crédito y/o débito con el que realizó su compra, y el motivo de la cancelación del boleto adquirido.\n</p><p class=\"col-md-offset-1\"><strong>6.4.1.3.-</strong> <strong>BUSOLINEA</strong>\n realizará la confirmación de la cancelación y la devolución del boleto con la línea de autobús en la cual se haya realizado la primera compra.\n</p><p class=\"col-md-offset-1\"><strong>6.4.1.4.-</strong>\n El Usuario recibirá un correo electrónico con la confirmación de la cancelación y el comprobante de la devolución total de su boleto y/o boletos cancelados.\n</p><p><strong>6.4.2.- BUSOLINEA</strong>\n le informa al Usuario que realiza y tramita el reembolso de su pago inmediatamente aunque el Usuario visualizará dicha devolución en un plazo de 2-dos a 30-treinta días hábiles en su cuenta bancaria y/o estado de cuenta de su tarjeta de crédito y/o débito debido a que este proceso y plazos de devolución son ajenos a \n<strong>BUSOLINEA</strong>\n y dependen de cada institución bancaria; en consecuencia, con algunas instituciones bancarias los plazos mencionados pueden ser diferentes, siendo absoluta responsabilidad de la institución bancaria acreditar el reembolso en las cuentas bancarias y/o estados de cuenta de los Usuarios.\n</p><p><strong>6.5.-</strong> Políticas de reembolso de los pagos realizados por causas no imputables al Usuario</p><p \nclass=\"col-md-offset-1\"><strong>6.5.1.-</strong>\n En aquellos casos en los que los boletos adquiridos por el Usuario no se puedan utilizar por causas imputables a \n<strong>BUSOLINEA</strong> a través de EL PORTAL y/o LA APLICACIÓN, <strong>BUSOLINEA</strong>\n procederá a realizar la cancelación de los boletos y el reembolso de los pagos realizados al Usuario. En estos casos, el Usuario deberá proceder conforme se describe en el apartado 6.4. de los presentes términos y condiciones de uso. Para estos casos no se aplicará la limitación de tiempo de las 2-dos horas antes del vencimiento de la compra de dicho boleto.\n</p><p class=\"col-md-offset-1\"><strong>6.5.2.-</strong>\n En aquellos casos en los que los boletos adquiridos por el Usuario no se puedan utilizar por causas imputables a las líneas de autobuses de terceros que brindan sus servicios a través de EL PORTAL y/o LA APLICACIÓN de \n<strong>BUSOLINEA</strong> , dichos reembolsos serán resueltos en cada caso concreto por <strong>BUSOLINEA</strong> .\n</p><h2>7.- Aviso de privacidad sobre el uso de información y base de datos</h2><p><strong>7.1.- BUSOLINEA</strong>\n , a través de EL PORTAL y/o LA APLICACIÓN puede obtener diversa información del Usuario que puede compilarse y fijarse en una base de datos para lo cual \n<strong>BUSOLINEA</strong>\n publica su “Aviso de Privacidad” en el sitio de EL PORTAL y/o LA APLICACIÓN, el cual se recomienda consultar en caso de dudas acerca del tratamiento de los datos personales por parte \n<strong>BUSOLINEA</strong> .</p><p><strong>7.2.-</strong> Si <strong>BUSOLINEA</strong>\n decide cambiar su Aviso de Privacidad, anunciará dichos cambios en EL PORTAL y/o LA APLICACIÓN, de manera que el Usuario siempre pueda saber qué información se recopila, cómo podría ser utilizada y si será revelada a alguien, así como para ejercer su derecho a la autodeterminación informativa.\n</p><h2>8.- Formatos y/o registros</h2><p><strong>8.1.-</strong>\n Para acceder a los servicios que se ofrecen en EL PORTAL y/o LA APLICACIÓN, será necesario que el Usuario proporcione a \n<strong>BUSOLINEA</strong> los datos que ésta requiera para la prestación de dichos servicios.</p><p><strong>8.2.-\n</strong>\n El Usuario reconoce que al proporcionar la información de carácter personal requerida en alguno de los servicios que se prestan en EL PORTAL y/o LA APLICACIÓN, otorga a \n<strong>BUSOLINEA</strong> la autorización señalada en el artículo 109 de la Ley Federal del Derecho de Autor.</p><p>\n<strong>8.3.-</strong>\n El Usuario acepta y reconoce que los datos que proporcione, serán los correctos y que, en caso de haber proporcionado información errónea, inapropiada o falsa a \n<strong>BUSOLINEA</strong>\n , que llevara al Usuario a hacerse de una cosa y/o a obtener un lucro indebido, estaría cometiendo una conducta ilegal, por lo que desde ahora \n<strong>BUSOLINEA</strong>\n se reserva el derecho de iniciar las acciones a que haya lugar ante las autoridades competentes.</p><p><strong>8.4.-\n</strong>\n En todos los casos, el Usuario responderá, bajo protesta de decir verdad, de la veracidad de la información proporcionada a \n<strong>BUSOLINEA</strong>\n , sacando a ésta en paz y a salvo, por cualquier información proporcionada por el Usuario de forma falsa o incorrecta, o bien, cuando no tenga derecho o legitimación para hacerlo.\n</p><p><strong>8.5.-</strong> Queda establecido que es decisión del Usuario, otorgar la información personal a <strong>\nBUSOLINEA</strong>\n . Por lo anterior, el Usuario es responsable de la veracidad y confiabilidad sobre dicha información. En caso de que el Usuario decida enviar Información Personal a través de los medios dispuestos para tal efecto, el Usuario, con base en lo establecido en el artículo 76 BIS de la Ley Federal de Protección al Consumidor, otorga su consentimiento expreso de manera electrónica, para que \n<strong>BUSOLINEA</strong>\n comparta su información con terceras personas. Asimismo, el Usuario declara que no se encuentra registrado en el Registro Público de Consumidores de la Procuraduría Federal del Consumidor, y en caso de encontrarse inscrito en el mismo, para efectos de los dispuesto en los artículos 16, 18 y 18bis de la Ley Federal de Protección al Consumidor, el Usuario, en este acto, otorga su consentimiento expreso y aceptación para recibir información con carácter o fines mercadotécnicos o publicitarios. Del mismo modo, el Usuario faculta a \n<strong>BUSOLINEA</strong>\n , de la forma más amplia que legalmente proceda, para utilizar la Información Personal para: (1) resolver controversias o disputas relacionadas con EL PORTAL y/o LA APLICACIÓN y violaciones al presente Convenio; (2) para posibilitar a \n<strong>BUSOLINEA</strong>\n que opere correctamente; y (3) en los casos que la ley así lo requiera. El Usuario faculta a <strong>BUSOLINEA\n</strong>\n , de la forma más amplia que legalmente proceda, así como a Proveedores y Asesores y demás terceros con quien contrate, a utilizar la Información Personal e Información Agregada del usuario (incluyendo, sin limitación alguna, información sobre el número de ocasiones que ha visto e/o ingresado a las ligas de otros sitios o páginas electrónicas a través de los anuncios y demás información que se publique en EL PORTAL y/o LA APLICACIÓN).\n</p><p><strong>8.6.-</strong>\n El Usuario es el único responsable de las actividades que se lleven a cabo dentro de EL PORTAL y/o LA APLICACIÓN. Si el Usuario encuentra cualquier uso no autorizado de sus datos de acceso a EL PORTAL y/o LA APLICACIÓN o cualquier otra violación a la seguridad, deberá de contactar a \n<strong>BUSOLINEA</strong>\n , en los datos de contacto que se ponen a su disposición en el punto 18.1. El Usuario es el único responsable de mantener la confidencialidad sobre sus datos de acceso a EL PORTAL y/o LA APLICACIÓN y por tanto será el único responsable sobre los daños y perjuicios que su mal uso pudieran causar.\n</p><h2>9.- Material publicitario y links</h2><p><strong>9.1.-</strong> El Usuario reconoce y acepta que <strong>\nBUSOLINEA</strong>\n es una organización independiente de terceros patrocinadores y anunciantes cuya información, imágenes, anuncios y demás material publicitario o promocional (el \"Material Publicitario\") pudiera estar publicado en EL PORTAL y/o en LA APLICACIÓN.\n</p><p><strong>9.2.-</strong>\n El Usuario reconoce y acepta que el Material Publicitario no forma parte del contenido principal que se publica en EL PORTAL y/o en LA APLICACIÓN. Asimismo, el Usuario reconoce y acepta en este acto, que el Material Publicitario se encuentra protegido por las leyes que en materia de propiedad intelectual e industrial resulten aplicables.\n</p><p><strong>9.3.-</strong>\n Los proveedores, usuarios u otros terceros, pueden incluir dentro de EL PORTAL y/o de LA APLICACIÓN links a otros sitios o páginas web. \n<strong>BUSOLINEA</strong>\n no tiene control alguno sobre el contenido de dichos sitios o páginas web, por lo que el Usuario reconoce que <strong>\nBUSOLINEA</strong>\n no tiene ninguna responsabilidad sobre la disponibilidad de Contenido en los mismos, así como del Contenido per se, ya sea material publicitario, productos, servicios. Por lo anterior, el Usuario acepta y reconoce que \n<strong>BUSOLINEA</strong>\n no tiene responsabilidad alguna por los daños y perjuicios que pudieran ser causados al Usuario, por cualquier tipo de ofrecimiento realizado en dichos sitios o páginas web.\n</p><p><strong>9.4.-</strong> Adicionalmente, <strong>BUSOLINEA</strong>\n le informa al Usuario que las redes sociales en la que participa <strong>BUSOLINEA</strong>\n serán utilizadas exclusivamente para brindar información y/o promociones de sus productos y/o servicios a los Usuarios. \n<strong>BUSOLINEA</strong>\n no realiza venta de sus productos y/o servicios a través de dichas redes sociales por lo que le recomienda al Usuario que no adquiera los productos y/o servicios a través de las mismas. En caso de que el Usuario adquiera los productos y/o servicios a través de las mencionadas redes sociales es bajo su exclusiva responsabilidad.\n</p><h2>10.- Copias de seguridad de la Información</h2><p><strong>10.1.- BUSOLINEA</strong>\n pondrá su mejor esfuerzo para prevenir cualquier pérdida de información, incluyendo la generación de copias de seguridad en forma diaria. Sin embargo, \n<strong>BUSOLINEA</strong>\n no puede garantizar que nunca ocurrirá ninguna pérdida de información y, por ende, es obligación del Usuario realizar copias de seguridad de su información.\n</p><h2>11.- Garantías y reconocimientos</h2><p><strong>11.1.-</strong>\n El Usuario está de acuerdo que el uso de EL PORTAL y/o de LA APLICACIÓN, se realiza bajo su propio riesgo, que los productos y/o servicios que se prestan y ofrecen en EL PORTAL y/o en LA APLICACIÓN, se prevén sobre una base \"tal cual\" y \"según sean disponibles\". \n<strong>BUSOLINEA</strong>\n no garantiza que EL PORTAL y/o LA APLICACIÓN, satisfaga al cien por ciento los requerimientos del Usuario, o que los servicios de EL PORTAL y/o de LA APLICACIÓN, se mantengan siempre ininterrumpidos, en tiempo, seguros o libres de errores.\n</p><p><strong>11.2.- BUSOLINEA</strong>\n no garantiza o avala en ninguna forma la veracidad, precisión, legalidad, moralidad o ninguna otra característica del contenido del material que se publique en EL PORTAL y/o en LA APLICACIÓN. \n<strong>BUSOLINEA</strong>\n se libera de cualquier responsabilidad y condiciones, tanto expresas como implícitas, en relación con los servicios e información contenida o disponible en o a través de EL PORTAL y/o de LA APLICACIÓN, incluyendo, sin limitación alguna:\n</p><p class=\"col-md-offset-1\"><strong>11.2.1.-</strong>\n La disponibilidad de uso de EL PORTAL y/o de LA APLICACIÓN, por motivo de problemas técnicos imputables a los sistemas de comunicación y transmisión de datos.\n</p><p class=\"col-md-offset-1\"><strong>11.2.2.-</strong>\n La ausencia de virus, errores, desactivadores o cualesquier otro material contaminante o con funciones destructivas en la información o programas disponibles en o a través de EL PORTAL y/o de LA APLICACIÓN, o en general, cualquier falla en EL PORTAL y/o en LA APLICACIÓN.\n</p><p class=\"col-md-offset-1\"><strong>11.2.3.-</strong> No obstante lo anterior, <strong>BUSOLINEA</strong>\n o sus proveedores podrán actualizar el contenido de EL PORTAL y/o de LA APLICACIÓN, constantemente, por lo que se pide al Usuario tomar en cuenta que alguna información publicitada o contenida en o a través de EL PORTAL y/o de LA APLICACIÓN puede haber quedado obsoleta y/o contener imprecisiones o errores tipográficos u ortográficos.\n</p><h2>12.- Limitaciones a la responsabilidad</h2><p><strong>12.1.-</strong>\n Hasta el máximo permitido por las leyes aplicables, <strong>BUSOLINEA</strong>\n no será responsable, en ningún caso, por daños directos, especiales, incidentales, indirectos, o consecuenciales que en cualquier forma se deriven o se relacionen, de manera enunciativa más no limitativa con:\n</p><p class=\"col-mf-offset-1\"><strong>12.1.1.-</strong>\n El uso o ejecución de EL PORTAL y/o de LA APLICACIÓN y/o con el retraso o falta de disponibilidad de uso de <strong>\nBUSOLINEA</strong> .</p><p class=\"col-mf-offset-1\"><strong>12.1.2.-</strong>\n La proveeduría de o falta de proveeduría de servicios, de cualesquier información o gráficos contenidos o publicados en o a través de EL PORTAL y/o de LA APLICACIÓN.\n</p><p class=\"col-mf-offset-1\"><strong>12.1.3.-</strong>\n De la actualización o falta de actualización de la información.</p><p class=\"col-mf-offset-1\"><strong>12.1.4.-\n</strong>\n Cualquier otro aspecto o característica de la información contenida o publicada en EL PORTAL y/o en LA APLICACIÓN o a través de las ligas que eventualmente se incluyan en el mismo.\n</p><p class=\"col-mf-offset-1\"><strong>12.1.5.-</strong> La proveeduría o falta de proveeduría de los demás servicios.\n</p><p><strong>12.2.- BUSOLINEA</strong>\n no será responsable en los supuestos enumerados previamente aún en los casos en que el Usuario hubiera notificado a \n<strong>BUSOLINEA</strong> acerca de la posibilidad de que se ocasionaran dichos daños.</p><p><strong>12.3.-</strong>\n Asimismo, <strong>BUSOLINEA</strong>\n tomará todas las precauciones necesarias e implementará las medida de seguridad físicas, técnicas y administrativas aunque no podrá garantizar al cien por ciento que EL PORTAL y/o en LA APLICACIÓN que se mantengan siempre ininterrumpidos, en tiempo, seguros o libres de errores.\n</p><h2>13.- Finalización del Contrato</h2><p><strong>13.1.-</strong> Sin perjuicio de lo expuesto, <strong>BUSOLINEA\n</strong>\n se reserva el derecho de dar por finalizado el Contrato y/o de suspender el Servicio y/o de negarle al Usuario el acceso a la Información, si el Usuario viola alguna de las disposiciones del Contrato; lo mismo aplica si el Usuario llegara a solicitarlo, siempre y cuando no tenga obligaciones pendientes por cumplir hacia \n<strong>BUSOLINEA</strong> .</p><p><strong>13.2.-</strong> Después de dicha terminación, <strong>BUSOLINEA</strong>\n no tendrá ninguna otra obligación de proporcionar los servicios al Usuario, ni de brindarle acceso a EL PORTAL y/o LA APLICACIÓN.\n</p><h2>14.- Modificaciones a EL PORTAL y/o a LA APLICACIÓN y al convenio</h2><p><strong>14.1.-</strong> <strong>\nBUSOLINEA</strong>\n podrá en cualquier momento y cuando lo considere conveniente, sin necesidad de aviso al Usuario, realizar correcciones, adiciones, mejoras o modificaciones al contenido, presentación, información, servicios, áreas, bases de datos y demás elementos de EL PORTAL y/o de LA APLICACIÓN sin que ello de lugar ni derecho a ninguna reclamación o indemnización, ni que lo mismo implique reconocimiento de responsabilidad alguna a favor del Usuario.\n</p><p><strong>14.2.-</strong> <strong>BUSOLINEA</strong>\n se reserva el derecho de modificar los términos y condiciones de éste Convenio en cualquier tiempo, siendo efectivas dichas modificaciones de forma inmediata:\n</p><p class=\"col-md-offset-1\"><strong>14.2.1.-</strong>\n Por la publicación en EL PORTAL y/o en LA APLICACIÓN del Convenio modificado;</p><p class=\"col-md-offset-1\"><strong>\n14.2.2.-</strong>\n Por la notificación al Usuario sobre dichas modificaciones. El Usuario está de acuerdo en revisar este Convenio periódicamente a fin de estar al tanto de dichas modificaciones. No obstante lo anterior, cada ocasión que el Usuario haga uso de EL PORTAL y/o de LA APLICACIÓN, se considerará como aceptación absoluta a las modificaciones del Convenio.\n</p><h2>15.- Excluyente de responsabilidad</h2><p><strong>15.1.-</strong>\n Adicionalmente a aquellas excluyentes que se describen en los presentes términos y condiciones, ocasionalmente \n<strong>BUSOLINEA</strong>\n podrá adicionar los términos y condiciones del presente Convenio con provisiones adicionales relativas a áreas específicas a nuevos servicios que se proporcionen en o a través de EL PORTAL y/o de LA APLICACIÓN (\"Términos Adicionales\"), los cuales serán publicados en las áreas específicas de nuevos servicios de EL PORTAL y/o de LA APLICACIÓN para su lectura y aceptación. El Usuario reconoce y acepta que dichos Términos Adicionales forman parte integrante del presente Convenio para todos los efectos legales a que haya lugar.\n</p><p><strong>15.2.- BUSOLINEA</strong>\n no tiene obligación de controlar y no controla la utilización que los Usuarios hacen de EL PORTAL y/o de LA APLICACIÓN, de los Servicios y de los Contenidos.\n</p><p><strong>15.3.-</strong> En particular, <strong>BUSOLINEA</strong>\n no garantiza que los Usuarios utilicen EL PORTAL y/o LA APLICACIÓN, los servicios y los contenidos de conformidad con estas Condiciones Generales y, en su caso, los Términos Adicionales aplicables, ni que lo hagan de forma diligente y prudente. \n<strong>BUSOLINEA</strong>\n tampoco tiene la obligación de verificar y no verifica la identidad de los Usuarios, ni la veracidad, vigencia, exhaustividad y/o autenticidad de los datos que los Usuarios proporcionan sobre sí mismos a otros Usuarios.\n</p><p><strong>15.4.- BUSOLINEA</strong>\n NO ASUME RESPONSABILIDAD ALGUNA POR LOS DAÑOS Y PERJUICIOS DE TODA NATURALEZA QUE PUDIERAN DERIVARSE DE LA UTILIZACIÓN DE LOS SERVICIOS Y DE LOS CONTENIDOS POR PARTE DE LOS USUARIOS O QUE PUEDAN DERIVARSE DE LA FALTA DE VERACIDAD, VIGENCIA, EXHAUSTIVIDAD Y/O AUTENTICIDAD DE LA INFORMACIÓN QUE LOS USUARIOS PROPORCIONAN A OTROS USUARIOS ACERCA DE SÍ MISMOS Y, EN PARTICULAR, AUNQUE NO DE FORMA EXCLUSIVA, POR LOS DAÑOS Y PERJUICIOS DE TODA NATURALEZA QUE PUEDAN DERIVARSE DE LA SUPLANTACIÓN DE LA PERSONALIDAD DE UN TERCERO EFECTUADA POR UN USUARIO EN CUALQUIER CLASE DE COMUNICACIÓN REALIZADA A TRAVÉS DE EL PORTAL y/o de LA APLICACIÓN.\n</p><h2>16.- Cesión de derechos</h2><p><strong>16.1.- BUSOLINEA</strong>\n podrá, en cualquier tiempo y cuando así lo estime conveniente, ceder total o parcialmente sus derechos y obligaciones derivados del presente Convenio. En virtud de dicha cesión, \n<strong>BUSOLINEA</strong>\n quedará liberada de cualquier obligación a favor del Usuario establecida en el presente Convenio.</p><h2>\n17.- Indemnización</h2><p><strong>17.1.-</strong> El Usuario está de acuerdo en indemnizar a <strong>BUSOLINEA</strong>\n , sus Afiliados, Proveedores, Vendedores y Asesores de cualquier acción, demanda o reclamación (incluso de honorarios de abogados y de costas judiciales) derivadas de cualesquier incumplimiento por parte del Usuario al presente Convenio, incluyendo, sin limitación de alguna de las derivadas:\n</p><p class=\"col-md-offset-1\"><strong>17.1.1.-</strong>\n De cualquier aspecto relativo al uso de EL PORTAL y/o de LA APLICACIÓN;</p><p class=\"col-md-offset-1\"><strong>17.1.2.-\n</strong> De la información contenida o disponible en o a través de EL PORTAL y/o de LA APLICACIÓN;</p><p \nclass=\"col-md-offset-1\"><strong>17.1.3.-</strong>\n De injurias, difamación o cualesquier otra conducta violatoria del presente convenio por parte del usuario en el uso de EL PORTAL y/o de LA APLICACIÓN;\n</p><p class=\"col-md-offset-1\"><strong>17.1.4.-</strong>\n De violación a las leyes aplicables o tratados internacionales relativos a los derechos de autor o propiedad intelectual, contenidos o disponibles en, o a través de EL PORTAL y/o de LA APLICACIÓN.\n</p><h2>18.- Notificaciones distintas a derechos de autor</h2><p><strong>18.1.-</strong>\n Cualquier notificación que el Usuario desee enviar a <strong>BUSOLINEA</strong>\n en virtud del presente Contrato, deberá ser enviada vía correo electrónico a <a href=\"mailto:legal@busolinea.com.mx\">\nlegal@busolinea.com.mx</a>.</p><h2>19.- Subsistencia</h2><p><strong>19.1.-</strong>\n Estos términos y condiciones, así como los Términos Adicionales constituyen el acuerdo íntegro entre las partes, y sustituye cualquier otro acuerdo o convenio celebrado con anterioridad. Cualesquier cláusula o provisión del presente Convenio así como de los Términos Adicionales, legalmente declarada inválida, será eliminada o modificada, a elección de \n<strong>BUSOLINEA</strong>\n , a fin de corregir su vicio o defecto. Sin embargo, el resto de las cláusulas o provisiones mantendrán su fuerza, obligatoriedad y validez.\n</p><h2>20.- No renuncia de derechos</h2><p><strong>20.1.-</strong> La inactividad por parte de <strong>BUSOLINEA\n</strong>\n , sus Afiliados o Proveedores al ejercicio de cualquier derecho o acción derivados del presente Convenio, en ningún momento deberá interpretarse como renuncia a dichos derechos o acciones.\n</p><h2>21.- Legislación aplicable y jurisdicción</h2><p><strong>21.1.-</strong>\n Los presentes términos y condiciones de uso serán aplicables a los Usuarios que se encuentren tanto dentro del territorio de los Estados Unidos Mexicanos como fuera de él y que realicen sus compras de boletos de autobuses a través de EL PORTAL y/o de LA APLICACIÓN, sometiéndose tanto a la mediación descrita en el apartado 21.2 como a la jurisdicción de los Tribunales de la Ciudad de México, antes Distrito Federal, México y a la legislación mexicana aplicable.\n</p><p><strong>21.2.-</strong>\n En caso de que se presente una controversia que se derive del presente contrato o se relacione con él, las partes se obligan a tratar de llegar a una transacción amistosa de esa controversia mediante la mediación; ésta tendrá lugar de conformidad con el Reglamento de Mediación de la Cámara Nacional de Comercio de la Ciudad de México, vigente al momento del inicio de la mediación. De no ser así, las partes podrán acudir ante los Tribunales de la Ciudad de México, antes Distrito Federal, México, renunciando a cualquier otro fuero que pudiera corresponderls, quedando este Convenio a la interpretación de acuerdo con las leyes de la República Mexicana.\n</p><p class=\"text-right\"><strong>[Fecha de última actualización 25 de mayo de 2017]</strong></p></div></div>");
$templateCache.put("app/views/transportamex/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"row\" layout-align=\"center center\"><img \nng-src=\"/assets/transportamex/images/backgrounds/404.jpg\"></div>");
$templateCache.put("app/views/transportamex/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" \ntranslate=\"ERROR500.MESSAGE\">Well, you broke the internet!</div><div class=\"sub-message\" \ntranslate=\"ERROR500.SUBMESSAGE\">Just kidding, looks like we have an internal issue, please try again in couple minutes\n</div><a class=\"report-link md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\">Report this problem</a></div></div>");
$templateCache.put("app/views/transportamex/pages/errors/503/error-503.html","<div id=\"error-503\" layout=\"row\" layout-align=\"center center\"><img \nng-src=\"https://s3.amazonaws.com/busolinea-pro/maintenance/maintenance-busolinea.jpg\"></div>");
$templateCache.put("app/views/transportamex/pages/home/home-search-box/home-search-box.html","<div id=\"home_search\" layout=\"row\" flex=\"auto\"><form name=\"SearchForm\" layout-sm=\"column\" layout-gt-sm=\"row\" \nflex=\"100\" layout-align-gt-sm=\"space-around center\" layout-align-sm=\"space-around none\" layout-padding><div \nid=\"origin\" flex-gt-sm=\"grow\" flex-sm=\"initial\"><div class=\"input-field\" scroll-to=\"#origin\"><md-autocomplete \nmd-no-cache md-select-on-match md-match-case-insensitive md-selected-item=\"selectedItem\" md-search-text=\"searchText\" \nmd-selected-item-change=\"originCityChange(item)\" md-items=\"item in querySearchOrigin(searchText)\" \nmd-item-text=\"item.name\" md-min-length=\"0\" ng-disabled=\"isDisabledOrigin\" \nplaceholder=\"{{ \'HOME.SEARCH.ORIGIN\' | translate }}\" md-dropdown-position=\"bottom\" md-input-id=\"departure_city\">\n<md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template>\n<md-not-found>{{ \'HOME.SEARCH.NOT_FOUND\' | translate }}</md-not-found></md-autocomplete></div></div><div \nflex-gt-sm=\"grow\" flex-sm=\"initial\"><div class=\"input-field\"><md-autocomplete md-no-cache md-select-on-match \nmd-match-case-insensitive md-selected-item=\"selectedItem2\" md-search-text=\"searchText2\" \nmd-selected-item-change=\"destinationCityChange(item2)\" md-items=\"item2 in querySearchDestination(searchText2)\" \nmd-item-text=\"item2.name\" md-min-length=\"0\" ng-disabled=\"isDisabledDestination\" \nplaceholder=\"{{ \'HOME.SEARCH.DESTINATION\' | translate }}\" md-dropdown-position=\"bottom\" md-input-id=\"destination_city\">\n<md-item-template><span md-highlight-text=\"searchText2\" md-highlight-flags=\"^i\">{{item2.name}}</span>\n</md-item-template><md-not-found><span class=\"not-found-text\">{{ \'HOME.SEARCH.NOT_FOUND\' | translate }}</span>\n</md-not-found></md-autocomplete></div></div><div flex-gt-sm=\"grow\" flex-sm=\"initial\"><div class=\"input-field\">\n<md-datepicker id=\"route_departure_date\" name=\"route_departure_date\" ng-model=\"departureDate\" \nmd-min-date=\"departureMinDate\" ng-change=\"departureDateChange()\" \nmd-placeholder=\"{{ \'HOME.SEARCH.DEPARTURE\' | translate }}\" md-is-open=\"departureisOpen\"></md-datepicker><div \nclass=\"departure-date-overlay\" ng-click=\"handleCalendar(true, \'departure\', $event)\"></div></div></div><div \nflex-gt-sm=\"grow\" flex-sm=\"initial\"><div class=\"input-field\"><md-datepicker id=\"route_arrival_date\" \nid=\"route_arrival_date\" name=\"route_arrival_date\" ng-model=\"arrivalDate\" md-min-date=\"arrivalMinDate\" \nng-change=\"arrivalDateChange()\" md-placeholder=\"{{ \'HOME.SEARCH.RETURN\' | translate }}\" md-is-open=\"arrivalisOpen\">\n</md-datepicker><div class=\"arrival-date-overlay\" ng-click=\"handleCalendar(true, \'arrival\', $event)\"></div><md-icon \nng-if=\"arrivalDate != null\" md-font-icon=\"icon-close\" class=\"icon s24 close-arrival-date\" \nng-click=\"handleCalendar(false, \'arrival\', $event)\"></md-icon></div></div><div flex-gt-sm=\"initial\" flex-sm=\"auto\" \nclass=\"search-wrap\"><md-button id=\"search-btn\" class=\"md-primary\" type=\"button\" ng-click=\"loadResults()\" \naria-label=\"Search\" analytics-on analytics-category=\"home-search\" analytics-label=\"submit\"></md-button></div></form>\n</div>");
$templateCache.put("app/views/transportamex/pages/routes/filter-sidebar/filter-sidebar.html","<div id=\"filters\" layout=\"column\" flex=\"auto\" layout-align=\"start none\"><div class=\"filter hour\" flex=\"nogrow\"><header>\n<span translate=\"ROUTES.DEPARTURE\">SALIENDO</span><div>{{routes.origin.name}}</div></header><div class=\"hours\"><div \nclass=\"line\"><div class=\"midle-line\"></div><span id=\"from_hour\" class=\"hour left\">{{timeMin | clockString}} </span>\n<span id=\"to_hour\" class=\"hour right\">{{timeMax | clockString}}</span></div><div class=\"range-field\"><div range-slider \nmin=\"0\" max=\"24\" model-min=\"timeMin\" model-max=\"timeMax\" analytics-on analytics-category=\"results\" \nanalytics-label=\"horarios\" analytics-event=\"refinar\"></div></div><div class=\"clearfix\"></div></div></div><div \nclass=\"filter cabin_type\" flex=\"nogrow\"><h5 translate=\"ROUTES.CABIN_TYPE\">Tipo de cabina</h5><div class=\"check\" \nng-repeat=\"cabin in cabinTypesRoute\"><input class=\"filled-in\" type=\"checkbox\" id=\"cabin_type_{{cabin.id}}\" \nname=\"cabin_type\" ng-model=\"cabin.check\" analytics-on analytics-category=\"results\" analytics-label=\"tipo de cabina\" \nanalytics-event=\"refinar\"><label class=\"css-label lrg.web-two-style\" for=\"cabin_type_{{cabin.id}}\">{{cabin.name}}\n</label></div></div><div class=\"filter local_paso\" flex=\"nogrow\"><h5 translate=\"ROUTES.LOCAL_PASO\">Local / Paso</h5>\n<div class=\"check\" ng-repeat=\"localpaso in localpasoRoute\"><input class=\"filled-in\" type=\"checkbox\" \nid=\"local_paso_{{localpaso.id}}\" name=\"local_paso\" ng-model=\"localpaso.check\" analytics-on \nanalytics-category=\"results\" analytics-label=\"local-paso\" analytics-event=\"refinar\"><label \nclass=\"css-label lrg.web-two-style\" for=\"local_paso_{{localpaso.id}}\">{{localpaso.name}}</label></div></div><div \nclass=\"filter companies\" flex=\"nogrow\"><h5 translate=\"ROUTES.BUS_COMPANIES\">Empresas de Autobuses</h5><div \nclass=\"clearfix\"><div class=\"check\" ng-repeat=\"bus1 in busCompaniesOutboundRoute\" ng-if=\"$root.returnTicket==false\">\n<input type=\"checkbox\" id=\"bus_{{bus1.id}}\" name=\"company\" rel=\"{{bus1.name}}\" class=\"filled-in\" ng-model=\"bus1.check\" \nanalytics-on analytics-category=\"results\" analytics-label=\"linea\" analytics-event=\"refinar\"><label \nclass=\"css-label lrg web-two-style\" for=\"bus_{{bus1.id}}\">{{bus1.name}}</label></div><div class=\"check\" \nng-repeat=\"bus2 in busCompaniesReturnRoute\" ng-if=\"$root.returnTicket\"><input type=\"checkbox\" id=\"bus_{{bus2.id}}\" \nname=\"company\" rel=\"{{bus2.name}}\" class=\"filled-in\" ng-model=\"bus2.check\" analytics-on analytics-category=\"results\" \nanalytics-label=\"linea\" analytics-event=\"refinar\"><label class=\"css-label lrg web-two-style\" for=\"bus_{{bus2.id}}\">\n{{bus2.name}}</label></div></div></div></div>");
$templateCache.put("app/views/transportamex/pages/routes/route-selection/route.html","<div class=\"result\" layout=\"column\" layout-align=\"start none\" flex><span ng-if=\"route.has_discount\" \nclass=\"discount_stamp\" layout=\"row\" layout-align=\"center-center\">-{{ route.discount }}%</span><div class=\"top_info\" \nlayout=\"column\" layout-align=\"start none\" flex><div class=\"logo_buttons\" layout=\"row\" \nlayout-align=\"space-between center\" layout-padding flex><div flex=\"40\"><img ng-src=\"{{route.company.logo_url}}\" \nalt=\"{{route.company.name}}\" class=\"logo\" ng-click=\"\"></div><div class=\"price_but_buttons\" flex=\"initial\"><p \nclass=\"included\" ng-if=\"route.has_discount\" translate=\"ROUTES.DISCOUNT\">Descuento ya incluido en el precio.</p><div \nlayout=\"row\" layout-align=\"end-center\"><div class=\"price_info\">${{route.price | formatPrice:2:\',\':\'.\':false }}</div>\n<button class=\"buy-btn\" data-id=\"{{route.id}}\" data-orinfo=\"{{route.orinfo}}\" ng-if=\"route.can_sell\" \nng-click=\"selectRoute($event, false)\" analytics-on analytics-category=\"results\" analytics-event=\"confirmar\" \ntranslate=\"ROUTES.CHOOSE\">ELEGIR</button> <button class=\"buy-btn\" data-id=\"{{route.id}}\" \ndata-orinfo=\"{{route.orinfo}}\" ng-if=\"!route.can_sell\" ng-click=\"selectRoute($event, true)\" analytics-on \nanalytics-category=\"results\" analytics-event=\"compra en central\" translate=\"ROUTES.CENTRAL\">Compra en central</button>\n</div></div></div><div class=\"departure_info\" layout=\"row\" flex layout-padding><div flex=\"50\"><div \nclass=\"departure_time\"><label translate=\"ROUTES.DEPARTURE_TIME\">SALIDA</label><span class=\"time\">\n{{route.departure_time_ampm}}</span></div><h4 class=\"name\">{{route.origin_name}}</h4></div><div \nclass=\"right_departure\" flex=\"50\"><div class=\"departure_time\"><label translate=\"ROUTES.ARRIVAL_TIME\">LLEGADA</label>\n<span class=\"time\">{{route.arrival_time_ampm}}</span></div><h4 class=\"name\">{{route.destination_name}}</h4></div></div>\n</div><div class=\"service-btn\" layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-between none\" flex=\"initial\"><div\n hide-xs hide-sm show-gt-sm class=\"details-btn\" layout=\"row\" layout-align=\"center center\" flex=\"initial\" \nng-click=\"toggleServices[$index]=!toggleServices[$index]\" analytics-on=\"click\" analytics-category=\"results\" \nanalytics-event=\"services\"><span>{{route.cabin_type_ws}}</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s18\"></md-icon></div><div class=\"extra_info\" layout=\"row\" layout-align=\"center center\" flex=\"initial\" \nflex-gt-sm=\"grow\"><span><img class=\"icon\" ng-src=\"/assets/transportamex/images/icons/bus-gray.png\" alt=\"Bus gray\"> \n<span class=\"localpaso\" ng-if=\"route.local\" ng-click=\"showBusDialog()\" analytics-on analytics-category=\"results\" \nanalytics-event=\"click\" analytics-label=\"local\" translate=\"ROUTES.LOCAL\">LOCAL</span> <span class=\"localpaso\" \nng-if=\"!route.local\" ng-click=\"showBusDialog()\" analytics-on analytics-category=\"results\" analytics-event=\"click\" \nanalytics-label=\"paso\" translate=\"ROUTES.PASO\">PASO</span> </span><img class=\"icon\" \nsrc=\"/assets/transportamex/images/icons/clock.png\" alt=\"Clock\"><label hide-xs hide-sm hide-md \ntranslate=\"ROUTES.DURATION\">Duración:</label><span><strong>{{route.duration | formatDuration }}</strong></span> <img \nclass=\"icon\" src=\"/assets/transportamex/images/icons/seat.png\" alt=\"Seat\"><label hide-xs hide-sm hide-md \ntranslate=\"ROUTES.AVAILABILITY\">Disponibilidad:</label><span class=\"tooltip_seats\"><strong>{{route.seats_available}}\n</strong></span></div><div hide-gt-sm class=\"details-btn\" layout=\"row\" layout-align=\"center center\" flex=\"initial\" \nng-click=\"toggleServices[$index]=!toggleServices[$index]\" analytics-on analytics-category=\"results\" \nanalytics-event=\"services\"><span>{{route.cabin_type_ws}}</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s18\"></md-icon></div></div></div><div class=\"services linea panel-collapse\" layout=\"row\" flex=\"initial\" \nng-init=\"toggleServices[$index]=false\" ng-show=\"toggleServices[$index]\"><div class=\"panel-body\" layout=\"row\" \nlayout-align=\"start center\" flex layout-padding><div ng-repeat=\"service in route.services\" flex=\"initial\"><img \nng-src=\"/assets/transportamex/images/icons/services/{{service.param_name}}.png\" alt=\"{{service.param_name}}\"></div>\n</div></div>");
$templateCache.put("app/views/transportamex/pages/routes/route-selection/routes-list.html","<div class=\"sort\" layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start space-between\" \nlayout-align-gt-sm=\"start start\" flex=\"initial\"><div class=\"num_results\" layout=\"row\" layout-align=\"start center\" \nflex=\"50\"><label class=\"control-label\" flex=\"50\"><span>{{ RoutesFiltered.length }}</span> <span class=\"res\" \ntranslate=\"ROUTES.RESULTS\">Resultados</span></label><label class=\"filter_results-btn\" hide-gt-sm flex=\"50\" \nng-click=\"toggleSidebar(\'sidebar-right\')\" translate=\"ROUTES.FILTER\">Filtrar</label></div><div class=\"sorter\" \nlayout=\"row\" layout-align=\"space-between center\" flex=\"50\"><label class=\"control-label\" flex=\"initial\" flex-gt-sm=\"50\" \ntranslate=\"ROUTES.SORT\">ORDENAR POR:</label><div class=\"input-field margin-0\" flex=\"grow\" flex-gt-sm=\"50\"><md-select \nng-model=\"sortItem\" md-selected-text=\"\'ROUTES.SORTS.\' + sortItem.id | translate\" aria-label=\"Ordenar por\"><md-option \nng-value=\"sort\" ng-repeat=\"sort in sortItems\" analytics-on analytics-category=\"results\" \nanalytics-label=\"{{sort.name}}\" analytics-event=\"ordenar\" translate=\"ROUTES.SORTS.{{sort.id}}\">{{ sort.name }}\n</md-option></md-select></div></div></div><h1 translate=\"{{ labelTranslate }}\">Elige corrida</h1><div \nid=\"route-{{$index}}\" class=\"result_wrapper\" \nng-repeat=\"route in RoutesFiltered = (routes | cabinType: cabinTypes | localPaso: localpaso | busCompany: busCompanies | timeRangeSlider: timeMin:timeMax | orinfo: orinfoServer | orderBy: sortItem.id)\" \nlayout=\"column\" layout-align=\"start none\" flex=\"initial\"><route data-route=\"route\"></route></div>");
$templateCache.put("app/views/transportamex/pages/routes/toasts/recent-toast.html","<md-toast id=\"toast\" class=\"recent-toast\" layout=\"column\" layout-align=\"center start\"><div class=\"md-toast-content\" \nlayout=\"row\" layout-align=\"space-around none\" layout-padding><img \nng-src=\"/assets/transportamex/images/icons/notification1.png\" flex=\"initial\"><span flex=\"grow\"><strong>\n{{ vm.toastMessage1 }}</strong></span></div></md-toast>");
$templateCache.put("app/views/transportamex/pages/routes/toasts/route-toast.html","<md-toast id=\"toast\" class=\"route-toast\" layout=\"column\" layout-align=\"center start\"><div class=\"md-toast-content\" \nlayout=\"row\" layout-align=\"space-around none\" layout-padding><img \nng-src=\"/assets/transportamex/images/icons/notification2.png\" width=\"70\" flex=\"initial\"><span flex=\"grow\"><strong>\n{{ vm.toastMessage2 }}</strong></span></div></md-toast>");
$templateCache.put("app/views/transportamex/pages/seats/seat-selection/seat-form.html","<div class=\"seat-form\"><button class=\"remove\" data-ng-click=\"this.onSeatRemove({seat: seat})\" analytics-on \nanalytics-category=\"seats\" analytics-event=\"unselect\" analytics-label=\"{{seat.number}}\"><img \nsrc=\"/assets/transportamex/images/icons/cancel.png\" alt=\"Cancel\"></button><div layout=\"row\" class=\"padding-bottom-10\" \nlayout-align=\"start center\"><seat data-state=\"seat.type\" flex=\"initial\"></seat><span class=\"seat-form-label\" flex>\n{{ \'SEATS.FORM.SEAT\' | translate }} {{seat.number}}</span></div><div class=\"input-group\"><input class=\"passenger-name\" \nname=\"passenger-name\" type=\"text\" placeholder=\"{{ \'SEATS.FORM.FULL_NAME\' | translate }}\" autocomplete=\"off\" \ndata-ng-model=\"seat.name\" data-ng-keyup=\"this.update(seat)\" ng-pattern=\"/^[a-zA-Z\\u00C0-\\u024F ]*$/\" \nvalid-passenger-name analytics-on=\"blur\" analytics-category=\"seats\" analytics-event=\"nombre-ok\"><label class=\"label\" \nfor=\"passenger-name\">{{ \'SEATS.FORM.PASSENGER_NAME\' | translate }}</label></div><div class=\"input-group\"><label \nfor=\"ticket-type\"><strong>{{ \'SEATS.FORM.INSTRUCTIONS\' | translate }}:</strong></label><seat-type-selector \ndata-ticket-type=\"seat.ticket_type\" data-prices=\"seat.prices || []\" data-on-update-seat=\"this.update(seat)\" \nanalytics-on=\"click\" analytics-category=\"seats\" analytics-event=\"seat.ticket_type\"></seat-type-selector></div><hr>\n</div>");
$templateCache.put("app/views/transportamex/pages/seats/seat-selection/seat-selection.html","<section class=\"wrapper\" layout-sm=\"column\" layout-gt-sm=\"row\" layout-align=\"space-between start\" flex=\"initial\"><div \nclass=\"seats-selection\" flex-gt-sm=\"65\" flex=\"auto\" layout=\"column\" layout-align=\"start center\"><div \nclass=\"route-information\" flex=\"auto\"><h2 ng-if=\"!$root.returnTicket\">\n({{ \'SEATS.SELECTION.DEPARTURE\' | translate }}) {{ \'SEATS.SELECTION.SELECT\' | translate }}</h2><h2 \nng-if=\"$root.returnTicket\">({{ \'SEATS.SELECTION.RETURN\' | translate }}) {{ \'SEATS.SELECTION.SELECT\' | translate }}</h2>\n<img class=\"logo\" data-ng-src=\"{{ route.company.logo_url }}\"><div class=\"route\"><span class=\"label\" \nng-if=\"!$root.returnTicket\">{{ \'SEATS.SELECTION.DEPARTURE\' | translate }}:</span> <span class=\"label\" \nng-if=\"$root.returnTicket\">{{ \'SEATS.SELECTION.RETURN\' | translate }}:</span> <span class=\"location\">\n{{route.origin_name}}</span> <i class=\"to\"></i> <span class=\"location\">{{route.destination_name}}</span></div><div \nclass=\"date\"><div class=\"segment\"><span class=\"label\">{{ \'SEATS.SELECTION.DAY\' | translate }}:</span> <strong>\n{{route.departure_date | date:\'dd MMM\'}}</strong></div><div class=\"segment\"><span class=\"label\">\n{{ \'SEATS.SELECTION.HOUR\' | translate }}:</span> <strong>{{route.departure_time_ampm}}</strong></div><div \nclass=\"segment service-item\"><span class=\"local\" ng-if=\"route.local\">● LOCAL</span> <span class=\"paso\" \nng-if=\"!route.local\">● PASO</span></div></div></div><div class=\"line\" flex=\"auto\"></div><div \nclass=\"btn-group floorSwitch\" role=\"group\" aria-label=\"switch floor\" ng-if=\"this.seats.length > 1\"><button \nclass=\"btn btn-default\" ng-click=\"changeDownFloor()\" ng-class=\"{\'active\':vista==\'lowLevel\'}\" \ntranslate=\"SEATS.GROUND_FLOOR\">PLANTA BAJA</button> <button type=\"button\" ng-click=\"changeFirstFloor()\" \nclass=\"btn btn-default\" ng-class=\"{\'active\':vista==\'firstFloor\'}\" translate=\"SEATS.FIRST_FLOOR\">PRIMER PISO</button>\n</div><div class=\"bus-layout\" flex=\"auto\" ng-class=\"{\'twoFloor\':this.seats.length > 1}\"><div \nng-if=\"this.seats.length == 1\"><div class=\"driver\"></div><div class=\"seat-selection-container\" layout=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start none\"><div class=\"seats-row\" data-ng-repeat=\"(key, row) in this.seats[0]\" \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start none\" flex=\"initial\" flex-order-gt-sm=\"{{5+(key*-1)}}\"><seat \nflex=\"initial\" data-ng-repeat=\"seat in row\" data-ng-click=\"this.seatClick(seat)\" data-number=\"seat.number\" \ndata-state=\"seat.type\" data-is-loading=\"seat.isLoading\" data-is-selected=\"seat.isSelected\"></seat></div></div></div>\n<div ng-if=\"this.seats.length > 1\" class=\"{{vista}}\"><div class=\"driver\" ng-if=\"vista == \'lowLevel\'\"></div><div \nclass=\"seat-selection-container lowLevelContainer\" layout=\"row\" layout-gt-sm=\"column\" layout-align=\"start none\"><div \nng-if=\"vista == \'lowLevel\'\" class=\"seats-row\" ng-repeat=\"(key, row) in this.seats[0] track by $index\" layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start none\" flex=\"initial\" flex-order-gt-sm=\"{{5+(key*-1)}}\"><seat flex=\"initial\" \ndata-ng-repeat=\"seat in row\" data-ng-click=\"this.seatClick(seat)\" data-number=\"seat.number\" data-state=\"seat.type\" \ndata-is-loading=\"seat.isLoading\" data-is-selected=\"seat.isSelected\"></seat></div><div class=\"clearfix\"></div><div \nng-if=\"vista == \'firstFloor\'\" class=\"seats-row\" ng-repeat=\"(key, row) in this.seats[1] track by $index\" \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start none\" flex=\"initial\" flex-order-gt-sm=\"{{5+(key*-1)}}\"><seat \nflex=\"initial\" data-ng-repeat=\"seat in row\" data-ng-click=\"this.seatClick(seat)\" data-number=\"seat.number\" \ndata-state=\"seat.type\" data-is-loading=\"seat.isLoading\" data-is-selected=\"seat.isSelected\"></seat></div></div></div>\n</div><div class=\"seats-legend\" flex-auto><ul layout-xs=\"column\" layout-gt-xs=\"row\" layout-align=\"start center\"><li \nflex-xs=\"100\" flex-gt-xs=\"initial\"><seat data-state=\"selected\"></seat><span class=\"description\">\n{{ \'SEATS.LABELS.selected\' | translate }}</span></li><li data-ng-repeat=\"type in this.types\" \ndata-ng-if=\"type !== \'space\'\" flex-xs=\"100\" flex-gt-xs=\"initial\"><seat data-state=\"type\"></seat><span \nclass=\"description\">{{ \'SEATS.LABELS.\' + type | translate }}</span></li></ul></div></div><div class=\"seats-data-bar\" \nlayout=\"column\" flex-gt-sm=\"30\" flex=\"auto\" flex-offset-gt-sm=\"5\"><div class=\"seats-information\" flex=\"initial\"><div \nlayout=\"row\" layout-align=\"space-between start\"><h2 class=\"margin-0\" ng-if=\"!$root.returnTicket\" flex>\n{{ \'SEATS.SELECTION.DEPARTURE\' | translate }}:</h2><h2 class=\"margin-0\" ng-if=\"$root.returnTicket\" flex>\n{{ \'SEATS.SELECTION.RETURN\' | translate }}:</h2><div class=\"total\" flex-grow>Total <span class=\"price\">\n{{this.totalPrice | money}}</span></div></div><ul><li data-ng-repeat=\"seat in this.selectedSeats\"><seat-form \ndata-seat=\"seat\" data-on-seat-update=\"this.onSeatUpdate({seat:seat})\" \ndata-on-seat-remove=\"this.onSeatRemove({seat:seat})\"></seat-form></li></ul><div class=\"no-seats-selected\" \ndata-ng-show=\"!this.selectedSeats.length\"><div class=\"select-icon\"></div><strong>\n{{ \'SEATS.SELECTION.INSTRUCTIONS\' | translate }}</strong></div></div><div class=\"buttons\" flex=\"initial\"><md-button \nclass=\"md-button md-primary btn-default btn margin-0\" type=\"button\" disabled=\"disabled\" analytics-on \nanalytics-category=\"seats\" analytics-event=\"confirmar\" data-ng-click=\"this.continue()\">\n{{ \'SEATS.FORM.CONTINUE\' | translate }}</md-button></div></div></section>");
$templateCache.put("app/views/transportamex/pages/seats/seat-selection/seat-type-selector.html","<div class=\"seat-type-selector\"><label class=\"seat-type-selector-option\"><input type=\"radio\" \ndata-ng-model=\"this.ticketType\" data-ng-change=\"this.onUpdateSeat(seat)\" value=\"ad\"><div class=\"display\"><svg \nwidth=\"10px\" height=\"30px\" viewBox=\"37 6 10 30\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" \nxmlns:xlink=\"http://www.w3.org/1999/xlink\"><desc>Created with Sketch.</desc><defs></defs><g id=\"Icon-/-Adult\" \nstroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(37.000000, 6.000000)\"><path \nd=\"M4.86607143,8.13636364 C2.72321429,8.13636364 0.9375,6.36363636 0.9375,4.13636364 C0.9375,1.95454545 2.67857143,0.136363636 4.86607143,0.136363636 C7.05357143,0.136363636 8.79464286,1.90909091 8.79464286,4.13636364 C8.79464286,6.31818182 7.05357143,8.13636364 4.86607143,8.13636364 Z M4.86607143,1.68181818 C3.52678571,1.68181818 2.45535714,2.77272727 2.45535714,4.13636364 C2.45535714,5.5 3.52678571,6.59090909 4.86607143,6.59090909 C6.20535714,6.59090909 7.27678571,5.5 7.27678571,4.13636364 C7.27678571,2.77272727 6.20535714,1.68181818 4.86607143,1.68181818 Z\" \nid=\"Shape\" fill=\"#FFFFFF\"></path><path \nd=\"M9.86607143,18.0019342 L9.86607143,19.3636364 C9.86607143,19.5909091 9.77678571,19.8181818 9.59821429,19.9545455 L8.34821429,21.0454545 L8.34821429,28.9090909 C8.34821429,29.3636364 8.03571429,29.7272727 7.58928571,29.7272727 L2.58928571,29.7272727 C2.1875,29.7272727 1.83035714,29.3636364 1.83035714,28.9545455 L1.83035714,21.0909091 L0.580357143,20 C0.401785714,19.8636364 0.3125,19.6363636 0.3125,19.4090909 L0.3125,10.2727273 C0.3125,9.86363636 0.669642857,9.5 1.07142857,9.5 L9.10714286,9.5 C9.50892857,9.5 9.86607143,9.86363636 9.86607143,10.2727273 L9.86607143,12.3617021 L9.86607143,18.0019342 Z M8.34821429,12.3617021 L8.34821429,11.0454545 L1.83035714,11.0454545 L1.83035714,19.0454545 L3.08035714,20.1363636 C3.25892857,20.2727273 3.34821429,20.5 3.34821429,20.7272727 L3.34821429,28.1818182 L6.83035714,28.1818182 L6.83035714,20.7272727 C6.83035714,20.5 6.91964286,20.2727273 7.09821429,20.1363636 L8.34821429,19.0454545 C8.34821429,19.0454545 8.34821429,20.8220503 8.34821429,18.0019342 C8.34821429,15.1818182 8.34821429,12.3617021 8.34821429,12.3617021 Z\" \nid=\"Shape\" fill=\"#FFFFFF\"></path></g></svg><p>{{ \'SEATS.FORM.ADULT\' | translate }}</p><p class=\"price\">\n{{this.pricesByType[\'ad\'] || money}} MXN</p></div></label><label class=\"seat-type-selector-option\"><input type=\"radio\" \ndata-ng-model=\"this.ticketType\" data-ng-change=\"this.onUpdateSeat(seat)\" value=\"ni\"><div class=\"display\"><svg \nwidth=\"23px\" height=\"30px\" viewBox=\"31 7 23 30\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" \nxmlns:xlink=\"http://www.w3.org/1999/xlink\"><desc>Created with Sketch.</desc><defs></defs><g id=\"Icon-/-Child\" \nstroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(31.000000, 7.000000)\"><path \nd=\"M13.290736,25.3350536 C13.290736,24.0925284 12.2896235,23.0841021 11.0574391,23.0841021 C9.82465917,23.0841021 8.82414213,24.0925284 8.82414213,25.3350536 C8.82414213,26.5769785 9.82465917,27.586005 11.0574391,27.586005 C12.2896235,27.586005 13.290736,26.5769785 13.290736,25.3350536 Z M6.59084518,25.3350536 C6.59084518,22.8494029 8.5912837,20.8331506 11.0574391,20.8331506 C13.5229989,20.8331506 15.524033,22.8494029 15.524033,25.3350536 C15.524033,27.820104 13.5229989,29.8369565 11.0574391,29.8369565 C8.5912837,29.8369565 6.59084518,27.820104 6.59084518,25.3350536 Z M14.0929363,8.12757997 L8.02134632,8.12757997 L8.02134632,10.3785314 L14.0929363,10.3785314 L14.0929363,8.12757997 Z M5.75248073,15.6907769 L5.79340928,6.99670195 C5.79579146,6.3772401 6.29545443,5.87662849 6.91005776,5.87662849 L8.04516816,5.87662849 L8.02015523,5.75177572 L8.02015523,1.70006306 C8.02015523,1.07880045 8.52041375,0.574587319 9.13680371,0.574587319 C9.75259812,0.574587319 10.2534522,1.07880045 10.2534522,1.70006306 L10.2534522,5.75177572 L10.2278437,5.87662849 L11.8507062,5.87662849 L11.8256932,5.75177572 L11.8256932,1.70006306 C11.8256932,1.07880045 12.3259518,0.574587319 12.9423417,0.574587319 C13.5581361,0.574587319 14.0589902,1.07880045 14.0589902,1.70006306 L14.0589902,5.75177572 L14.0333817,5.87662849 L15.2048204,5.87662849 C15.8188282,5.87662849 16.3184912,6.3772401 16.3208734,6.99670195 L16.3613705,15.6907769 L20.095443,11.9397914 C20.5319781,11.5010059 21.2394866,11.5022064 21.674235,11.9421924 C22.1095791,12.3821784 22.108388,13.0952798 21.6718529,13.533465 L16.0457312,19.1860544 C15.3459648,19.8895518 14.1453443,19.3907409 14.1411755,18.3943197 L14.1411755,12.6294829 L7.97310711,12.6294829 L7.97310711,18.3943197 C7.97072492,19.0161826 7.46748868,19.5179947 6.85050317,19.5143932 C6.85050317,19.5143932 6.02720163,19.6746439 5.67824898,19.0344818 C5.32929633,18.3943197 0.295495752,13.5324402 0.295495752,13.5324402 C0.295495752,13.5324402 -0.440159879,12.6294829 0.410015667,11.9397914 C1.26019121,11.2500999 1.98421509,11.97404 2.45561839,12.4734698 C2.9270217,12.9728997 5.75248073,15.6907769 5.75248073,15.6907769 Z\" \nid=\"Combined-Shape\" fill=\"#878787\" \ntransform=\"translate(11.000000, 15.205772) scale(1, -1) translate(-11.000000, -15.205772) \"></path></g></svg><p>\n{{ \'SEATS.FORM.CHILD\' | translate }}</p><p class=\"price\">{{this.pricesByType[\'ni\'] || money}} MXN</p></div></label>\n<label class=\"seat-type-selector-option\"><input type=\"radio\" data-ng-model=\"this.ticketType\" \ndata-ng-change=\"this.onUpdateSeat(seat)\" value=\"in\"><div class=\"display\"><svg width=\"13px\" height=\"30px\" \nviewBox=\"36 6 13 30\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><desc>\nCreated with Sketch.</desc><defs></defs><g id=\"Icon-/-INAPAM\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" \nfill-rule=\"evenodd\" transform=\"translate(36.000000, 6.000000)\"><path \nd=\"M5.06071429,8.13636364 C2.83214286,8.13636364 0.975,6.36363636 0.975,4.13636364 C0.975,1.95454545 2.78571429,0.136363636 5.06071429,0.136363636 C7.33571429,0.136363636 9.14642857,1.90909091 9.14642857,4.13636364 C9.14642857,6.31818182 7.33571429,8.13636364 5.06071429,8.13636364 Z M5.06071429,1.68181818 C3.66785714,1.68181818 2.55357143,2.77272727 2.55357143,4.13636364 C2.55357143,5.5 3.66785714,6.59090909 5.06071429,6.59090909 C6.45357143,6.59090909 7.56785714,5.5 7.56785714,4.13636364 C7.56785714,2.77272727 6.45357143,1.68181818 5.06071429,1.68181818 Z\" \nid=\"Shape\" fill=\"#878787\"></path><path \nd=\"M7.89285714,29.7272727 L2.69285714,29.7272727 C2.275,29.7272727 1.90357143,29.3636364 1.90357143,28.9545455 L1.90357143,21.0909091 L0.603571429,20 C0.417857143,19.8636364 0.325,19.6363636 0.325,19.4090909 L0.325,10.2727273 C0.325,9.86363636 0.696428571,9.5 1.11428571,9.5 L9.47142857,9.5 C9.88928571,9.5 10.2607143,9.86363636 10.2607143,10.2727273 L10.2607143,12.3617021 C10.2607143,12.770793 9.88928571,13.1344294 9.47142857,13.1344294 C9.05357143,13.1344294 8.68214286,12.770793 8.68214286,12.3617021 L8.68214286,11.0454545 L1.90357143,11.0454545 L1.90357143,19.0454545 L3.20357143,20.1363636 C3.38928571,20.2727273 3.48214286,20.5 3.48214286,20.7272727 L3.48214286,28.1818182 L7.10357143,28.1818182 L7.10357143,20.7272727 C7.10357143,20.5 7.19642857,20.2727273 7.38214286,20.1363636 L8.68214286,19.0454545 C8.68214286,18.5928433 9.05357143,18.229207 9.47142857,18.229207 C9.88928571,18.229207 10.2607143,18.5928433 10.2607143,19.0019342 L10.2607143,19.3636364 C10.2607143,19.5909091 10.1678571,19.8181818 9.98214286,19.9545455 L8.68214286,21.0454545 L8.68214286,28.9090909 C8.68214286,29.3636364 8.35714286,29.7272727 7.89285714,29.7272727 Z\" \nid=\"Shape\" fill=\"#878787\"></path><path \nd=\"M11.9321429,29.9090909 C11.5142857,29.9090909 11.1428571,29.5454545 11.1428571,29.1363636 L11.1491595,18.5605639 C11.1491595,17.3332911 10.8241595,16.651473 10.5920166,16.3332911 C9.84915946,15.4242002 8.17773089,15.8787457 8.17773089,17.2878366 C8.17773089,17.6969275 7.80630232,18.0605639 7.38844517,18.0605639 C6.97058803,18.0605639 6.59915946,17.6969275 6.59915946,17.2878366 C6.59915946,15.6060184 7.94558803,14.2878366 9.6170166,14.2878366 C10.4991595,14.2878366 11.2884452,14.6969275 11.845588,15.3787457 C12.4491595,16.151473 12.7277309,17.1969275 12.7277309,18.5605639 L12.7214286,29.1363636 C12.7214286,29.5454545 12.35,29.9090909 11.9321429,29.9090909 Z\" \nid=\"Shape\" fill=\"#878787\"></path></g></svg><p>{{ \'SEATS.FORM.INAPAM\' | translate }}</p><p class=\"price\">\n{{this.pricesByType[\'in\'] || money}} MXN</p></div></label><label ng-show=\"this.availableByType[\'es\']\" \nclass=\"seat-type-selector-option\"><input type=\"radio\" data-ng-model=\"this.ticketType\" \ndata-ng-change=\"this.onUpdateSeat(seat)\" value=\"es\"><div class=\"display\"><svg version=\"1.1\" id=\"Capa_1\" \nxmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"30px\" \nviewBox=\"0 0 500 500\" style=\"enable-background:new 0 0 500 500\" xml:space=\"preserve\"><style type=\"text/css\">\n.st0{fill:#FFFFFF;}</style><path class=\"st0\" \nd=\"M409.95,377.42c-0.75-13.13-3.48-29.78-9.3-51.62c-11.47-43.03-47.08-78.69-69.36-97.62\n			       c12.55-12.4,22.19-27.66,28.06-44.68c0.01-0.04,0.05-0.06,0.06-0.09c0.01-0.05,0.02-0.11,0.03-0.16c3.08-8.99,5.07-18.45,5.84-28.28\n			       c1.61-10.42,2.77-21.2,3.36-32.31c1.88-35.21-7.3-63.82-27.29-85.05C306.68,0.8,252.37,0.02,249.92,0\n			       c-2.3,0.02-56.61,0.8-91.28,37.62c-19.98,21.23-29.17,49.84-27.29,85.04c0.59,11.07,1.74,21.82,3.35,32.23\n			       c0.77,9.91,2.78,19.45,5.9,28.51c0,0,0,0.01,0,0.01c0,0,0,0.01,0,0.01c5.87,17.06,15.53,32.35,28.1,44.77\n			       c-22.28,18.93-57.88,54.59-69.36,97.62c-5.82,21.83-8.55,38.46-9.31,51.59L65.94,490.3c-0.7,3.27,0.77,6.58,3.58,8.38\n			       c2.81,1.79,6.51,1.62,9.19-0.38c0.14-0.11,15.11-10.91,75.57-24.55c58.64-13.24,88.2,21.7,89.49,23.28c0.89,1.1,2.06,1.82,3.31,2.31\n			       c0.09,0.04,0.13,0.13,0.22,0.17c0.21,0.07,0.42-0.03,0.62,0.02c0.69,0.19,1.35,0.46,2.07,0.46c0.62,0,1.23-0.17,1.85-0.32\n			       c0.15-0.04,0.28-0.03,0.43-0.07c0.13-0.04,0.26-0.02,0.39-0.07c0.73-0.26,1.16-0.9,1.77-1.33c0.59-0.41,1.31-0.59,1.78-1.16\n			       c1.23-1.5,30.84-36.47,89.49-23.29c60.45,13.64,75.43,24.44,75.43,24.44c1.46,1.19,3.27,1.8,5.07,1.8c1.44,0,2.89-0.39,4.18-1.18\n			       c2.91-1.78,4.37-5.19,3.66-8.52L409.95,377.42z M385.15,329.94c16.33,61.23,6.74,75.97,1.02,84.79c-2.8,4.32-11.46,9.65-21.97,11.01\n			       c-4.46,0.61-12.8,0.81-18.35-4.2c-3.3-2.98-2.54-13.54-1.73-24.71c1.45-20.01,3.19-47.01-10.65-76.99l32.92-29.18\n			       C374.49,302.78,381.42,315.95,385.15,329.94z M147.39,121.8c-1.64-30.61,6.06-55.2,22.86-73.1c29.88-31.82,79.3-32.65,79.72-32.66\n			       c0.49,0,49.7,0.7,79.71,32.57c16.86,17.91,24.58,42.53,22.94,73.19c-0.63,12.08-1.92,23.76-3.82,34.92l-27.66-57.9\n			       c-1.36-2.85-4.21-4.57-7.24-4.57c-0.78,0-1.56,0.11-2.33,0.34l-61.93,18.85l-61.89-18.85c-3.83-1.17-7.9,0.65-9.6,4.28l-26.96,57.56\n			       C149.29,145.34,148.02,133.76,147.39,121.8z M157.05,181.7l32.67-69.72l57.57,17.53c1.51,0.45,3.16,0.47,4.67,0l57.67-17.55\n			       l33.31,69.74c-14.43,37.31-50.59,63.9-92.94,63.9C207.65,245.61,171.48,219.02,157.05,181.7z M114.85,329.94\n			       c3.73-13.99,10.66-27.15,18.76-39.27l32.92,29.18c-13.84,29.98-12.1,56.98-10.65,77c0.81,11.17,1.57,21.72-1.72,24.7\n			       c-5.53,5.02-13.87,4.8-18.36,4.2c-10.51-1.36-19.16-6.7-21.97-11.01C108.11,405.91,98.52,391.16,114.85,329.94z M241.98,474.08\n			       c-16.39-11.78-46.83-25.95-91.23-15.97c-33.19,7.49-53.51,14.23-65.64,19.2l12.49-58.46c0.9,1.62,1.83,3.17,2.78,4.62\n			       c5.88,9.04,19.28,16.35,33.35,18.18c2.26,0.3,4.47,0.44,6.61,0.44c9.75,0,18.32-2.98,24.59-8.66c9.1-8.23,8.16-21.26,6.96-37.75\n			       c-0.71-9.78-1.45-20.73-0.46-32.56c24.74-2.35,51.23,1.13,70.55,19.66V474.08z M250,368.78c-21.97-19.22-49.87-23.66-75.96-21.92\n			       c1.9-8.15,4.77-16.59,9.37-25.35c0.11-0.2,0.1-0.42,0.18-0.63c0.21-0.5,0.33-0.99,0.44-1.5c0.11-0.52,0.2-1.02,0.2-1.54\n			       c0-0.49-0.07-0.96-0.16-1.44c-0.09-0.53-0.2-1.03-0.4-1.54c-0.17-0.44-0.42-0.84-0.67-1.25c-0.3-0.48-0.61-0.93-1.02-1.35\n			       c-0.15-0.15-0.21-0.35-0.37-0.49l-38.53-34.16c13.09-16.49,27.47-29.99,38.09-38.88c19.26,14.32,43.03,22.9,68.83,22.9\n			       c25.79,0,49.56-8.58,68.82-22.9c10.62,8.9,25,22.39,38.09,38.88l-38.54,34.16c-0.16,0.14-0.22,0.34-0.37,0.49\n			       c-0.4,0.42-0.72,0.86-1.01,1.34c-0.26,0.41-0.5,0.81-0.68,1.25c-0.2,0.5-0.3,1-0.4,1.54c-0.09,0.49-0.16,0.95-0.16,1.45\n			       c0,0.52,0.1,1.01,0.2,1.53c0.11,0.52,0.23,1.01,0.44,1.51c0.09,0.21,0.08,0.43,0.18,0.63c4.6,8.75,7.46,17.19,9.36,25.34\n			       C299.87,345.11,271.97,349.55,250,368.78z M349.24,458.1c-10.57-2.38-20.34-3.39-29.32-3.39c-28.77,0-49.41,10.38-61.9,19.37v-91.29\n			       c19.3-18.51,45.79-21.98,70.55-19.62c0.99,11.81,0.25,22.75-0.46,32.51c-1.2,16.49-2.14,29.52,6.96,37.75\n			       c6.26,5.67,14.83,8.66,24.58,8.66c2.15,0,4.36-0.14,6.61-0.44c14.07-1.83,27.47-9.13,33.36-18.18c0.94-1.45,1.87-2.99,2.77-4.61\n			       l12.48,58.45C402.76,472.34,382.43,465.59,349.24,458.1z\"/>\n<g><g><path class=\"st0\" d=\"M652.21,268.19c0.01,0,0.01-0.01,0.02-0.01c-0.01,0-0.01-0.01-0.02-0.01V268.19z\"/><path \nclass=\"st0\" \nd=\"M712.34,230.53h-58.92c-0.67,0-1.21,0.54-1.21,1.21v18.58c0.75-0.47,1.57-0.83,2.43-1.11v-16.26h56.49v42.24\n				   H670.7c0.36,0.77,0.64,1.59,0.86,2.43h40.78c0.67,0,1.21-0.54,1.21-1.21v-44.67C713.56,231.08,713.02,230.53,712.34,230.53z\"/>\n</g><g id=\"XMLID_2_\"><g><path class=\"st0\" \nd=\"M672.04,287c-0.67,0-1.21-0.54-1.21-1.21v-4.58c0-1.92-0.42-3.77-1.23-5.51c-0.14-0.3-0.15-0.64-0.04-0.95\n				     c0.12-0.31,0.35-0.56,0.65-0.69c4.51-1.95,7.99-5.68,10.36-11.08c0.3-0.68,0.31-1.43,0.05-2.12c-0.27-0.69-0.79-1.23-1.47-1.53\n				     c-0.68-0.3-1.43-0.31-2.12-0.05c-0.69,0.27-1.24,0.79-1.54,1.47c-3.43,7.81-8.81,8.99-10.97,9.14c-0.23,0.01-0.45-0.03-0.65-0.14\n				     l-0.32-0.17c-0.19-0.1-0.37-0.21-0.57-0.29c-0.41-0.18-0.69-0.57-0.73-1.02c-0.03-0.45,0.18-0.88,0.56-1.12\n				     c2.75-1.73,4.39-4.69,4.39-7.9c0-5.16-4.2-9.36-9.36-9.36c-5.16,0-9.36,4.2-9.36,9.36c0,3.21,1.64,6.17,4.39,7.9\n				     c0.38,0.24,0.6,0.67,0.56,1.12c-0.04,0.45-0.32,0.84-0.73,1.02c-4.76,2.06-7.84,6.73-7.84,11.92v4.58c0,0.67-0.54,1.21-1.21,1.21\n				     c-0.67,0-1.21-0.54-1.21-1.21v-4.58c0-5.48,2.89-10.48,7.52-13.23c-2.47-2.22-3.9-5.36-3.9-8.73c0-6.5,5.29-11.79,11.79-11.79\n				     c6.5,0,11.79,5.29,11.79,11.79c0,2.84-1.02,5.52-2.82,7.62c1.99-0.82,4.52-2.73,6.44-7.1c0.56-1.27,1.58-2.25,2.88-2.76\n				     c1.3-0.51,2.71-0.47,3.98,0.09c1.27,0.56,2.25,1.58,2.75,2.88c0.51,1.3,0.48,2.71-0.08,3.98c-2.43,5.54-5.97,9.51-10.53,11.82\n				     c0.66,1.73,0.99,3.55,0.99,5.43v4.58C673.25,286.46,672.71,287,672.04,287z\"/>\n</g></g></g></svg><p>{{ \'SEATS.FORM.STUDENT\' | translate }}</p><p class=\"price\">\n{{this.pricesByType[\'es\'] || money}} MXN</p></div></label><label ng-show=\"this.availableByType[\'ma\']\" \nclass=\"seat-type-selector-option\"><input type=\"radio\" data-ng-model=\"this.ticketType\" \ndata-ng-change=\"this.onUpdateSeat(seat)\" value=\"ma\"><div class=\"display\"><svg version=\"1.1\" id=\"Capa_1\" \nxmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"30px\" \nviewBox=\"0 0 500 500\" style=\"enable-background:new 0 0 500 500\" xml:space=\"preserve\"><style type=\"text/css\">\n.st0{fill:#FFFFFF;}</style><path class=\"st0\" \nd=\"M-108.05,539.42c-0.75-13.13-3.48-29.78-9.3-51.62c-11.47-43.03-47.08-78.69-69.36-97.62\n			       c12.55-12.4,22.19-27.66,28.06-44.68c0.01-0.04,0.05-0.06,0.06-0.09c0.01-0.05,0.02-0.11,0.03-0.16c3.08-8.99,5.07-18.45,5.84-28.28\n			       c1.61-10.42,2.77-21.2,3.36-32.31c1.88-35.21-7.3-63.82-27.29-85.05c-34.67-36.82-88.99-37.6-91.43-37.62\n			       c-2.3,0.02-56.61,0.8-91.28,37.62c-19.98,21.23-29.17,49.84-27.29,85.04c0.59,11.07,1.74,21.82,3.35,32.23\n			       c0.77,9.91,2.78,19.45,5.9,28.51c0,0,0,0.01,0,0.01c0,0,0,0.01,0,0.01c5.87,17.06,15.53,32.35,28.1,44.77\n			       c-22.28,18.93-57.88,54.59-69.36,97.62c-5.82,21.83-8.55,38.46-9.31,51.59l-24.11,112.91c-0.7,3.27,0.77,6.58,3.58,8.38\n			       c2.81,1.79,6.51,1.62,9.19-0.38c0.14-0.11,15.11-10.91,75.57-24.55c58.64-13.24,88.2,21.7,89.49,23.28c0.89,1.1,2.06,1.82,3.31,2.31\n			       c0.09,0.04,0.13,0.13,0.22,0.17c0.21,0.07,0.42-0.03,0.62,0.02c0.69,0.19,1.35,0.46,2.07,0.46c0.62,0,1.23-0.17,1.85-0.32\n			       c0.15-0.04,0.28-0.03,0.43-0.07c0.13-0.04,0.26-0.02,0.39-0.07c0.73-0.26,1.16-0.9,1.77-1.33c0.59-0.41,1.31-0.59,1.78-1.16\n			       c1.23-1.5,30.84-36.47,89.49-23.29c60.45,13.64,75.43,24.44,75.43,24.44c1.46,1.19,3.27,1.8,5.07,1.8c1.44,0,2.89-0.39,4.18-1.18\n			       c2.91-1.78,4.37-5.19,3.66-8.52L-108.05,539.42z M-132.85,491.94c16.33,61.23,6.74,75.97,1.02,84.79\n			       c-2.8,4.32-11.46,9.65-21.97,11.01c-4.46,0.61-12.8,0.81-18.35-4.2c-3.3-2.98-2.54-13.54-1.73-24.71\n			       c1.45-20.01,3.19-47.01-10.65-76.99l32.92-29.18C-143.51,464.78-136.58,477.95-132.85,491.94z M-370.61,283.8\n			       c-1.64-30.61,6.06-55.2,22.86-73.1c29.88-31.82,79.3-32.65,79.72-32.66c0.49,0,49.7,0.7,79.71,32.57\n			       c16.86,17.91,24.58,42.53,22.94,73.19c-0.63,12.08-1.92,23.76-3.82,34.92l-27.66-57.9c-1.36-2.85-4.21-4.57-7.24-4.57\n			       c-0.78,0-1.56,0.11-2.33,0.34l-61.93,18.85l-61.89-18.85c-3.83-1.18-7.9,0.65-9.6,4.28l-26.96,57.56\n			       C-368.71,307.34-369.98,295.76-370.61,283.8z M-360.95,343.7l32.67-69.72l57.57,17.53c1.51,0.45,3.16,0.47,4.67,0l57.67-17.55\n			       l33.31,69.74c-14.43,37.31-50.59,63.9-92.94,63.9C-310.35,407.61-346.52,381.02-360.95,343.7z M-403.15,491.94\n			       c3.73-13.99,10.66-27.15,18.76-39.27l32.92,29.18c-13.84,29.98-12.1,56.98-10.65,77c0.81,11.17,1.57,21.72-1.72,24.7\n			       c-5.53,5.02-13.87,4.8-18.36,4.2c-10.51-1.36-19.16-6.7-21.97-11.01C-409.89,567.91-419.48,553.16-403.15,491.94z M-276.02,636.08\n			       c-16.39-11.78-46.83-25.95-91.23-15.97c-33.19,7.49-53.51,14.23-65.64,19.2l12.49-58.46c0.9,1.62,1.83,3.17,2.78,4.62\n			       c5.88,9.04,19.28,16.35,33.35,18.18c2.26,0.3,4.47,0.44,6.61,0.44c9.75,0,18.32-2.98,24.59-8.66c9.1-8.23,8.16-21.26,6.96-37.75\n			       c-0.71-9.78-1.45-20.73-0.46-32.56c24.74-2.35,51.23,1.13,70.55,19.66V636.08z M-268,530.78c-21.97-19.22-49.87-23.66-75.96-21.92\n			       c1.9-8.15,4.77-16.59,9.37-25.35c0.11-0.2,0.1-0.42,0.18-0.63c0.21-0.5,0.33-0.99,0.44-1.5c0.11-0.52,0.2-1.02,0.2-1.54\n			       c0-0.49-0.07-0.96-0.16-1.44c-0.09-0.53-0.2-1.03-0.4-1.54c-0.17-0.44-0.42-0.84-0.67-1.25c-0.3-0.48-0.61-0.93-1.02-1.35\n			       c-0.15-0.15-0.21-0.35-0.37-0.49l-38.53-34.16c13.09-16.49,27.47-29.99,38.09-38.88c19.26,14.32,43.03,22.9,68.83,22.9\n			       c25.79,0,49.56-8.58,68.82-22.9c10.62,8.9,25,22.39,38.09,38.88l-38.54,34.16c-0.16,0.14-0.22,0.34-0.37,0.49\n			       c-0.4,0.42-0.72,0.86-1.01,1.34c-0.26,0.41-0.5,0.81-0.68,1.25c-0.2,0.5-0.3,1-0.4,1.54c-0.09,0.49-0.16,0.95-0.16,1.45\n			       c0,0.52,0.1,1.01,0.2,1.53c0.11,0.52,0.23,1.01,0.44,1.51c0.09,0.21,0.08,0.43,0.18,0.63c4.6,8.75,7.46,17.19,9.36,25.34\n			       C-218.13,507.11-246.03,511.55-268,530.78z M-168.76,620.1c-10.57-2.38-20.34-3.39-29.32-3.39c-28.77,0-49.41,10.38-61.9,19.37\n			       v-91.29c19.3-18.51,45.79-21.98,70.55-19.62c0.99,11.81,0.25,22.75-0.46,32.51c-1.2,16.49-2.14,29.52,6.96,37.75\n			       c6.26,5.67,14.83,8.66,24.58,8.66c2.15,0,4.36-0.14,6.61-0.44c14.07-1.83,27.47-9.13,33.36-18.18c0.94-1.45,1.87-2.99,2.77-4.61\n			       l12.48,58.45C-115.24,634.34-135.57,627.59-168.76,620.1z\"/>\n<g><g><path class=\"st0\" d=\"M72.32,314.9c0.04-0.02,0.08-0.04,0.12-0.06c-0.04-0.03-0.08-0.06-0.12-0.08V314.9z\"/><path \nclass=\"st0\" \nd=\"M486.63,55.48H80.69c-4.63,0-8.37,3.74-8.37,8.37v128.02c5.16-3.27,10.81-5.73,16.74-7.63V72.22h389.21v291\n				   H199.69c2.5,5.32,4.43,10.95,5.95,16.74h280.99c4.63,0,8.37-3.74,8.37-8.37V63.85C495,59.22,491.26,55.48,486.63,55.48z\"/>\n</g><g id=\"XMLID_2_\"><g><path class=\"st0\" \nd=\"M208.93,444.52c-4.63,0-8.37-3.74-8.37-8.37v-31.53c0-13.22-2.86-26-8.5-37.98\n				     c-0.96-2.04-1.06-4.4-0.26-6.51c0.8-2.12,2.42-3.82,4.5-4.72c31.04-13.47,55.06-39.16,71.39-76.35\n				     c2.06-4.67,2.17-9.86,0.31-14.63c-1.85-4.76-5.45-8.51-10.13-10.57c-4.67-2.04-9.82-2.17-14.61-0.31\n				     c-4.76,1.86-8.53,5.46-10.59,10.14c-23.64,53.79-60.72,61.96-75.56,62.97c-1.58,0.07-3.09-0.22-4.47-0.95l-2.21-1.19\n				     c-1.28-0.7-2.54-1.42-3.9-2c-2.84-1.23-4.78-3.95-5.02-7.04c-0.24-3.1,1.26-6.07,3.88-7.72c18.94-11.95,30.25-32.3,30.25-54.45\n				     c0-35.56-28.93-64.49-64.49-64.49c-35.57,0-64.5,28.93-64.5,64.49c0,22.15,11.31,42.5,30.25,54.45c2.63,1.66,4.12,4.63,3.88,7.72\n				     c-0.25,3.1-2.17,5.81-5.03,7.04c-32.81,14.16-54.02,46.4-54.02,82.1v31.53c0,4.63-3.74,8.37-8.37,8.37S5,440.78,5,436.15v-31.53\n				     c0-37.73,19.93-72.18,51.78-91.16c-17.02-15.27-26.86-36.92-26.86-60.15c0-44.79,36.44-81.23,81.24-81.23\n				     c44.79,0,81.23,36.44,81.23,81.23c0,19.59-7,38.06-19.4,52.53c13.71-5.67,31.15-18.81,44.38-48.89\n				     c3.86-8.77,10.9-15.51,19.83-18.99c8.96-3.49,18.7-3.27,27.44,0.59c8.76,3.85,15.5,10.89,18.98,19.81\n				     c3.48,8.92,3.28,18.67-0.58,27.44c-16.76,38.19-41.15,65.54-72.54,81.44c4.54,11.95,6.82,24.49,6.82,37.39v31.53\n				     C217.3,440.78,213.56,444.52,208.93,444.52z\"/>\n</g></g></g></svg><p>{{ \'SEATS.FORM.TEACHER\' | translate }}</p><p class=\"price\">\n{{this.pricesByType[\'ma\'] || money}} MXN</p></div></label></div>");
$templateCache.put("app/views/transportamex/pages/seats/seat-selection/seat.html","<div class=\"seat_wrapper\"><div class=\"seat\" data-ng-class=\"[this.state, { selected: isSelected }]\"><img \nclass=\"seat-person\" ng-src=\"/assets/transportamex/images/bus/person.svg\" alt=\"person\" \ndata-ng-if=\"this.state === \'occupied\'\"> <svg width=\"42px\" height=\"38px\" viewBox=\"460 146 42 38\" version=\"1.1\" \nxmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><desc>Single Seat Graphic</desc><defs>\n</defs><g id=\"seat\" stroke=\"none\" ng-if=\"this.state != \'wc\' && this.state!=\'stair\'\" stroke-width=\"1\" fill=\"none\" \nfill-rule=\"evenodd\" \ntransform=\"translate(481.500000, 165.000000) rotate(-90.000000) translate(-481.500000, -165.000000) translate(463.000000, 145.000000)\">\n<g id=\"Created-with-Sketch.\" fill=\"#A8A8BA\"><g id=\"seat\" \ntransform=\"translate(18.666667, 20.000000) rotate(90.000000) translate(-18.666667, -20.000000) translate(-1.333333, 2.000000)\">\n<path \nd=\"M32.2218373,26.6666667 L32.2218373,15.087218 L36.428,15.087218 L36.428,3.96480975 C36.428,1.78443651 34.7156355,0 32.6233258,0 L8.23267424,0 C6.14036454,0 4.428,1.78443651 4.428,3.96480975 L4.428,15.087218 L8.41024311,15.087218 L8.41024311,26.6666667 L32.2218373,26.6666667 Z\" \nid=\"Shape\"></path><polygon id=\"Shape\" \npoints=\"33.8106667 17.455876 33.8106667 29.0671008 6.18933333 29.0671008 6.18933333 17.455876 0 17.455876 0 35.3996899 3.09466667 35.3996899 6.18933333 35.3996899 33.8106667 35.3996899 40 35.3996899 40 29.0671008 40 17.455876\">\n</polygon></g></g></g></svg><div class=\"loader\" data-ng-show=\"this.isLoading\"></div></div><div class=\"seat-number\" \ndata-ng-if=\"this.displayNumber()\"><span>{{this.number}}</span></div></div>");
$templateCache.put("app/views/transportamex/pages/payment/dialogs/exit/exit-dialog.html","<md-dialog id=\"exit-dialog\" class=\"custom-dialog\" aria-label=\"Alert\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"PAYMENT.DIALOGS.EXIT.TOOLBAR\">¡Alerta!\n</span></div></md-toolbar><md-dialog-content>{{ \"NOTIFICATION.DIALOG.MESSAGE.BACK\" | translate }}</md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.closeDialog()\" class=\"md-primary\" \nflex=\"initial\">{{ \"NOTIFICATION.DIALOG.BUTTON.CANCEL\" | translate }}</md-button><md-button \nng-click=\"vm.confirmDialog()\" class=\"md-primary btn-default\" flex=\"initial\">\n{{ \"NOTIFICATION.DIALOG.BUTTON.OK\" | translate }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/views/transportamex/pages/payment/dialogs/notbuy/notbuy.html","<md-dialog id=\"timeout-dialog\" class=\"custom-dialog\" aria-label=\"Alert\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">¡Su banco no responde!</span></div></md-toolbar>\n<md-dialog-content>{{ \"NOTIFICATION.DIALOG.MESSAGE.NOT_BUY\" | translate }}</md-dialog-content><md-dialog-actions>\n<md-button ng-click=\"vm.closeDialog()\" class=\"md-primary\">{{ \"NOTIFICATION.DIALOG.BUTTON.SEARCH_AGAIN\" | translate }}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/views/transportamex/pages/payment/dialogs/timeout/timeout-dialog.html","<md-dialog id=\"timeout-dialog\" class=\"custom-dialog\" aria-label=\"Alert\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">¡Oops!</span></div></md-toolbar>\n<md-dialog-content>{{ \"NOTIFICATION.DIALOG.MESSAGE.TIME_EXPIRED\" | translate }}</md-dialog-content><md-dialog-actions>\n<md-button ng-click=\"vm.closeDialog()\" class=\"md-primary\">{{ \"NOTIFICATION.DIALOG.BUTTON.SEARCH_AGAIN\" | translate }}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/views/transportamex/pages/routes/dialogs/bus/bus-dialog.html","<md-dialog id=\"bus-dialog\" class=\"custom-dialog\" aria-label=\"Alert\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ROUTES.DIALOGS.BUS.TOOLBAR\">Descripción\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"row\" \nlayout-align=\"start start\" layout-padding><div flex=\"initial\"><img \nng-src=\"/assets/transportamex/images/icons/bus-orange.png\" alt=\"Bus orange\"></div><div class=\"desc\" flex=\"grow\" \nlayout=\"column\" layout-align=\"start none\"><p flex><u><b>LOCAL:</b></u>\n {{ \"ROUTES.DIALOGS.BUS.LOCAL_TEXT\" | translate }}</p><p flex><u><b>PASO:</b></u>\n {{ \"ROUTES.DIALOGS.BUS.PASO_TEXT\" | translate }}</p></div></md-dialog-content></md-dialog>");}]);